import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@nuxtjs/composition-api';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _FieldSet: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};






export type AiAssistantInput = {
  /** Name for the assistant to use */
  assistant?: Maybe<BambeeAssistant>;
  /** ID for the assistant to use */
  assistantId?: Maybe<Scalars['String']>;
  /** Content for next message to add to thread */
  content?: Maybe<Scalars['String']>;
  /** files to upload to attach to the artifact */
  files?: Maybe<Array<UploadedFileCore>>;
  /** This is a spcial flag that will result in a hidden metadata value being added to the message. This allows the client to send information without it being displayed to the user */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Do not create a run; Do not send thread messages to be processed by model; Just return messages that exist on the thread */
  skipRun?: Maybe<Scalars['Boolean']>;
  /** ID for the current message thread */
  threadId?: Maybe<Scalars['String']>;
};

export type AiAssistantResponse = {
  __typename?: 'AIAssistantResponse';
  /** If artifacts were created from the thread they will be mapped to here */
  artifact?: Maybe<ChatArtifact>;
  /** Canonical name for the assistant last interacted with. To continue a converstation ensure you send your next message to the correct assistant and thread */
  assistant?: Maybe<Scalars['String']>;
  /** ID for the assistant last interacted with. To continue a converstation ensure you send your next message to the correct assistant and thread */
  assistantId?: Maybe<Scalars['String']>;
  /** All messages associated to the current thread */
  messages?: Maybe<Array<Maybe<AiMessageDto>>>;
  /** All messages associated to the current thread */
  next: NextMessage;
  /** ID for the last / current run. Useful for debugging runs stuck in unexpected states */
  runId: Scalars['String'];
  /** ID for the current message thread. To continue a converstation ensure you send your next message to the correct assistant and thread */
  threadId: Scalars['String'];
};

export type AiMessageDto = {
  __typename?: 'AIMessageDto';
  /** ID for the message */
  content: Array<MessageContentDto>;
  /** ID for the message */
  id: Scalars['String'];
  /** Metadata about the message */
  metadata: MessageMetaDataDto;
  /** ID for the message */
  role: Scalars['String'];
};

export type AiThread = {
  __typename?: 'AIThread';
  /** The archived at date of the thread, optional */
  archivedAt?: Maybe<Scalars['DateTime']>;
  /** The company id of the thread */
  companyId: Scalars['String'];
  /** The created at date of the thread */
  createdAt: Scalars['DateTime'];
  /** The id of the thread */
  id: Scalars['String'];
  /** The summary of the thread */
  summary?: Maybe<Scalars['String']>;
  /** The title of the thread */
  title?: Maybe<Scalars['String']>;
  /** The updated at date of the thread */
  updatedAt: Scalars['DateTime'];
  /** The user id of the thread */
  userId: Scalars['String'];
};

export type AcceptOfferInput = {
  /** When customer provides a customer reason for cancelling */
  clientOtherReasonNote?: Maybe<Scalars['String']>;
  /** The plan value to accept. */
  planValue: Scalars['String'];
  /** Reason Codes the customer wanted to cancel before accepting offer */
  reasonCodes?: Maybe<Array<Scalars['Float']>>;
  /** The cancellation request wizard session id */
  sessionId?: Maybe<Scalars['String']>;
};

export type AcceptRecommendationInput = {
  /** The id of the recommendation to be accepted. */
  recommendationId: Scalars['String'];
};

export type AcceptTrialOfferInput = {
  /** When customer provides a customer reason for cancelling */
  clientOtherReasonNote?: Maybe<Scalars['String']>;
  /** Reason Codes the customer wanted to cancel before accepting offer */
  reasonCodes?: Maybe<Array<Scalars['Float']>>;
  /** The cancellation request wizard session id */
  sessionId?: Maybe<Scalars['String']>;
  /** The date the trial should be extended to */
  trialEndDate: Scalars['DateTime'];
};

export type ActionPlanArtifact = {
  __typename?: 'ActionPlanArtifact';
  /** The download url for the action plan artifact */
  downloadUrl: Scalars['String'];
  /** The dto of the action plan */
  dto: Scalars['String'];
  /** The artifact renered as HTML */
  html: Scalars['String'];
  /** ID of the action plan that was created */
  id?: Maybe<Scalars['String']>;
  /** The status of the action plan artifact */
  status: Scalars['String'];
  /** Title of the action plan */
  title: Scalars['String'];
};

export type ActivationDeleteInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** The feature key to delete. */
  key: Scalars['String'];
};

export type ActivationFilterInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** Filter by enabled status. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Filter by specific feature key. */
  key?: Maybe<Scalars['String']>;
};

export type ActivationInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** Whether to enable this feature. */
  enabled?: Scalars['Boolean'];
  /** The feature key to activate. */
  key: Scalars['String'];
};

export type ActivationQueryInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** The feature key to find. */
  key: Scalars['String'];
};

export type ActivationToggleInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** Whether to enable or disable this feature. */
  enabled: Scalars['Boolean'];
  /** The feature key to toggle. */
  key: Scalars['String'];
};

export type ActivePlanFilters = {
  /** The billing periods to filter by */
  billingPeriods?: Maybe<Array<BillingPeriod>>;
  /** Include internal plans (defaults to false) */
  internal?: Maybe<Scalars['Boolean']>;
  /** The product keys to filter by */
  productKeys?: Maybe<Array<ProductKey>>;
};

export type AddCreditsInput = {
  chargeCustomer?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  creationDescription: Scalars['String'];
  creationReason: ProductCreditCreationReason;
  productKey: ProductKey;
  quantity: Scalars['Int'];
};

export type AddCreditsResult = {
  __typename?: 'AddCreditsResult';
  amountCharged?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  creditsCreated: Scalars['Int'];
  productKey: ProductKey;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export type AddSubscriptionInput = {
  billingPeriod?: Maybe<BillingPeriod>;
  chargeCustomer?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  creationDescription: Scalars['String'];
  creationReason: ProductCreditCreationReason;
  productKey: ProductKey;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AdvisorNextAvailableSlotInput = {
  /** The company identifier */
  companyId: Scalars['String'];
  /** The duration of the slot in minutes */
  duration: Scalars['Int'];
  /** The role for the company advisor */
  role: CompanyAdvisorRole;
};

export type AdvisorNextTimeSlot = {
  __typename?: 'AdvisorNextTimeSlot';
  /** The calendly slug for the advisor */
  calendlySlug?: Maybe<Scalars['String']>;
  /** The role for the advisor */
  role: CompanyAdvisorRole;
  /** The next available time slot for the advisor */
  slot?: Maybe<TimeSlot>;
  /** The advisor user identifier */
  userId: Scalars['String'];
};

export type AiGenerated = {
  __typename?: 'AiGenerated';
  /** Extracted json parsed data generated by the AI */
  body?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Raw response provided by AI */
  response: Scalars['JSON'];
};

/** The status of the prompt */
export enum AiGeneratedStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type AiOptionInput = {
  /** The user has opted in to or out of the AI assistant. This will be used to determine if the user should be routed to the AI assistant or not */
  optIn: Scalars['Boolean'];
};

export type AiPromptInput = {
  /** The prompts to send to OpenAI */
  prompts: Array<RawAiPrompt>;
  /** The side effects to trigger after the prompt is completed */
  sideEffects?: Maybe<Array<Maybe<AiPromptSideEffect>>>;
};

export type AiPromptResponse = {
  __typename?: 'AiPromptResponse';
  /** The id of the prompt */
  id: Scalars['String'];
  /** The status of the prompt */
  status: AiGeneratedStatus;
};

/** Side effects that can be triggered by an AI prompt completion */
export enum AiPromptSideEffect {
  CallTranscriptionSummary = 'CALL_TRANSCRIPTION_SUMMARY',
  SaveGeneratedTitleOnThread = 'SAVE_GENERATED_TITLE_ON_THREAD',
  SentimentAnalysis = 'SENTIMENT_ANALYSIS'
}

export type AnalyticEvent = {
  /** name or key of the event */
  event: Scalars['String'];
  /** The id of the analytic event */
  id: Scalars['ID'];
  /** additional properties associated with the event */
  properties?: Maybe<Scalars['JSONObject']>;
  /** the identity associated with the data */
  userId?: Maybe<Scalars['String']>;
};

export type AnalyticEventTracked = {
  __typename?: 'AnalyticEventTracked';
  /** name or key of the event */
  event: Scalars['String'];
  /** The id of the analytic event */
  id: Scalars['ID'];
  /** indicator if event was tracked successfully */
  success: Scalars['Boolean'];
  /** the identity associated with the data */
  userId?: Maybe<Scalars['String']>;
};

export type AnnotationDto = FileCitationAnnotationDto | FilePathAnnotationDto;

export type ApplyCorePayrollDiscountInput = {
  stripeCustomerId: Scalars['String'];
};

/** The result of the decision. */
export enum ApprovalResult {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ApprovePayrollInput = {
  id: Scalars['ID'];
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
};

export type ArchivePolicyInput = {
  policyId: Scalars['ID'];
};

export type AskNicelySurveyInfo = {
  __typename?: 'AskNicelySurveyInfo';
  emailHash?: Maybe<Scalars['String']>;
  force: Scalars['Boolean'];
  show: Scalars['Boolean'];
};

export type AssignUserToPoliciesInput = {
  /** Company ID of the policy */
  companyId: Scalars['ID'];
  /** Employee ID to assign policy to */
  employeeId: Scalars['ID'];
  /** Policy IDs */
  policyIds: Array<Scalars['ID']>;
};

export type AssignUsersToPoliciesInput = {
  /** Company ID of the policy */
  companyId: Scalars['ID'];
  /** Employee IDs to assign policy to */
  employeeIds: Array<Scalars['ID']>;
  /** Policy IDs */
  policyIds: Array<Scalars['ID']>;
};

export type AssignWorkerRolesInput = {
  add?: Maybe<Array<CreateWorkerRoleInput>>;
  delete?: Maybe<Array<Scalars['ID']>>;
  update?: Maybe<Array<UpdateWorkerRoleInput>>;
  userId: Scalars['ID'];
};

export type AuthMfaChallenge = {
  __typename?: 'AuthMfaChallenge';
  deviceHeader: Scalars['String'];
  deviceId: Scalars['String'];
  expiration: Scalars['DateTime'];
  metadata?: Maybe<AuthMfaMetadata>;
  nonce: Scalars['String'];
};

export type AuthMfaChallengeResponseInput = {
  nonce: Scalars['String'];
  response: Scalars['String'];
};

export type AuthMfaConfig = {
  __typename?: 'AuthMfaConfig';
  /** When enrolling the first MFA device, a backup code will also be created and presented to the user. */
  backupCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastChallengedAt?: Maybe<Scalars['DateTime']>;
  lastDevice?: Maybe<Scalars['String']>;
  mfaType: AuthMfaType;
};

export type AuthMfaMetadata = {
  __typename?: 'AuthMfaMetadata';
  phoneLast4?: Maybe<Scalars['String']>;
};

export type AuthMfaSmsEnrollmentInput = {
  mfaType: AuthMfaType;
  phoneNumber: Scalars['String'];
};

export enum AuthMfaType {
  /** The backup code (which should be printed and securely stored!) in case the phone number becomes unavailable. */
  Backup = 'BACKUP',
  /** Certain challenges (like creating an MFA enrollment, or running a process without any other MFA) require using a password. */
  Password = 'PASSWORD',
  /** Perform MFA verification via SMS text message */
  Sms = 'SMS'
}

/** The user role of the decision maker. */
export enum AuthRole {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE'
}

export type AuthorizationDocument = Document & {
  __typename?: 'AuthorizationDocument';
  /** Date that this document was filed */
  filedOn: Scalars['String'];
  id: Scalars['ID'];
  /** will be either a two-character state abbreviation or "FED" */
  jurisdiction?: Maybe<Scalars['String']>;
  /** Document’s type */
  label: Scalars['String'];
  /** Year that this document was filed */
  year: Scalars['Float'];
};

export type AutoAssignHrManager = {
  __typename?: 'AutoAssignHrManager';
  coordinator: CoreUser;
  lastAssignedOn?: Maybe<Scalars['DateTime']>;
  stateGroup: Scalars['ID'];
  user: CoreUser;
};

export type AutoAssignHrManagerInput = {
  coordinatorUserId: Scalars['ID'];
  stateGroup: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AvailableProduct = {
  __typename?: 'AvailableProduct';
  /** Number of credits provided on core subscription. Null if single purchase */
  allowance?: Maybe<Scalars['Int']>;
  /** Billing period of the product. Null if single purchase */
  billingPeriod?: Maybe<Scalars['String']>;
  /** One-time discounted price of product, if available. Null if subscription */
  discountedPrice?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  key: ProductKey;
  /** Number of credits provided per month, if applicable. Null if single purchase */
  monthlyAllowance?: Maybe<Scalars['Int']>;
  /** Name of product */
  name?: Maybe<Scalars['String']>;
  /** One-time price of product. Null if subscription */
  price?: Maybe<Scalars['Int']>;
  /** The price to subscribe, based on billing period. Null if single purchase */
  subscriptionPrice?: Maybe<Scalars['Int']>;
  /** Company tier */
  tier?: Maybe<Scalars['Int']>;
};

export type AvailableProducts = {
  __typename?: 'AvailableProducts';
  bundles: Array<BundleResponse>;
  id: Scalars['ID'];
  topics: Array<CourseTopic>;
};

export type BackfillBambeePlusTopicsInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicIds: Array<Scalars['String']>;
};

export enum BambeeAssistant {
  CompanyInfo = 'CompanyInfo',
  Compliance = 'Compliance',
  CorrectiveAction = 'CorrectiveAction',
  Editor = 'Editor',
  Gather = 'Gather',
  Guard = 'Guard',
  Guidance = 'Guidance',
  Incident = 'Incident',
  JobDescription = 'JobDescription',
  Policy = 'Policy',
  Router = 'Router',
  Sentiment = 'Sentiment'
}

export type BambeePlus = {
  __typename?: 'BambeePlus';
  eligible: Scalars['Boolean'];
  hasExtendedOnboardingDeadline: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Late fee implementation price in units i.e $10.00 = 1000 */
  lateFeeImplementationPrice?: Maybe<Scalars['Float']>;
  onboardingDueDate?: Maybe<Scalars['DateTime']>;
  /** Price related to core subscription in units i.e $10.00 = 1000 */
  price?: Maybe<Scalars['Float']>;
  status: BambeePlusStatuses;
};

export enum BambeePlusStatuses {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  /** Type of bank account (e.g. CHECKING, SAVINGS, etc */
  accountSubType: BankAccountSubtype;
  /** Check ID of bank account */
  checkId?: Maybe<Scalars['ID']>;
  /** Bambee bank account ID */
  id: Scalars['ID'];
  /** The name of the bank holding the account */
  institutionName: Scalars['String'];
  /** Bank's mask number or last 4 of the account number */
  mask: Scalars['String'];
  /** Bank nickname */
  name?: Maybe<Scalars['String']>;
  /**
   * Type of bank account (e.g. CHECKING, SAVINGS, etc
   * @deprecated Use accountSubType instead
   */
  subType: Subtype;
};

export enum BankAccountSteps {
  BankAccountDebitAuthorizationSubmitted = 'BANK_ACCOUNT_DEBIT_AUTHORIZATION_SUBMITTED',
  BankAccountExists = 'BANK_ACCOUNT_EXISTS',
  BankAccountVerified = 'BANK_ACCOUNT_VERIFIED'
}

export enum BankAccountSubtype {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type BaseTemplateDto = {
  __typename?: 'BaseTemplateDto';
  /** Indicates whether the final artifact is based on a Bambee template */
  isBambeeTemplateBase?: Maybe<Scalars['String']>;
};

export type Benefit = {
  __typename?: 'Benefit';
  /** Indicates whether the benefit is active for this employee. */
  active: Scalars['Boolean'];
  /** The Check ID associated with the benefit. */
  checkId?: Maybe<Scalars['ID']>;
  companyBenefit?: Maybe<CompanyBenefit>;
  /** Company Benefit ID of the benefit */
  companyBenefitId: Scalars['ID'];
  /** If provided, the timestamp the benefit was deleted */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** The timestamp of the benefit end date */
  effectiveEnd?: Maybe<Scalars['DateTime']>;
  /** The timestamp of the benefit start date */
  effectiveStart?: Maybe<Scalars['DateTime']>;
  /** The amount the employee is contributing per benefit */
  employeeContribution: Scalars['Float'];
  /** The amount the employer is contributing per benefit */
  employerContribution: Scalars['Float'];
  id: Scalars['ID'];
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
};

export type BenefitCompanyOnboarding = {
  __typename?: 'BenefitCompanyOnboarding';
  coverageStartedAtChanged?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: CompanyBenefitOnboardStatus;
  targetEffectiveStart?: Maybe<Scalars['String']>;
};

export type BenefitCostEstimated = {
  __typename?: 'BenefitCostEstimated';
  /** The lowest cost per zip (for a 30 year old). */
  monthlyPremium: Scalars['Float'];
  /** The state abbreviation of the benefit cost. */
  state: Scalars['String'];
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
  /** The zip of the benefit cost. */
  zip: Scalars['ID'];
};

export enum BenefitOnboardStatus {
  Enrolled = 'ENROLLED',
  Enrolling = 'ENROLLING',
  Ineligible = 'INELIGIBLE',
  NotEnrolling = 'NOT_ENROLLING',
  OptedOut = 'OPTED_OUT'
}

export enum BenefitPeriod {
  Monthly = 'MONTHLY'
}

export enum BenefitType {
  Dental = 'DENTAL',
  Medical = 'MEDICAL',
  Vision = 'VISION'
}

export type BenefitWorkerOnboarding = {
  __typename?: 'BenefitWorkerOnboarding';
  status: BenefitOnboardStatus;
};

export enum BestPracticeStatus {
  Accepted = 'accepted',
  Drafted = 'drafted',
  New = 'new'
}

export type BestPracticeSummaryArtifact = {
  __typename?: 'BestPracticeSummaryArtifact';
  /** The download url for the best practice summary artifact */
  downloadUrl: Scalars['String'];
  /** The download url for the best practice summary artifact */
  dto: Scalars['String'];
  /** The best practice summary rendered as HTML */
  html: Scalars['String'];
  /** The id of the best practice summary artifact */
  id: Scalars['String'];
  /** The status of the best practice summary artifact */
  status: BestPracticeStatus;
  /** The title of the best practice summary artifact */
  title: Scalars['String'];
};

/** Billing feature */
export enum BillingFeature {
  Addon = 'ADDON',
  Plan = 'PLAN',
  Setup = 'SETUP'
}

export type BillingInfo = {
  __typename?: 'BillingInfo';
  addonSubscriptions: Array<SubscriptionModel>;
  coreSubscription?: Maybe<CoreSubscriptionModel>;
  id: Scalars['ID'];
  pause: Paused;
  paymentMethods: Array<BillingPaymentMethod>;
};

export type BillingPaymentMethod = {
  __typename?: 'BillingPaymentMethod';
  default: Scalars['Boolean'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  issueReason?: Maybe<PaymentMethodIssueReason>;
  name: Scalars['String'];
  nextAction?: Maybe<PaymentMethodNextAction>;
  status: PaymentMethodStatus;
  type: PaymentMethodType;
};

/** Billing Period */
export enum BillingPeriod {
  HalfYear = 'HALF_YEAR',
  Month = 'MONTH',
  NineMonths = 'NINE_MONTHS',
  Quarter = 'QUARTER',
  ThreeYears = 'THREE_YEARS',
  TwoYears = 'TWO_YEARS',
  Year = 'YEAR'
}

export type BoolNullableFilter = {
  equals?: Maybe<Scalars['Boolean']>;
};

export type BulkActivationResult = {
  __typename?: 'BulkActivationResult';
  activations?: Maybe<Array<Maybe<CoreActivation>>>;
  errors?: Maybe<Array<Maybe<BulkActivationResultError>>>;
};

export type BulkActivationResultError = {
  __typename?: 'BulkActivationResultError';
  companyId: Scalars['String'];
  key: Scalars['String'];
  message: Scalars['String'];
};

export type BulkCompleteEnrollmentInput = {
  doceboCourseIds: Array<Scalars['Float']>;
  userIds: Array<Scalars['String']>;
};

export type BulkEarningsImportErrors = {
  __typename?: 'BulkEarningsImportErrors';
  errorMsg: Scalars['String'];
  staffId: Scalars['ID'];
};

export type BulkEarningsImportInput = {
  /** Bambee payroll id */
  payrollId: Scalars['ID'];
  /** FlatfileResults JSON */
  results: Scalars['JSON'];
};

export type BulkEarningsImportResult = {
  __typename?: 'BulkEarningsImportResult';
  errors: Array<Maybe<BulkEarningsImportErrors>>;
  payroll: Payroll;
  successfulStaffIds: Array<Maybe<Scalars['ID']>>;
};

export type BulkEnrollUsersInput = {
  companyId: Scalars['String'];
  enrollments: Array<EnrollmentInput>;
};

export type BulkEnrollUsersResponse = {
  __typename?: 'BulkEnrollUsersResponse';
  enrolledUsers: Array<EnrollUsersResponse>;
  errors: Array<EnrollUsersError>;
};

export type BulkMessageStaff = {
  active?: Maybe<Scalars['Boolean']>;
  signatureRequired?: Maybe<Scalars['Boolean']>;
  staffId: Scalars['ID'];
  status?: Maybe<StaffStatus>;
};

export type BulkMessageStaffError = {
  __typename?: 'BulkMessageStaffError';
  errorMsg: Scalars['String'];
  staffId: Scalars['ID'];
};

export type BulkMessageStaffInput = {
  messageBody: Scalars['String'];
  messageGroupType: MessageGroupType;
  messageType: MessageType;
  pageSource?: Maybe<Scalars['String']>;
  staff: Array<BulkMessageStaff>;
  textMessage?: Maybe<Scalars['Boolean']>;
};

export type BulkMessageStaffResult = {
  __typename?: 'BulkMessageStaffResult';
  errors: Array<Maybe<BulkMessageStaffError>>;
  successfulStaffIds: Array<Maybe<Scalars['ID']>>;
};

export type BulkPurchaseSeatsInput = {
  purchases: Array<Maybe<PurchaseSeatsInput>>;
};

export type BulkRequestResult = {
  __typename?: 'BulkRequestResult';
  errors?: Maybe<Array<Maybe<BulkRequestResultError>>>;
  requests?: Maybe<Array<Maybe<CoreRequest>>>;
};

export type BulkRequestResultError = {
  __typename?: 'BulkRequestResultError';
  message: Scalars['String'];
  requestId: Scalars['String'];
};

export type BulkSetupStaffInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
  /** IDs of Bambee staff (w2/1099) to be setup for payroll */
  ids: Array<Maybe<Scalars['ID']>>;
};

export type BulkUploadEmployeesResponse = {
  __typename?: 'BulkUploadEmployeesResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Scalars['String']>;
};

export type BundleResponse = {
  __typename?: 'BundleResponse';
  annualStripePriceId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  global: Scalars['Boolean'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  singleStripePriceId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  topics: Array<Maybe<CourseTopic>>;
  updatedAt: Scalars['DateTime'];
};

export type BusinessManager = {
  __typename?: 'BusinessManager';
  lastAssignedOn?: Maybe<Scalars['DateTime']>;
  tier: Scalars['Int'];
  user: CoreUser;
};

export type BusinessManagerForTierInput = {
  tier: Scalars['Int'];
  userId: Scalars['ID'];
};

export type Cadence = {
  __typename?: 'Cadence';
  value: Scalars['String'];
};

export type Calendly = {
  __typename?: 'Calendly';
  url: Scalars['String'];
};

export type CallAgent = {
  __typename?: 'CallAgent';
  avatarUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CallInformation = {
  /** The reason for requesting a new call */
  reasonForCall: Scalars['String'];
};

export type CallSummary = {
  __typename?: 'CallSummary';
  actionItems?: Maybe<Scalars['String']>;
  agent?: Maybe<CallAgent>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  callDurationInMinutes?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  followUps?: Maybe<Scalars['String']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isBambeeLiteCall: Scalars['Boolean'];
  summary?: Maybe<Scalars['String']>;
};

export type CancelPayrollInput = {
  companyId: Scalars['String'];
  currentUserId: Scalars['String'];
  keepTimeAttendance: Scalars['Boolean'];
};

export type CancelRecommendationInput = {
  /** The id of the recommendation to be canceled. */
  recommendationId: Scalars['String'];
};

export type CancelScheduledEventInput = {
  /** Scheduled Event ID */
  scheduledEventId: Scalars['String'];
};

export type CancelSubscriptionInput = {
  companyId: Scalars['String'];
  consumptionDescription: Scalars['String'];
  consumptionReason: ProductCreditConsumptionReason;
  productKey: ProductKey;
};

export type CancelTimeAttendanceInput = {
  companyId: Scalars['String'];
  currentUserId: Scalars['String'];
};

export type CancellationModel = {
  __typename?: 'CancellationModel';
  /** A note from the client */
  clientReasonNote: Scalars['String'];
  /** User who requested the cancellation */
  closedBy?: Maybe<Scalars['String']>;
  /** When was the cancellation closed */
  closedDate?: Maybe<Scalars['String']>;
  /** A final note when the cancellation request is closed by either confirming or rescueing it */
  closingNote: Scalars['String'];
  /** User who created the cancellation */
  createdBy: Scalars['String'];
  /** When was the cancellation created */
  createdDate: Scalars['String'];
  /** Numbers of months credited upon reinstatement */
  creditMonths: Scalars['Float'];
  /** If cancellation is confirmed, when is the subscription's effective last day */
  effectiveDate: Scalars['String'];
  /** Unique identifier for the cancellation */
  id: Scalars['String'];
  /** An internal note made by a Bambee user */
  internalReasonNote: Scalars['String'];
  /** Flag stating if company was in trial when cancellation was requested */
  isTrialCancellation: Scalars['Boolean'];
  netAmount: Scalars['Float'];
  /** List of reason codes specified by the user */
  reasonCodes: Array<Scalars['Float']>;
  rebuttalReasonCode: Scalars['String'];
  /** amount to be refunded */
  refundAmount: Scalars['Float'];
  /** Amount to be charged upon reinstatement */
  reinstatementAmount: Scalars['Float'];
  /** User who requested the cancellation, usually the company owner */
  requestedBy: Scalars['String'];
  /** When was the cancellation requested */
  requestedDate: Scalars['String'];
  /** The status of the cancellation */
  source: CancellationSource;
  /** The status of the cancellation */
  status: CancellationStatus;
};

export type CancellationOffersModel = {
  __typename?: 'CancellationOffersModel';
  /** The downgrade plan available for the customer */
  downgradePlan?: Maybe<CorePlanModel>;
  /** The downgrade plans available for the customer */
  downgradePlans: Array<CorePlanModel>;
  /** The downgrade plan available for the customer */
  pausePlan?: Maybe<CorePlanModel>;
  /** The downgrade plan available for the customer */
  storagePlan?: Maybe<CorePlanModel>;
  /** Flag indicating if the customer can extend their trial */
  trialExtension: Scalars['Boolean'];
};

export type CancellationReasonGroupModel = {
  __typename?: 'CancellationReasonGroupModel';
  /** Identifier for the cancellation reason group */
  code: Scalars['String'];
  /** Text to be displayed in UI */
  externalText: Scalars['String'];
  /** List of cancellation reasons for the group */
  reasons: Array<CancellationReasonModel>;
};

export type CancellationReasonModel = {
  __typename?: 'CancellationReasonModel';
  /** Flag indicating whether or the reason is active */
  active: Scalars['Boolean'];
  /** Identifier for the cancellation reason */
  code: Scalars['Float'];
  /** Text to be displayed in UI */
  externalText: Scalars['String'];
  /** Flag indicating if reason should be displayed only to Bambee users in Honey */
  internalOnly: Scalars['Boolean'];
};

export enum CancellationSource {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Internal = 'INTERNAL',
  None = 'NONE',
  Phone = 'PHONE',
  Stripe = 'STRIPE',
  Web = 'WEB'
}

export enum CancellationStatus {
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rescued = 'RESCUED'
}

export enum CardVerificationStatus {
  Fail = 'FAIL',
  Pass = 'PASS',
  Unknown = 'UNKNOWN'
}

export enum CaseStage {
  Approved = 'APPROVED',
  AuditHrCompliance = 'AUDIT_HR_COMPLIANCE',
  Bambeedispute = 'BAMBEEDISPUTE',
  Bambeerefundapproved = 'BAMBEEREFUNDAPPROVED',
  Bambeerefunddeclined = 'BAMBEEREFUNDDECLINED',
  Bambeerefundprocessed = 'BAMBEEREFUNDPROCESSED',
  Bambeerefundsubmitted = 'BAMBEEREFUNDSUBMITTED',
  BambeePayrollActivationInProgress = 'BAMBEE_PAYROLL_ACTIVATION_IN_PROGRESS',
  BambeePlusSetupInProgress = 'BAMBEE_PLUS_SETUP_IN_PROGRESS',
  BuildEmployeeOnboardingKit = 'BUILD_EMPLOYEE_ONBOARDING_KIT',
  FirstPayrollPaid = 'FIRST_PAYROLL_PAID',
  FirstPayrollPendingPay = 'FIRST_PAYROLL_PENDING_PAY',
  ImproveStaffCommunication = 'IMPROVE_STAFF_COMMUNICATION',
  IntroduceStaffToBambee = 'INTRODUCE_STAFF_TO_BAMBEE',
  MeetYourTeam = 'MEET_YOUR_TEAM',
  OnboardingComplete = 'ONBOARDING_COMPLETE',
  PendingApproval = 'PENDING_APPROVAL',
  ReadyToRunFirstPayroll = 'READY_TO_RUN_FIRST_PAYROLL',
  Reminder = 'REMINDER',
  Requested = 'REQUESTED',
  Revision = 'REVISION',
  Withdrawn = 'WITHDRAWN'
}

export enum CaseStatus {
  Backedout = 'BACKEDOUT',
  Blocked = 'BLOCKED',
  Blockedcheck = 'BLOCKEDCHECK',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Closederror = 'CLOSEDERROR',
  Closedinactive = 'CLOSEDINACTIVE',
  Confirmresolution = 'CONFIRMRESOLUTION',
  Contacting = 'CONTACTING',
  Customerreplied = 'CUSTOMERREPLIED',
  DoItMyself = 'DO_IT_MYSELF',
  Escalated = 'ESCALATED',
  InProgress = 'IN_PROGRESS',
  Merged = 'MERGED',
  Negotiationreview = 'NEGOTIATIONREVIEW',
  New = 'NEW',
  NewActionPlan = 'NEW_ACTION_PLAN',
  Onhold = 'ONHOLD',
  Pendingsummary = 'PENDINGSUMMARY',
  Reopened = 'REOPENED',
  ResponseReceived = 'RESPONSE_RECEIVED',
  Saved = 'SAVED',
  Selfservice = 'SELFSERVICE',
  Summaryreview = 'SUMMARYREVIEW',
  WithCustomer = 'WITH_CUSTOMER',
  Wontdo = 'WONTDO'
}

export enum CaseSubType {
  Actionplan = 'ACTIONPLAN',
  Adaaccommodation = 'ADAACCOMMODATION',
  Adjustapprovedpayroll = 'ADJUSTAPPROVEDPAYROLL',
  Apphelp = 'APPHELP',
  Bambeeplusinitial = 'BAMBEEPLUSINITIAL',
  Bambeeplusofferquestion = 'BAMBEEPLUSOFFERQUESTION',
  BenefitsCancelation = 'BENEFITS_CANCELATION',
  Billingissue = 'BILLINGISSUE',
  Bonuscommission = 'BONUSCOMMISSION',
  Cabinet = 'CABINET',
  Callcoverage = 'CALLCOVERAGE',
  Callrequest = 'CALLREQUEST',
  Cap = 'CAP',
  Check = 'CHECK',
  Checkembeddedsetup = 'CHECKEMBEDDEDSETUP',
  Checkfundingfailed = 'CHECKFUNDINGFAILED',
  Checkimplementation = 'CHECKIMPLEMENTATION',
  Checkkyb = 'CHECKKYB',
  CheckIn = 'CHECK_IN',
  Companyonboarding = 'COMPANYONBOARDING',
  Completeonboarding = 'COMPLETEONBOARDING',
  CoreHrCancelation = 'CORE_HR_CANCELATION',
  Customerfeedback = 'CUSTOMERFEEDBACK',
  Delinquent = 'DELINQUENT',
  Detractor = 'DETRACTOR',
  Employeebenefits = 'EMPLOYEEBENEFITS',
  Employeechat = 'EMPLOYEECHAT',
  Employeeonboarding = 'EMPLOYEEONBOARDING',
  Employeeonboardingrequested = 'EMPLOYEEONBOARDINGREQUESTED',
  Employeerequest = 'EMPLOYEEREQUEST',
  Employeeresignationstarted = 'EMPLOYEERESIGNATIONSTARTED',
  Employeevoices = 'EMPLOYEEVOICES',
  Endemploymentemergency = 'ENDEMPLOYMENTEMERGENCY',
  Event = 'EVENT',
  Existingpolicyrevision = 'EXISTINGPOLICYREVISION',
  FederalEinValidation = 'FEDERAL_EIN_VALIDATION',
  Finalpay = 'FINALPAY',
  Firingtermination = 'FIRINGTERMINATION',
  FollowUp = 'FOLLOW_UP',
  General = 'GENERAL',
  Golive = 'GOLIVE',
  Hrmreasignment = 'HRMREASIGNMENT',
  Hrpractice = 'HRPRACTICE',
  Hrpractices = 'HRPRACTICES',
  Hrteamissue = 'HRTEAMISSUE',
  HrEscalation = 'HR_ESCALATION',
  HrReassignment = 'HR_REASSIGNMENT',
  I9Employmenteligibilityform = 'I9EMPLOYMENTELIGIBILITYFORM',
  Inapptraining = 'INAPPTRAINING',
  Incident = 'INCIDENT',
  Incorrectbilling = 'INCORRECTBILLING',
  Initialhrrequest = 'INITIALHRREQUEST',
  Initialonboarding = 'INITIALONBOARDING',
  Introcall = 'INTROCALL',
  Invoicereceipt = 'INVOICERECEIPT',
  Jd = 'JD',
  Jobdescription = 'JOBDESCRIPTION',
  Keyaccountsemployeeonboarding = 'KEYACCOUNTSEMPLOYEEONBOARDING',
  Latecancellationprocessing = 'LATECANCELLATIONPROCESSING',
  Layoff = 'LAYOFF',
  Leaveabsence = 'LEAVEABSENCE',
  Loginaccess = 'LOGINACCESS',
  Managedservicesbriefcorrectiveaction = 'MANAGEDSERVICESBRIEFCORRECTIVEACTION',
  Managedservicesbrieftermination = 'MANAGEDSERVICESBRIEFTERMINATION',
  Managedservicesother = 'MANAGEDSERVICESOTHER',
  Missedpayroll = 'MISSEDPAYROLL',
  Missingemployees = 'MISSINGEMPLOYEES',
  Newcustompolicy = 'NEWCUSTOMPOLICY',
  Newpolicy = 'NEWPOLICY',
  Other = 'OTHER',
  Otherissue = 'OTHERISSUE',
  Payment = 'PAYMENT',
  Paymentmethodchange = 'PAYMENTMETHODCHANGE',
  Payroll = 'PAYROLL',
  Payrollpreactivation = 'PAYROLLPREACTIVATION',
  Payrollsupport = 'PAYROLLSUPPORT',
  PayrollCancelation = 'PAYROLL_CANCELATION',
  Pip = 'PIP',
  Pipcap = 'PIPCAP',
  Planchange = 'PLANCHANGE',
  Policies = 'POLICIES',
  Policyreview = 'POLICYREVIEW',
  Policyrevision = 'POLICYREVISION',
  Poorservice = 'POORSERVICE',
  Precancelation = 'PRECANCELATION',
  Preemployment = 'PREEMPLOYMENT',
  Productortechissues = 'PRODUCTORTECHISSUES',
  Pto = 'PTO',
  Ptomigration = 'PTOMIGRATION',
  Qbr = 'QBR',
  Refundcredit = 'REFUNDCREDIT',
  Reportcards = 'REPORTCARDS',
  Resignation = 'RESIGNATION',
  Retentionsave = 'RETENTIONSAVE',
  Salesmisalignment = 'SALESMISALIGNMENT',
  Seasonalhraudit = 'SEASONALHRAUDIT',
  Settingupbambeepayroll = 'SETTINGUPBAMBEEPAYROLL',
  Sickleave = 'SICKLEAVE',
  Staffcomplaint = 'STAFFCOMPLAINT',
  Subscriptionchange = 'SUBSCRIPTIONCHANGE',
  Subscriptionplanquestions = 'SUBSCRIPTIONPLANQUESTIONS',
  Taxamendment = 'TAXAMENDMENT',
  Taxquestion = 'TAXQUESTION',
  TaCancelation = 'TA_CANCELATION',
  Technologyissue = 'TECHNOLOGYISSUE',
  Terminationrequest = 'TERMINATIONREQUEST',
  Timeandattendancedisqualified = 'TIMEANDATTENDANCEDISQUALIFIED',
  Timeandattendancepurchased = 'TIMEANDATTENDANCEPURCHASED',
  Training = 'TRAINING',
  TrainingCancelation = 'TRAINING_CANCELATION',
  Triage = 'TRIAGE',
  Unemploymentclaims = 'UNEMPLOYMENTCLAIMS',
  Userpermissions = 'USERPERMISSIONS',
  Voicemailmissedcalls = 'VOICEMAILMISSEDCALLS',
  Wagehour = 'WAGEHOUR',
  Workerscompensation = 'WORKERSCOMPENSATION',
  Workplaceposting = 'WORKPLACEPOSTING',
  Workplaceviolenceprevention = 'WORKPLACEVIOLENCEPREVENTION',
  Ytdreporting = 'YTDREPORTING',
  '3Rdpartytraining' = '_3RDPARTYTRAINING'
}

export enum CaseType {
  Adminsupport = 'ADMINSUPPORT',
  Bambeepayroll = 'BAMBEEPAYROLL',
  BusinessManagement = 'BUSINESS_MANAGEMENT',
  Cancellationrequest = 'CANCELLATIONREQUEST',
  Compensationbenefits = 'COMPENSATIONBENEFITS',
  Customeractivation = 'CUSTOMERACTIVATION',
  Emailautoresponder = 'EMAILAUTORESPONDER',
  Employeefeedback = 'EMPLOYEEFEEDBACK',
  Employeerelations = 'EMPLOYEERELATIONS',
  Endingemployment = 'ENDINGEMPLOYMENT',
  Generalrequest = 'GENERALREQUEST',
  Guidance = 'GUIDANCE',
  Hiringonboarding = 'HIRINGONBOARDING',
  Hrmsupport = 'HRMSUPPORT',
  Implementation = 'IMPLEMENTATION',
  Implementationplan = 'IMPLEMENTATIONPLAN',
  Issuereporting = 'ISSUEREPORTING',
  Laborlaws = 'LABORLAWS',
  Legacy = 'LEGACY',
  Payrollonboarding = 'PAYROLLONBOARDING',
  Payrollsupport = 'PAYROLLSUPPORT',
  Performancemanagement = 'PERFORMANCEMANAGEMENT',
  Policies = 'POLICIES',
  Policyrequest = 'POLICYREQUEST',
  Service = 'SERVICE',
  Techsupport = 'TECHSUPPORT',
  Terminationrequest = 'TERMINATIONREQUEST',
  Trainingdevelopment = 'TRAININGDEVELOPMENT',
  Trainingenrollment = 'TRAININGENROLLMENT',
  Typebilling = 'TYPEBILLING',
  Unknownrequest = 'UNKNOWNREQUEST'
}

export type ChangeTrialEndDateForCoreSubscriptionInput = {
  companyId: Scalars['String'];
  trialEndDate: Scalars['DateTime'];
};

export type ChannelPartipants = {
  __typename?: 'ChannelPartipants';
  user: CoreUser;
};

export enum ChannelType {
  /** A channel representing a group of employees at a company. */
  Group = 'Group',
  /** A channel representing a one-on-one conversation at a company. */
  OneOnOne = 'OneOnOne'
}

export type ChatArtifact = {
  __typename?: 'ChatArtifact';
  /** The action plan that was generated */
  actionPlan?: Maybe<ActionPlanArtifact>;
  /** Information on the base template used to generate the artifact */
  baseTemplate?: Maybe<BaseTemplateDto>;
  /** The best practice summary that was generated */
  bestPracticeSummary?: Maybe<BestPracticeSummaryArtifact>;
  /** A company role that was added to the company */
  companyRole?: Maybe<CompanyRoleArtifact>;
  /** The comprehensive guidance that was generated */
  comprehensiveGuidance?: Maybe<ComprehensiveGuidanceArtifact>;
  /** The corrective action that was generated */
  correctiveAction?: Maybe<CorrectiveActionArtifact>;
  /** The document that was generated */
  document?: Maybe<DocumentArtifact>;
  /** The result of the guard */
  guard?: Maybe<GuardArtifact>;
  /** The hr practices artifact that was generated */
  hrPractices?: Maybe<HrPracticesArtifact>;
  /** The implementation plan that was generated */
  implementationPlan?: Maybe<ImplementationPlanArtifact>;
  /** The incident that was generated */
  incident?: Maybe<IncidentArtifact>;
  /** The job description that was generated */
  jobDescription?: Maybe<JobDescriptionArtifact>;
  /** The policy that was generated */
  policy?: Maybe<PolicyArtifact>;
  /** The intake summary that was generated */
  summary?: Maybe<SummaryArtifact>;
};

/** The role of the prompt */
export enum ChatCompletionRole {
  Assistant = 'assistant',
  Developer = 'developer',
  Function = 'function',
  System = 'system',
  Tool = 'tool',
  User = 'user'
}

export type ChatMessageInterface = {
  channelId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isThreadMessage: Scalars['Boolean'];
  isThreadParent: Scalars['Boolean'];
  rawType: SendbirdMessageType;
  /** Recipieint, if a one-on-one message */
  recipient?: Maybe<CoreUser>;
  sender: CoreUser;
  threadParentId?: Maybe<Scalars['ID']>;
  type: ChatMessageTypeEnum;
};

/** The message type as applicable to Bambee Chat */
export enum ChatMessageTypeEnum {
  /** This message represents a customized feedback item, containing a feedback value. */
  Feedback = 'Feedback',
  /** This message is just simple text and does not to be decoded or enriched. */
  Text = 'Text'
}

export type ChatTopicSuggestion = {
  __typename?: 'ChatTopicSuggestion';
  /** A list of CoreUsers that a suggested topic could be sent to. */
  recipients: Array<CoreUser>;
  type: Scalars['String'];
};

export type CheckCompanyImplementation = {
  __typename?: 'CheckCompanyImplementation';
  id: Scalars['ID'];
  remainingSteps?: Maybe<CheckCompanyImplementationSteps>;
  status: Scalars['String'];
};

export type CheckCompanyImplementationSteps = {
  __typename?: 'CheckCompanyImplementationSteps';
  kyb: CheckCompanyKyb;
};

export type CheckCompanyKyb = {
  __typename?: 'CheckCompanyKYB';
  status: Scalars['String'];
};

export type CheckCompanyOnboarding = {
  __typename?: 'CheckCompanyOnboarding';
  bankAccount?: Maybe<Array<Maybe<BankAccountSteps>>>;
  blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>;
  filingAuthorization?: Maybe<Array<Maybe<IdNamePair>>>;
  id: Scalars['ID'];
  remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>;
  setupParameters?: Maybe<Array<Maybe<IdNamePair>>>;
  status: CheckOnboardSteps;
};

export enum CheckCompanyOnboardingSteps {
  BankAccount = 'BANK_ACCOUNT',
  FilingAuthorization = 'FILING_AUTHORIZATION',
  SetupParameters = 'SETUP_PARAMETERS'
}

export enum CheckComponent {
  CompanyAccountingIntegration = 'CompanyAccountingIntegration',
  CompanyAuthorizationDocuments = 'CompanyAuthorizationDocuments',
  CompanyDetails = 'CompanyDetails',
  CompanyEmployeeSetup = 'CompanyEmployeeSetup',
  CompanyFilingAuthorization = 'CompanyFilingAuthorization',
  CompanyOnboard = 'CompanyOnboard',
  CompanyPaymentSetup = 'CompanyPaymentSetup',
  CompanyReports = 'CompanyReports',
  CompanyTaxDocuments = 'CompanyTaxDocuments',
  CompanyTaxSetup = 'CompanyTaxSetup',
  CompanyTermsOfService = 'CompanyTermsOfService',
  ContractorOnboard = 'ContractorOnboard',
  ContractorTaxDocuments = 'ContractorTaxDocuments',
  EmployeeBenefits = 'EmployeeBenefits',
  EmployeeOnboard = 'EmployeeOnboard',
  EmployeePaymentSetup = 'EmployeePaymentSetup',
  EmployeePaystubs = 'EmployeePaystubs',
  EmployeePostTaxDeductions = 'EmployeePostTaxDeductions',
  EmployeeProfile = 'EmployeeProfile',
  EmployeeSsnSetup = 'EmployeeSSNSetup',
  EmployeeTaxDocuments = 'EmployeeTaxDocuments',
  EmployeeWithholdingsSetup = 'EmployeeWithholdingsSetup',
  PreviousProviderAccess = 'PreviousProviderAccess',
  RunPayroll = 'RunPayroll'
}

export type CheckComponentInput = {
  /** The contractor id to generate a link for */
  companyId?: Maybe<Scalars['String']>;
  /** The component to generate a link for */
  component: CheckComponent;
  /** The contractor id to generate a link for */
  contractorId?: Maybe<Scalars['String']>;
  /** Email of the signatory; Required for CompanyOnboard component */
  email?: Maybe<Scalars['String']>;
  /** The employee id to generate a link for */
  employeeId?: Maybe<Scalars['String']>;
  /** Name of the signatory; Required for CompanyOnboard component */
  signerName?: Maybe<Scalars['String']>;
  /** Title of the signatory; Required for CompanyOnboard component */
  signerTitle?: Maybe<Scalars['String']>;
};

export type CheckComponentLink = {
  __typename?: 'CheckComponentLink';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type CheckContractorOnboarding = {
  __typename?: 'CheckContractorOnboarding';
  blockingSteps: Array<Maybe<ContractorOnboardingSteps>>;
  ein?: Maybe<Array<Maybe<EinSteps>>>;
  id: Scalars['ID'];
  paymentMethod?: Maybe<Array<Maybe<PaymentMethodSteps>>>;
  remainingSteps: Array<Maybe<ContractorOnboardingSteps>>;
  ssn?: Maybe<Array<Maybe<SsnSteps>>>;
  status: OnboardStatus;
  type?: Maybe<Array<Maybe<TypeSteps>>>;
};

export type CheckEmployeeOnboarding = {
  __typename?: 'CheckEmployeeOnboarding';
  blockingSteps: Array<EmployeeOnboardingSteps>;
  companyDefinedAttributes?: Maybe<Array<Maybe<IdNamePair>>>;
  id: Scalars['ID'];
  paymentMethod?: Maybe<Array<Maybe<PaymentMethodSteps>>>;
  remainingSteps: Array<EmployeeOnboardingSteps>;
  ssn?: Maybe<Array<Maybe<SsnSteps>>>;
  status: OnboardStatus;
  withholdings?: Maybe<Array<Maybe<IdNamePair>>>;
};

export type CheckFeinVerification = {
  __typename?: 'CheckFEINVerification';
  company: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  federalEin: Scalars['String'];
  id: Scalars['ID'];
  legalName: Scalars['String'];
  startTime: Scalars['String'];
  status: Scalars['String'];
};

export type CheckIntegration = {
  __typename?: 'CheckIntegration';
  active: Scalars['Boolean'];
  autoSync: Scalars['Boolean'];
  id: Scalars['ID'];
  qboCompanyId: Scalars['ID'];
};

export enum CheckOnboardSteps {
  Blocking = 'BLOCKING',
  Completed = 'COMPLETED',
  NeedsAttention = 'NEEDS_ATTENTION'
}

export type CheckSyncCompaniesInput = {
  correctData: Scalars['Boolean'];
};

export type CheckSyncCompanyData = {
  __typename?: 'CheckSyncCompanyData';
  onboard?: Maybe<Scalars['String']>;
  processingPeriod?: Maybe<ProcessingPeriod>;
};

export type CheckSyncCompanyFanoutResponse = {
  __typename?: 'CheckSyncCompanyFanoutResponse';
  count: Scalars['Float'];
  id: Scalars['ID'];
  ids: Array<Maybe<Scalars['String']>>;
  messages: Array<Maybe<CompanySyncMessage>>;
  queue: Scalars['String'];
};

export type CheckSyncCompanyInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
  correctData: Scalars['Boolean'];
};

export type ClearPayrollsInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
};

export type CloseHrRequestInput = {
  caseId: Scalars['String'];
};

export type Company = {
  __typename?: 'Company';
  authorizationDocuments: Array<Maybe<AuthorizationDocument>>;
  availableProducts: AvailableProducts;
  bankAccounts?: Maybe<Array<Maybe<BankAccount>>>;
  benefitOnboarding?: Maybe<BenefitCompanyOnboarding>;
  boxInfo?: Maybe<CompanyBoxInfo>;
  checkId?: Maybe<Scalars['ID']>;
  checkImplementation?: Maybe<CheckCompanyImplementation>;
  checkIndustry?: Maybe<IndustryType>;
  checkIntegration?: Maybe<CheckIntegration>;
  checkOnboarding?: Maybe<CheckCompanyOnboarding>;
  companyBenefits: Array<Maybe<CompanyBenefit>>;
  companyId?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated; Use companyId instead */
  companyMngId?: Maybe<Scalars['String']>;
  complexPayrollOnboarding?: Maybe<Array<Maybe<ComplexPayrollOnboarding>>>;
  contractors: Array<Maybe<Contractor>>;
  defaultPayScheduleDays?: Maybe<Array<Maybe<DefaultPayScheduleDays>>>;
  /** Has this company established a connection to Deputy */
  deputyConnection?: Maybe<DeputyConnection>;
  /** Timestamp for when company accepted deputy terms of service */
  deputyTosAcceptedAt?: Maybe<Scalars['DateTime']>;
  employees: Array<Maybe<Employee>>;
  excludedStaffIds: Array<Maybe<Scalars['ID']>>;
  feinVerification?: Maybe<CheckFeinVerification>;
  feinVerificationAttempts: Scalars['Int'];
  /** Has this company established a connection to Finch */
  finchConnection?: Maybe<CompanyFinchAccessToken>;
  goals: Array<Goal>;
  hasDraftPayroll: Scalars['Boolean'];
  hasRunPayroll: Scalars['Boolean'];
  hasTraining: Scalars['Boolean'];
  /** Bambee company id */
  id: Scalars['ID'];
  /** Needs pay schedule assistance */
  needsPayScheduleAssistance?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  onboardingGarnishmentsOrDeductions: Array<OnboardingGarnishmentOrDeduction>;
  onboardingGarnishmentsOrDeductionsOther: Scalars['String'];
  onboardingHasComplexScenario?: Maybe<Scalars['Boolean']>;
  onboardingHasComplexTimeAttendanceScenario?: Maybe<Scalars['Boolean']>;
  onboardingHasGarnishmentsOrDeductions?: Maybe<Scalars['Boolean']>;
  onboardingOffersEmployeeBenefits: Scalars['Boolean'];
  /** Past payroll usage ( prior to Bambee ) */
  pastPayrollUsage?: Maybe<PastPayrollUsage>;
  /** Frequency by which the employees get paid. */
  payFrequency: PayFrequency;
  paySchedules: Array<Maybe<PaySchedule>>;
  paydays?: Maybe<Array<Maybe<CompanyPaydays>>>;
  processedPayrollsThisYear: Scalars['Boolean'];
  /** Frequency by which the employees get paid. */
  processingPeriod: ProcessingPeriod;
  purchasedProducts: PurchasedProducts;
  seatsSummary: SeatsSummary;
  signatoryEmail: Scalars['String'];
  signatoryFirstName: Scalars['String'];
  signatoryLastName: Scalars['String'];
  signatoryTitle: Scalars['String'];
  /** Date the company will start using Check as their payroll processor. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Bambee payroll status of the company. */
  status?: Maybe<CompanyStatus>;
  taxDocYears: Array<Scalars['String']>;
  taxDocuments: Array<Maybe<TaxDocument>>;
  taxExemptStatus?: Maybe<TaxExemptStatus>;
  timesheets: Array<Timesheet>;
  topics: Array<CourseTopic>;
  /** version of payroll terms last signed */
  tosVersion?: Maybe<Scalars['String']>;
  /** Total count of employees by category */
  total?: Maybe<Total>;
  users: Array<User>;
  /** Company workplaces */
  workplaces?: Maybe<Array<Workplace>>;
};


export type CompanyComplexPayrollOnboardingArgs = {
  take?: Maybe<Scalars['Float']>;
};


export type CompanyDefaultPayScheduleDaysArgs = {
  input?: Maybe<DefaultPayScheduleDaysInput>;
};


export type CompanySeatsSummaryArgs = {
  data: GetCompanyInput;
};


export type CompanyTaxDocumentsArgs = {
  data?: Maybe<CompanyTaxDocumentsInput>;
};


export type CompanyTimesheetsArgs = {
  filter?: Maybe<TimesheetFilter>;
};

export enum CompanyAdvisorRole {
  AccountCoordinator = 'ACCOUNT_COORDINATOR',
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  BusinessManager = 'BUSINESS_MANAGER',
  HandbookSpecialist = 'HANDBOOK_SPECIALIST',
  HrCoordinator = 'HR_COORDINATOR',
  HrManager = 'HR_MANAGER',
  InsuranceSalesperson = 'INSURANCE_SALESPERSON',
  OnboardingCoordinator = 'ONBOARDING_COORDINATOR',
  OnboardingSpecialist = 'ONBOARDING_SPECIALIST',
  OpsManager = 'OPS_MANAGER',
  PayrollManager = 'PAYROLL_MANAGER'
}

export type CompanyAiProfile = {
  __typename?: 'CompanyAiProfile';
  /** Whether the company has opted in to AI */
  optIn?: Maybe<Scalars['Boolean']>;
};

export type CompanyBenefit = {
  __typename?: 'CompanyBenefit';
  /** The SimplyInsured type the benefit. */
  benefitType: BenefitType;
  /** The SimplyInsured type of cost. */
  costType?: Maybe<CostType>;
  /** If provided, the timestamp the companyBenefit was deleted */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** The timestamp of the company benefit end date */
  effectiveEnd?: Maybe<Scalars['DateTime']>;
  /** The timestamp of the company benefit start date */
  effectiveStart?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** The SimplyInsured name of the benefit. */
  name: Scalars['String'];
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
};

export enum CompanyBenefitOnboardStatus {
  BorCompleted = 'BOR_COMPLETED',
  BorSubmitted = 'BOR_SUBMITTED',
  Completed = 'COMPLETED',
  CoverageStartDateAtChanged = 'COVERAGE_START_DATE_AT_CHANGED',
  DocumentsUploaded = 'DOCUMENTS_UPLOADED',
  Enrolling = 'ENROLLING',
  FinishedEmployeeEnrollment = 'FINISHED_EMPLOYEE_ENROLLMENT',
  IframeLoaded = 'IFRAME_LOADED',
  PendingEmployeeEnrollment = 'PENDING_EMPLOYEE_ENROLLMENT',
  Submitted = 'SUBMITTED'
}

export type CompanyBoxInfo = {
  __typename?: 'CompanyBoxInfo';
  /** Folder ID to use when uploading to Box. */
  boxFolderId?: Maybe<Scalars['String']>;
  /** Token to use when uploading to Box. */
  token?: Maybe<Scalars['String']>;
};

export type CompanyChannel = {
  __typename?: 'CompanyChannel';
  channelUrl: Scalars['ID'];
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastMessage?: Maybe<ChatMessageInterface>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  messages: Array<ChatMessageInterface>;
  participants: Array<ChannelPartipants>;
  type: ChannelType;
  unreadMentionCount?: Maybe<Scalars['Int']>;
  unreadMessageCount?: Maybe<Scalars['Int']>;
};

export type CompanyCourseTopic = {
  __typename?: 'CompanyCourseTopic';
  enrollments: Array<CompanyTopicEnrollments>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompanyDelinquency = {
  __typename?: 'CompanyDelinquency';
  defaultCardVerificationStatus: CardVerificationStatus;
  delinquent: Scalars['Boolean'];
  delinquentAmount: Scalars['Float'];
  delinquentServices?: Maybe<Array<ServiceKey>>;
  /** The date customer was expected to pay the Core subscription */
  delinquentSince?: Maybe<Scalars['DateTime']>;
  lockout: Scalars['Boolean'];
  /** The original expected payment date for the Core subscription */
  originalPaymentDate?: Maybe<Scalars['DateTime']>;
};

export type CompanyFinchAccessToken = {
  __typename?: 'CompanyFinchAccessToken';
  createdAt: Scalars['DateTime'];
  finchProviderId: Scalars['ID'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type CompanyPaydays = {
  __typename?: 'CompanyPaydays';
  approvalDeadline: Scalars['DateTime'];
  impactedByHoliday: Scalars['Boolean'];
  payday: Scalars['DateTime'];
};

export type CompanyRole = {
  __typename?: 'CompanyRole';
  /** Bambee Core Company Id */
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  /** Date of role deletion */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Bambee Core Company Role id */
  id: Scalars['ID'];
  /** Bambee Core Company Role title */
  title: Scalars['String'];
  workerRoles?: Maybe<Array<WorkerRole>>;
};

export type CompanyRoleArtifact = {
  __typename?: 'CompanyRoleArtifact';
  /** Id of the company role */
  id: Scalars['String'];
  /** Title of the company role  */
  title: Scalars['String'];
};

export type CompanySetting = {
  __typename?: 'CompanySetting';
  companyId: Scalars['String'];
  id: Scalars['Int'];
  key: CompanySettingKey;
  type: SettingType;
  value: Scalars['String'];
};

export enum CompanySettingKey {
  HrPracticeAuditActivated = 'HR_PRACTICE_AUDIT_ACTIVATED',
  HrPracticeAuditCadence = 'HR_PRACTICE_AUDIT_CADENCE',
  HrPracticeDocumentActivated = 'HR_PRACTICE_DOCUMENT_ACTIVATED',
  HrPracticeDocumentFilesUploaded = 'HR_PRACTICE_DOCUMENT_FILES_UPLOADED',
  HrPracticePayrollActivated = 'HR_PRACTICE_PAYROLL_ACTIVATED',
  HrPracticePayrollPurchase = 'HR_PRACTICE_PAYROLL_PURCHASE',
  HrPracticePolicyActivated = 'HR_PRACTICE_POLICY_ACTIVATED',
  HrPracticePolicyCadence = 'HR_PRACTICE_POLICY_CADENCE',
  HrPracticeReportCardActivated = 'HR_PRACTICE_REPORT_CARD_ACTIVATED',
  HrPracticeReportCardCadence = 'HR_PRACTICE_REPORT_CARD_CADENCE',
  HrPracticeTrainingActivated = 'HR_PRACTICE_TRAINING_ACTIVATED',
  HrPracticeTrainingPurchase = 'HR_PRACTICE_TRAINING_PURCHASE',
  HrPracticeVoicesActivated = 'HR_PRACTICE_VOICES_ACTIVATED',
  HrPracticeVoicesCadence = 'HR_PRACTICE_VOICES_CADENCE',
  HrPracticeVoicesManuallyDisabled = 'HR_PRACTICE_VOICES_MANUALLY_DISABLED'
}

export enum CompanyStatus {
  BackedOut = 'BACKED_OUT',
  Cancelled = 'CANCELLED',
  Disqualified = 'DISQUALIFIED',
  Initialized = 'INITIALIZED',
  Live = 'LIVE',
  Provisioned = 'PROVISIONED',
  SetupComplete = 'SETUP_COMPLETE'
}

export type CompanySyncMessage = {
  __typename?: 'CompanySyncMessage';
  body: CompanySyncMessageBody;
  id: Scalars['ID'];
};

export type CompanySyncMessageBody = {
  __typename?: 'CompanySyncMessageBody';
  companyId: Scalars['String'];
  correctData: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type CompanyTaxDocumentsInput = {
  /** Return tax documents for this class */
  documentClass?: Maybe<TaxDocumentClass>;
  /** Return tax documents for this jurisdiction */
  jurisdiction?: Maybe<Jurisdiction>;
  /** Return tax documents for this quarter */
  quarter?: Maybe<Quarter>;
  /** Return tax documents for this year (must be greater than or equal to 2019) */
  year?: Maybe<Scalars['Int']>;
};

export type CompanyTopicEnrollments = {
  __typename?: 'CompanyTopicEnrollments';
  course: CourseEnrollmentDetails;
  user: CoreUser;
};

/** The type of the company */
export enum CompanyType {
  CCorp = 'CCorp',
  Llc = 'LLC',
  NonProfit = 'NonProfit',
  Other = 'Other',
  Partnership = 'Partnership',
  SCorp = 'SCorp',
  SoleProprietorship = 'SoleProprietorship'
}

export enum CompanyV1EmploymentType {
  /** default behavior is all */
  All = 'All',
  /** A 1099 contractor */
  Contractor = 'Contractor',
  /** A W2 employee */
  W2 = 'W2'
}

export type CompleteCompanySurveyInput = {
  companyId: Scalars['String'];
  surveyId: Scalars['Float'];
};

export type CompleteGoalInput = {
  completionStatus: GoalCompletionStatus;
  id: Scalars['String'];
};

export type CompletePracticeInput = {
  companyId: Scalars['String'];
  practiceId: Scalars['String'];
};

/** Complete the Report Card for all employees, pending or not */
export type CompleteReportCardInput = {
  /** Report Card Id */
  reportCardId: Scalars['String'];
};

export type CompleteTaskInput = {
  completionStatus: TaskCompletionStatus;
  id: Scalars['ID'];
};

export enum ComplexActivity {
  AdultEntertainment = 'ADULT_ENTERTAINMENT',
  ArmsDealing = 'ARMS_DEALING',
  CannabisSales = 'CANNABIS_SALES',
  DrugParaphernalia = 'DRUG_PARAPHERNALIA',
  Gambling = 'GAMBLING',
  NoneApply = 'NONE_APPLY',
  SellingHazardousSubstances = 'SELLING_HAZARDOUS_SUBSTANCES',
  UnauthorizedMediaDistribution = 'UNAUTHORIZED_MEDIA_DISTRIBUTION',
  VirtualCurrency = 'VIRTUAL_CURRENCY'
}

export enum ComplexCompanyType {
  DomesticPayroll = 'DOMESTIC_PAYROLL',
  EmployerOfRecord = 'EMPLOYER_OF_RECORD',
  FederalContractor = 'FEDERAL_CONTRACTOR',
  GovernmentEntity = 'GOVERNMENT_ENTITY',
  NevadaFinancialInstitution = 'NEVADA_FINANCIAL_INSTITUTION',
  NoneApply = 'NONE_APPLY',
  NonProfit = 'NON_PROFIT',
  ProfessionalEmployerOrganization = 'PROFESSIONAL_EMPLOYER_ORGANIZATION'
}

export enum ComplexEmployeeType {
  AgriculturalWorkers = 'AGRICULTURAL_WORKERS',
  NoneApply = 'NONE_APPLY',
  NonResidentAliens = 'NON_RESIDENT_ALIENS',
  PieceRateWages = 'PIECE_RATE_WAGES',
  SimpleIra = 'SIMPLE_IRA',
  StateSpecificExemptions = 'STATE_SPECIFIC_EXEMPTIONS',
  TaxWithholdingForContractors = 'TAX_WITHHOLDING_FOR_CONTRACTORS'
}

export enum ComplexFinancialPractice {
  CourtesyWithholding = 'COURTESY_WITHHOLDING',
  NoneApply = 'NONE_APPLY',
  OwnersDraw = 'OWNERS_DRAW'
}

export type ComplexPayrollOnboarding = {
  __typename?: 'ComplexPayrollOnboarding';
  activity: Array<ComplexActivity>;
  companyType: Array<ComplexCompanyType>;
  employeeType: Array<ComplexEmployeeType>;
  financialPractice: Array<ComplexFinancialPractice>;
  id: Scalars['ID'];
  specializedEarningCodes?: Maybe<Scalars['Boolean']>;
  workerCompensationRateReports?: Maybe<Scalars['Boolean']>;
};

export type ComplexPayrollOnboardingInput = {
  activity: Array<ComplexActivity>;
  companyId: Scalars['ID'];
  companyType: Array<ComplexCompanyType>;
  employeeType: Array<ComplexEmployeeType>;
  financialPractice: Array<ComplexFinancialPractice>;
  specializedEarningCodes?: Maybe<Scalars['Boolean']>;
  workerCompensationRateReports?: Maybe<Scalars['Boolean']>;
};

export type ComprehensiveGuidanceArtifact = {
  __typename?: 'ComprehensiveGuidanceArtifact';
  /** The download url for the guidance artifact */
  downloadUrl: Scalars['String'];
  /** The download url for the guidance artifact */
  dto: Scalars['String'];
  /** The guidance rendered as HTML */
  html: Scalars['String'];
  /** The id of the guidance artifact */
  id: Scalars['String'];
  /** The status of the guidance artifact */
  status: BestPracticeStatus;
  /** The title of the guidance artifact */
  title: Scalars['String'];
};

export type ConfirmMicroDepositInput = {
  depositValues?: Maybe<Array<Scalars['Float']>>;
  descriptorCode?: Maybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
};

export type Contractor = {
  __typename?: 'Contractor';
  bankAccounts?: Maybe<Array<Maybe<BankAccount>>>;
  benefitOnboarding?: Maybe<BenefitWorkerOnboarding>;
  checkId?: Maybe<Scalars['ID']>;
  checkOnboarding?: Maybe<CheckContractorOnboarding>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deputyId?: Maybe<Scalars['ID']>;
  /** Bambee contractor id */
  id: Scalars['ID'];
  payRate: Scalars['Float'];
  payType?: Maybe<ContractorPayType>;
  paymentMethodPreference?: Maybe<PaymentMethod>;
  payments: Array<ContractorPayment>;
  profile?: Maybe<EmployeeProfile>;
  /** @deprecated checkOnboarding is a superset */
  remainingOnboardingSteps: Array<ContractorOnboardingSteps>;
  taxDocuments?: Maybe<Array<Maybe<TaxDocument>>>;
  timesheets: Array<Timesheet>;
  user?: Maybe<CoreUser>;
  workplaces: Array<Workplace>;
};


export type ContractorPaymentsArgs = {
  excludeZeroGross?: Maybe<Scalars['Boolean']>;
};


export type ContractorTaxDocumentsArgs = {
  data?: Maybe<ContractorTaxDocumentsInput>;
};


export type ContractorTimesheetsArgs = {
  filter?: Maybe<ContractorTimesheetFilter>;
};

export enum ContractorOnboardingSteps {
  Address = 'ADDRESS',
  Ein = 'EIN',
  PaymentMethod = 'PAYMENT_METHOD',
  Ssn = 'SSN',
  Type = 'TYPE'
}

export enum ContractorPayType {
  Contract = 'CONTRACT',
  Hourly = 'HOURLY',
  Salary = 'SALARY'
}

export type ContractorPayment = {
  __typename?: 'ContractorPayment';
  addedAfterInitialization: Scalars['Boolean'];
  basePayRate: Scalars['Float'];
  /** For accounting. The check number associated with any printed checks. Can be updated even after the associated payroll has been approved. */
  checkNumber?: Maybe<Scalars['String']>;
  contractor: Contractor;
  entries: Array<PaymentEntry>;
  grossPay: Scalars['Float'];
  /** Determines if any worker role has been deleted in this payroll item */
  hasDeletedWorkerRole: Scalars['Boolean'];
  id: Scalars['ID'];
  netPay?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  noteVisible?: Maybe<Scalars['Boolean']>;
  payType: ContractorPayType;
  /** The way the contractor will be paid */
  paymentMethod?: Maybe<PaymentMethod>;
  payroll: Payroll;
  /** Determines if payment entry hours were synced from a timesheet */
  syncedFromDeputy: Scalars['Boolean'];
  timesheetHours?: Maybe<TimesheetAggregate>;
  timesheetHoursByRole?: Maybe<Array<Maybe<TimesheetAggregate>>>;
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
};

export type ContractorPaymentAdvancedWhereInput = {
  /** All conditions passed into this must return true for payrolls returned. */
  AND?: Maybe<Array<ContractorPaymentBaseWhereInput>>;
  /** All conditions passed into this must return false for payrolls returned. */
  NOT?: Maybe<Array<ContractorPaymentBaseWhereInput>>;
  /** One or more conditions passed into this must return true for payrolls returned. */
  OR?: Maybe<Array<ContractorPaymentBaseWhereInput>>;
};

export type ContractorPaymentArgs = {
  advancedWhere?: Maybe<ContractorPaymentAdvancedWhereInput>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ContractorPaymentOrderByInput>;
};

export type ContractorPaymentBaseWhereInput = {
  addedAfterInitialization?: Maybe<BoolNullableFilter>;
  basePayRate?: Maybe<NumberNullableFilter>;
  /** For accounting. The check number associated with any printed checks. Can be updated even after the associated payroll has been approved. */
  checkNumber?: Maybe<StringNullableFilter>;
  contractorId?: Maybe<StringNullableFilter>;
  grossPay?: Maybe<NumberNullableFilter>;
  /** Determines if any worker role has been deleted in this payroll item */
  hasDeletedWorkerRole?: Maybe<BoolNullableFilter>;
  note?: Maybe<StringNullableFilter>;
  noteVisible?: Maybe<BoolNullableFilter>;
  payType?: Maybe<EnumContractorPayTypeFilter>;
  /** The way the contractor will be paid */
  paymentMethod?: Maybe<EnumPaymentMethodFilter>;
  /** Determines if payment entry hours were synced from a timesheet */
  syncedFromDeputy?: Maybe<BoolNullableFilter>;
};

export type ContractorPaymentCheckNumbers = {
  checkNumber: Scalars['String'];
  /** The PayrollItem ID the check number is for. */
  id: Scalars['ID'];
};

export type ContractorPaymentConnection = {
  __typename?: 'ContractorPaymentConnection';
  edges: Array<ContractorPaymentEdge>;
  pageInfo: PageInfo;
};

export type ContractorPaymentEdge = {
  __typename?: 'ContractorPaymentEdge';
  cursor: Scalars['String'];
  node: ContractorPayment;
};

export type ContractorPaymentOrderByInput = {
  direction?: Maybe<OrderByDirection>;
  key: Scalars['String'];
};

export type ContractorPaymentPage = {
  __typename?: 'ContractorPaymentPage';
  /** Reflects the limit argument provided in the query. */
  limit: Scalars['Int'];
  /** Tells if there is a next page of results available. */
  nextPage: Scalars['Boolean'];
  /** Reflects the page argument provided in the query. */
  page: Scalars['Int'];
  /** Tells if there is a previous page of results available. */
  prevPage: Scalars['Boolean'];
  results: Array<ContractorPayment>;
  /** The total number of payrolls in the database or for the company when companyId is provided. */
  totalCount: Scalars['Int'];
};

export type ContractorPaymentSync = {
  __typename?: 'ContractorPaymentSync';
  bambee?: Maybe<Scalars['String']>;
  check?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ContractorSync = {
  __typename?: 'ContractorSync';
  bambee?: Maybe<Scalars['String']>;
  check?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ContractorTaxDocumentsInput = {
  /** Return tax documents for this year (must be greater than or equal to 2019) */
  year?: Maybe<Scalars['Int']>;
};

export type ContractorTimesheetFilter = {
  /** Find approved if true, find unapproved if false, do not filter on approval status if not provided. */
  approved?: Maybe<Scalars['Boolean']>;
  /** Find timesheets for a particular contractor (Deputy Employee Id) */
  contractorId?: Maybe<Scalars['String']>;
  /** Find timesheets for a particular payroll (this will overwrite start/end fields in filter (Bambee Payroll Id) */
  payrollId?: Maybe<Scalars['Int']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inBound: Scalars['Boolean'];
  intercomConversationId: Scalars['String'];
  messages: Array<ConversationMessage>;
  subject: Scalars['String'];
};

export type ConversationHistoryInput = {
  afterId?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  attachments?: Maybe<Array<ConversationMessageAttachment>>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  inBound: Scalars['Boolean'];
};

export type ConversationMessageAttachment = {
  __typename?: 'ConversationMessageAttachment';
  contentType: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type CoreActivation = {
  __typename?: 'CoreActivation';
  /** The company ID this activation belongs to. */
  companyId: Scalars['String'];
  /** The date the activation was created. */
  createdAt: Scalars['DateTime'];
  /** Whether the feature is enabled for this company. */
  enabled: Scalars['Boolean'];
  /** The feature key of the activation. */
  key: Scalars['String'];
  /** The date the activation was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The user ID who last updated this activation. */
  updatedBy: Scalars['String'];
};

export type CoreAddress = {
  __typename?: 'CoreAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreAddressInput = {
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreCompany = {
  __typename?: 'CoreCompany';
  address: CoreAddress;
  ai?: Maybe<CompanyAiProfile>;
  companyRoles?: Maybe<Array<CompanyRole>>;
  countPayroll: Scalars['Float'];
  dba?: Maybe<Scalars['String']>;
  documents: Array<CoreDocument>;
  employees: Array<CoreUser>;
  fein?: Maybe<Scalars['String']>;
  getPayroll?: Maybe<Payroll>;
  getPayrollWithCompanyRoles?: Maybe<Payroll>;
  goals: Array<CoreGoal>;
  groups: Array<CoreUserGroup>;
  handsFreeActionItemActivatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  legalAddress?: Maybe<CoreLegalAddress>;
  listPayroll?: Maybe<PayrollPage>;
  mailingAddress?: Maybe<CoreMailingAddress>;
  name: Scalars['String'];
  numOfContractors?: Maybe<Scalars['Int']>;
  numOfFullTimeHourlyEmployees?: Maybe<Scalars['Int']>;
  numOfFullTimeSalaryEmployees?: Maybe<Scalars['Int']>;
  numOfPartTimeEmployees?: Maybe<Scalars['Int']>;
  onboarding?: Maybe<CoreOnboarding>;
  owner: CoreUser;
  paginatedEmployees: PaginatedCoreUsers;
  payDayOfMonth?: Maybe<Scalars['Int']>;
  payDayOfWeek?: Maybe<Scalars['Int']>;
  payrollCompany?: Maybe<PayrollCompany>;
  phone?: Maybe<Scalars['String']>;
  policies: Array<CorePolicy>;
  tasks: Array<CoreTask>;
  users: Array<CoreUser>;
  website?: Maybe<Scalars['String']>;
  whatBroughtYouToBambee?: Maybe<LeadReason>;
};


export type CoreCompanyCountPayrollArgs = {
  advancedWhere?: Maybe<PayrollAdvancedWhereInput>;
  companyId?: Maybe<Scalars['ID']>;
  companyStatus?: Maybe<CompanyStatus>;
  deletedAt?: Maybe<ListPayrollDeletedOptions>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PayrollOrderByInput>;
  page?: Maybe<Scalars['Int']>;
  where?: Maybe<PayrollWhereInput>;
};


export type CoreCompanyEmployeesArgs = {
  active?: Maybe<Scalars['Boolean']>;
  employmentType?: Maybe<CompanyV1EmploymentType>;
};


export type CoreCompanyGetPayrollArgs = {
  id: Scalars['ID'];
};


export type CoreCompanyGetPayrollWithCompanyRolesArgs = {
  id: Scalars['ID'];
};


export type CoreCompanyListPayrollArgs = {
  advancedWhere?: Maybe<PayrollAdvancedWhereInput>;
  companyId?: Maybe<Scalars['ID']>;
  companyStatus?: Maybe<CompanyStatus>;
  deletedAt?: Maybe<ListPayrollDeletedOptions>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PayrollOrderByInput>;
  page?: Maybe<Scalars['Int']>;
  where?: Maybe<PayrollWhereInput>;
};


export type CoreCompanyOnboardingArgs = {
  args: CoreOnboardingVersion;
};


export type CoreCompanyPaginatedEmployeesArgs = {
  active?: Maybe<Scalars['Boolean']>;
  employmentType?: Maybe<CompanyV1EmploymentType>;
  limit?: Scalars['Float'];
  page?: Scalars['Float'];
};


export type CoreCompanyPoliciesArgs = {
  isCPD?: Maybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
  status?: Array<Scalars['String']>;
};


export type CoreCompanyUsersArgs = {
  active?: Maybe<Scalars['Boolean']>;
  employmentType?: Maybe<CompanyV1EmploymentType>;
};

export type CoreCompanyTraining = {
  __typename?: 'CoreCompanyTraining';
  enrolledTopics?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
};

export enum CoreContractorType {
  Business = 'Business',
  Individual = 'Individual'
}

export type CoreDocument = {
  __typename?: 'CoreDocument';
  id: Scalars['ID'];
  name: Scalars['String'];
  policy?: Maybe<CorePolicy>;
  reaffirmations?: Maybe<Array<Scalars['DateTime']>>;
  signature?: Maybe<CoreDocumentSignature>;
  signer?: Maybe<CoreUser>;
};

export type CoreDocumentSignature = {
  __typename?: 'CoreDocumentSignature';
  id: Scalars['ID'];
  requestedAt: Scalars['DateTime'];
  signedAt: Scalars['DateTime'];
  signer?: Maybe<CoreUser>;
  /** @deprecated In favor of signer CoreUser */
  signerId?: Maybe<Scalars['String']>;
  signingOrder?: Maybe<Scalars['Int']>;
};

export enum CoreEmployeeClassification {
  Exempt = 'Exempt',
  NonExempt = 'NonExempt'
}

export enum CoreEmployeePaytype {
  Contractor = 'Contractor',
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export enum CoreEmployeeType {
  Contractor = 'Contractor',
  FullTime = 'FullTime',
  PartTime = 'PartTime'
}

export type CoreGoal = {
  __typename?: 'CoreGoal';
  assignedTo?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionStatus?: Maybe<GoalCompletionStatus>;
  copy: CoreGoalCopy;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  /** @deprecated Use copy.description instead */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  name: GoalName;
  taskNames: Array<TaskName>;
  tasks: Array<CoreTask>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CoreGoalCopy = {
  __typename?: 'CoreGoalCopy';
  cta: Scalars['String'];
  description: Scalars['String'];
  estimated: Scalars['String'];
};

export type CoreLegalAddress = {
  __typename?: 'CoreLegalAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreLegalAddressInput = {
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreMailingAddress = {
  __typename?: 'CoreMailingAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreMailingAddressInput = {
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreOnboarding = {
  __typename?: 'CoreOnboarding';
  /** Company ID of the user who created the Onboarding */
  companyId?: Maybe<Scalars['String']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime'];
  /** Data for the Onboarding */
  data: CoreOnboardingData;
  /** Unique identifier for the Onboarding */
  id: Scalars['ID'];
  /** Status of the Onboarding */
  status: OnboardingStatus;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime'];
  /** The user who owns the onboarding */
  user: CoreUser;
  /** ID of the user who created the Onboarding */
  userId: Scalars['String'];
  /** The onboarding version */
  version: Scalars['Float'];
};

export type CoreOnboardingData = {
  __typename?: 'CoreOnboardingData';
  /** The company address */
  address?: Maybe<CoreAddress>;
  /** The ID of the call event */
  callEventId?: Maybe<Scalars['String']>;
  /** The legal name of the company */
  companyLegalName?: Maybe<Scalars['String']>;
  /** The name of the company */
  companyName?: Maybe<Scalars['String']>;
  /** The type of company */
  companyType?: Maybe<CompanyType>;
  /** The name of the company */
  discussionTopicDetails?: Maybe<Array<Maybe<DisucssionTopicDetail>>>;
  /** The name of the company */
  discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>;
  /** The company FEIN */
  fein?: Maybe<Scalars['String']>;
  /** The company has remote employees */
  hasRemoteEmployees?: Maybe<Scalars['Boolean']>;
  /** The company has a scheduled call */
  hasScheduledCall?: Maybe<Scalars['Boolean']>;
  /** ID used for apollo caching; e.g. userId from parent object */
  id: Scalars['ID'];
  /** The company is incorporated in another state */
  incorporatedInOtherState?: Maybe<Scalars['Boolean']>;
  /** The state the company is incorporated in */
  incorporatedState?: Maybe<StateAbbreviation>;
  /** The user is the owner of the company */
  isOwner?: Maybe<Scalars['Boolean']>;
  /** The company needs help converting contractors */
  needsHelpConvertingContractors?: Maybe<Scalars['Boolean']>;
  /** The next action for the company */
  nextAction?: Maybe<NextOnboardingAction>;
  /** The company does not have an FEIN or does not know it */
  noFeinOrDoesNotKnow?: Maybe<Scalars['Boolean']>;
  /** The number of contractors in the company */
  numOfContractors?: Maybe<Scalars['Float']>;
  /** The number of employees in the company */
  numOfEmployees?: Maybe<Scalars['Float']>;
  /** The user is the primary contact for the company */
  primaryContact?: Maybe<Scalars['Boolean']>;
  /** The progress the company has made through onboarding */
  progress?: Maybe<Scalars['Float']>;
  /** The states the company has remote workers in */
  remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>;
  /** The company will have additional contacts */
  willHaveAdditionalContact?: Maybe<Scalars['Boolean']>;
};

export type CoreOnboardingDataInput = {
  /** The company address */
  address?: Maybe<CoreAddressInput>;
  /** The ID of the call event */
  callEventId?: Maybe<Scalars['String']>;
  /** The legal name of the company */
  companyLegalName?: Maybe<Scalars['String']>;
  /** The name of the company */
  companyName?: Maybe<Scalars['String']>;
  /** The type of company */
  companyType?: Maybe<CompanyType>;
  /** The name of the company */
  discussionTopicDetails?: Maybe<Array<Maybe<DisucssionTopicDetailInput>>>;
  /** The name of the company */
  discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>;
  /** The company FEIN */
  fein?: Maybe<Scalars['String']>;
  /** The company has remote employees */
  hasRemoteEmployees?: Maybe<Scalars['Boolean']>;
  /** The company has a scheduled call */
  hasScheduledCall?: Maybe<Scalars['Boolean']>;
  /** ID used for apollo caching; e.g. userId from parent object */
  id?: Maybe<Scalars['ID']>;
  /** The company is incorporated in another state */
  incorporatedInOtherState?: Maybe<Scalars['Boolean']>;
  /** The state the company is incorporated in */
  incorporatedState?: Maybe<StateAbbreviation>;
  /** The user is the owner of the company */
  isOwner?: Maybe<Scalars['Boolean']>;
  /** The company needs help converting contractors */
  needsHelpConvertingContractors?: Maybe<Scalars['Boolean']>;
  /** The next action for the company */
  nextAction?: Maybe<NextOnboardingAction>;
  /** The company does not have an FEIN or does not know it */
  noFeinOrDoesNotKnow?: Maybe<Scalars['Boolean']>;
  /** The number of contractors in the company */
  numOfContractors?: Maybe<Scalars['Float']>;
  /** The number of employees in the company */
  numOfEmployees?: Maybe<Scalars['Float']>;
  /** The user is the primary contact for the company */
  primaryContact?: Maybe<Scalars['Boolean']>;
  /** The progress the company has made through onboarding */
  progress?: Maybe<Scalars['Float']>;
  /** The states the company has remote workers in */
  remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>;
  /** The company will have additional contacts */
  willHaveAdditionalContact?: Maybe<Scalars['Boolean']>;
};

export type CoreOnboardingInput = {
  /** Company ID of the user who created the Onboarding */
  companyId?: Maybe<Scalars['String']>;
  /** Data for the Onboarding */
  data: CoreOnboardingDataInput;
  /** Unique identifier for the Onboarding */
  id?: Maybe<Scalars['ID']>;
  /** Status of the Onboarding */
  status: OnboardingStatus;
  /** ID of the user who created the Onboarding */
  userId: Scalars['String'];
  /** The onboarding version */
  version: Scalars['Float'];
};

export type CoreOnboardingKeys = {
  /** ID of the user who created the Onboarding */
  userId: Scalars['String'];
  /** The onboarding version */
  version?: Maybe<Scalars['Float']>;
};

export type CoreOnboardingVersion = {
  /** The onboarding version */
  version: Scalars['Float'];
};

export type CorePageInfo = {
  __typename?: 'CorePageInfo';
  /** Cursor to continue from (null if no more pages) */
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type CorePlanChangeInvoice = {
  __typename?: 'CorePlanChangeInvoice';
  /** Tax amount charged for the invoice */
  tax: Scalars['Float'];
  /** Total amount charged for the invoice */
  total: Scalars['Float'];
};

/** A model representing the core plan details. */
export type CorePlanModel = {
  __typename?: 'CorePlanModel';
  /** Indicates if the plan is annual. */
  annual?: Maybe<Scalars['Boolean']>;
  /** The billing feature of the plan. */
  billingFeature?: Maybe<BillingFeature>;
  /** Billing period for the plan. */
  billingPeriod: BillingPeriod;
  /** Indicates if the plan is chat-only. */
  chatOnly?: Maybe<Scalars['Boolean']>;
  /** Indicates if the plan is configured to collect taxes. */
  collectTax: Scalars['Boolean'];
  /** Contract period for the plan, if applicable. */
  contractPeriod?: Maybe<BillingPeriod>;
  /** DRP (Disaster Recovery Plan) identifier, if applicable. */
  drp?: Maybe<Scalars['String']>;
  /** Mapping of the plan to the size of the employee base. */
  employeeSizeMapping?: Maybe<Scalars['String']>;
  /** Indicates if the plan is for internal use only. */
  internal: Scalars['Boolean'];
  /** Maximum size of the employee base for this plan. */
  maxSize?: Maybe<Scalars['Float']>;
  /** Minimum size of the employee base for this plan. */
  minSize?: Maybe<Scalars['Float']>;
  /** Monthly price of the plan. */
  monthlyPrice: Scalars['Float'];
  /** Name of the plan. */
  name: Scalars['String'];
  /** Partner associated with the plan, if any. */
  partner?: Maybe<Scalars['String']>;
  /** Indicates if the plan can be paused. */
  pause?: Maybe<Scalars['Boolean']>;
  /** Total price of the plan. */
  price: Scalars['Float'];
  /** Price identifier in Stripe. */
  priceId: Scalars['String'];
  /** The product key associated to the plan object (Lite, Dedicated, Plus, Elite). */
  productKey: ProductKey;
  /** Indicates if the plan is regulated. */
  regulated: Scalars['Boolean'];
  /** The service key associated to the plan object (always Core here). */
  serviceKey: ServiceKey;
  /** Initial setup fee for the plan. */
  setupFee?: Maybe<Scalars['Float']>;
  /** Discount on the setup fee, if applicable. */
  setupFeeDiscount?: Maybe<Scalars['Float']>;
  /** Current status of the plan. */
  status: PlanStatuses;
  /** Tier number of the plan. */
  tierNumber?: Maybe<Scalars['Float']>;
  /** Value proposition of the plan. */
  value: Scalars['String'];
  /** Version of the plan. */
  version: Scalars['String'];
  /** Indicates if the plan pricing is based on volume. */
  volumeBased?: Maybe<Scalars['Boolean']>;
};

export type CorePolicy = {
  __typename?: 'CorePolicy';
  /** Timestamp set when a policy is archived */
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  icon: Scalars['String'];
  id: Scalars['ID'];
  isCPD: Scalars['Boolean'];
  isContractor: Scalars['Boolean'];
  name: Scalars['String'];
  notSentTo: Array<CoreUser>;
  recipients: Array<CorePolicyRecipient>;
  status: Scalars['String'];
  step?: Maybe<PolicyStepNames>;
};

export type CorePolicyRecipient = {
  __typename?: 'CorePolicyRecipient';
  document: CoreDocument;
  employee: CoreUser;
  id: Scalars['ID'];
};

export type CoreRecommendation = {
  __typename?: 'CoreRecommendation';
  /** Permitted types of reactions */
  allowedReactions: Array<ReactionType>;
  /** ID of the company for which the recommendation is made */
  companyId?: Maybe<Scalars['String']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime'];
  /** Demographic target of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** Expiration timestamp */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the recommendation */
  id: Scalars['ID'];
  /** Note about the recommendation */
  note?: Maybe<Scalars['String']>;
  /** Roles allowed to react */
  reactorRoles: Array<Scalars['String']>;
  /** Timestamps of recommendation */
  recommendedAt: Array<Scalars['String']>;
  /** ID of the recommended resource */
  resourceId: Scalars['String'];
  /** Type of recommended resource */
  resourceType: Scalars['String'];
  /** The scope of the recommendation */
  scope: RecommendationScope;
  /** Status of the recommendation */
  status: RecommendationStatus;
  /** List of targets for the recommendation */
  targets: Array<Scalars['String']>;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime'];
  user: CoreUser;
  /** ID of the user who created the recommendation */
  userId: Scalars['String'];
};

export type CoreRequest = {
  __typename?: 'CoreRequest';
  /** The number of approvals required to approve the request. */
  approvalCriteria: Scalars['Int'];
  /** The roles of the decision makers. */
  approverRoles?: Maybe<Array<Maybe<AuthRole>>>;
  /** The company id of the employee requesting training. */
  companyId: Scalars['String'];
  /** The date the request was created. */
  createdAt: Scalars['DateTime'];
  decisions?: Maybe<Array<Maybe<CoreRequestDecision>>>;
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The date the request was expired. Null if the request does not expire */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** The id of the request. */
  id: Scalars['ID'];
  /** The number of rejections required to reject the request. */
  rejectionCriteria: Scalars['Int'];
  /** The dates the request was requested at. */
  requestedAt: Array<Scalars['DateTime']>;
  /** The id of the resource. */
  resourceId: Scalars['String'];
  /** The resource type of the request. */
  resourceType: RequestResourceType;
  /** The status of the request. */
  status: RequestStatus;
  /** The date the request was last updated. */
  updatedAt: Scalars['DateTime'];
  user: CoreUser;
  /** The user id of the employee requesting training. */
  userId: Scalars['String'];
};

export type CoreRequestDecision = {
  __typename?: 'CoreRequestDecision';
  /** The date the decision was created. */
  createdAt: Scalars['DateTime'];
  /** The id of the decision. */
  id: Scalars['ID'];
  /** The id of the request. */
  requestId: Scalars['String'];
  /** The result of the decision. */
  result: ApprovalResult;
  /** The role of the decision maker. */
  role: AuthRole;
  /** The date the decision was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The user id of the decision maker. */
  userId: Scalars['String'];
};

export type CoreSubscriptionModel = {
  __typename?: 'CoreSubscriptionModel';
  /** Subscription Status */
  active: Scalars['Boolean'];
  /** True when there is a pending cancellation request */
  cancellationRequested: Scalars['Boolean'];
  /** A scheduled date for when the subscription will be canceled */
  cancelsAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the subscription. */
  id: Scalars['ID'];
  /** Date when the current period will end */
  periodEndsAt: Scalars['DateTime'];
  plan: CorePlanModel;
  /** The quantity of the plan to which the customer is subscribed to. */
  quantity?: Maybe<Scalars['Float']>;
  /** Scheduled plan change, if any. */
  scheduledPlanChange?: Maybe<ScheduledCorePlanChangeModel>;
  /** Date when the subscription trial will end */
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  /** True if they are actively trialing */
  trialing: Scalars['Boolean'];
};

export type CoreTask = {
  __typename?: 'CoreTask';
  assignedTo?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionStatus?: Maybe<TaskCompletionStatus>;
  copy: CoreTaskCopy;
  /** @deprecated Tasks will not have descriptions. */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  name: TaskName;
  startedAt?: Maybe<Scalars['DateTime']>;
  startedBy?: Maybe<Scalars['String']>;
};

export type CoreTaskCopy = {
  __typename?: 'CoreTaskCopy';
  confirmCta?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  denyCta?: Maybe<Scalars['String']>;
  details?: Maybe<Array<CoreTaskCopyDetails>>;
  estimated?: Maybe<Scalars['String']>;
};

export type CoreTaskCopyDetails = {
  __typename?: 'CoreTaskCopyDetails';
  items: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type CoreUser = {
  __typename?: 'CoreUser';
  active: Scalars['Boolean'];
  chat: CoreUserChatConfig;
  company?: Maybe<CoreCompany>;
  contractor?: Maybe<Contractor>;
  createdAt: Scalars['DateTime'];
  documents?: Maybe<Array<CoreDocument>>;
  employee?: Maybe<Employee>;
  employment?: Maybe<CoreUserEmployment>;
  feedback: Array<FeedbackHistory>;
  groups: Array<CoreUserGroup>;
  id: Scalars['ID'];
  permissions?: Maybe<CoreUserPermissions>;
  profile?: Maybe<CoreUserProfile>;
  role: Scalars['String'];
  roles: Array<Scalars['String']>;
  settings?: Maybe<CoreUserSettings>;
  states?: Maybe<CoreUserStates>;
  timeZone: Scalars['String'];
  training?: Maybe<CoreUserTraining>;
};


export type CoreUserFeedbackArgs = {
  count?: Maybe<Scalars['Int']>;
};

export type CoreUserChatConfig = {
  __typename?: 'CoreUserChatConfig';
  token?: Maybe<Scalars['String']>;
};

export type CoreUserEmployment = {
  __typename?: 'CoreUserEmployment';
  classification?: Maybe<CoreEmployeeClassification>;
  contractorBusinessName?: Maybe<Scalars['String']>;
  contractorType?: Maybe<CoreContractorType>;
  directReports: Array<CoreUser>;
  employeeType?: Maybe<CoreEmployeeType>;
  hoursPerWeek?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isContractor?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<CoreUser>;
  payDay?: Maybe<Scalars['String']>;
  payFrequency?: Maybe<Scalars['String']>;
  payRate?: Maybe<Scalars['String']>;
  payType?: Maybe<CoreEmployeePaytype>;
  startDate?: Maybe<Scalars['String']>;
  stateWorksIn?: Maybe<Scalars['String']>;
  supervisor: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  workerRoles: Array<WorkerRole>;
};


export type CoreUserEmploymentWorkerRolesArgs = {
  showDeleted?: Maybe<Scalars['Boolean']>;
};

export type CoreUserEmploymentInput = {
  classification?: Maybe<CoreEmployeeClassification>;
  contractorBusinessName?: Maybe<Scalars['String']>;
  contractorType?: Maybe<CoreContractorType>;
  employeeType?: Maybe<CoreEmployeeType>;
  hoursPerWeek?: Maybe<Scalars['String']>;
  isContractor?: Maybe<Scalars['Boolean']>;
  payDay?: Maybe<Scalars['String']>;
  payFrequency?: Maybe<Scalars['String']>;
  payRate?: Maybe<Scalars['String']>;
  payType?: Maybe<CoreEmployeePaytype>;
  startDate?: Maybe<Scalars['DateTime']>;
  stateWorksIn?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CoreUserGroup = {
  __typename?: 'CoreUserGroup';
  id: Scalars['ID'];
  members: Array<CoreUser>;
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['ID']>;
  type: CoreUserGroupType;
};

export enum CoreUserGroupType {
  Admin = 'Admin',
  Contractors = 'Contractors',
  Custom = 'Custom',
  Employees = 'Employees',
  Managers = 'Managers',
  ManagersWithReports = 'ManagersWithReports'
}

export type CoreUserPermissions = {
  __typename?: 'CoreUserPermissions';
  approver: Scalars['Boolean'];
  canCancelAccount: Scalars['Boolean'];
  canEditGlobalPolicies: Scalars['Boolean'];
  canRetractSignedPolicies: Scalars['Boolean'];
  canViewPayrollTab: Scalars['Boolean'];
  id: Scalars['ID'];
  manager: Scalars['Boolean'];
};

export type CoreUserProfile = {
  __typename?: 'CoreUserProfile';
  address?: Maybe<CoreAddress>;
  avatarUrl?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emergencyContact?: Maybe<CoreUserProfileEmergencyContact>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type CoreUserProfileEmergencyContact = {
  __typename?: 'CoreUserProfileEmergencyContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type CoreUserProfileEmergencyContactInput = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type CoreUserProfileInput = {
  address?: Maybe<CoreAddressInput>;
  dob?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<CoreUserProfileEmergencyContactInput>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CoreUserSettings = {
  __typename?: 'CoreUserSettings';
  calendlySlug?: Maybe<Scalars['String']>;
  hrEmailAlias?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intercomEmail?: Maybe<Scalars['String']>;
  intercomUserId?: Maybe<Scalars['Int']>;
  pandaContactId?: Maybe<Scalars['String']>;
  salesforceContactId?: Maybe<Scalars['String']>;
  salesforceUserId?: Maybe<Scalars['String']>;
  slackUserId?: Maybe<Scalars['String']>;
  vonageExtension?: Maybe<Scalars['String']>;
  vonageNumber?: Maybe<Scalars['String']>;
  zendeskEmail?: Maybe<Scalars['String']>;
  zendeskOrgMembershipId?: Maybe<Scalars['Int']>;
  zendeskUserId?: Maybe<Scalars['Int']>;
};

export type CoreUserStates = {
  __typename?: 'CoreUserStates';
  emailNotification: Scalars['Boolean'];
  id: Scalars['ID'];
  interestedInPersonalInsurance: Scalars['Boolean'];
  onboardRequest: Scalars['Boolean'];
  onboarded: Scalars['Boolean'];
  resignationLastDate?: Maybe<Scalars['DateTime']>;
  resignationStatus?: Maybe<Scalars['String']>;
  selfSignupActivated: Scalars['Boolean'];
  selfSignupRegistered: Scalars['Boolean'];
  terminated: Scalars['Boolean'];
  terminationRequest: Scalars['Boolean'];
  viewedBciToHrPracticeModal: Scalars['Boolean'];
  viewedBciToHrPracticeReportCardModal: Scalars['Boolean'];
  viewedCovid: Scalars['Boolean'];
  viewedInAppUpgradeModal: Scalars['Boolean'];
  viewedInsuranceIntroduction: Scalars['Boolean'];
  viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>;
  viewedPersonalInsurance: Scalars['Boolean'];
  viewedTaskCenter: Scalars['Boolean'];
  viewedVideoTourBusinessHealth: Scalars['Boolean'];
  viewedVideoTourCabinet: Scalars['Boolean'];
  viewedVideoTourPolicy: Scalars['Boolean'];
  viewedVideoTourReportCards: Scalars['Boolean'];
  viewedVideoTourStaffFolder: Scalars['Boolean'];
};

export type CoreUserStatesInput = {
  emailNotification?: Maybe<Scalars['Boolean']>;
  interestedInPersonalInsurance?: Maybe<Scalars['Boolean']>;
  onboardRequest?: Maybe<Scalars['Boolean']>;
  onboarded?: Maybe<Scalars['Boolean']>;
  resignationLastDate?: Maybe<Scalars['DateTime']>;
  resignationStatus?: Maybe<Scalars['String']>;
  selfSignupActivated?: Maybe<Scalars['Boolean']>;
  selfSignupRegistered?: Maybe<Scalars['Boolean']>;
  terminated?: Maybe<Scalars['Boolean']>;
  terminationRequest?: Maybe<Scalars['Boolean']>;
  viewedBciToHrPracticeModal?: Maybe<Scalars['Boolean']>;
  viewedBciToHrPracticeReportCardModal?: Maybe<Scalars['Boolean']>;
  viewedCovid?: Maybe<Scalars['Boolean']>;
  viewedInAppUpgradeModal?: Maybe<Scalars['Boolean']>;
  viewedInsuranceIntroduction?: Maybe<Scalars['Boolean']>;
  viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>;
  viewedPersonalInsurance?: Maybe<Scalars['Boolean']>;
  viewedTaskCenter?: Maybe<Scalars['Boolean']>;
  viewedVideoTourBusinessHealth?: Maybe<Scalars['Boolean']>;
  viewedVideoTourCabinet?: Maybe<Scalars['Boolean']>;
  viewedVideoTourPolicy?: Maybe<Scalars['Boolean']>;
  viewedVideoTourReportCards?: Maybe<Scalars['Boolean']>;
  viewedVideoTourStaffFolder?: Maybe<Scalars['Boolean']>;
};

export type CoreUserTraining = {
  __typename?: 'CoreUserTraining';
  enrolledTopics: Array<UserCourseTopic>;
  id?: Maybe<Scalars['ID']>;
};

export enum CoreUserViewedOnboardingInstructions {
  FirstTime = 'FirstTime',
  LastTime = 'LastTime'
}

export type CorrectiveActionArtifact = {
  __typename?: 'CorrectiveActionArtifact';
  /** The ID of the salesforce case associated with the corrective action */
  caseId: Scalars['String'];
  /** The ID of the document associated with the corrective action */
  documentId: Scalars['String'];
  /** The ID of the employee the corrective action is for */
  employeeId: Scalars['String'];
  /** The name of the employee the corrective action is for */
  employeeName: Scalars['String'];
  /** The corrective action render as a rich HTML document. */
  html: Scalars['String'];
  /** The id of the corrective action after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** Whether this is a final written warning */
  isFinal: Scalars['Boolean'];
  /** The status of the corrective action */
  status: BestPracticeStatus;
  /** The title of the document */
  title: Scalars['String'];
  /** The type of corrective action */
  type: CorrectiveActionType;
};

export enum CorrectiveActionType {
  PerformanceImprovementPlan = 'performanceImprovementPlan',
  Unknown = 'unknown',
  VerbalWarning = 'verbalWarning',
  WrittenWarning = 'writtenWarning'
}

export enum CostType {
  Monthly = 'MONTHLY'
}

export type CourseEnrollmentDetails = {
  __typename?: 'CourseEnrollmentDetails';
  courseId: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  ticketId: Scalars['ID'];
};

export enum CourseRole {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type CourseTopic = {
  __typename?: 'CourseTopic';
  /** The topic description */
  description?: Maybe<Scalars['String']>;
  /** The topic duration e.g. play time */
  duration?: Maybe<Scalars['Int']>;
  /** Helpers for fields that will commonly be used for filtering topics */
  filterHelpers?: Maybe<CourseTopicFilterHelpers>;
  /** The topic id */
  id: Scalars['String'];
  /** The topic image url */
  imageUrl?: Maybe<Scalars['String']>;
  /** List of industries */
  industries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The topic key used to sync with external systems */
  key: Scalars['String'];
  /** The topic name */
  name: Scalars['String'];
  /** The topic price */
  price?: Maybe<Scalars['Float']>;
  /** List of roles with specific course content for the topic */
  roles?: Maybe<Array<Maybe<CourseRole>>>;
  /**
   * deprecated search tag
   * @deprecated use key instead
   */
  searchTag?: Maybe<Scalars['String']>;
  /** List of states that the topic has state specific course content */
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of search tags */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CourseTopicFilterHelpers = {
  __typename?: 'CourseTopicFilterHelpers';
  /** Whether this topic offers a manager specific course */
  hasManagerCourse?: Maybe<Scalars['Boolean']>;
  /** Whether this topic offers a course version in Spanish */
  hasSpanish?: Maybe<Scalars['Boolean']>;
  /** States for which this topic offers a specific course for */
  states?: Maybe<Array<Scalars['String']>>;
};

export type CreateBundleInput = {
  /** Core Company ID to associate with the bundle. If not provided, the bundle will be global */
  companyId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  name: Scalars['String'];
  topicIds: Array<Scalars['String']>;
};

export type CreateCancellationRequestInput = {
  /** A list of plan values that were offered in order to prevent the cancellation (downgrade, pause, storage) */
  cancellationOffers?: Maybe<Array<Scalars['String']>>;
  /** Additional details if "Other" reason is chosen */
  clientOtherReasonNote?: Maybe<Scalars['String']>;
  /** A note from the client about why they requested the cancellation */
  clientReasonNote?: Maybe<Scalars['String']>;
  /** The company ID */
  companyId: Scalars['String'];
  /** A note from a Bambee user about */
  internalReasonNote?: Maybe<Scalars['String']>;
  /** The list of reason codes chosen by the requestor */
  reasonCodes: Array<Scalars['Float']>;
  /** Actual user requesting the cancellation, usually the company owner */
  requestedBy: Scalars['String'];
  /** When the cancellation request was made, defaults to "now" */
  requestedDate?: Maybe<Scalars['DateTime']>;
  /** Send email about the cancellation request */
  requestedEmail?: Maybe<Scalars['Boolean']>;
  /** The cancellation wizard session ID */
  sessionId?: Maybe<Scalars['String']>;
  /** The company ID */
  source?: Maybe<CancellationSource>;
};

export type CreateCompanyInCheckInput = {
  /** Bambee company id */
  id: Scalars['ID'];
  /** Boolean indicating whether to send an email to the customer. */
  notifyCustomer?: Maybe<Scalars['Boolean']>;
  /** Date the company will start using Check as their payroll processor. */
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CreateEliteAddonSubscriptionInput = {
  companyId: Scalars['String'];
};

export type CreateEnrollmentProfileRequest = {
  /** Company ID */
  id: Scalars['String'];
  numOfContractors?: Maybe<Scalars['Int']>;
  numOfFullTimeHourlyEmployees?: Maybe<Scalars['Int']>;
  numOfFullTimeSalaryEmployees?: Maybe<Scalars['Int']>;
  numOfPartTimeEmployees?: Maybe<Scalars['Int']>;
};

export type CreateHrRequestByInternalUserInput = {
  autoRespond?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  description: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  origin?: Maybe<HrRequestOrigin>;
  originFeature?: Maybe<Scalars['String']>;
  subType?: Maybe<HrRequestSubType>;
  subject: Scalars['String'];
  type: HrRequestType;
};

export type CreateHrRequestFromSalesforceCaseInput = {
  message?: Maybe<Scalars['String']>;
  salesforceCaseId: Scalars['String'];
};

export type CreateHrRequestInput = {
  aiArtifacts?: Maybe<Array<Scalars['String']>>;
  aiGenerated?: Maybe<Scalars['Boolean']>;
  answers?: Maybe<Scalars['String']>;
  autoRespond?: Maybe<Scalars['Boolean']>;
  chatNow: Scalars['Boolean'];
  description: Scalars['String'];
  origin?: Maybe<HrRequestOrigin>;
  originFeature?: Maybe<Scalars['String']>;
  subType?: Maybe<HrRequestSubType>;
  subject: Scalars['String'];
  /** ID of the Assistants API thread used to generate the Policy HR Request */
  threadId?: Maybe<Scalars['String']>;
  type: HrRequestType;
};

export type CreateHrRequestsFromIntercomConversationsInput = {
  intercomConversationIds: Array<Scalars['String']>;
};

export type CreateJobDescriptionInput = {
  body: Scalars['JSON'];
  title: Scalars['String'];
};

export type CreateManyNoticesInput = {
  /** Array of notices to create */
  notices: Array<CreateNoticeInput>;
};

export type CreateMultipleRolesForCompanyInput = {
  /** Bambee Core Company id */
  companyId: Scalars['ID'];
  /** Bambee Core Company Role title */
  titles: Array<Scalars['String']>;
};

export type CreateNoticeInput = {
  actions?: Maybe<Array<NoticeActionInput>>;
  badge?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  headline?: Maybe<Scalars['String']>;
  version?: Scalars['String'];
  visualization?: Maybe<VisualizationDataInput>;
};

export type CreatePayScheduleInput = {
  companyId: Scalars['ID'];
  /** The first date on which employees will be paid for the payroll. */
  firstPayday: Scalars['String'];
  /** The end of the date range that the payroll covers. YYYY-MM-DD */
  firstPeriodEnd: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  payFrequency: PayScheduleFrequency;
  /** The payday date of the the second payroll the company will run on this pay schedule. This field should only be used with the semimonthly frequency to specify custom paydays besides the 15th and last day of the month. second_payday must be between one day and one month after first_payday. */
  secondPayday?: Maybe<Scalars['String']>;
};

export type CreatePayrollInput = {
  /** The approval deadline provided in paydays */
  approvalDeadline: Scalars['DateTime'];
  /** Bambee company id */
  companyId: Scalars['ID'];
  /** Additional configuration options controlling off-cycle payroll behavior. */
  offCycleOptions?: Maybe<OffcycleOptionsInput>;
  /** The date on which employees will be paid for the payroll. */
  payday: Scalars['String'];
  /** The type of payroll, regular or off-cycle. */
  payrollType?: Maybe<PayrollType>;
  /** The end of the date range that the payroll covers. YYYY-MM-DD */
  periodEnd: Scalars['String'];
  /** The start of the date range that the payroll covers. YYYY-MM-DD */
  periodStart: Scalars['String'];
};

export type CreatePayrollSubscriptionInput = {
  applyTrial?: Maybe<Scalars['Boolean']>;
  /** The Company ID. */
  companyId: Scalars['String'];
  /** Should Time & Attendance be included as an addon to the new Payroll Subscription? */
  includeTimeAndAttendance?: Maybe<Scalars['Boolean']>;
  /** The Payroll Plan identifier for the new subscription. */
  planValue?: Maybe<Scalars['String']>;
  /** The date to start billing after. */
  startBillingAfter?: Maybe<Scalars['DateTime']>;
};

export type CreatePlanLockInput = {
  active: Scalars['Boolean'];
  companyId: Scalars['String'];
  couponId: Scalars['String'];
  plan: Scalars['String'];
  setupFee: Scalars['Float'];
  trialDuration: Scalars['Float'];
};

export type CreateProductInterestInput = {
  productKey: ProductKey;
  productSubKey?: Maybe<ProductSubKey>;
};

export type CreateReportCardInput = {
  companyId: Scalars['String'];
};

export type CreateRoleForCompanyInput = {
  /** Bambee Core Company id */
  companyId: Scalars['ID'];
  /** Bambee Core Company Role title */
  title: Scalars['String'];
};

export type CreateSignatoryInput = {
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  companyPlan?: Maybe<Scalars['String']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
  signatoryEmail: Scalars['String'];
  signatoryFirstName: Scalars['String'];
  signatoryLastName: Scalars['String'];
  signatoryTitle: Scalars['String'];
  userFullName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userRole?: Maybe<Scalars['String']>;
};

export type CreateVoicesFeedbackInput = {
  anonymous: Scalars['Boolean'];
  feedback: Scalars['String'];
};

export type CreateWebinarInstanceRequest = {
  /** The duration of the webinar in minutes */
  duration?: Scalars['Int'];
  /** The ID of the user who is hosting the webinar */
  hostUserId: Scalars['ID'];
  startTime: Scalars['DateTime'];
  /** The tiers that are allowed to attend the webinar */
  tiers: Array<Scalars['String']>;
  /** The topic of the webinar */
  topic: Scalars['String'];
};

export type CreateWorkerRoleInput = {
  companyRoleId?: Maybe<Scalars['ID']>;
  isPrimary: Scalars['Boolean'];
  newCompanyRole?: Maybe<CreateRoleForCompanyInput>;
  payRate: Scalars['Float'];
  payType: WorkerRolePaytype;
  /** Bambee Core User id */
  userId: Scalars['ID'];
};

export type CreateWorkplaceInput = {
  active?: Maybe<Scalars['Boolean']>;
  /** Workplace address */
  address: AddressInput;
  /** Bambee company id */
  companyId: Scalars['ID'];
  default: Scalars['Boolean'];
  /** Workplace name */
  name: Scalars['String'];
};

export type Credit = {
  __typename?: 'Credit';
  companyId: Scalars['String'];
  consumedAt?: Maybe<Scalars['DateTime']>;
  consumedBy?: Maybe<Scalars['String']>;
  consumptionDescription?: Maybe<Scalars['String']>;
  consumptionReason?: Maybe<ProductCreditConsumptionReason>;
  /** Subkey of the product, if consuming managed service credit */
  consumptionSubKey?: Maybe<Scalars['String']>;
  consumptionType?: Maybe<ProductCreditConsumptionType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  creationDescription?: Maybe<Scalars['String']>;
  creationReason?: Maybe<ProductCreditCreationReason>;
  creditType: ProductCreditType;
  id: Scalars['ID'];
  productKey: ProductKey;
  stripeCreditNoteId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};


export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  greaterThan?: Maybe<Scalars['DateTime']>;
  greaterThanOrEqualTo?: Maybe<Scalars['DateTime']>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<Scalars['DateTime']>>;
  lessThan?: Maybe<Scalars['DateTime']>;
  lessThanOrEqualTo?: Maybe<Scalars['DateTime']>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  greaterThan?: Maybe<Scalars['DateTime']>;
  greaterThanOrEqualTo?: Maybe<Scalars['DateTime']>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<Scalars['DateTime']>>;
  lessThan?: Maybe<Scalars['DateTime']>;
  lessThanOrEqualTo?: Maybe<Scalars['DateTime']>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DeclineRecommendationInput = {
  /** The id of the recommendation to be declined. */
  recommendationId: Scalars['String'];
};

export type DefaultPayScheduleDays = {
  __typename?: 'DefaultPayScheduleDays';
  approvalDeadline: Scalars['DateTime'];
  impactedByWeekendOrHoliday: Scalars['Boolean'];
  payday: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
};

export type DefaultPayScheduleDaysInput = {
  /** The number of pay days requested, defaults to 10. */
  limit?: Maybe<Scalars['Int']>;
};

export type DeleteBundleInput = {
  /** Core Company ID to associate with the bundle. If not provided, the bundle will be global */
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteBundleResponse = {
  __typename?: 'DeleteBundleResponse';
  deleted: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteCompanyRolesInput = {
  /** Bambee Core Company id */
  companyId: Scalars['ID'];
  /** Bambee Core Company Role title */
  roleIds: Array<Scalars['String']>;
};

export type DeleteContractorInput = {
  /** Bambee contractor ID */
  contractorId: Scalars['ID'];
};

export type DeleteEmployeeInput = {
  /** Bambee employee ID */
  employeeId: Scalars['ID'];
};

export type DeletePayrollInput = {
  id: Scalars['ID'];
};

export type DeputyConnection = {
  __typename?: 'DeputyConnection';
  /** Is the client allowed to trigger cancellation; If the product is being billed a la carte then we would expect this to be true. Otherwise T&A is bundled with payroll and can not be cancelled independently */
  canCancel: Scalars['Boolean'];
  /** Date when the connection was created. */
  createdAt: Scalars['DateTime'];
  /** The edition of Deputy subscription */
  edition?: Maybe<Scalars['String']>;
  /** Validation error message, when validation fails */
  error?: Maybe<Scalars['String']>;
  hasAccessToken: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Deputy installation id. Used to communicate with Deputy API. */
  installId: Scalars['String'];
  isSupportEnabled: Scalars['Boolean'];
  /** Is support enabled */
  supportEnabled: Scalars['Boolean'];
  /** Date when the connection was last updated. */
  updatedAt: Scalars['DateTime'];
  /** Date when the connection was validated. */
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type DeputySyncError = {
  __typename?: 'DeputySyncError';
  /** meta data about conflicting timesheets */
  data?: Maybe<DeputySyncMetadata>;
  /** The error id */
  id: Scalars['ID'];
  /** The error message */
  message: Scalars['String'];
  /** The stack trace of the error */
  stack?: Maybe<Scalars['String']>;
};

export type DeputySyncInfo = {
  __typename?: 'DeputySyncInfo';
  /** number of contractors with synced timesheets */
  contractors: Scalars['Int'];
  /** number of earnings / payment entries associated to timesheets for this payroll */
  earnings: Scalars['Int'];
  /** number of deputy employees associated to timesheets for this payroll */
  employees: Scalars['Int'];
  /**
   * Sync errors
   * @deprecated Use syncErrors instead
   */
  errors: Array<Scalars['String']>;
  /** The payroll id */
  id: Scalars['ID'];
  /** Indicates if approved timesheets where converted into earnings */
  imported: Scalars['Boolean'];
  /** The last sync update */
  lastUpdate?: Maybe<Scalars['DateTime']>;
  /** number of contractor payment entries with synced timesheets */
  paymentEntries: Scalars['Int'];
  /** Sync errors */
  syncErrors: Array<DeputySyncError>;
  /** Indicates if approved timesheets where converted into earnings */
  synced: Scalars['Boolean'];
};

export type DeputySyncMetadata = {
  __typename?: 'DeputySyncMetadata';
  /** The dollar amount of the conflicting deputy timesheet */
  deputyAmount: Scalars['Float'];
  /** The employee id in deputy */
  deputyEmployeeId: Scalars['String'];
  /** The number of hours of the conflicting deputy timesheet */
  deputyHours: Scalars['Float'];
  /** The dollar amount of the imported timesheet */
  importedAmount: Scalars['Float'];
  /** The number of hours of the imported timesheet */
  importedHours: Scalars['Float'];
};

export type DisableDeputySupportInput = {
  companyId: Scalars['ID'];
};

/** The discussion topics for the Onboarding */
export enum DiscussionTopic {
  CreatingCompanyPolicies = 'CreatingCompanyPolicies',
  EnsuringMyBusinessIsCompliant = 'EnsuringMyBusinessIsCompliant',
  EstablishingANewBusiness = 'EstablishingANewBusiness',
  ExpandingMyBusiness = 'ExpandingMyBusiness',
  ManagingAnActiveHrIssue = 'ManagingAnActiveHRIssue',
  ManagingEmployees = 'ManagingEmployees',
  SomethingElse = 'SomethingElse'
}

export type DisucssionTopicDetail = {
  __typename?: 'DisucssionTopicDetail';
  /** The details of the discussion topic */
  detail: Scalars['String'];
  /** The discussion topic */
  topic: DiscussionTopic;
};

export type DisucssionTopicDetailInput = {
  /** The details of the discussion topic */
  detail: Scalars['String'];
  /** The discussion topic */
  topic: DiscussionTopic;
};

export type DoceboTokenResponse = {
  __typename?: 'DoceboTokenResponse';
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  token: Scalars['String'];
};

export type Document = {
  /** Date that this document was filed */
  filedOn: Scalars['String'];
  id: Scalars['ID'];
  /** will be either a two-character state abbreviation or "FED" */
  jurisdiction?: Maybe<Scalars['String']>;
  /** Document’s type */
  label: Scalars['String'];
  /** Year that this document was filed */
  year: Scalars['Float'];
};

export type DocumentArtifact = {
  __typename?: 'DocumentArtifact';
  /** The html of the document */
  html: Scalars['String'];
  /** The id of the document */
  id: Scalars['String'];
  /** The status of the document */
  status: DocumentStatus;
};

export type DocumentOption = {
  __typename?: 'DocumentOption';
  id: DocumentOptionType;
  label: Scalars['String'];
  name: Scalars['String'];
};

export enum DocumentOptionType {
  ArticlesOfIncorporation = 'ARTICLES_OF_INCORPORATION',
  ArticlesOfIncorporationSignatoryAmendment = 'ARTICLES_OF_INCORPORATION_SIGNATORY_AMENDMENT',
  BalanceSheet = 'BALANCE_SHEET',
  BankLetter = 'BANK_LETTER',
  BankStatement = 'BANK_STATEMENT',
  CashFlowStatement = 'CASH_FLOW_STATEMENT',
  Cp_575 = 'CP_575',
  FiveZeroOneC_3 = 'FIVE_ZERO_ONE_C_3',
  NineForty = 'NINE_FORTY',
  NineFortyFive = 'NINE_FORTY_FIVE',
  NineFortyFour = 'NINE_FORTY_FOUR',
  NineFortyOne = 'NINE_FORTY_ONE',
  NineFortyThree = 'NINE_FORTY_THREE',
  OneFortySevenC = 'ONE_FORTY_SEVEN_C',
  ProfitAndLoss = 'PROFIT_AND_LOSS',
  SignatoryPhotoId = 'SIGNATORY_PHOTO_ID',
  Ss4 = 'SS4',
  StateRegistration = 'STATE_REGISTRATION',
  VoidedCheck = 'VOIDED_CHECK'
}

export enum DocumentStatus {
  Accepted = 'accepted',
  Editing = 'editing'
}

export enum DocumentType {
  ArticlesOfIncorporation = 'ARTICLES_OF_INCORPORATION',
  ArticlesOfIncorporationSignatoryAmendment = 'ARTICLES_OF_INCORPORATION_SIGNATORY_AMENDMENT',
  BalanceSheet = 'BALANCE_SHEET',
  BankLetter = 'BANK_LETTER',
  BankStatement = 'BANK_STATEMENT',
  CashFlowStatement = 'CASH_FLOW_STATEMENT',
  Cp_575 = 'CP_575',
  FiveZeroOneC_3 = 'FIVE_ZERO_ONE_C_3',
  NineForty = 'NINE_FORTY',
  NineFortyFive = 'NINE_FORTY_FIVE',
  NineFortyFour = 'NINE_FORTY_FOUR',
  NineFortyOne = 'NINE_FORTY_ONE',
  NineFortyThree = 'NINE_FORTY_THREE',
  OneFortySevenC = 'ONE_FORTY_SEVEN_C',
  ProfitAndLoss = 'PROFIT_AND_LOSS',
  SignatoryPhotoId = 'SIGNATORY_PHOTO_ID',
  Ss4 = 'SS4',
  StateRegistration = 'STATE_REGISTRATION',
  VoidedCheck = 'VOIDED_CHECK'
}

/** Downgrade Deputy installation from paid to free */
export type DowngradeDeputyInstallInput = {
  /** Bambee company id */
  companyId: Scalars['String'];
};

export type DuplicatedPolicyDocumentResult = {
  __typename?: 'DuplicatedPolicyDocumentResult';
  /** Company ID for which duplicated policy documents have been removed */
  companyId: Scalars['ID'];
  failureCount: Scalars['Float'];
  successCount: Scalars['Float'];
};

export enum EinSteps {
  EinSubmitted = 'EIN_SUBMITTED'
}

export type Earning = {
  __typename?: 'Earning';
  /** Amount earned for this earning */
  amount?: Maybe<Scalars['Float']>;
  /** The decimal value of the inputted number of hours worked */
  decimal?: Maybe<Scalars['Float']>;
  /** Readable description of the earning code that will show up on the paystub */
  description?: Maybe<Scalars['String']>;
  /** Bambee earning id */
  id: Scalars['ID'];
  /** Number of hours worked for this earning */
  minutes?: Maybe<Scalars['Float']>;
  /** Source of earning */
  source: SourceType;
  /** SubType of earning. */
  subtype?: Maybe<EarningSubtype>;
  /** Type of earning. */
  type: EarningType;
  /** Worker role id to be applied to this item */
  workerRoleId?: Maybe<Scalars['ID']>;
};

export type EarningInput = {
  /** Amount earned for this earning */
  amount?: Maybe<Scalars['Float']>;
  /** The decimal value of the inputted number of hours worked */
  decimal?: Maybe<Scalars['Float']>;
  /** Readable description of the earning code that will show up on the paystub */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** Number of hours worked for this earning */
  minutes?: Maybe<Scalars['Float']>;
  /** Source of Earning */
  source?: Maybe<SourceType>;
  /** SubType of earning. */
  subtype?: Maybe<EarningSubtype>;
  /** Type of earning. */
  type: EarningType;
  /** Worker role id to be applied to this item */
  workerRoleId?: Maybe<Scalars['ID']>;
};

export enum EarningSubtype {
  Discretionary = 'DISCRETIONARY',
  Gift = 'GIFT',
  NonDiscretionary = 'NON_DISCRETIONARY'
}

export type EarningSummaryItem = {
  __typename?: 'EarningSummaryItem';
  /** The earning amount */
  amount?: Maybe<Scalars['Float']>;
  /** The earning description */
  description?: Maybe<Scalars['String']>;
  /** The earning type */
  type?: Maybe<Scalars['String']>;
};

export enum EarningType {
  Allowance = 'ALLOWANCE',
  Bonus = 'BONUS',
  CashTips = 'CASH_TIPS',
  CaSpsl = 'CA_SPSL',
  ClergyHousing = 'CLERGY_HOUSING',
  Commission = 'COMMISSION',
  DoubleOvertime = 'DOUBLE_OVERTIME',
  FfcraFamilyLeave = 'FFCRA_FAMILY_LEAVE',
  FfcraSickIndividual = 'FFCRA_SICK_INDIVIDUAL',
  FfcraSickOther = 'FFCRA_SICK_OTHER',
  GroupTermLife = 'GROUP_TERM_LIFE',
  Hourly = 'HOURLY',
  NonHourlyRegular = 'NON_HOURLY_REGULAR',
  NonProductive = 'NON_PRODUCTIVE',
  OtherImputed = 'OTHER_IMPUTED',
  Overtime = 'OVERTIME',
  PaidHoliday = 'PAID_HOLIDAY',
  PaidHoliday_1_5X = 'PAID_HOLIDAY_1_5X',
  PaycheckTips = 'PAYCHECK_TIPS',
  Piece = 'PIECE',
  PieceAdjustmentToMinimumWage = 'PIECE_ADJUSTMENT_TO_MINIMUM_WAGE',
  Pto = 'PTO',
  ReportedAllowance = 'REPORTED_ALLOWANCE',
  ReportedClergyHousing = 'REPORTED_CLERGY_HOUSING',
  RestAndRecovery = 'REST_AND_RECOVERY',
  Salaried = 'SALARIED',
  Severance = 'SEVERANCE',
  Sick = 'SICK',
  TipCreditAdjustmentToMinimumWage = 'TIP_CREDIT_ADJUSTMENT_TO_MINIMUM_WAGE',
  TwoPercentShareholderBenefits = 'TWO_PERCENT_SHAREHOLDER_BENEFITS',
  TwoPercentShareholderHsa = 'TWO_PERCENT_SHAREHOLDER_HSA',
  WeightedDoubleOvertime = 'WEIGHTED_DOUBLE_OVERTIME',
  WeightedOvertime = 'WEIGHTED_OVERTIME'
}

export type EligibleAddonsInput = {
  /** The company ID */
  companyId: Scalars['ID'];
};

export type EligibleAddonsResponse = {
  __typename?: 'EligibleAddonsResponse';
  /** The list of payroll plans available for subscribing */
  payroll: Array<PayrollPlanModel>;
  /** The list of time and attendance plans available for subscribing */
  time_attendance: Array<PayrollPlanModel>;
};

/** A model representing the Elite addon. */
export type EliteAddonModel = {
  __typename?: 'EliteAddonModel';
  /** Billing period for the addon. */
  billingPeriod: BillingPeriod;
  /** Total price of the addon. */
  price: Scalars['Float'];
  /** The product key associated to the addon object (Elite). */
  productKey: ProductKey;
  /** The service key associated to the addon object (always Elite here). */
  serviceKey: ServiceKey;
  /** Current status of the addon. */
  status: PlanStatuses;
  /** Tier number of the addon. */
  tierNumber: Scalars['Float'];
  /** Addon identifier in Bambee's Catalog. */
  value: Scalars['String'];
  /** Version of the addon. */
  version: Scalars['String'];
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type EmittableEvent = {
  /** The identity associated with the data */
  company?: Maybe<Scalars['String']>;
  /** Name or key of the event */
  event: Scalars['String'];
  /** The id of the event */
  id?: Maybe<Scalars['ID']>;
  /** Additional properties for the event */
  properties?: Maybe<Scalars['JSON']>;
  /** The identity associated with the data */
  userId?: Maybe<Scalars['String']>;
};

export type Employee = {
  __typename?: 'Employee';
  bankAccounts?: Maybe<Array<Maybe<BankAccount>>>;
  benefitOnboarding?: Maybe<BenefitWorkerOnboarding>;
  benefits: Array<Benefit>;
  checkId?: Maybe<Scalars['ID']>;
  /** @deprecated Use generateOnboardingLink */
  checkOnboardLink: Scalars['String'];
  checkOnboarding?: Maybe<CheckEmployeeOnboarding>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deputyId?: Maybe<Scalars['ID']>;
  /** Bambee employee id */
  id: Scalars['ID'];
  payRate: Scalars['Float'];
  payType?: Maybe<PaymentType>;
  paymentMethodPreference?: Maybe<PaymentMethod>;
  payrollItems: Array<PayrollItem>;
  profile?: Maybe<EmployeeProfile>;
  /** @deprecated checkOnboarding is a superset */
  remainingOnboardingSteps: Array<EmployeeOnboardingSteps>;
  taxDocuments?: Maybe<Array<Maybe<TaxDocument>>>;
  timesheets: Array<Timesheet>;
  user?: Maybe<CoreUser>;
  workplaces: Array<Workplace>;
};


export type EmployeePayrollItemsArgs = {
  excludeZeroGross?: Maybe<Scalars['Boolean']>;
};


export type EmployeeTaxDocumentsArgs = {
  data?: Maybe<EmployeeTaxDocumentsInput>;
};


export type EmployeeTimesheetsArgs = {
  filter?: Maybe<EmployeeTimesheetFilter>;
};

export enum EmployeeClassification {
  Empty = 'empty',
  Exempt = 'exempt',
  Nonexempt = 'nonexempt'
}

export type EmployeeJobDescription = {
  __typename?: 'EmployeeJobDescription';
  createdAt: Scalars['DateTime'];
  documentId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobDescription: JobDescription;
  signedAt?: Maybe<Scalars['DateTime']>;
};

export enum EmployeeOnboardingSteps {
  BankAccount = 'BANK_ACCOUNT',
  CompanyDefinedAttributes = 'COMPANY_DEFINED_ATTRIBUTES',
  Ein = 'EIN',
  EmployeeDetails = 'EMPLOYEE_DETAILS',
  FilingAuthorization = 'FILING_AUTHORIZATION',
  PaymentMethod = 'PAYMENT_METHOD',
  SetupParameters = 'SETUP_PARAMETERS',
  Ssn = 'SSN',
  Withholdings = 'WITHHOLDINGS',
  Workplaces = 'WORKPLACES'
}

export type EmployeeProfile = {
  __typename?: 'EmployeeProfile';
  active?: Maybe<Scalars['Boolean']>;
  contractorBusinessName?: Maybe<Scalars['String']>;
  contractorType?: Maybe<PayrollContractorType>;
  dob?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  employeeType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeAddress?: Maybe<ProfileAddress>;
  /** Bambee employee id */
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum EmployeeServiceContractorType {
  Business = 'business',
  Empty = 'empty',
  Individual = 'individual'
}

export enum EmployeeServiceEmployeeType {
  Contractor = 'contractor',
  Empty = 'empty',
  Fulltime = 'fulltime',
  Parttime = 'parttime'
}

export type EmployeeSync = {
  __typename?: 'EmployeeSync';
  bambee?: Maybe<Scalars['String']>;
  check?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type EmployeeTaxDocumentsInput = {
  /** Return tax documents for this year (must be greater than or equal to 2019) */
  year?: Maybe<Scalars['Int']>;
};

export type EmployeeTimesheetFilter = {
  /** Find approved if true, find unapproved if false, do not filter on approval status if not provided. */
  approved?: Maybe<Scalars['Boolean']>;
  /** Find timesheets for a particular employee (Deputy Employee Id) */
  employeeId?: Maybe<Scalars['String']>;
  /** Find timesheets for a particular payroll (this will overwrite start/end fields in filter (Bambee Payroll Id) */
  payrollId?: Maybe<Scalars['Int']>;
};

export type EnableDeputySupportInput = {
  companyId: Scalars['ID'];
};

export type EnqueueHotlineCallInput = {
  /** Additional information associated to the call that is being requested */
  information: CallInformation;
  /** An arbitrary string specifying where the request was originated */
  origin: Scalars['String'];
};

export type EnrollUserResponse = {
  __typename?: 'EnrollUserResponse';
  enrolled: Scalars['Boolean'];
  enrollments?: Maybe<EnrollUserTicket>;
  errors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
};

export type EnrollUserTicket = {
  __typename?: 'EnrollUserTicket';
  bundleId?: Maybe<Scalars['ID']>;
  courseId: Scalars['ID'];
  ticketId: Scalars['ID'];
  topicId?: Maybe<Scalars['ID']>;
};

export type EnrollUsersError = {
  __typename?: 'EnrollUsersError';
  bundleId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type EnrollUsersInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  users: Array<UserInput>;
};

export type EnrollUsersResponse = {
  __typename?: 'EnrollUsersResponse';
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  enrolled: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  topicId?: Maybe<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type EnrolledUser = {
  __typename?: 'EnrolledUser';
  id: Scalars['String'];
  language?: Maybe<Language>;
  role?: Maybe<UserRole>;
  state?: Maybe<State>;
  /** @deprecated Use id instead */
  userId: Scalars['String'];
};

export type EnrollmentCompleted = {
  __typename?: 'EnrollmentCompleted';
  completedUserIds: Array<Maybe<Scalars['String']>>;
  errors: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
};

export type EnrollmentInput = {
  bundleId?: Maybe<Scalars['String']>;
  topicId?: Maybe<Scalars['String']>;
  users: Array<UserInput>;
};

export type EnumContractorPayTypeFilter = {
  equals?: Maybe<ContractorPayType>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<ContractorPayType>>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<ContractorPayType>>;
};

export type EnumPaymentMethodFilter = {
  equals?: Maybe<PaymentMethod>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<PaymentMethod>>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<PaymentMethod>>;
};

export type EnumPayrollItemPayTypeFilter = {
  equals?: Maybe<PaymentType>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<PaymentType>>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<PaymentType>>;
};

export type EnumPayrollItemPaymentMethodFilter = {
  equals?: Maybe<PaymentMethod>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<PaymentMethod>>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<PaymentMethod>>;
};

export type EnumPayrollItemPayrollItemStatusFilter = {
  equals?: Maybe<PayrollItemStatus>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<PayrollItemStatus>>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<PayrollItemStatus>>;
};

export type EnumPayrollStatusFilter = {
  equals?: Maybe<PayrollStatus>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<PayrollStatus>>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<PayrollStatus>>;
};

export type EnumPayrollTypeFilter = {
  equals?: Maybe<PayrollType>;
  /** The value for the field must be in the provided list. */
  in?: Maybe<Array<PayrollType>>;
  /** The value for the field must not be in the provided list. */
  notIn?: Maybe<Array<PayrollType>>;
};

export type EoEHrRequestAnswer = {
  __typename?: 'EoEHrRequestAnswer';
  answers?: Maybe<Scalars['JSON']>;
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  refId: Scalars['String'];
  sfSubType?: Maybe<Scalars['String']>;
  sfType?: Maybe<Scalars['String']>;
  type: EoeHrRequestType;
};

export enum EoeHrRequestType {
  HrRequest = 'HR_REQUEST',
  Resignation = 'RESIGNATION',
  Termination = 'TERMINATION'
}

export type EventEmitted = {
  __typename?: 'EventEmitted';
  /** Name or key of the event */
  event: Scalars['String'];
  /** The id of the event */
  id: Scalars['ID'];
  /** Indicator if event was emitted successfully */
  success: Scalars['Boolean'];
  /** The identity associated with the data */
  userId?: Maybe<Scalars['String']>;
};

export type ExtendBambeePlusOnboardingToSpecificDate = {
  companyId: Scalars['String'];
  newDeadline: Scalars['DateTime'];
};

export type Feed = {
  __typename?: 'Feed';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user: CoreUser;
};

export type FeedbackHistory = {
  __typename?: 'FeedbackHistory';
  byUser: CoreUser;
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  message: FeedbackMessage;
  value: FeedbackValue;
};

export type FeedbackMessage = ChatMessageInterface & {
  __typename?: 'FeedbackMessage';
  channelId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  feedbackId: Scalars['ID'];
  id: Scalars['ID'];
  isThreadMessage: Scalars['Boolean'];
  isThreadParent: Scalars['Boolean'];
  message: Scalars['String'];
  rawType: SendbirdMessageType;
  /** Recipieint, if a one-on-one message */
  recipient?: Maybe<CoreUser>;
  sender: CoreUser;
  threadParentId?: Maybe<Scalars['ID']>;
  type: ChatMessageTypeEnum;
  value: FeedbackValue;
};

export type FeedbackMessageInput = {
  message: Scalars['String'];
  value: FeedbackValue;
};

/** A representation of feedback values */
export enum FeedbackValue {
  AboveExpectations = 'AboveExpectations',
  BelowExpectations = 'BelowExpectations',
  MeetsExpectations = 'MeetsExpectations'
}

export type FileCitationAnnotationDto = {
  __typename?: 'FileCitationAnnotationDto';
  end_index: Scalars['Int'];
  file_citation: FileCitationDto;
  start_index: Scalars['Int'];
  text: Scalars['String'];
  type: Scalars['String'];
};

export type FileCitationDto = {
  __typename?: 'FileCitationDto';
  file_id: Scalars['String'];
};

export type FileInput = {
  /** base64 encoded file data */
  file: Scalars['String'];
  /** file name */
  name: Scalars['String'];
  type: DocumentOptionType;
};

export type FilePathAnnotationDto = {
  __typename?: 'FilePathAnnotationDto';
  end_index: Scalars['Int'];
  file_path: FilePathDto;
  start_index: Scalars['Int'];
  text: Scalars['String'];
  type: Scalars['String'];
};

export type FilePathDto = {
  __typename?: 'FilePathDto';
  file_id: Scalars['String'];
};

export type FileStackInput = {
  filename?: Scalars['String'];
  id?: Scalars['String'];
  mimetype?: Scalars['String'];
  name?: Scalars['String'];
  size?: Scalars['Int'];
  uploaded_date?: Maybe<Scalars['DateTime']>;
  url?: Scalars['String'];
};

export type FileStackModel = {
  __typename?: 'FileStackModel';
  filename: Scalars['String'];
  id: Scalars['String'];
  mimetype: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
  uploaded_date?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export enum FileType {
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG'
}

export type FinchManualSetupCompletedInput = {
  companyName: Scalars['String'];
  payrollProvider: Scalars['String'];
};

export type ForceApproveComplexPayrollOnboardingInput = {
  companyId: Scalars['ID'];
};

export type GenerateAiJobDescriptionInput = {
  employeeType?: Maybe<JobDescriptionEmployeePayType>;
  employmentPayRate?: Maybe<JobDescriptionEmploymentPayRate>;
  employmentTaxType?: Maybe<JobDescriptionEmploymentTaxType>;
  industry: Scalars['String'];
  jobTitle: Scalars['String'];
  location?: Maybe<JobDescriptionLocation>;
  travelRequirements?: Maybe<Scalars['String']>;
  workingSchedule?: Maybe<Array<WorkingSchedule>>;
};

/** Generate AI job description attatching it to user */
export type GenerateAiJobDescriptionInputV2 = {
  employeeType?: Maybe<JobDescriptionEmployeePayType>;
  employmentPayRate?: Maybe<JobDescriptionEmploymentPayRate>;
  employmentTaxType?: Maybe<JobDescriptionEmploymentTaxType>;
  industry: Scalars['String'];
  /** Allows the AI generation process to use an existing job description */
  jobDescriptionId?: Maybe<Scalars['String']>;
  jobTitle: Scalars['String'];
  location?: Maybe<JobDescriptionLocation>;
  travelRequirements?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  workingSchedule?: Maybe<Array<WorkingSchedule>>;
};

export type GenerateCompanyOnboardingLinkInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
  /** The email of the person who has permission to onboard on behalf of the company. */
  email: Scalars['String'];
  /** Should this trigger the sending of an e-mail to the individual? If left out an e-mail will NOT be sent. */
  sendEmail?: Maybe<Scalars['Boolean']>;
  /** The name of the person who has permission to onboard on behalf of the company. */
  signerName: Scalars['String'];
  /** The title of the person who has permission to onboard on behalf of the company (e.g. "Officer", "Manager", etc.). */
  signerTitle: Scalars['String'];
};

export type GetAskNicelyWebSurveyInfoInput = {
  /** Whether to always provide the email hash. */
  provideHash?: Maybe<Scalars['Boolean']>;
  /** ID of user to get NPS survey info for. */
  userId: Scalars['String'];
};

export type GetAvailableProductsInput = {
  companyId: Scalars['String'];
};

export type GetBillingInfoInput = {
  companyId: Scalars['String'];
};

export type GetBusinessManagerCalendlyUrlInput = {
  tierNumber: Scalars['Int'];
};

export type GetCalendlyRescheduleLinkInput = {
  /** Scheduled Event ID */
  scheduledEventId: Scalars['String'];
};

export type GetCompanyCreditsInputV2 = {
  active?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['String']>;
  consumed?: Maybe<Scalars['Boolean']>;
  creditType?: Maybe<ProductCreditType>;
  productKey?: Maybe<ProductKey>;
  refundable?: Maybe<Scalars['Boolean']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
};

export type GetCompanyDelinquency = {
  companyId: Scalars['String'];
};

export type GetCompanyInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
};

export type GetCompanyPaymentSources = {
  companyId: Scalars['String'];
};

export type GetCompanyProductsInput = {
  companyId: Scalars['String'];
};

export type GetCompanySubscriptionsInput = {
  productCode?: Maybe<ProductKey>;
  stripeCustomerId: Scalars['String'];
};

export type GetCompanySurveyAnswerInput = {
  companyId: Scalars['ID'];
  key: SurveyQuestionKey;
  type: Scalars['String'];
};

export type GetCompanySurveyInput = {
  companyId: Scalars['String'];
  type: Scalars['String'];
};

export type GetCompanySurveyListInput = {
  companyId: Scalars['String'];
};

export type GetCompanyUpcomingBillingChangesInput = {
  companyId: Scalars['String'];
  /** Tier number the company will upgrade to */
  tierNumber: Scalars['Float'];
};

export type GetConversationByIntercomIdInput = {
  fetchAsHtml?: Maybe<Scalars['Boolean']>;
  intercomConversationId: Scalars['String'];
};

export type GetCoreUpgradeOptionsInput = {
  companyId: Scalars['String'];
};

export type GetCouponInput = {
  couponId: Scalars['String'];
};

export type GetEliteAddonInput = {
  companyId: Scalars['String'];
};

export type GetEntityInput = {
  id: Scalars['String'];
};

export type GetEoeHrRequestInput = {
  companyId: Scalars['String'];
  refId: Scalars['String'];
  type: EoeHrRequestType;
};

export type GetExistingResignationByEmployeeInput = {
  employeeId: Scalars['String'];
};

export type GetExistingTerminationByEmployeeInput = {
  employeeId: Scalars['String'];
};

export type GetHrRequestByIdInput = {
  /** ID of the HR Request */
  id: Scalars['String'];
};

export type GetHrRequestBySalesforceCaseIdInput = {
  salesforceCaseId: Scalars['String'];
};

export type GetHrRequestExtendedDetailByIdInput = {
  /** SF case ID */
  caseId: Scalars['String'];
};

export type GetPolicy = {
  policyId: Scalars['ID'];
};

export type GetPracticeInput = {
  companyId: Scalars['String'];
  practiceId: Scalars['String'];
};

export type GetProductInterestInput = {
  productKey?: Maybe<ProductKey>;
  productSubKey?: Maybe<ProductSubKey>;
};

export type GetReportCardInput = {
  /** employee id */
  employeeId?: Maybe<Scalars['String']>;
  reportCardId: Scalars['String'];
};

export type GetResignationHrRequestInput = {
  hrRequestId: Scalars['String'];
};

export type GetResignationInput = {
  resignationId: Scalars['String'];
};

export type GetResignationsInput = {
  companyId?: Maybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  status?: Maybe<ResignationStatus>;
};

export type GetSalesforceCasesForNewPolicyRequestInput = {
  companyId: Scalars['String'];
  excludedHrRequestIds: Array<Scalars['String']>;
};

export type GetScheduledEventsForUserInput = {
  /** User ID */
  userId?: Maybe<Scalars['String']>;
};

export type GetTerminationHrRequestInput = {
  hrRequestId: Scalars['String'];
};

export type GetTerminationInput = {
  terminationId: Scalars['String'];
};

export type GetTerminationsInput = {
  companyId?: Maybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  status?: Maybe<TerminationStatus>;
};

export type GetUserCoursesInput = {
  userId?: Maybe<Scalars['String']>;
};

export type GetUserWarningDocumentsInput = {
  employeeId: Scalars['String'];
};

export type GetVoicesFeedbackListInput = {
  companyId: Scalars['String'];
};

export type Goal = {
  __typename?: 'Goal';
  category: GoalCategory;
  id: Scalars['ID'];
  label: Scalars['String'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
  requirements: Array<Requirement>;
  status: GoalStatus;
};

export enum GoalCategory {
  CompleteCompanyReview = 'COMPLETE_COMPANY_REVIEW',
  VerifyBankAccountOwnership = 'VERIFY_BANK_ACCOUNT_OWNERSHIP',
  VerifyCompanyFinances = 'VERIFY_COMPANY_FINANCES'
}

/** The completion status of the goal */
export enum GoalCompletionStatus {
  Automatic = 'Automatic',
  Cancelled = 'Cancelled',
  Manual = 'Manual',
  Skipped = 'Skipped'
}

/** The name of the goal */
export enum GoalName {
  BambeePlusSetup = 'BambeePlusSetup',
  EmployeeOnboardingKit = 'EmployeeOnboardingKit',
  GetReadyToGetPaid = 'GetReadyToGetPaid',
  GettingReadyToHire = 'GettingReadyToHire',
  HiringKit = 'HiringKit',
  HrAudit = 'HrAudit',
  ImproveStaffCommunication = 'ImproveStaffCommunication',
  IntroduceStaffToBambee = 'IntroduceStaffToBambee',
  MeetYourTeam = 'MeetYourTeam',
  PayrollOnboarding = 'PayrollOnboarding',
  SendJobOffer = 'SendJobOffer',
  WorkplaceViolenceCaHrmFollowUp = 'WorkplaceViolenceCaHrmFollowUp'
}

export enum GoalStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum GroupView {
  Default = 'Default',
  IAmMember = 'IAmMember',
  ICanSee = 'ICanSee',
  ThatIOwn = 'ThatIOwn'
}

export type GuardArtifact = {
  __typename?: 'GuardArtifact';
  /** The name of the guard */
  name: Scalars['String'];
  /** The result of the guard */
  result: GuardResultDto;
};

export type GuardResultDto = {
  __typename?: 'GuardResultDto';
  /** Whether or not the user was allowed to pass the guard */
  allowed: Scalars['Boolean'];
  /** The reason why the guard choice was made */
  reason: Scalars['Boolean'];
};

export type HotlineCall = {
  __typename?: 'HotlineCall';
  agent?: Maybe<HotlineCallAgent>;
  callDuration?: Maybe<Scalars['Float']>;
  callPlacedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  status: HotlineCallStatus;
  summary?: Maybe<Scalars['String']>;
};

export type HotlineCallAgent = {
  __typename?: 'HotlineCallAgent';
  avatarUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum HotlineCallStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Missed = 'MISSED',
  Pending = 'PENDING'
}

export type HrPracticesArtifact = {
  __typename?: 'HrPracticesArtifact';
  /** The download url for the hr practices artifact */
  downloadUrl: Scalars['String'];
  /** The dto of the hr practices artifact */
  dto: Scalars['String'];
  /** The artifact renered as HTML */
  html: Scalars['String'];
  /** ID of the hr practices artifact that was created */
  id?: Maybe<Scalars['String']>;
  /** The status of the hr practices artifact */
  status: Scalars['String'];
  /** Title of the hr practices artifact */
  title: Scalars['String'];
};

export type HrRequest = {
  __typename?: 'HrRequest';
  /** list of artifacts created by ai workflows */
  aiArtifacts?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether this HR Request originated from an AI request */
  aiGenerated?: Maybe<Scalars['String']>;
  /** Salesforce ID of the HR Request */
  caseId: Scalars['String'];
  conversation?: Maybe<Conversation>;
  /** Intercom conversation ID */
  conversationId?: Maybe<Scalars['String']>;
  /** Date the HR Request was created */
  createdAt: Scalars['DateTime'];
  /** Company ID of the customer */
  customerCompanyId: Scalars['String'];
  /** Bambee ID of the HR Request */
  id: Scalars['String'];
  intercomConversationId?: Maybe<Scalars['String']>;
  /** ID of the Assistants API thread used to generate the Policy HR Request */
  threadId?: Maybe<Scalars['String']>;
};

export enum HrRequestAudience {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE'
}

export type HrRequestDetail = {
  __typename?: 'HrRequestDetail';
  /** AI metadata of the HR request */
  aiMetadata?: Maybe<Scalars['String']>;
  caseId: Scalars['String'];
  caseNumber?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expectationDate?: Maybe<Scalars['DateTime']>;
  hrRequestSurveyAnswers?: Maybe<Scalars['JSON']>;
  intercomId?: Maybe<Scalars['String']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']>;
  stage?: Maybe<CaseStage>;
  status: CaseStatus;
  subType?: Maybe<CaseSubType>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<CaseType>;
};

export type HrRequestExpectation = {
  __typename?: 'HrRequestExpectation';
  cycleTime: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type HrRequestExtendedDetail = {
  __typename?: 'HrRequestExtendedDetail';
  /** AI generated action plan */
  actionPlan?: Maybe<Scalars['String']>;
  /** Bambee agent who is assigned to the HR request */
  agent?: Maybe<CallAgent>;
  /** AI metadata of the HR request */
  aiMetadata?: Maybe<Scalars['String']>;
  /** Present if HR request went through AI Assistant flow */
  aiSummary?: Maybe<Scalars['String']>;
  /** AI generated best practice summary */
  bestPractices?: Maybe<Scalars['String']>;
  caseId: Scalars['String'];
  caseNumber?: Maybe<Scalars['String']>;
  /** Company ID of the HR request */
  companyId: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  /** AI generated comprehensive guidance */
  comprehensiveGuidance?: Maybe<Scalars['String']>;
  /** Created by user ID */
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expectationDate?: Maybe<Scalars['DateTime']>;
  /** AI generated HR practices */
  hrPractices?: Maybe<Scalars['String']>;
  hrRequestSurveyAnswers?: Maybe<Scalars['JSON']>;
  intercomId?: Maybe<Scalars['String']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** Owner ID of the HR request (Bambee rep) */
  ownerId?: Maybe<Scalars['String']>;
  /** Policies related to the HR request */
  policies?: Maybe<Array<HrRequestPolicy>>;
  /** Cases related to the HR request */
  relatedCases?: Maybe<Array<RelatedCase>>;
  /** Scheduled events for the HR request */
  scheduledEvents: Array<ScheduledEvent>;
  stage?: Maybe<CaseStage>;
  status: CaseStatus;
  subType?: Maybe<CaseSubType>;
  subject?: Maybe<Scalars['String']>;
  /** AI generated summary of the HR request */
  summary?: Maybe<Scalars['String']>;
  /** AI Assistant thread ID, if available */
  threadId?: Maybe<Scalars['String']>;
  /** Timeline of events for the HR request */
  timeline: Array<TimelineItem>;
  type?: Maybe<CaseType>;
};

export type HrRequestGroup = {
  __typename?: 'HrRequestGroup';
  icon: Scalars['String'];
  key: HrRequestGroupKey;
  title: Scalars['String'];
};

export enum HrRequestGroupKey {
  EmployeeFeedback = 'EMPLOYEE_FEEDBACK',
  EmployeeIssues = 'EMPLOYEE_ISSUES',
  EndingEmployment = 'ENDING_EMPLOYMENT',
  HiringOnboarding = 'HIRING_ONBOARDING',
  IssueReporting = 'ISSUE_REPORTING',
  PayBenefits = 'PAY_BENEFITS',
  Policies = 'POLICIES',
  Support = 'SUPPORT',
  TimeOff = 'TIME_OFF'
}

export type HrRequestOption = {
  __typename?: 'HrRequestOption';
  audience: Array<HrRequestAudience>;
  description: Scalars['String'];
  expectation?: Maybe<HrRequestExpectation>;
  groupKey: HrRequestGroupKey;
  keywords: Array<Scalars['String']>;
  popular?: Maybe<HrRequestOptionPopular>;
  requiresPrimaryHrm: Scalars['Boolean'];
  slug: HrRequestSlug;
  subType?: Maybe<HrRequestSubType>;
  title: Scalars['String'];
  type: HrRequestType;
  unlisted?: Maybe<Scalars['Boolean']>;
};

export type HrRequestOptionPopular = {
  __typename?: 'HrRequestOptionPopular';
  description?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
};

export type HrRequestOptionsResponse = {
  __typename?: 'HrRequestOptionsResponse';
  groups: Array<HrRequestGroup>;
  options: Array<HrRequestOption>;
};

export enum HrRequestOrigin {
  Ai = 'AI',
  Api1 = 'API1',
  Api2 = 'API2',
  App = 'APP',
  Call = 'CALL',
  Email = 'EMAIL',
  Honey = 'HONEY',
  Intercom = 'INTERCOM',
  MobileApp = 'MOBILE_APP',
  Payrollservice = 'PAYROLLSERVICE',
  Phone = 'PHONE',
  Salesforceautomation = 'SALESFORCEAUTOMATION',
  Salesforcemanualinput = 'SALESFORCEMANUALINPUT',
  Taskservice = 'TASKSERVICE',
  Truly = 'TRULY',
  Webform = 'WEBFORM'
}

export type HrRequestPolicy = {
  __typename?: 'HrRequestPolicy';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['String'];
  kind: PolicyKind;
  name: Scalars['String'];
  status: PolicyStatus;
  step: Scalars['String'];
};

export enum HrRequestSlug {
  AdminSupport = 'ADMIN_SUPPORT',
  BillingIssue = 'BILLING_ISSUE',
  BillingPayments = 'BILLING_PAYMENTS',
  BonusesCommission = 'BONUSES_COMMISSION',
  DisabilityAccomodation = 'DISABILITY_ACCOMODATION',
  EmployeeBenefits = 'EMPLOYEE_BENEFITS',
  EmployeeChat = 'EMPLOYEE_CHAT',
  EmployeeCompliants = 'EMPLOYEE_COMPLIANTS',
  FinalPay = 'FINAL_PAY',
  FiringTermination = 'FIRING_TERMINATION',
  Guidance = 'GUIDANCE',
  HrTeamIssue = 'HR_TEAM_ISSUE',
  I9EmploymentEligibility = 'I9_EMPLOYMENT_ELIGIBILITY',
  Incident = 'INCIDENT',
  JobDescription = 'JOB_DESCRIPTION',
  Layoff = 'LAYOFF',
  LeaveOfAbsence = 'LEAVE_OF_ABSENCE',
  MealAndRestBreaks = 'MEAL_AND_REST_BREAKS',
  NewPolicy = 'NEW_POLICY',
  OtherIssue = 'OTHER_ISSUE',
  Overtime = 'OVERTIME',
  PaidTimeOff = 'PAID_TIME_OFF',
  Payroll = 'PAYROLL',
  PayrollEmployee = 'PAYROLL_EMPLOYEE',
  PayrollImplementation = 'PAYROLL_IMPLEMENTATION',
  PerformanceDisciplinaryAction = 'PERFORMANCE_DISCIPLINARY_ACTION',
  PreEmployment = 'PRE_EMPLOYMENT',
  Resignation = 'RESIGNATION',
  SickLeave = 'SICK_LEAVE',
  TechnologyIssue = 'TECHNOLOGY_ISSUE',
  Tips = 'TIPS',
  TravelTime = 'TRAVEL_TIME',
  UnemploymentClaims = 'UNEMPLOYMENT_CLAIMS',
  WebsiteAppHelp = 'WEBSITE_APP_HELP',
  WorkplacePosting = 'WORKPLACE_POSTING',
  WorkInjury = 'WORK_INJURY'
}

export enum HrRequestSubType {
  AdaAccommodation = 'ADA_ACCOMMODATION',
  AdjustApprovedPayroll = 'ADJUST_APPROVED_PAYROLL',
  AppHelp = 'APP_HELP',
  BambeePlusOfferQuestion = 'BAMBEE_PLUS_OFFER_QUESTION',
  BillingIssue = 'BILLING_ISSUE',
  BonusCommission = 'BONUS_COMMISSION',
  EmployeeBenefits = 'EMPLOYEE_BENEFITS',
  EmployeeChat = 'EMPLOYEE_CHAT',
  EmployeeIncident = 'EMPLOYEE_INCIDENT',
  EmployeeRequest = 'EMPLOYEE_REQUEST',
  EndingEmploymentEmergency = 'ENDING_EMPLOYMENT_EMERGENCY',
  EndingEmploymentLayoff = 'ENDING_EMPLOYMENT_LAYOFF',
  EndingEmploymentResignation = 'ENDING_EMPLOYMENT_RESIGNATION',
  FinalPay = 'FINAL_PAY',
  FiringTermination = 'FIRING_TERMINATION',
  General = 'GENERAL',
  HiringOnboardingPreEmployment = 'HIRING_ONBOARDING_PRE_EMPLOYMENT',
  HrPractice = 'HR_PRACTICE',
  HrTeamIssue = 'HR_TEAM_ISSUE',
  I9EmploymentEligibilityForm = 'I9_EMPLOYMENT_ELIGIBILITY_FORM',
  InitialHrRequest = 'INITIAL_HR_REQUEST',
  JobDescription = 'JOB_DESCRIPTION',
  LeaveAbsence = 'LEAVE_ABSENCE',
  MissedPayroll = 'MISSED_PAYROLL',
  NewPolicy = 'NEW_POLICY',
  OtherIssue = 'OTHER_ISSUE',
  PayrollImplementation = 'PAYROLL_IMPLEMENTATION',
  SettingUpBambeePayroll = 'SETTING_UP_BAMBEE_PAYROLL',
  SickLeave = 'SICK_LEAVE',
  StaffComplaint = 'STAFF_COMPLAINT',
  TaxAmendment = 'TAX_AMENDMENT',
  TaxQuestion = 'TAX_QUESTION',
  TechnologyIssue = 'TECHNOLOGY_ISSUE',
  TimeAndAttendance = 'TIME_AND_ATTENDANCE',
  UnemploymentClaims = 'UNEMPLOYMENT_CLAIMS',
  WageHour = 'WAGE_HOUR',
  WorkersCompensation = 'WORKERS_COMPENSATION',
  WorkplacePosting = 'WORKPLACE_POSTING'
}

export enum HrRequestType {
  AdminSupport = 'ADMIN_SUPPORT',
  BambeePayroll = 'BAMBEE_PAYROLL',
  Billing = 'BILLING',
  CompensationBenefits = 'COMPENSATION_BENEFITS',
  CustomerActivation = 'CUSTOMER_ACTIVATION',
  EmailAutoresponder = 'EMAIL_AUTORESPONDER',
  EmployeeFeedback = 'EMPLOYEE_FEEDBACK',
  EmployeeRelations = 'EMPLOYEE_RELATIONS',
  EndingEmployment = 'ENDING_EMPLOYMENT',
  Guidance = 'GUIDANCE',
  HiringOnboarindg = 'HIRING_ONBOARINDG',
  ImplementationPlan = 'IMPLEMENTATION_PLAN',
  IssueReporting = 'ISSUE_REPORTING',
  LaborLaws = 'LABOR_LAWS',
  PayrollSupport = 'PAYROLL_SUPPORT',
  PerformanceManagement = 'PERFORMANCE_MANAGEMENT',
  Policies = 'POLICIES',
  Service = 'SERVICE',
  TechSupport = 'TECH_SUPPORT',
  UnknownRequest = 'UNKNOWN_REQUEST'
}

export enum HrScore {
  Fail = 'FAIL',
  Fair = 'FAIR',
  Good = 'GOOD',
  Great = 'GREAT',
  Poor = 'POOR'
}

export type IdNamePair = {
  __typename?: 'IdNamePair';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ImplementationPlanArtifact = {
  __typename?: 'ImplementationPlanArtifact';
  /** The download url for the hr practices artifact */
  downloadUrl: Scalars['String'];
  /** The dto of the hr practices artifact */
  dto: Scalars['String'];
  /** The artifact renered as HTML */
  html: Scalars['String'];
  /** ID of the hr practices artifact that was created */
  id?: Maybe<Scalars['String']>;
  /** The status of the hr practices artifact */
  status: Scalars['String'];
  /** Title of the hr practices artifact */
  title: Scalars['String'];
};

export type ImportTimesheetsInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
  /** Ids of Bambee contractors who's hourly, OT, and Holiday earnings will be imported from timesheets */
  contractorIds?: Maybe<Array<Scalars['String']>>;
  /** Ids of Bambee employees who's hourly, OT, and Holiday earnings will be imported from timesheets */
  employeeIds?: Maybe<Array<Scalars['String']>>;
  /** Bambee payroll ID */
  id: Scalars['Int'];
};

export type IncidentArtifact = {
  __typename?: 'IncidentArtifact';
  /** The ID of the salesforce case associated with the incident */
  caseId: Scalars['String'];
  /** The url to download the artifact */
  downloadUrl: Scalars['String'];
  /** The summary render as a rich HTML document. */
  html: Scalars['String'];
  /** The id of the incident after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** The parties involved with the incident */
  involved: Array<InvolvedPartyArtifact>;
  /** The status of the incident artifact */
  status: BestPracticeStatus;
  /** The title of the incident */
  title: Scalars['String'];
};

export enum IndustryType {
  ArtsOrEntertainmentOrRecreation = 'ARTS_OR_ENTERTAINMENT_OR_RECREATION',
  AutoOrMachineRepair = 'AUTO_OR_MACHINE_REPAIR',
  AutoOrMachineSales = 'AUTO_OR_MACHINE_SALES',
  CleaningServices = 'CLEANING_SERVICES',
  ConsultingServices = 'CONSULTING_SERVICES',
  EducationalServices = 'EDUCATIONAL_SERVICES',
  FamilyCareServices = 'FAMILY_CARE_SERVICES',
  FinancialServices = 'FINANCIAL_SERVICES',
  FoodAndBeverageRetailOrWholesale = 'FOOD_AND_BEVERAGE_RETAIL_OR_WHOLESALE',
  GeneralConstructionOrGeneralContracting = 'GENERAL_CONSTRUCTION_OR_GENERAL_CONTRACTING',
  HealthCare = 'HEALTH_CARE',
  HospitalityOrAccommodation = 'HOSPITALITY_OR_ACCOMMODATION',
  HvacOrPlumbingOrElectricalContracting = 'HVAC_OR_PLUMBING_OR_ELECTRICAL_CONTRACTING',
  LegalServices = 'LEGAL_SERVICES',
  NonFoodRetailOrWholesale = 'NON_FOOD_RETAIL_OR_WHOLESALE',
  Other = 'OTHER',
  PersonalCareServices = 'PERSONAL_CARE_SERVICES',
  RealEstate = 'REAL_ESTATE',
  Restaurant = 'RESTAURANT',
  ScientificOrTechnicalServices = 'SCIENTIFIC_OR_TECHNICAL_SERVICES',
  SecurityServices = 'SECURITY_SERVICES',
  TobaccoOrAlcoholSales = 'TOBACCO_OR_ALCOHOL_SALES',
  Transportation = 'TRANSPORTATION'
}

export type InitializePayrollInput = {
  /** Payroll ID */
  id: Scalars['ID'];
  /** If this payroll is importing hours from deputy */
  importHours?: Scalars['Boolean'];
};

export type InvolvedPartyArtifact = {
  __typename?: 'InvolvedPartyArtifact';
  /** The id of the party involved with the incident, if an employee */
  id?: Maybe<Scalars['String']>;
  /** The name of the party involved with the incident */
  name: Scalars['String'];
  /** The role of the party involved with the incident */
  role: InvolvedPartyRole;
};

export enum InvolvedPartyRole {
  Accused = 'ACCUSED',
  Reporter = 'REPORTER',
  Subject = 'SUBJECT',
  Witness = 'WITNESS'
}

export type IsEventScheduledForUser = {
  __typename?: 'IsEventScheduledForUser';
  /** The invitee email */
  email: Scalars['String'];
  /** The event slug to check */
  eventSlug: Scalars['String'];
  id: Scalars['ID'];
  /** True if event type has already been scheduled for the email. False otherwise. */
  isScheduled: Scalars['Boolean'];
};

export type IsEventScheduledForUserInput = {
  /** The invitee email */
  email: Scalars['String'];
  /** The event slug to check */
  eventSlug: Scalars['String'];
};



export type JobDescription = {
  __typename?: 'JobDescription';
  aiGenerated?: Maybe<AiGenerated>;
  aiGeneratedId?: Maybe<Scalars['String']>;
  /** Number of employees this job description is assigned to */
  assignmentCount?: Maybe<Scalars['Float']>;
  body: Scalars['JSON'];
  completedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type JobDescriptionArtifact = {
  __typename?: 'JobDescriptionArtifact';
  /** The ID of the salesforce case associated with the job description */
  caseId: Scalars['String'];
  /** The job description dto */
  dto: JobDescriptionDto;
  /** The summary render as a rich HTML document. */
  html: Scalars['String'];
  /** The id of the job description after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** The gather summary status */
  status: JobDescriptionStatus;
  /** The title the job description */
  title?: Maybe<Scalars['String']>;
};

export type JobDescriptionDto = {
  __typename?: 'JobDescriptionDto';
  employeeType?: Maybe<JobDescriptionEmployeePayType>;
  employmentPayRate?: Maybe<JobDescriptionEmploymentPayRate>;
  employmentTaxType?: Maybe<JobDescriptionEmploymentTaxType>;
  industry: Scalars['String'];
  jobTitle: Scalars['String'];
  location?: Maybe<JobDescriptionLocation>;
  travelRequirements?: Maybe<Scalars['String']>;
  workingSchedule?: Maybe<Array<WorkingSchedule>>;
};

export enum JobDescriptionEmployeePayType {
  FullTime = 'FullTime',
  PartTime = 'PartTime'
}

export enum JobDescriptionEmploymentPayRate {
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export enum JobDescriptionEmploymentTaxType {
  Report_1099 = 'REPORT_1099',
  ReportW2 = 'REPORT_W2'
}

export enum JobDescriptionLocation {
  Hybrid = 'Hybrid',
  InPerson = 'InPerson',
  Remote = 'Remote'
}

export enum JobDescriptionStatus {
  Accepted = 'accepted',
  Assigned = 'assigned',
  Drafted = 'drafted',
  New = 'new'
}

export enum Jurisdiction {
  All = 'ALL',
  Fed = 'FED',
  Local = 'LOCAL'
}

export enum Language {
  En = 'EN',
  Es = 'ES'
}

/** The reason the company was brought to Bambee */
export enum LeadReason {
  ActiveHrIssue = 'ACTIVE_HR_ISSUE',
  CompliancePolicies = 'COMPLIANCE_POLICIES',
  EeOnboardingTraining = 'EE_ONBOARDING_TRAINING',
  General = 'GENERAL',
  Other = 'OTHER',
  PerformanceManagement = 'PERFORMANCE_MANAGEMENT',
  RecruitingHiring = 'RECRUITING_HIRING',
  Terminations = 'TERMINATIONS',
  Wages = 'WAGES'
}

/** The type of link for LINK action type */
export enum LinkType {
  Cap = 'CAP',
  Document = 'DOCUMENT',
  EmployeeDetail = 'EMPLOYEE_DETAIL',
  Eoe = 'EOE',
  GuidanceDetail = 'GUIDANCE_DETAIL',
  Pip = 'PIP',
  Policy = 'POLICY'
}

export type ListHrRequestDetails = {
  __typename?: 'ListHrRequestDetails';
  hrRequests: Array<Maybe<HrRequestDetail>>;
};

export type ListHrRequestsResponse = {
  __typename?: 'ListHrRequestsResponse';
  hrRequests: Array<Maybe<HrRequest>>;
};

export enum ListPayrollDeletedOptions {
  All = 'ALL',
  None = 'NONE',
  Only = 'ONLY'
}

export type ListReportCardsInput = {
  companyId: Scalars['String'];
  employeeId?: Maybe<Scalars['String']>;
};

export type ListSalesforceCasesResponse = {
  __typename?: 'ListSalesforceCasesResponse';
  cases: Array<Maybe<SalesforceCase>>;
};

export type ListTicketsInput = {
  companyId: Scalars['String'];
};

export type ListTicketsResponse = {
  __typename?: 'ListTicketsResponse';
  id: Scalars['ID'];
  tickets: Array<Maybe<Ticket>>;
  totalTickets: Scalars['Int'];
};

export type ManagedReport = {
  __typename?: 'ManagedReport';
  employees: Array<CoreUser>;
  /** Manager Employee Id */
  id: Scalars['ID'];
  manager: CoreUser;
};

export type MessageContentDto = {
  __typename?: 'MessageContentDto';
  /** image content */
  image_file?: Maybe<Scalars['String']>;
  /** image content */
  image_url?: Maybe<Scalars['String']>;
  /** refusal content */
  refusal?: Maybe<Scalars['String']>;
  /** text content */
  text?: Maybe<TextContentBlock>;
  /** Type of content */
  type: Scalars['String'];
};

export enum MessageGroupType {
  Custom = 'CUSTOM',
  Inactive = 'INACTIVE',
  SignatureRequired = 'SIGNATURE_REQUIRED'
}

export type MessageMetaDataDto = {
  __typename?: 'MessageMetaDataDto';
  /** Indicates the message represents an artifact. Use the artifact object to retreive values instead of message content */
  artifact?: Maybe<Scalars['String']>;
  /** The name of the assistant */
  assistant?: Maybe<Scalars['String']>;
  /** The id of the assistant */
  assistantId?: Maybe<Scalars['String']>;
  /** Indicates the message should not be displayed to the user */
  hidden?: Maybe<Scalars['String']>;
  /** Indicates the message was injected by the backend. Regardless of the role. */
  injected?: Maybe<Scalars['String']>;
  /** Indicates whether the base policy template is from our existing database */
  isBambeeTemplateBase?: Maybe<Scalars['String']>;
  /** Metadata type */
  type?: Maybe<Scalars['String']>;
  /** Metadata value */
  value?: Maybe<Scalars['String']>;
};

export enum MessageType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export enum MissedCallFeeStatus {
  Charged = 'CHARGED',
  Warned = 'WARNED'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept a cancellation offer */
  acceptOffer: Scalars['Boolean'];
  /** Attempts to accept a recommendation. If the acceptr meets the criteria, the recommendation is acceptd, setting the status to ACCEPTED. */
  acceptRecommendation: CoreRecommendation;
  /** Accept a cancellation trial offer */
  acceptTrialOffer: Scalars['Boolean'];
  activateHandsFreeActionItem: Scalars['Boolean'];
  addAutoassignHrManagerConfiguration: Array<AutoAssignHrManager>;
  addBusinessManagerConfiguration: Array<BusinessManager>;
  addCredits: AddCreditsResult;
  addSubscription: AddCreditsResult;
  adminEnqueueTicketForSync: Scalars['Boolean'];
  aiOptIn: Scalars['Boolean'];
  applyCorePayrollDiscountToCompanySubscription: Subscription;
  approvePayroll: Payroll;
  /** Attempts to approve a request. If the approver meets the criteria, the request is approved, setting the status to APPROVED. */
  approveRequest: CoreRequest;
  archiveAiThread: AiThread;
  archiveCompanyPolicy?: Maybe<CorePolicy>;
  archivePolicy?: Maybe<CorePolicy>;
  assignUserToPolicies: Array<CoreDocument>;
  assignUsersToPolicies: Array<CoreUser>;
  assignWorkerRoles: CoreUser;
  attachResignationFiles: Resignation;
  attachTerminationFiles: Termination;
  backfillBambeePlusTopics: Scalars['Boolean'];
  /** Attempts to bulk approve requests. If the approver meets the criteria, the requests are approved, setting their statuses to APPROVED.If an approval fails, the operation continues and the error is returned in the response. */
  bulkApproveRequests: BulkRequestResult;
  /** Attempts to bulk cancel requests. If a cancellation fails, the operation continues and the error is returned in the response. */
  bulkCancelRequests: BulkRequestResult;
  bulkCompleteEnrollments: EnrollmentCompleted;
  bulkEarningsImport: BulkEarningsImportResult;
  bulkEnrollUsers: BulkEnrollUsersResponse;
  bulkMessageStaff: BulkMessageStaffResult;
  bulkPurchaseSeats: Array<PurchaseSeatsResponse>;
  /** Attempts to bulk reject requests. If the rejector meets the criteria, the requests are rejected, setting their statuses to REJECTED.If a rejection fails, the operation continues and the error is returned in the response. */
  bulkRejectRequests: BulkRequestResult;
  bulkSetupStaff: Scalars['Boolean'];
  /** Toggles multiple activations at once */
  bulkToggleActivations: BulkActivationResult;
  bulkUploadEmployeesThroughCsv: Array<BulkUploadEmployeesResponse>;
  cancelBambeePlus: BambeePlus;
  cancelNectarSubscription: Product;
  cancelPayroll: Scalars['Boolean'];
  cancelPendingHotlineCall: Scalars['Boolean'];
  /** Attempts to cancel a recommendation. If canceler is the user who created the recommendation, the recommendation is cancelled, setting the status to CANCELLED. */
  cancelRecommendation: CoreRecommendation;
  /** Attempts to cancel a request. If canceler is the user who created the request, the request is cancelled, setting the status to CANCELLED. */
  cancelRequest: CoreRequest;
  cancelResignation: Resignation;
  cancelScheduledEvent: ScheduledEvent;
  cancelTermination: Termination;
  cancelTimeAttendance: Scalars['Boolean'];
  changeTrialEndDateForCoreSubscription: Subscription;
  chatWithAssistant: AiAssistantResponse;
  checkSyncCompanies: CheckSyncCompanyFanoutResponse;
  /** Sync Company FROM check */
  checkSyncCompany?: Maybe<Company>;
  clearBenefits: Scalars['Boolean'];
  clearPayrolls: Scalars['Boolean'];
  /** Record that a user clicked on an action */
  clickedOnNotificationAction: Scalars['Boolean'];
  closeHrRequest: HrRequest;
  completeCompanyPractice: Practice;
  completeCompanySurvey: Survey;
  completeGoal: CoreGoal;
  /** Completes a job description. Will no longer be editable. */
  completeJobDescription: JobDescription;
  completeReportCard: ReportCard;
  completeTask?: Maybe<CoreTask>;
  confirmMicroDeposit: BillingPaymentMethod;
  confirmResignation: Resignation;
  confirmTermination: Termination;
  confirmUserMfaEnrollment: AuthMfaConfig;
  /** Creates or updates an activation for a feature key for a company */
  createActivation: CoreActivation;
  createBundle: BundleResponse;
  createCancellationRequest: CancellationModel;
  createChallenge: AuthMfaChallenge;
  createCompany: Company;
  createCompanyInCheck: Company;
  createCompanyRoles: Array<CompanyRole>;
  createEliteAddonSubscription: Scalars['Boolean'];
  createEnrollmentProfile: Scalars['Boolean'];
  createHrRequest: HrRequest;
  createHrRequestByInternalUser: HrRequest;
  createHrRequestFromSalesforceCase: HrRequest;
  createHrRequestsFromIntercomConversations: ListHrRequestsResponse;
  createInitialPayrollsBackfill: Scalars['Boolean'];
  /** Creates a new job description */
  createJobDescription: JobDescription;
  /** Create multiple notices at once */
  createManyNotices: Array<Notice>;
  /** Create a new notice */
  createNotice: Notice;
  createPaySchedule: PaySchedule;
  createPayroll: Payroll;
  createPayrollSubscription: Subscription;
  createPlanLock: PlanLock;
  createProductInterest: ProductInterest;
  createReportCard: NewReportCard;
  createResignation: Resignation;
  createSignatoryInCheck: Company;
  createTermination: Termination;
  createVoicesFeedback: VoicesFeedback;
  createWebinar: Webinar;
  createWorkplace: Workplace;
  /** Attempts to decline a recommendation. If the declineor meets the criteria, the recommendation is declined, setting the status to DECLINED. */
  declineRecommendation: CoreRecommendation;
  /** Deletes an activation */
  deleteActivation: CoreActivation;
  deleteBundle: DeleteBundleResponse;
  deleteCompanyRolesById?: Maybe<Array<CompanyRole>>;
  deleteContractor: Contractor;
  deleteEmployee: Employee;
  /** Soft delete a job description. Will throw an error if the job description is assigned to any employees. */
  deleteJobDescription: JobDescription;
  deletePayroll: Payroll;
  deleteUser: Scalars['Boolean'];
  /** Enable Deputy support for the install associated to input companyId */
  disableDeputySupport: Scalars['Boolean'];
  disableMfaEnrollment: Array<AuthMfaConfig>;
  /** Dismiss a notice */
  dismissNotice: Scalars['Boolean'];
  /** Dismiss a notification */
  dismissNotification: Notification;
  /** Upgrade a deputy install for a company. If successful, will trigger the creation of workplaces and the upsert of users in deputy */
  downgradeInstall?: Maybe<DeputyConnection>;
  editResignationDetails: Resignation;
  editTerminationDetails: Termination;
  emit: EventEmitted;
  /** Enable Deputy support for the install associated to input companyId */
  enableDeputySupport: Scalars['Boolean'];
  enqueueHotlineCall: Scalars['Boolean'];
  enrollMfaDevice: AuthMfaChallenge;
  enrollUsers: EnrollUsersResponse;
  existingCompanyPurchasedPayroll: Scalars['Boolean'];
  extendBambeePlusOnboardingDueDate: BambeePlus;
  extendBambeePlusOnboardingWithSpecificDate: BambeePlus;
  finchManualSetupCompleted: Scalars['Boolean'];
  forceApproveComplexPayrollOnboardingAnswers: Scalars['Boolean'];
  forceInitializeUserGroups: Scalars['Boolean'];
  /** Calls our ai provider to generate a job description powered by AI taking user input into consideration */
  generateAiJobDescription: JobDescription;
  /** Kicks off the AI generation process in the background returning quickly with a partial job description */
  generateAiJobDescriptionV2: JobDescription;
  generateCheckComponentLink: CheckComponentLink;
  generateCompanyOnboardingLink: Scalars['String'];
  /** Generates a link to the company's Payroll Report in Check */
  generateCompanyPayrollReportLink: Scalars['String'];
  generateContractorOnboardingLink: Scalars['String'];
  generateEmployeeOnboardingLink: Scalars['String'];
  /** Generates a link to the employee's post-tax deductions page in Check */
  generateEmployeePostTaxDeductionsLink: Scalars['String'];
  ignoreEligiblityAndPurchaseBambeePlus: BambeePlus;
  importTimesheets: DeputySyncInfo;
  initializePayroll: Payroll;
  markCourseTicketAsIncomplete: Ticket;
  migrateUsersToMultiplePayRates: Scalars['Boolean'];
  optInToElectronicDeliveryInCheck: Scalars['Boolean'];
  overrideCheckOnboarding: Scalars['Boolean'];
  performAutoHrmPodAssignment: Scalars['Boolean'];
  /** Ping deputy to test access token, and refresh if necessary */
  pingDeputy: PingDeputyResponse;
  previewPayroll: Payroll;
  productInterestNotificationDismissedInApp: ProductInterest;
  /** Provision a deputy install for a company. If successful, will trigger the creation of workplaces and the upsert of users in deputy */
  provisionDeputyInstall: DeputyConnection;
  purchaseBambeePlus: BambeePlus;
  purchaseCredits: PurchaseResult;
  purchaseSeats: PurchaseSeatsResponse;
  /** @deprecated Use `purchaseSeats` mutation instead */
  purchaseSeatsForBundle: PurchaseSeatsResponse;
  purchaseSubscription: PurchaseResult;
  /** @deprecated Use `purchaseSeats` mutation instead */
  purchaseTickets: PurchaseTicketsResponse;
  purchaseTimeAttendance: TimeAttendanceSubscriptionResponse;
  qaDeleteWebinar: Scalars['Boolean'];
  qaMutateDocumentAsUnsigned?: Maybe<CoreDocument>;
  qaMutateFeedsForCurrentDocumentStatus: Array<Feed>;
  qaMutatePolicyIncomplete?: Maybe<CorePolicy>;
  qaMutateRemoveManagerFeedsForDocument: Array<Feed>;
  quickbooksSync?: Maybe<SyncAttempt>;
  /** A generic reaction to a recommendation. If the reactor meets the criteria, the reaction is recorded and the recommendation status may be updated */
  reactToRecommendation: CoreRecommendation;
  reactivatePausedCompany: Scalars['Boolean'];
  reaffirmDocument: CoreDocument;
  /** Creates a generic recommendation based on the input provided. This is a raw recommendation and does not have any business logic applied to it. Admins only */
  recommendation: CoreRecommendation;
  refundCreditPurchase: RefundResult;
  registerForWebinar: WebinarRegistration;
  reinstateEmployee: Resignation;
  /** Attempts to reject a request. If the rejector meets the criteria, the request is rejected, setting the status to REJECTED. */
  rejectRequest: CoreRequest;
  remove: RemoveCompanyTrainingResponse;
  removeActiveCredits: Array<Credit>;
  removeAutoassignHrManagerConfiguration: Array<AutoAssignHrManager>;
  removeBusinessManagerConfiguration: Array<BusinessManager>;
  removeCourseCertificate?: Maybe<QaTrainingCertificates>;
  removeDuplicatedPolicyDocuments: DuplicatedPolicyDocumentResult;
  removePaymentMethod: Scalars['Boolean'];
  removeS3fileFromCourseCertificate?: Maybe<QaTrainingCertificates>;
  removeSeats: RemoveSeatsResponse;
  /** @deprecated Use `removeSeats` mutation instead */
  removeSeatsFromBundle: RemoveSeatsResponse;
  reopenPayroll: Payroll;
  replyToConversation: Conversation;
  replyToHrRequestAsAdmin: HrRequest;
  /** Creates a generic request based on the input provided. This is a raw request and does not have any business logic applied to it. Admins only */
  request: CoreRequest;
  requestPayrollCancellation: Scalars['Boolean'];
  resendChallenge: AuthMfaChallenge;
  resetCompany: Scalars['Boolean'];
  /** Reset deputy locations and departments */
  resetDeputy: Scalars['Boolean'];
  saveCompanyAnswer: Survey;
  saveCompanySetting: CompanySetting;
  saveComplexPayrollOnboarding: Scalars['Boolean'];
  /** Saves job description latest state associating to an employee if not already associated */
  saveJobDescriptionOnEmployee: EmployeeJobDescription;
  scratchToggleServiceAddon: ScratchServiceAddonsModel;
  sendFeedbackMessage: ChatMessageInterface;
  /** Finalizes a job description and sends it for acknowledgment to an employee */
  sendJobDescriptionToEmployee: EmployeeJobDescription;
  sendMagicLinkForEmail: Scalars['Boolean'];
  sendMessageToUser: ChatMessageInterface;
  sendReplyToUserThread: ChatMessageInterface;
  sendStaffOnboardInvite: Scalars['Boolean'];
  setCaseStatus: HrRequest;
  setDefaultPaymentMethod: BillingPaymentMethod;
  /** Sets up a contractor for payroll */
  setupContractor: Contractor;
  /** Sets up an employee for payroll */
  setupEmployee: Employee;
  /** User acknowleges the job description sent by employer */
  signEmployeeJobDescription: EmployeeJobDescription;
  startTask: CoreTask;
  submitAiPrompt: AiPromptResponse;
  sync: SyncResponse;
  /** Sync Company TO check */
  syncCompany: Company;
  syncContractor: Contractor;
  syncDocuments?: Maybe<Array<CoreDocument>>;
  syncEmployee: Employee;
  syncPayroll: Payroll;
  syncRequirements: Array<Requirement>;
  syncTimesheets: DeputySyncInfo;
  syncUserEnrollments: SyncUserEnrollmentsResponse;
  syncWorkerRoles: Scalars['Boolean'];
  /** Toggles an activation (enables or disables it) */
  toggleActivation: CoreActivation;
  track: AnalyticEventTracked;
  trackProductInterest: Scalars['String'];
  /** Creates a training recommendation based on the input provided */
  trainingRecommendation: CoreRecommendation;
  /** Creates a training request based on the input provided */
  trainingRequest: CoreRequest;
  triggerFixUserBundleEnrollments: EnrollUserResponse;
  triggerPayrollRunSNSTopicPublish: Scalars['Boolean'];
  unenrollCompanyBundle: Scalars['Boolean'];
  unenrollUsers: UnenrolledUsers;
  /** @deprecated use unenrollUsers */
  unenrollUsersFromBundle: UnenrolledUsers;
  updateApprovalDeadline: Payroll;
  updateCompany: Company;
  updateCompanyNotes: Company;
  updateCompanyRoles: Array<CompanyRole>;
  updateCompanyStatus: Company;
  updateContractorPayment: ContractorPayment;
  updateContractorWorkplace: Scalars['Boolean'];
  updateCoreCompany: CoreCompany;
  updateCoreUserEmployment: CoreUserEmployment;
  updateCoreUserProfile: CoreUserProfile;
  updateCoreUserState: CoreUserStates;
  updateEmployeeWorkplace: Scalars['Boolean'];
  /** Updates the title and body of a job description that is still in draft mode. */
  updateJobDescription: JobDescription;
  /** Update an existing notice */
  updateNotice?: Maybe<Notice>;
  updatePaySchedule: PaySchedule;
  updatePaymentSourceBillingAddress: PaymentSource;
  updatePayroll: Payroll;
  updatePayrollChecks: Payroll;
  updatePayrollItem: PayrollItem;
  updatePlanLock: PlanLock;
  updateReportCard: ReportCard;
  updateWorkplace: Workplace;
  /** Upgrade a company subscription from one plan to another one. */
  upgradeCorePlan: Subscription;
  upgradeFinchCode: CompanyFinchAccessToken;
  /** Upgrade a deputy install for a company. If successful, will trigger the creation of workplaces and the upsert of users in deputy */
  upgradeInstall?: Maybe<DeputyConnection>;
  uploadFile: Array<Goal>;
  uploadFilesToConversation: Conversation;
  /** Trigger the upsert of users in deputy */
  upsertDeputyAreas: Scalars['Boolean'];
  /** Upsert a deputy connection for a company. If successful, will trigger the creation of workplaces and the upsert of users in deputy */
  upsertDeputyConnection?: Maybe<DeputyConnection>;
  /** Trigger the upsert of users in deputy */
  upsertDeputyLocations: Scalars['Boolean'];
  /** Trigger the upsert of users in deputy */
  upsertDeputyUsers: Scalars['Boolean'];
  /** Creates a generic onboarding based on the input provided. This is a raw onboarding and does not have any business logic applied to it. Admins only */
  upsertOnboarding: CoreOnboarding;
  userToken: DoceboTokenResponse;
  verifyFEINInCheck?: Maybe<Company>;
};


export type MutationAcceptOfferArgs = {
  input: AcceptOfferInput;
};


export type MutationAcceptRecommendationArgs = {
  data: AcceptRecommendationInput;
};


export type MutationAcceptTrialOfferArgs = {
  input: AcceptTrialOfferInput;
};


export type MutationAddAutoassignHrManagerConfigurationArgs = {
  input: AutoAssignHrManagerInput;
};


export type MutationAddBusinessManagerConfigurationArgs = {
  input: BusinessManagerForTierInput;
};


export type MutationAddCreditsArgs = {
  data: AddCreditsInput;
};


export type MutationAddSubscriptionArgs = {
  data: AddSubscriptionInput;
};


export type MutationAdminEnqueueTicketForSyncArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationAiOptInArgs = {
  data: AiOptionInput;
};


export type MutationApplyCorePayrollDiscountToCompanySubscriptionArgs = {
  input: ApplyCorePayrollDiscountInput;
};


export type MutationApprovePayrollArgs = {
  data: ApprovePayrollInput;
};


export type MutationApproveRequestArgs = {
  data: RequestApprovalInput;
};


export type MutationArchiveAiThreadArgs = {
  threadId: Scalars['String'];
};


export type MutationArchiveCompanyPolicyArgs = {
  input: ArchivePolicyInput;
};


export type MutationArchivePolicyArgs = {
  input: ArchivePolicyInput;
};


export type MutationAssignUserToPoliciesArgs = {
  data: AssignUserToPoliciesInput;
};


export type MutationAssignUsersToPoliciesArgs = {
  data: AssignUsersToPoliciesInput;
};


export type MutationAssignWorkerRolesArgs = {
  input: AssignWorkerRolesInput;
};


export type MutationAttachResignationFilesArgs = {
  data: ResignationAttachInput;
};


export type MutationAttachTerminationFilesArgs = {
  data: TerminationAttachInput;
};


export type MutationBackfillBambeePlusTopicsArgs = {
  input: BackfillBambeePlusTopicsInput;
};


export type MutationBulkApproveRequestsArgs = {
  data: Array<RequestApprovalInput>;
};


export type MutationBulkCancelRequestsArgs = {
  data: Array<RequestCancelInput>;
};


export type MutationBulkCompleteEnrollmentsArgs = {
  data: BulkCompleteEnrollmentInput;
};


export type MutationBulkEarningsImportArgs = {
  data: BulkEarningsImportInput;
};


export type MutationBulkEnrollUsersArgs = {
  data: BulkEnrollUsersInput;
};


export type MutationBulkMessageStaffArgs = {
  data: BulkMessageStaffInput;
};


export type MutationBulkPurchaseSeatsArgs = {
  data: BulkPurchaseSeatsInput;
};


export type MutationBulkRejectRequestsArgs = {
  data: Array<RequestRejectionInput>;
};


export type MutationBulkSetupStaffArgs = {
  data: BulkSetupStaffInput;
};


export type MutationBulkToggleActivationsArgs = {
  data: Array<ActivationToggleInput>;
};


export type MutationBulkUploadEmployeesThroughCsvArgs = {
  base64: Scalars['String'];
};


export type MutationCancelBambeePlusArgs = {
  input: PurchaseBambeePlusInput;
};


export type MutationCancelNectarSubscriptionArgs = {
  data: CancelSubscriptionInput;
};


export type MutationCancelPayrollArgs = {
  data: CancelPayrollInput;
};


export type MutationCancelRecommendationArgs = {
  data: CancelRecommendationInput;
};


export type MutationCancelRequestArgs = {
  data: RequestCancelInput;
};


export type MutationCancelResignationArgs = {
  data: ResignationCancelInput;
};


export type MutationCancelScheduledEventArgs = {
  input: CancelScheduledEventInput;
};


export type MutationCancelTerminationArgs = {
  data: TerminationCancelInput;
};


export type MutationCancelTimeAttendanceArgs = {
  data: CancelTimeAttendanceInput;
};


export type MutationChangeTrialEndDateForCoreSubscriptionArgs = {
  data: ChangeTrialEndDateForCoreSubscriptionInput;
};


export type MutationChatWithAssistantArgs = {
  data: AiAssistantInput;
};


export type MutationCheckSyncCompaniesArgs = {
  data: CheckSyncCompaniesInput;
};


export type MutationCheckSyncCompanyArgs = {
  data: CheckSyncCompanyInput;
};


export type MutationClearBenefitsArgs = {
  companyId: Scalars['ID'];
};


export type MutationClearPayrollsArgs = {
  data: ClearPayrollsInput;
};


export type MutationClickedOnNotificationActionArgs = {
  actionId: Scalars['String'];
};


export type MutationCloseHrRequestArgs = {
  input: CloseHrRequestInput;
};


export type MutationCompleteCompanyPracticeArgs = {
  data: CompletePracticeInput;
};


export type MutationCompleteCompanySurveyArgs = {
  data: CompleteCompanySurveyInput;
};


export type MutationCompleteGoalArgs = {
  data: CompleteGoalInput;
};


export type MutationCompleteJobDescriptionArgs = {
  id: Scalars['String'];
};


export type MutationCompleteReportCardArgs = {
  data: CompleteReportCardInput;
};


export type MutationCompleteTaskArgs = {
  data: CompleteTaskInput;
};


export type MutationConfirmMicroDepositArgs = {
  input: ConfirmMicroDepositInput;
};


export type MutationConfirmResignationArgs = {
  data: ResignationConfirmationInput;
};


export type MutationConfirmTerminationArgs = {
  data: TerminationConfirmationInput;
};


export type MutationConfirmUserMfaEnrollmentArgs = {
  input: AuthMfaChallengeResponseInput;
};


export type MutationCreateActivationArgs = {
  data: ActivationInput;
};


export type MutationCreateBundleArgs = {
  data: CreateBundleInput;
};


export type MutationCreateCancellationRequestArgs = {
  input: CreateCancellationRequestInput;
};


export type MutationCreateChallengeArgs = {
  reason: Scalars['String'];
  type: AuthMfaType;
};


export type MutationCreateCompanyArgs = {
  id: Scalars['ID'];
  startDate?: Maybe<Scalars['DateTime']>;
};


export type MutationCreateCompanyInCheckArgs = {
  data: CreateCompanyInCheckInput;
};


export type MutationCreateCompanyRolesArgs = {
  data: CreateMultipleRolesForCompanyInput;
};


export type MutationCreateEliteAddonSubscriptionArgs = {
  input: CreateEliteAddonSubscriptionInput;
};


export type MutationCreateEnrollmentProfileArgs = {
  data: CreateEnrollmentProfileRequest;
};


export type MutationCreateHrRequestArgs = {
  input: CreateHrRequestInput;
};


export type MutationCreateHrRequestByInternalUserArgs = {
  input: CreateHrRequestByInternalUserInput;
};


export type MutationCreateHrRequestFromSalesforceCaseArgs = {
  input: CreateHrRequestFromSalesforceCaseInput;
};


export type MutationCreateHrRequestsFromIntercomConversationsArgs = {
  input: CreateHrRequestsFromIntercomConversationsInput;
};


export type MutationCreateJobDescriptionArgs = {
  data: CreateJobDescriptionInput;
};


export type MutationCreateManyNoticesArgs = {
  input: CreateManyNoticesInput;
};


export type MutationCreateNoticeArgs = {
  input: CreateNoticeInput;
};


export type MutationCreatePayScheduleArgs = {
  data: CreatePayScheduleInput;
};


export type MutationCreatePayrollArgs = {
  data: CreatePayrollInput;
};


export type MutationCreatePayrollSubscriptionArgs = {
  data: CreatePayrollSubscriptionInput;
};


export type MutationCreatePlanLockArgs = {
  input: CreatePlanLockInput;
};


export type MutationCreateProductInterestArgs = {
  input: CreateProductInterestInput;
};


export type MutationCreateReportCardArgs = {
  data: CreateReportCardInput;
};


export type MutationCreateResignationArgs = {
  data: ResignationCreateInput;
};


export type MutationCreateSignatoryInCheckArgs = {
  companyCheckId: Scalars['String'];
  data: CreateSignatoryInput;
};


export type MutationCreateTerminationArgs = {
  data: TerminationCreateInput;
};


export type MutationCreateVoicesFeedbackArgs = {
  input: CreateVoicesFeedbackInput;
};


export type MutationCreateWebinarArgs = {
  input: CreateWebinarInstanceRequest;
};


export type MutationCreateWorkplaceArgs = {
  data: CreateWorkplaceInput;
};


export type MutationDeclineRecommendationArgs = {
  data: DeclineRecommendationInput;
};


export type MutationDeleteActivationArgs = {
  data: ActivationDeleteInput;
};


export type MutationDeleteBundleArgs = {
  data: DeleteBundleInput;
};


export type MutationDeleteCompanyRolesByIdArgs = {
  data: DeleteCompanyRolesInput;
};


export type MutationDeleteContractorArgs = {
  data: DeleteContractorInput;
};


export type MutationDeleteEmployeeArgs = {
  data: DeleteEmployeeInput;
};


export type MutationDeleteJobDescriptionArgs = {
  id: Scalars['String'];
};


export type MutationDeletePayrollArgs = {
  data: DeletePayrollInput;
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDisableDeputySupportArgs = {
  data: DisableDeputySupportInput;
};


export type MutationDisableMfaEnrollmentArgs = {
  authId?: Maybe<Scalars['ID']>;
  enrollmentId: Scalars['ID'];
};


export type MutationDismissNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationDismissNotificationArgs = {
  id: Scalars['String'];
};


export type MutationDowngradeInstallArgs = {
  data: DowngradeDeputyInstallInput;
};


export type MutationEditResignationDetailsArgs = {
  data: ResignationEditDetailsInput;
};


export type MutationEditTerminationDetailsArgs = {
  data: TerminationEditDetailsInput;
};


export type MutationEmitArgs = {
  data: EmittableEvent;
};


export type MutationEnableDeputySupportArgs = {
  data: EnableDeputySupportInput;
};


export type MutationEnqueueHotlineCallArgs = {
  data: EnqueueHotlineCallInput;
};


export type MutationEnrollMfaDeviceArgs = {
  input: AuthMfaSmsEnrollmentInput;
};


export type MutationEnrollUsersArgs = {
  data: EnrollUsersInput;
};


export type MutationExistingCompanyPurchasedPayrollArgs = {
  id: Scalars['ID'];
};


export type MutationExtendBambeePlusOnboardingDueDateArgs = {
  input: PurchaseBambeePlusInput;
};


export type MutationExtendBambeePlusOnboardingWithSpecificDateArgs = {
  input: ExtendBambeePlusOnboardingToSpecificDate;
};


export type MutationFinchManualSetupCompletedArgs = {
  data: FinchManualSetupCompletedInput;
};


export type MutationForceApproveComplexPayrollOnboardingAnswersArgs = {
  data: ForceApproveComplexPayrollOnboardingInput;
};


export type MutationGenerateAiJobDescriptionArgs = {
  data: GenerateAiJobDescriptionInput;
};


export type MutationGenerateAiJobDescriptionV2Args = {
  data: GenerateAiJobDescriptionInputV2;
};


export type MutationGenerateCheckComponentLinkArgs = {
  data: CheckComponentInput;
};


export type MutationGenerateCompanyOnboardingLinkArgs = {
  data: GenerateCompanyOnboardingLinkInput;
};


export type MutationGenerateCompanyPayrollReportLinkArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateContractorOnboardingLinkArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateEmployeeOnboardingLinkArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateEmployeePostTaxDeductionsLinkArgs = {
  id: Scalars['ID'];
};


export type MutationIgnoreEligiblityAndPurchaseBambeePlusArgs = {
  input: PurchaseBambeePlusInput;
};


export type MutationImportTimesheetsArgs = {
  data: ImportTimesheetsInput;
};


export type MutationInitializePayrollArgs = {
  data: InitializePayrollInput;
};


export type MutationMarkCourseTicketAsIncompleteArgs = {
  id: Scalars['String'];
};


export type MutationOptInToElectronicDeliveryInCheckArgs = {
  data: OptInToElectronicDeliveryInCheckInput;
};


export type MutationOverrideCheckOnboardingArgs = {
  data: OverrideCheckOnboardingInput;
};


export type MutationPerformAutoHrmPodAssignmentArgs = {
  input: PerformAutoHrmPodAssignmentInput;
};


export type MutationPingDeputyArgs = {
  data: PingDeputyInput;
};


export type MutationPreviewPayrollArgs = {
  id: Scalars['ID'];
};


export type MutationProductInterestNotificationDismissedInAppArgs = {
  input: UpdateProductInterestWasAppNotificationDismissedInput;
};


export type MutationProvisionDeputyInstallArgs = {
  data: ProvisionDeputyInstallInput;
};


export type MutationPurchaseBambeePlusArgs = {
  input: PurchaseBambeePlusInput;
};


export type MutationPurchaseCreditsArgs = {
  data: PurchaseInput;
};


export type MutationPurchaseSeatsArgs = {
  data: PurchaseSeatsInput;
};


export type MutationPurchaseSeatsForBundleArgs = {
  data: PurchaseBundleSeatsInput;
};


export type MutationPurchaseSubscriptionArgs = {
  data: PurchaseSubscriptionInput;
};


export type MutationPurchaseTicketsArgs = {
  data: TicketsInput;
};


export type MutationPurchaseTimeAttendanceArgs = {
  data: PurchaseTimeAttendanceInput;
};


export type MutationQaDeleteWebinarArgs = {
  id: Scalars['ID'];
};


export type MutationQaMutateDocumentAsUnsignedArgs = {
  documentId: Scalars['ID'];
  who?: QaPolicyViewer;
};


export type MutationQaMutateFeedsForCurrentDocumentStatusArgs = {
  documentId: Scalars['ID'];
};


export type MutationQaMutatePolicyIncompleteArgs = {
  policyId: Scalars['ID'];
};


export type MutationQaMutateRemoveManagerFeedsForDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationQuickbooksSyncArgs = {
  data: SyncAttemptInput;
};


export type MutationReactToRecommendationArgs = {
  data: RecommendationReactionInput;
};


export type MutationReactivatePausedCompanyArgs = {
  input: ReactivatePausedCompanyInput;
};


export type MutationReaffirmDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRecommendationArgs = {
  data: RecommendationInput;
};


export type MutationRefundCreditPurchaseArgs = {
  data: RefundCreditsInput;
};


export type MutationRegisterForWebinarArgs = {
  id: Scalars['ID'];
  userID?: Maybe<Scalars['ID']>;
};


export type MutationReinstateEmployeeArgs = {
  data: ReinstateEmployeeInput;
};


export type MutationRejectRequestArgs = {
  data: RequestRejectionInput;
};


export type MutationRemoveArgs = {
  data: RemoveCompanyTrainingInput;
};


export type MutationRemoveActiveCreditsArgs = {
  data: RemoveCreditsInput;
};


export type MutationRemoveAutoassignHrManagerConfigurationArgs = {
  input: RemoveAutoAssignHrManagerInput;
};


export type MutationRemoveBusinessManagerConfigurationArgs = {
  input: BusinessManagerForTierInput;
};


export type MutationRemoveCourseCertificateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveDuplicatedPolicyDocumentsArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePaymentMethodArgs = {
  input: RemovePaymentMethodInput;
};


export type MutationRemoveS3fileFromCourseCertificateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveSeatsArgs = {
  data: RemoveSeatsInput;
};


export type MutationRemoveSeatsFromBundleArgs = {
  data: RemoveBundleSeatsInput;
};


export type MutationReopenPayrollArgs = {
  data: ReopenPayrollInput;
};


export type MutationReplyToConversationArgs = {
  input: ReplyToConversationInput;
};


export type MutationReplyToHrRequestAsAdminArgs = {
  input: ReplyToHrRequestAsAdminInput;
};


export type MutationRequestArgs = {
  data: RequestInput;
};


export type MutationRequestPayrollCancellationArgs = {
  data: PayrollCancellationRequestInput;
};


export type MutationResendChallengeArgs = {
  nonceId: Scalars['String'];
  reason: Scalars['String'];
  type: AuthMfaType;
};


export type MutationResetCompanyArgs = {
  data: ResetCompanyInput;
};


export type MutationResetDeputyArgs = {
  data: ResetDeputyInput;
};


export type MutationSaveCompanyAnswerArgs = {
  data: SaveCompanyAnswerInput;
};


export type MutationSaveCompanySettingArgs = {
  input: SaveCompanySettingInput;
};


export type MutationSaveComplexPayrollOnboardingArgs = {
  data: ComplexPayrollOnboardingInput;
};


export type MutationSaveJobDescriptionOnEmployeeArgs = {
  data: SaveJobDescriptionOnEmployeeInput;
};


export type MutationScratchToggleServiceAddonArgs = {
  input: ScratchToggleServiceAddonInput;
};


export type MutationSendFeedbackMessageArgs = {
  id: Scalars['ID'];
  message: FeedbackMessageInput;
};


export type MutationSendJobDescriptionToEmployeeArgs = {
  data: SendJobDescriptionToEmployeeInput;
};


export type MutationSendMagicLinkForEmailArgs = {
  input: SendMagicLinkForEmailInput;
};


export type MutationSendMessageToUserArgs = {
  id: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationSendReplyToUserThreadArgs = {
  message: Scalars['String'];
  parentId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationSendStaffOnboardInviteArgs = {
  data: SendStaffOnboardInviteInput;
};


export type MutationSetCaseStatusArgs = {
  input: SetCaseStatusInput;
};


export type MutationSetDefaultPaymentMethodArgs = {
  input: SetDefaultPaymentMethodInput;
};


export type MutationSetupContractorArgs = {
  data: SetupContractorInput;
};


export type MutationSetupEmployeeArgs = {
  data: SetupEmployeeInput;
};


export type MutationSignEmployeeJobDescriptionArgs = {
  id: Scalars['String'];
};


export type MutationStartTaskArgs = {
  id: Scalars['String'];
};


export type MutationSubmitAiPromptArgs = {
  data: AiPromptInput;
};


export type MutationSyncCompanyArgs = {
  data: SyncCompanyInput;
};


export type MutationSyncContractorArgs = {
  data: SyncContractorInput;
};


export type MutationSyncDocumentsArgs = {
  input: PandadocDocumentSyncInput;
};


export type MutationSyncEmployeeArgs = {
  data: SyncEmployeeInput;
};


export type MutationSyncPayrollArgs = {
  id: Scalars['ID'];
};


export type MutationSyncRequirementsArgs = {
  data: SyncRequirementInput;
};


export type MutationSyncTimesheetsArgs = {
  data: SyncTimesheetsInput;
};


export type MutationSyncUserEnrollmentsArgs = {
  data: SyncUserEnrollmentInput;
};


export type MutationToggleActivationArgs = {
  data: ActivationToggleInput;
};


export type MutationTrackArgs = {
  data: AnalyticEvent;
};


export type MutationTrackProductInterestArgs = {
  data: ProductInterestInput;
};


export type MutationTrainingRecommendationArgs = {
  data: TrainingRecommendationInput;
};


export type MutationTrainingRequestArgs = {
  data: TrainingRequestInput;
};


export type MutationTriggerFixUserBundleEnrollmentsArgs = {
  userId: Scalars['ID'];
};


export type MutationTriggerPayrollRunSnsTopicPublishArgs = {
  data: TriggerPayrollRunSnsTopicPublishInput;
};


export type MutationUnenrollCompanyBundleArgs = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationUnenrollUsersArgs = {
  data: UnenrollUsersInput;
};


export type MutationUnenrollUsersFromBundleArgs = {
  data: UnenrollUsersFromBundleInput;
};


export type MutationUpdateApprovalDeadlineArgs = {
  data: UpdatePayrollApprovalDeadlineInput;
};


export type MutationUpdateCompanyArgs = {
  data: UpdateCompanyInput;
};


export type MutationUpdateCompanyNotesArgs = {
  data: UpdateCompanyNotesInput;
};


export type MutationUpdateCompanyRolesArgs = {
  data: UpdateMultipleRolesForCompanyInput;
};


export type MutationUpdateCompanyStatusArgs = {
  data: UpdateCompanyStatusInput;
};


export type MutationUpdateContractorPaymentArgs = {
  data: UpdateContractorPaymentInput;
};


export type MutationUpdateContractorWorkplaceArgs = {
  data: UpdateContractorWorkplaceInput;
};


export type MutationUpdateCoreCompanyArgs = {
  data: UpdateCoreCompanyInput;
};


export type MutationUpdateCoreUserEmploymentArgs = {
  id: Scalars['ID'];
  input: CoreUserEmploymentInput;
};


export type MutationUpdateCoreUserProfileArgs = {
  id: Scalars['ID'];
  input: CoreUserProfileInput;
};


export type MutationUpdateCoreUserStateArgs = {
  input: CoreUserStatesInput;
};


export type MutationUpdateEmployeeWorkplaceArgs = {
  data: UpdateEmployeeWorkplaceInput;
};


export type MutationUpdateJobDescriptionArgs = {
  data: UpdateJobDescriptionInput;
};


export type MutationUpdateNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  input: UpdateNoticeInput;
};


export type MutationUpdatePayScheduleArgs = {
  data: UpdatePayScheduleInput;
};


export type MutationUpdatePaymentSourceBillingAddressArgs = {
  input: UpdatePaymentSourceBillingAddress;
};


export type MutationUpdatePayrollArgs = {
  data: UpdatePayrollInput;
};


export type MutationUpdatePayrollChecksArgs = {
  data: UpdatePayrollChecksInput;
};


export type MutationUpdatePayrollItemArgs = {
  data: UpdatePayrollItemInput;
};


export type MutationUpdatePlanLockArgs = {
  input: UpdatePlanLockInput;
};


export type MutationUpdateReportCardArgs = {
  data: UpdateReportCardInput;
};


export type MutationUpdateWorkplaceArgs = {
  data: UpdateWorkplaceInput;
};


export type MutationUpgradeCorePlanArgs = {
  input: UpgradeCorePlanInput;
};


export type MutationUpgradeFinchCodeArgs = {
  data: UserFinchCodeInput;
};


export type MutationUpgradeInstallArgs = {
  data: UpgradeDeputyInstallInput;
};


export type MutationUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationUploadFilesToConversationArgs = {
  input: UploadFilesToConversationInput;
};


export type MutationUpsertDeputyAreasArgs = {
  data: UpsertDeputyAreasInput;
};


export type MutationUpsertDeputyConnectionArgs = {
  data: UpsertDeputyConnectionInput;
};


export type MutationUpsertDeputyLocationsArgs = {
  data: UpsertDeputyLocationsInput;
};


export type MutationUpsertDeputyUsersArgs = {
  data: UpsertDeputyUsersInput;
};


export type MutationUpsertOnboardingArgs = {
  data: CoreOnboardingInput;
};


export type MutationVerifyFeinInCheckArgs = {
  data: VerifyFeinInCheckInput;
};

export type MyRecommendationFilterInput = {
  /** The target demographic of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the recommendation. */
  resourceType?: Maybe<RequestResourceType>;
  /** The scope of the recommendation */
  scope?: Maybe<RecommendationScope>;
  /** The status of the recommendation. */
  status?: Maybe<RecommendationStatus>;
  /** The targets of the recommendation */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MyRequestFilterInput = {
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the request. */
  resourceType?: Maybe<RequestResourceType>;
  /** The status of the request. */
  status?: Maybe<RequestStatus>;
};

export type MyTrainingRecommendationFilterInput = {
  /** The target demographic of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The status of the recommendation. */
  status?: Maybe<RecommendationStatus>;
  /** The targets of the recommendation */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MyTrainingRequestFilterInput = {
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The status of the request. */
  status?: Maybe<RequestStatus>;
};

export type NewReportCard = {
  __typename?: 'NewReportCard';
  /** new report created when is false */
  existing: Scalars['Boolean'];
  report: ReportCard;
};

export type NextMessage = {
  __typename?: 'NextMessage';
  /** Affirmation of the last user message otherwise empty */
  affirmation?: Maybe<Scalars['String']>;
  /** Context for the message or additional guidance like: you can select multiple options */
  context?: Maybe<Scalars['String']>;
  /** Next message to the user */
  message?: Maybe<Scalars['String']>;
  /** Multiple choice options for the user to select from if the message requires it. MUST Provide multiple-choice options labeled A, B, C, etc */
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** An example response to the content */
  sample?: Maybe<Scalars['String']>;
};

/** The next action for onboarding */
export enum NextOnboardingAction {
  ExploreOnYourOwn = 'EXPLORE_ON_YOUR_OWN',
  MeetHrManager = 'MEET_HR_MANAGER',
  ScheduleConsultation = 'SCHEDULE_CONSULTATION'
}

export type Notice = {
  __typename?: 'Notice';
  actions?: Maybe<Array<NoticeAction>>;
  badge?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  dismissedAt?: Maybe<Scalars['DateTime']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: NoticeStatus;
  version: Scalars['String'];
  visualization?: Maybe<VisualizationData>;
};

export type NoticeAction = {
  __typename?: 'NoticeAction';
  color?: Maybe<NoticeActionColor>;
  handler: NoticeActionHandler;
  label: Scalars['String'];
  variant?: Maybe<NoticeActionVariant>;
};

/** The color theme of the action button (primary, secondary, or neutral) */
export enum NoticeActionColor {
  Neutral = 'NEUTRAL',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type NoticeActionHandler = {
  __typename?: 'NoticeActionHandler';
  actionType: NoticeActionType;
  /** The ID of the entity being linked to, required when actionType is LINK */
  entityId?: Maybe<Scalars['String']>;
  /** The link type, required when actionType is LINK */
  linkType?: Maybe<LinkType>;
  value: Scalars['String'];
};

export type NoticeActionHandlerInput = {
  actionType: NoticeActionType;
  entityId?: Maybe<Scalars['String']>;
  linkType?: Maybe<LinkType>;
  value: Scalars['String'];
};

export type NoticeActionInput = {
  color?: Maybe<NoticeActionColor>;
  handler: NoticeActionHandlerInput;
  label: Scalars['String'];
  variant?: Maybe<NoticeActionVariant>;
};

/** The type of action for a notice button */
export enum NoticeActionType {
  Chat = 'CHAT',
  Dismiss = 'DISMISS',
  ExternalLink = 'EXTERNAL_LINK',
  Link = 'LINK'
}

/** The variant of the action button (solid or outline) */
export enum NoticeActionVariant {
  Outline = 'OUTLINE',
  Solid = 'SOLID'
}

/** The status of the notice */
export enum NoticeStatus {
  Active = 'ACTIVE',
  Dismissed = 'DISMISSED'
}

export type NoticesPaginationInput = {
  /** Filter notices by company ID */
  companyId?: Maybe<Scalars['String']>;
  /** Cursor for pagination (null means start from beginning) */
  cursor?: Maybe<Scalars['String']>;
  /** Number of items per page (max 100) */
  limit?: Scalars['Int'];
  /** Whether to include dismissed notices (default: false) */
  showDismissed?: Scalars['Boolean'];
};

export type Notification = {
  __typename?: 'Notification';
  actions?: Maybe<Array<NotificationAction>>;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dismissedAt?: Maybe<Scalars['DateTime']>;
  dismissedBy?: Maybe<Scalars['String']>;
  dismissible: Scalars['Boolean'];
  id: Scalars['ID'];
  level: NotificationLevel;
  metadata?: Maybe<Scalars['JSON']>;
  subject?: Maybe<Scalars['String']>;
  targets: Array<NotificationTarget>;
  userId: Scalars['String'];
};

export type NotificationAction = {
  __typename?: 'NotificationAction';
  id: Scalars['ID'];
  label: Scalars['String'];
  type: NotificationActionType;
  value: Scalars['String'];
};

export enum NotificationActionType {
  Event = 'EVENT',
  Link = 'LINK'
}

export enum NotificationLevel {
  Error = 'ERROR',
  Notice = 'NOTICE',
  Warning = 'WARNING'
}

export type NotificationTarget = {
  __typename?: 'NotificationTarget';
  id: Scalars['ID'];
  type: NotificationTargetType;
};

export enum NotificationTargetType {
  Dashboard = 'DASHBOARD',
  Global = 'GLOBAL'
}

export type NumberNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
};

export type OffcycleOptions = {
  __typename?: 'OffcycleOptions';
  /** Whether to apply benefit deductions and contributions to the payroll. */
  applyBenefits?: Maybe<Scalars['Boolean']>;
  /** Whether to apply post-tax deductions to the payroll. */
  applyPostTaxDeductions?: Maybe<Scalars['Boolean']>;
  /** Whether to tax all earnings as supplemental earnings. */
  forceSupplementalWithholding?: Maybe<Scalars['Boolean']>;
};

export type OffcycleOptionsInput = {
  /** Whether to apply benefit deductions and contributions to the payroll. */
  applyBenefits?: Maybe<Scalars['Boolean']>;
  /** Whether to apply post-tax deductions to the payroll. */
  applyPostTaxDeductions?: Maybe<Scalars['Boolean']>;
  /** Whether to tax all earnings as supplemental earnings. */
  forceSupplementalWithholding?: Maybe<Scalars['Boolean']>;
};

export enum OnboardStatus {
  Blocking = 'BLOCKING',
  Completed = 'COMPLETED',
  NeedsAttention = 'NEEDS_ATTENTION'
}

export type OnboardingCalendlyConfig = {
  __typename?: 'OnboardingCalendlyConfig';
  link: Scalars['String'];
  tierNumber: Scalars['Float'];
  zone: SchedulerZone;
};

export type OnboardingCalendlyConfigInput = {
  tierNumber: Scalars['Float'];
  zip: Scalars['String'];
};

export type OnboardingFilesAnalysis = {
  __typename?: 'OnboardingFilesAnalysis';
  /** The files that were acquired */
  acquired: Array<Maybe<Scalars['String']>>;
  /** The files that are missing */
  missing: Array<Maybe<Scalars['String']>>;
};

export enum OnboardingGarnishmentOrDeduction {
  Alimony = 'ALIMONY',
  CharitableContributions = 'CHARITABLE_CONTRIBUTIONS',
  ChildSupportGarnishments = 'CHILD_SUPPORT_GARNISHMENTS',
  EmployerLoanRepayment = 'EMPLOYER_LOAN_REPAYMENT',
  FederalTaxLiens = 'FEDERAL_TAX_LIENS',
  Other = 'OTHER'
}

/** The status of the Onboarding */
export enum OnboardingStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type OptInToElectronicDeliveryInCheckInput = {
  /** Bambee employee IDs */
  employeeIds: Array<Scalars['ID']>;
};

export enum OrderByDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OverrideCheckOnboardingInput = {
  /** Bambee company id */
  companyId?: Maybe<Scalars['ID']>;
  /** Bambee contractor id */
  contractorId?: Maybe<Scalars['ID']>;
  /** Bambee employee id */
  employeeId?: Maybe<Scalars['ID']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedCoreUsers = {
  __typename?: 'PaginatedCoreUsers';
  id: Scalars['ID'];
  /** Page number to be used for pagination */
  page: Scalars['Float'];
  /** Actual list of users */
  result: Array<CoreUser>;
  /** Total count of all users */
  totalCount: Scalars['Float'];
  /** Total number of pages based on limit passed */
  totalPages: Scalars['Float'];
};

export type PaginatedNoticesResponse = {
  __typename?: 'PaginatedNoticesResponse';
  corePageInfo: CorePageInfo;
  notices: Array<Notice>;
  totalCount: Scalars['Int'];
};

export type PandadocDocumentSyncInput = {
  documentIds: Array<Scalars['ID']>;
};

export enum PastPayrollUsage {
  HaveCurrentPayrollProvider = 'HAVE_CURRENT_PAYROLL_PROVIDER',
  NewToPayingEmployees = 'NEW_TO_PAYING_EMPLOYEES',
  NewToPayrollWithCurrentCompany = 'NEW_TO_PAYROLL_WITH_CURRENT_COMPANY'
}

export type Paused = {
  __typename?: 'Paused';
  id: Scalars['ID'];
  isPaused: Scalars['Boolean'];
  reactivatesOn?: Maybe<Scalars['DateTime']>;
};

export enum PayFrequency {
  Annually = 'ANNUALLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semimonthly = 'SEMIMONTHLY',
  Weekly = 'WEEKLY'
}

export type PaySchedule = {
  __typename?: 'PaySchedule';
  checkId: Scalars['ID'];
  default: Scalars['Boolean'];
  firstPayday: Scalars['DateTime'];
  firstPeriodEnd: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  payFrequency: PayScheduleFrequency;
  /** The payday date of the the second payroll the company will run on this pay schedule. This field should only be used with the semimonthly frequency to specify custom paydays besides the 15th and last day of the month. second_payday must be between one day and one month after first_payday. */
  secondPayday?: Maybe<Scalars['DateTime']>;
};

export enum PayScheduleFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Semimonthly = 'SEMIMONTHLY',
  Weekly = 'WEEKLY'
}

export enum PayType {
  Contractor = 'contractor',
  Empty = 'empty',
  Hourly = 'hourly',
  Salary = 'salary'
}

export enum Payer {
  Company = 'COMPANY',
  Employee = 'EMPLOYEE'
}

export type PaymentEntry = {
  __typename?: 'PaymentEntry';
  /** Amount earned for this entry */
  amount?: Maybe<Scalars['Float']>;
  /** The decimal value of the inputted number of hours worked */
  decimal?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** Number of hours worked for this entry */
  minutes?: Maybe<Scalars['Float']>;
  /** Source of PaymentEntry */
  source: SourceType;
  /** Type of entry. */
  type: PaymentEntryType;
  /** Worker role id to be applied to this item */
  workerRoleId?: Maybe<Scalars['ID']>;
};

export type PaymentEntryInput = {
  /** Amount earned for this earning */
  amount?: Maybe<Scalars['Float']>;
  /** The decimal value of the inputted number of hours worked */
  decimal?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  /** Number of hours worked for this earning */
  minutes?: Maybe<Scalars['Float']>;
  /** Source of PaymentEntry */
  source?: Maybe<SourceType>;
  /** Type of entry. */
  type: PaymentEntryType;
  /** Worker role id to be applied to this item */
  workerRoleId?: Maybe<Scalars['ID']>;
};

export enum PaymentEntryType {
  AmountTime = 'AMOUNT_TIME',
  AmountValue = 'AMOUNT_VALUE',
  Reimbursement = 'REIMBURSEMENT'
}

export enum PaymentMethod {
  DirectDeposit = 'DIRECT_DEPOSIT',
  Manual = 'MANUAL'
}

export enum PaymentMethodIssueReason {
  DefaultAchTransfer = 'DEFAULT_ACH_TRANSFER',
  DefaultDebitCard = 'DEFAULT_DEBIT_CARD',
  DefaultExpired = 'DEFAULT_EXPIRED',
  DefaultInvalid = 'DEFAULT_INVALID',
  DefaultUpcomingExpiration = 'DEFAULT_UPCOMING_EXPIRATION',
  Other = 'OTHER'
}

export enum PaymentMethodNextAction {
  MicroDepositValidation = 'MICRO_DEPOSIT_VALIDATION',
  MicroDepositValidationDescriptor = 'MICRO_DEPOSIT_VALIDATION_DESCRIPTOR'
}

export enum PaymentMethodStatus {
  ActionRequired = 'ACTION_REQUIRED',
  Active = 'ACTIVE'
}

export enum PaymentMethodSteps {
  BankAccountExists = 'BANK_ACCOUNT_EXISTS',
  BankAccountVerified = 'BANK_ACCOUNT_VERIFIED',
  PaymentMethodPreferenceSet = 'PAYMENT_METHOD_PREFERENCE_SET'
}

export enum PaymentMethodType {
  BankAccount = 'BANK_ACCOUNT',
  Card = 'CARD',
  Unknown = 'UNKNOWN'
}

export type PaymentSource = {
  __typename?: 'PaymentSource';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  cvcCheck?: Maybe<Scalars['String']>;
  default: Scalars['Boolean'];
  dynamicLast4?: Maybe<Scalars['String']>;
  expMonth: Scalars['Float'];
  expYear: Scalars['Float'];
  funding?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentSources = {
  __typename?: 'PaymentSources';
  companyId: Scalars['String'];
  sources: Array<PaymentSource>;
};

export enum PaymentType {
  Hourly = 'HOURLY',
  Salary = 'SALARY'
}

export type Payroll = {
  __typename?: 'Payroll';
  /** The date by which the payroll must be approved. */
  approvalDeadline?: Maybe<Scalars['DateTime']>;
  /** Datetime at which the payroll was approved. */
  approvedAt?: Maybe<Scalars['DateTime']>;
  /** The check ID of the payroll. */
  checkId?: Maybe<Scalars['ID']>;
  /** The Bambee company ID associated with the payroll. */
  companyId: Scalars['ID'];
  contractorCount?: Maybe<Scalars['Int']>;
  contractorPayment?: Maybe<ContractorPayment>;
  /** @deprecated Use contractorPaymentsPage instead */
  contractorPayments: Array<ContractorPayment>;
  contractorPaymentsConnection: ContractorPaymentConnection;
  contractorPaymentsPage: ContractorPaymentPage;
  coreCompany?: Maybe<CoreCompany>;
  /** The timestamp the payroll was created */
  createdAt: Scalars['DateTime'];
  /** If provided, the timestamp the payroll was deleted */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Deptuy sync info */
  deputySync?: Maybe<DeputySyncInfo>;
  /** Total liability for a payroll with a status of DRAFT */
  draftLiability?: Maybe<Scalars['Float']>;
  employeeCount?: Maybe<Scalars['Int']>;
  hasEmployeesWithMissingSSN: Scalars['Boolean'];
  id: Scalars['ID'];
  /** If the dates are impacted by a weekend or holiday. */
  impactedByWeekendOrHoliday?: Maybe<Scalars['Boolean']>;
  /** The set of payroll items associated with the payroll. */
  items?: Maybe<Array<Maybe<PayrollItem>>>;
  itemsPage: PayrollItemPage;
  /** An indicator after payroll approval of manual payroll items without associated check numbers */
  needsChecksEntered?: Maybe<Scalars['Boolean']>;
  /** Additional configuration options controlling off-cycle payroll behavior. */
  offCycleOptions?: Maybe<OffcycleOptions>;
  /** The date on which employees will be paid for the payroll. */
  payday: Scalars['DateTime'];
  payrollItem?: Maybe<PayrollItem>;
  payrollItems: PayrollItemConnection;
  /** The end of the date range that the payroll covers. */
  periodEnd: Scalars['DateTime'];
  /** The start of the date range that the payroll covers. */
  periodStart: Scalars['DateTime'];
  /** latest sync attempt from webhook */
  quickbooksSyncAttempt?: Maybe<SyncAttempt>;
  /** Indicates where the payroll is in its lifecycle. */
  status: PayrollStatus;
  /** Date when the status changed. */
  statusChangedAt: Scalars['DateTime'];
  syncAttempts?: Maybe<Array<SyncAttempt>>;
  timesheetHours?: Maybe<TimesheetAggregate>;
  timesheets: Array<Timesheet>;
  /** Calculated totals for various payroll categories. null for payrolls with a status of draft outside of the preview endpoint. */
  totals?: Maybe<Totals>;
  /** Indicates whether the payroll is a regular or off-cycle payroll. */
  type: PayrollType;
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
  withdrawDate?: Maybe<Scalars['DateTime']>;
};


export type PayrollContractorPaymentArgs = {
  id: Scalars['ID'];
};


export type PayrollContractorPaymentsConnectionArgs = {
  args?: Maybe<ContractorPaymentArgs>;
};


export type PayrollContractorPaymentsPageArgs = {
  advancedWhere?: Maybe<ContractorPaymentAdvancedWhereInput>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ContractorPaymentOrderByInput>;
  page?: Maybe<Scalars['Int']>;
};


export type PayrollItemsPageArgs = {
  advancedWhere?: Maybe<PayrollItemAdvancedWhereInput>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PayrollItemOrderByInput>;
  page?: Maybe<Scalars['Int']>;
};


export type PayrollPayrollItemArgs = {
  id: Scalars['ID'];
};


export type PayrollPayrollItemsArgs = {
  args?: Maybe<PayrollItemArgs>;
};


export type PayrollTimesheetHoursArgs = {
  filter?: Maybe<TimesheetFilter>;
};


export type PayrollTimesheetsArgs = {
  filter?: Maybe<TimesheetFilter>;
};

export type PayrollAdvancedWhereInput = {
  /** All conditions passed into this must return true for payrolls returned. */
  AND?: Maybe<Array<PayrollBaseWhereInput>>;
  /** All conditions passed into this must return false for payrolls returned. */
  NOT?: Maybe<Array<PayrollBaseWhereInput>>;
  /** One or more conditions passed into this must return true for payrolls returned. */
  OR?: Maybe<Array<PayrollBaseWhereInput>>;
};

export type PayrollBaseWhereInput = {
  approvalDeadline?: Maybe<DateTimeNullableFilter>;
  approvedAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  needsChecksEntered?: Maybe<BoolNullableFilter>;
  paidAt?: Maybe<DateTimeNullableFilter>;
  partiallyPaidAt?: Maybe<DateTimeNullableFilter>;
  payday?: Maybe<DateTimeFilter>;
  periodEnd?: Maybe<DateTimeFilter>;
  periodStart?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumPayrollStatusFilter>;
  statusChangedAt?: Maybe<DateTimeFilter>;
  type?: Maybe<EnumPayrollTypeFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PayrollBenefit = {
  __typename?: 'PayrollBenefit';
  benefit: Scalars['String'];
  companyContributionAmount?: Maybe<Scalars['String']>;
  companyPeriodAmount?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  employeeContributionAmount?: Maybe<Scalars['String']>;
  employeePeriodAmount?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  period?: Maybe<BenefitPeriod>;
};

export type PayrollCancellationRequestInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
};

export type PayrollCompany = {
  __typename?: 'PayrollCompany';
  authorizationDocuments: Array<Maybe<AuthorizationDocument>>;
  bankAccounts?: Maybe<Array<Maybe<BankAccount>>>;
  benefitOnboarding?: Maybe<BenefitCompanyOnboarding>;
  boxInfo?: Maybe<CompanyBoxInfo>;
  checkId?: Maybe<Scalars['ID']>;
  checkImplementation?: Maybe<CheckCompanyImplementation>;
  checkIndustry?: Maybe<IndustryType>;
  checkIntegration?: Maybe<CheckIntegration>;
  checkOnboarding?: Maybe<CheckCompanyOnboarding>;
  companyBenefits: Array<Maybe<CompanyBenefit>>;
  complexPayrollOnboarding?: Maybe<Array<Maybe<ComplexPayrollOnboarding>>>;
  contractors: Array<Maybe<Contractor>>;
  coreCompany?: Maybe<CoreCompany>;
  defaultPayScheduleDays?: Maybe<Array<Maybe<DefaultPayScheduleDays>>>;
  /** Has this company established a connection to Deputy */
  deputyConnection?: Maybe<DeputyConnection>;
  /** Timestamp for when company accepted deputy terms of service */
  deputyTosAcceptedAt?: Maybe<Scalars['DateTime']>;
  employees: Array<Maybe<Employee>>;
  excludedStaffIds: Array<Maybe<Scalars['ID']>>;
  feinVerification?: Maybe<CheckFeinVerification>;
  feinVerificationAttempts: Scalars['Int'];
  /** Has this company established a connection to Finch */
  finchConnection?: Maybe<CompanyFinchAccessToken>;
  goals: Array<Goal>;
  hasDraftPayroll: Scalars['Boolean'];
  hasRunPayroll: Scalars['Boolean'];
  /** Bambee company id */
  id: Scalars['ID'];
  /** Needs pay schedule assistance */
  needsPayScheduleAssistance?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  onboardingGarnishmentsOrDeductions: Array<OnboardingGarnishmentOrDeduction>;
  onboardingGarnishmentsOrDeductionsOther: Scalars['String'];
  onboardingHasComplexScenario?: Maybe<Scalars['Boolean']>;
  onboardingHasComplexTimeAttendanceScenario?: Maybe<Scalars['Boolean']>;
  onboardingHasGarnishmentsOrDeductions?: Maybe<Scalars['Boolean']>;
  onboardingOffersEmployeeBenefits: Scalars['Boolean'];
  /** Past payroll usage ( prior to Bambee ) */
  pastPayrollUsage?: Maybe<PastPayrollUsage>;
  /** Frequency by which the employees get paid. */
  payFrequency: PayFrequency;
  paySchedules: Array<Maybe<PaySchedule>>;
  paydays?: Maybe<Array<Maybe<CompanyPaydays>>>;
  processedPayrollsThisYear: Scalars['Boolean'];
  /** Frequency by which the employees get paid. */
  processingPeriod: ProcessingPeriod;
  signatoryEmail: Scalars['String'];
  signatoryFirstName: Scalars['String'];
  signatoryLastName: Scalars['String'];
  signatoryTitle: Scalars['String'];
  /** Date the company will start using Check as their payroll processor. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Bambee payroll status of the company. */
  status?: Maybe<CompanyStatus>;
  taxDocYears: Array<Scalars['String']>;
  taxDocuments: Array<Maybe<TaxDocument>>;
  taxExemptStatus?: Maybe<TaxExemptStatus>;
  timesheets: Array<Timesheet>;
  /** version of payroll terms last signed */
  tosVersion?: Maybe<Scalars['String']>;
  /** Total count of employees by category */
  total?: Maybe<Total>;
  /** Company workplaces */
  workplaces?: Maybe<Array<Workplace>>;
};


export type PayrollCompanyComplexPayrollOnboardingArgs = {
  take?: Maybe<Scalars['Float']>;
};


export type PayrollCompanyDefaultPayScheduleDaysArgs = {
  input?: Maybe<DefaultPayScheduleDaysInput>;
};


export type PayrollCompanyTaxDocumentsArgs = {
  data?: Maybe<CompanyTaxDocumentsInput>;
};


export type PayrollCompanyTimesheetsArgs = {
  filter?: Maybe<TimesheetFilter>;
};

export enum PayrollContractorType {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL',
  Unknown = 'UNKNOWN'
}

export type PayrollItem = {
  __typename?: 'PayrollItem';
  addedAfterInitialization: Scalars['Boolean'];
  basePayRate: Scalars['Float'];
  benefits?: Maybe<Array<Maybe<PayrollBenefit>>>;
  checkNumber?: Maybe<Scalars['String']>;
  earnings: Array<Earning>;
  employee: Employee;
  employeeId: Scalars['ID'];
  grossPay: Scalars['Float'];
  /** Determines if any worker role has been deleted in this payroll item */
  hasDeletedWorkerRole: Scalars['Boolean'];
  id: Scalars['ID'];
  netPay?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  noteVisible?: Maybe<Scalars['Boolean']>;
  payType: PaymentType;
  /** The way the employee will be paid */
  paymentMethod?: Maybe<PaymentMethod>;
  payroll: Payroll;
  postTaxDeductions?: Maybe<Array<Maybe<PostTaxDeductionItem>>>;
  /** The employee's remaining PTO hour balance, for display on the paystub */
  ptoBalanceHours?: Maybe<Scalars['Float']>;
  reimbursements: Array<Maybe<Reimbursement>>;
  /** The employee's remaining sick hour balance, for display on the paystub */
  sickBalanceHours?: Maybe<Scalars['Float']>;
  /** Indicates where the payroll item is in its lifecycle. */
  status: PayrollItemStatus;
  /** Determines if this item earnings were synced from a timesheet */
  syncedFromDeputy: Scalars['Boolean'];
  taxes?: Maybe<Array<Maybe<Tax>>>;
  timesheetHours?: Maybe<TimesheetAggregate>;
  timesheetHoursByRole?: Maybe<Array<Maybe<TimesheetAggregate>>>;
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
  warnings?: Maybe<Array<Maybe<Warning>>>;
  workerRoles?: Maybe<CoreCompany>;
};


export type PayrollItemWorkerRolesArgs = {
  showDeleted?: Maybe<Scalars['Boolean']>;
};

export type PayrollItemAdvancedWhereInput = {
  /** All conditions passed into this must return true for payrolls returned. */
  AND?: Maybe<Array<PayrollItemBaseWhereInput>>;
  /** All conditions passed into this must return false for payrolls returned. */
  NOT?: Maybe<Array<PayrollItemBaseWhereInput>>;
  /** One or more conditions passed into this must return true for payrolls returned. */
  OR?: Maybe<Array<PayrollItemBaseWhereInput>>;
};

export type PayrollItemArgs = {
  advancedWhere?: Maybe<PayrollItemAdvancedWhereInput>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PayrollItemOrderByInput>;
};

export type PayrollItemBaseWhereInput = {
  addedAfterInitialization?: Maybe<BoolNullableFilter>;
  basePayRate?: Maybe<NumberNullableFilter>;
  checkNumber?: Maybe<StringNullableFilter>;
  employeeId?: Maybe<StringNullableFilter>;
  grossPay?: Maybe<NumberNullableFilter>;
  /** Determines if any worker role has been deleted in this payroll item */
  hasDeletedWorkerRole?: Maybe<BoolNullableFilter>;
  netPay?: Maybe<NumberNullableFilter>;
  note?: Maybe<StringNullableFilter>;
  noteVisible?: Maybe<BoolNullableFilter>;
  payType?: Maybe<EnumPayrollItemPayTypeFilter>;
  /** The way the employee will be paid */
  paymentMethod?: Maybe<EnumPayrollItemPaymentMethodFilter>;
  /** The employee's remaining PTO hour balance, for display on the paystub */
  ptoBalanceHours?: Maybe<NumberNullableFilter>;
  /** The employee's remaining sick hour balance, for display on the paystub */
  sickBalanceHours?: Maybe<NumberNullableFilter>;
  /** Indicates where the payroll item is in its lifecycle. */
  status?: Maybe<EnumPayrollItemPayrollItemStatusFilter>;
  /** Determines if this item earnings were synced from a timesheet */
  syncedFromDeputy?: Maybe<BoolNullableFilter>;
};

export type PayrollItemCheckNumbers = {
  checkNumber: Scalars['String'];
  /** The PayrollItem ID the check number is for. */
  id: Scalars['ID'];
};

export type PayrollItemConnection = {
  __typename?: 'PayrollItemConnection';
  edges: Array<PayrollItemEdge>;
  pageInfo: PageInfo;
};

export type PayrollItemEdge = {
  __typename?: 'PayrollItemEdge';
  cursor: Scalars['String'];
  node: PayrollItem;
};

export type PayrollItemOrderByInput = {
  direction?: Maybe<OrderByDirection>;
  key: Scalars['String'];
};

export type PayrollItemPage = {
  __typename?: 'PayrollItemPage';
  /** Reflects the limit argument provided in the query. */
  limit: Scalars['Int'];
  /** Tells if there is a next page of results available. */
  nextPage: Scalars['Boolean'];
  /** Reflects the page argument provided in the query. */
  page: Scalars['Int'];
  /** Tells if there is a previous page of results available. */
  prevPage: Scalars['Boolean'];
  results: Array<PayrollItem>;
  /** The total number of payrolls in the database or for the company when companyId is provided. */
  totalCount: Scalars['Int'];
};

export enum PayrollItemStatus {
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Initial = 'INITIAL',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type PayrollItemSync = {
  __typename?: 'PayrollItemSync';
  bambee?: Maybe<Scalars['String']>;
  check?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type PayrollOrderByInput = {
  direction?: Maybe<OrderByDirection>;
  key?: Maybe<Scalars['String']>;
};

export type PayrollPage = {
  __typename?: 'PayrollPage';
  /** Reflects the limit argument provided in the query. */
  limit: Scalars['Int'];
  /** Tells if there is a next page of results available. */
  nextPage: Scalars['Boolean'];
  /** Reflects the page argument provided in the query. */
  page: Scalars['Int'];
  /** Tells if there is a previous page of results available. */
  prevPage: Scalars['Boolean'];
  results: Array<Maybe<Payroll>>;
  totalContractors: Scalars['Int'];
  /** The total number of payrolls in the database or for the company when companyId is provided. */
  totalCount: Scalars['Int'];
  totalEmployees: Scalars['Int'];
};

/** A model representing a payroll plan. */
export type PayrollPlanModel = {
  __typename?: 'PayrollPlanModel';
  /** Billing period for the plan. */
  billingPeriod: BillingPeriod;
  /** Maximum size of employees (legacy payroll) or maximum tier number (basic & premium). */
  maxSize?: Maybe<Scalars['Float']>;
  /** Minimum size of employees (legacy payroll) or minimum tier number (basic & premium). */
  minSize: Scalars['Float'];
  /** Name of the plan. */
  name: Scalars['String'];
  /** Total price of the plan. */
  price?: Maybe<Scalars['Float']>;
  /** Price identifier in Stripe. */
  priceId: Scalars['String'];
  /** The payroll product key associated to the plan object. */
  productKey: ProductKey;
  /** The service key associated to the plan object (always "payroll"). */
  serviceKey: ServiceKey;
  /** Current status of the plan. */
  status: PlanStatuses;
  /** Unit price of the plan. */
  unitPrice?: Maybe<Scalars['Float']>;
  /** Unit Price identifier in Stripe. */
  unitPriceId?: Maybe<Scalars['String']>;
  /** Value proposition of the plan. */
  value: Scalars['String'];
  /** Version of the plan. */
  version: Scalars['String'];
};

export enum PayrollStatus {
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Initial = 'INITIAL',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type PayrollSync = {
  __typename?: 'PayrollSync';
  bambee?: Maybe<Scalars['String']>;
  check?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum PayrollType {
  OffCycle = 'OFF_CYCLE',
  Regular = 'REGULAR'
}

export type PayrollWhereInput = {
  condition: Scalars['String'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type PerformAutoHrmPodAssignmentInput = {
  companyId: Scalars['String'];
  pricingPackageType?: Maybe<PricingPackageType>;
  stateGroup: Scalars['String'];
  tierNumber: Scalars['Float'];
};

/** Ping Deputy installation to validate / refresh access token */
export type PingDeputyInput = {
  /** Bambee company id */
  companyId: Scalars['String'];
};

/** Ping Deputy response object */
export type PingDeputyResponse = {
  __typename?: 'PingDeputyResponse';
  /** deputy version */
  deputyVersion?: Maybe<Scalars['String']>;
  /** deputy employeeId */
  employeeID?: Maybe<Scalars['Float']>;
  /** deputy user first name */
  firstName?: Maybe<Scalars['String']>;
  /** deputy username */
  id: Scalars['ID'];
  /** deputy user last name */
  lastName?: Maybe<Scalars['String']>;
  /** deputy username */
  login?: Maybe<Scalars['String']>;
  /** deputy user name */
  name?: Maybe<Scalars['String']>;
  /** dupty user primary email */
  primaryEmail?: Maybe<Scalars['String']>;
  /** dupty user primary phone */
  primaryPhone?: Maybe<Scalars['String']>;
  /** deputy userId */
  userID?: Maybe<Scalars['Float']>;
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PlanCoupon = {
  __typename?: 'PlanCoupon';
  amountOff: Scalars['Float'];
  appliesToPlans: Array<Plan>;
  id: Scalars['String'];
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['Float']>;
  setupFeeOff: Scalars['Float'];
};

export type PlanLock = {
  __typename?: 'PlanLock';
  active: Scalars['Boolean'];
  couponId?: Maybe<Scalars['String']>;
  plan: Scalars['String'];
  setupFee: Scalars['Float'];
  trialDuration: Scalars['Float'];
};

/** A model representing a generic plan. */
export type PlanModel = {
  __typename?: 'PlanModel';
  /** Indicates if the plan is annual. */
  annual?: Maybe<Scalars['Boolean']>;
  /** Billing period for the plan. */
  billingPeriod: BillingPeriod;
  /** Indicates if the plan is chat-only. */
  chatOnly?: Maybe<Scalars['Boolean']>;
  /** Indicates if the plan is configured to collect taxes. */
  collectTax?: Maybe<Scalars['Boolean']>;
  /** Contract period for the plan, if applicable. */
  contractPeriod?: Maybe<BillingPeriod>;
  /** DRP (Disaster Recovery Plan) identifier, if applicable. */
  drp?: Maybe<Scalars['String']>;
  /** Mapping of the plan to the size of the employee base. */
  employeeSizeMapping?: Maybe<Scalars['String']>;
  /** Indicates if the plan is for internal use only. */
  internal?: Maybe<Scalars['Boolean']>;
  /** Maximum size of the employee base for this plan. */
  maxSize?: Maybe<Scalars['Float']>;
  /** Minimum size of the employee base for this plan. */
  minSize?: Maybe<Scalars['Float']>;
  /** Monthly price of the plan. */
  monthlyPrice?: Maybe<Scalars['Float']>;
  /** Name of the plan. */
  name: Scalars['String'];
  /** Partner associated with the plan, if any. */
  partner?: Maybe<Scalars['String']>;
  /** Indicates if the plan can be paused. */
  pause?: Maybe<Scalars['Boolean']>;
  /** Total price of the plan. */
  price?: Maybe<Scalars['Float']>;
  /** Price identifier in Stripe. */
  priceId: Scalars['String'];
  /** The product key associated to the plan object (Lite, Dedicated, Plus, Elite). */
  productKey: ProductKey;
  /** Indicates if the plan is regulated. */
  regulated?: Maybe<Scalars['Boolean']>;
  /** The service key associated to the plan object (Core, Payroll, Training, ...). */
  serviceKey: ServiceKey;
  /** Initial setup fee for the plan. */
  setupFee?: Maybe<Scalars['Float']>;
  /** Discount on the setup fee, if applicable. */
  setupFeeDiscount?: Maybe<Scalars['Float']>;
  /** Current status of the plan. */
  status: PlanStatuses;
  /** Tier number of the plan. */
  tierNumber?: Maybe<Scalars['Float']>;
  /** Value proposition of the plan. */
  value: Scalars['String'];
  /** Version of the plan. */
  version?: Maybe<Scalars['String']>;
  /** Indicates if the plan pricing is based on volume. */
  volumeBased?: Maybe<Scalars['Boolean']>;
};

/** Plan statuses */
export enum PlanStatuses {
  Active = 'ACTIVE',
  Deprecated = 'DEPRECATED',
  Inactive = 'INACTIVE'
}

export type PolicyArtifact = {
  __typename?: 'PolicyArtifact';
  /** Confidence score between 0 and 100 */
  confidence?: Maybe<Scalars['Float']>;
  /** The policy draft render as a rich HTML document. */
  html?: Maybe<Scalars['String']>;
  /** The id of the policy after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** Indicates whether the base policy template is from our existing database */
  isBambeeTemplateBase?: Maybe<Scalars['String']>;
  /** The policy draft render as a rich HTML document. */
  status: BestPracticeStatus;
  /** The policy draft title. */
  title?: Maybe<Scalars['String']>;
};

export enum PolicyKind {
  Bambee = 'BAMBEE',
  Draft = 'DRAFT',
  Panda = 'PANDA'
}

export enum PolicyStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Declined = 'DECLINED',
  InProgress = 'IN_PROGRESS',
  Qa = 'QA',
  Ready = 'READY',
  Sent = 'SENT',
  Uploaded = 'UPLOADED'
}

export enum PolicyStepNames {
  Created = 'CREATED',
  Implemented = 'IMPLEMENTED',
  Ready = 'READY',
  Requested = 'REQUESTED',
  Sent = 'SENT',
  Unknown = 'UNKNOWN'
}

export type PostTaxDeductionItem = {
  __typename?: 'PostTaxDeductionItem';
  /** Per pay period amount to deduct. */
  amount: Scalars['Float'];
  description: Scalars['String'];
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type Practice = {
  __typename?: 'Practice';
  companyId: Scalars['String'];
  description: Scalars['String'];
  iconUrl: Scalars['String'];
  id: Scalars['String'];
  illustrationUrl: Scalars['String'];
  introDescription: Scalars['String'];
  outroIllustrationUrl: Scalars['String'];
  setupProgress: PracticeSetupProgress;
  shortDescription: Scalars['String'];
  shortName: Scalars['String'];
  state: PracticeState;
  status: PracticeStatuses;
  successOutroTitle: Scalars['String'];
  survey: Survey;
  title: Scalars['String'];
};

export enum PracticeCadenceValue {
  Annually = 'ANNUALLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Weekly = 'WEEKLY'
}

export enum PracticeSetupProgress {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export enum PracticeState {
  Activated = 'ACTIVATED',
  NotActivated = 'NOT_ACTIVATED'
}

export enum PracticeStatuses {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export type PreviewCorePlanChangeModel = {
  __typename?: 'PreviewCorePlanChangeModel';
  /** Details for the following invoice after the upcoming one */
  next: CorePlanChangeInvoice;
  /** The core plan for the upgrade calculation */
  plan: CorePlanModel;
  /** Proration date considered for this plan change */
  prorationDate: Scalars['DateTime'];
  /** Details for the upcoming invoice if plan is applied */
  upcoming: UpcomingCorePlanChangeInvoice;
};

export type PricingPackage = {
  __typename?: 'PricingPackage';
  /** The pricing plans available for the package */
  plans: Array<Maybe<CorePlanModel>>;
  /** The type of the package */
  type: PricingPackageType;
};

export type PricingPackageFilterInput = {
  /** The billing period */
  billingPeriod?: Maybe<Scalars['String']>;
  /** The company ID */
  companyId: Scalars['ID'];
  /** The number of employees */
  employeeCount?: Maybe<Scalars['Float']>;
  /** Include internal plans ( defaults to external only ) */
  includeInternal?: Maybe<Scalars['Boolean']>;
  /** The partner */
  partner?: Maybe<Scalars['String']>;
  /** The status of the plan e.g. active, inactive etc.  */
  statuses?: Maybe<Array<PlanStatuses>>;
};

export type PricingPackageResponse = {
  __typename?: 'PricingPackageResponse';
  /** The pricing packages */
  packages: Array<PricingPackage>;
};

/** Pricing package type */
export enum PricingPackageType {
  Business = 'BUSINESS',
  Elite = 'ELITE',
  Lite = 'LITE',
  Pause = 'PAUSE',
  Plus = 'PLUS',
  Storage = 'STORAGE'
}

export enum ProcessingPeriod {
  FourDay = 'FOUR_DAY',
  OneDay = 'ONE_DAY',
  TwoDay = 'TWO_DAY'
}

export type Product = {
  __typename?: 'Product';
  activeSubscription?: Maybe<Scalars['Boolean']>;
  /** Number of credits provided on core subscription. Null if single purchase */
  allowance?: Maybe<Scalars['Int']>;
  /** Billing period of the product. Null if single purchase */
  billingPeriod?: Maybe<Scalars['String']>;
  creditBalance: Scalars['Float'];
  /** One-time discounted price of product, if available. Null if subscription */
  discountedPrice?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  key: ProductKey;
  /** Number of credits provided per month, if applicable. Null if single purchase */
  monthlyAllowance?: Maybe<Scalars['Int']>;
  /** Name of product */
  name?: Maybe<Scalars['String']>;
  /** One-time price of product. Null if subscription */
  price?: Maybe<Scalars['Int']>;
  /** The price to subscribe, based on billing period. Null if single purchase */
  subscriptionPrice?: Maybe<Scalars['Int']>;
  /** Company tier */
  tier?: Maybe<Scalars['Int']>;
};

export enum ProductCreditConsumptionReason {
  CustomerSatisfaction = 'CUSTOMER_SATISFACTION',
  HumanError = 'HUMAN_ERROR',
  Other = 'OTHER',
  ProcessRelated = 'PROCESS_RELATED',
  TechError = 'TECH_ERROR',
  UpsellingCustomer = 'UPSELLING_CUSTOMER'
}

export enum ProductCreditConsumptionType {
  Expiration = 'EXPIRATION',
  Manual = 'MANUAL',
  Refund = 'REFUND',
  Usage = 'USAGE',
  Void = 'VOID'
}

export enum ProductCreditCreationReason {
  CustomerSatisfaction = 'CUSTOMER_SATISFACTION',
  HumanError = 'HUMAN_ERROR',
  Other = 'OTHER',
  ProcessRelated = 'PROCESS_RELATED',
  TechError = 'TECH_ERROR',
  UpsellingCustomer = 'UPSELLING_CUSTOMER'
}

export enum ProductCreditType {
  Allowance = 'ALLOWANCE',
  Manual = 'MANUAL',
  OnetimeTransaction = 'ONETIME_TRANSACTION',
  SubscriptionRefillAdditional = 'SUBSCRIPTION_REFILL_ADDITIONAL',
  SubscriptionRefillLimit = 'SUBSCRIPTION_REFILL_LIMIT',
  SubscriptionUnlimited = 'SUBSCRIPTION_UNLIMITED'
}

export type ProductInterest = {
  __typename?: 'ProductInterest';
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  productKey: ProductKey;
  productSubKey?: Maybe<ProductSubKey>;
  userId: Scalars['String'];
  /** Whether the user has dismissed the app notification for this product interest */
  wasAppNotificationDismissed: Scalars['Boolean'];
};

export type ProductInterestInput = {
  companyId: Scalars['String'];
  interests: Scalars['JSON'];
  origin: Scalars['String'];
};

export enum ProductKey {
  BambeePlus = 'BAMBEE_PLUS',
  Bolt = 'BOLT',
  Core = 'CORE',
  Dedicated = 'DEDICATED',
  Elite = 'ELITE',
  JobDescription = 'JOB_DESCRIPTION',
  JobDescriptionAi = 'JOB_DESCRIPTION_AI',
  Lite = 'LITE',
  ManagedHrServices = 'MANAGED_HR_SERVICES',
  MissedCall = 'MISSED_CALL',
  NewPolicy = 'NEW_POLICY',
  Pause = 'PAUSE',
  Payroll = 'PAYROLL',
  PayrollBasic = 'PAYROLL_BASIC',
  PayrollPremium = 'PAYROLL_PREMIUM',
  Plus = 'PLUS',
  Storage = 'STORAGE',
  TimeAttendance = 'TIME_ATTENDANCE',
  Training = 'TRAINING',
  WebinarWorkplaceViolence = 'WEBINAR_WORKPLACE_VIOLENCE'
}

export enum ProductSubKey {
  BenefitsAdministration = 'BENEFITS_ADMINISTRATION',
  CorrectiveActions = 'CORRECTIVE_ACTIONS',
  EmployeeSupport = 'EMPLOYEE_SUPPORT',
  HiringGuidance = 'HIRING_GUIDANCE',
  HrPolicies = 'HR_POLICIES',
  ImmigrationConsultation = 'IMMIGRATION_CONSULTATION',
  JobDescriptions = 'JOB_DESCRIPTIONS',
  LeaveOfAbsenceStrategy = 'LEAVE_OF_ABSENCE_STRATEGY',
  ManagedTermination = 'MANAGED_TERMINATION',
  ManagerLiveSupport = 'MANAGER_LIVE_SUPPORT',
  OrgDesignConsultation = 'ORG_DESIGN_CONSULTATION',
  SettingUpHrInvestigations = 'SETTING_UP_HR_INVESTIGATIONS'
}

export type ProfileAddress = {
  __typename?: 'ProfileAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Provision Deputy installation to enable T&A features */
export type ProvisionDeputyInstallInput = {
  /** Bambee company id */
  companyId: Scalars['String'];
};

export type PurchaseBambeePlusInput = {
  companyId: Scalars['String'];
};

export type PurchaseBundleSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipPayment?: Maybe<Scalars['Boolean']>;
};

export type PurchaseInput = {
  productKey: ProductKey;
  quantity: Scalars['Float'];
};

export type PurchaseResult = {
  __typename?: 'PurchaseResult';
  createdAt: Scalars['DateTime'];
  creditsPurchased: Scalars['Int'];
  id: Scalars['ID'];
  productKey: ProductKey;
  status: StatementStatus;
  totalAmount: Scalars['Int'];
};

export type PurchaseSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipPayment?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
};

export type PurchaseSeatsResponse = {
  __typename?: 'PurchaseSeatsResponse';
  bundleId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numPurchased: Scalars['Int'];
  topicId?: Maybe<Scalars['String']>;
  totalSeats: Scalars['Int'];
};

export type PurchaseSubscriptionInput = {
  billingPeriod?: Maybe<BillingPeriod>;
  companyId?: Maybe<Scalars['String']>;
  productKey: ProductKey;
};

export type PurchaseTicketsResponse = {
  __typename?: 'PurchaseTicketsResponse';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numPurchased: Scalars['Int'];
  totalTickets: Scalars['Int'];
};

export type PurchaseTimeAttendanceInput = {
  companyId: Scalars['String'];
  currentUserId: Scalars['String'];
  planValue?: Maybe<Scalars['String']>;
};

export type PurchasedBundle = {
  __typename?: 'PurchasedBundle';
  /** @deprecated Use bundleId instead */
  bundleId: Scalars['String'];
  counts: UserCounts;
  description?: Maybe<Scalars['String']>;
  global: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  topics: Array<Maybe<PurchasedTopic>>;
  totalSeats: Scalars['Float'];
  unfilledSeats: Scalars['Float'];
};

export type PurchasedProducts = {
  __typename?: 'PurchasedProducts';
  bundles: Array<Maybe<PurchasedBundle>>;
  id: Scalars['ID'];
  topics: Array<Maybe<PurchasedTopic>>;
};

export type PurchasedTopic = {
  __typename?: 'PurchasedTopic';
  counts?: Maybe<UserCounts>;
  enrollments: Array<Maybe<TopicEnrolledTickets>>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** @deprecated Use id instead */
  topicId: Scalars['String'];
  totalSeats?: Maybe<Scalars['Float']>;
  unfilledSeats?: Maybe<Scalars['Float']>;
};

export enum QaPolicyViewer {
  /** employee */
  Employee = 'Employee',
  /** manager */
  Manager = 'Manager'
}

export type QaTrainingCertificates = {
  __typename?: 'QaTrainingCertificates';
  id: Scalars['ID'];
  s3FileName?: Maybe<Scalars['String']>;
};

export enum Quarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4'
}

export type Query = {
  __typename?: 'Query';
  /** Gets a specific activation by key for current user's company */
  activation?: Maybe<CoreActivation>;
  /** Gets all activations for current user's company with optional filtering */
  activations?: Maybe<Array<CoreActivation>>;
  activeCancellationReasonGroups: Array<CancellationReasonGroupModel>;
  advisorNextAvailableSlot: AdvisorNextTimeSlot;
  availableCadence: Array<Cadence>;
  availableSettings: Array<Setting>;
  callSummaries: Array<CallSummary>;
  cancellationOffers: CancellationOffersModel;
  cancellationReasonGroups: Array<CancellationReasonGroupModel>;
  company: Company;
  companySubscriptions: Array<Subscription>;
  companySurvey: Survey;
  companySurveyAnswer: SurveyAnswer;
  companySurveyList: Array<Survey>;
  contractor?: Maybe<Contractor>;
  coreCompany: CoreCompany;
  coreUpgradeOptions: Array<PreviewCorePlanChangeModel>;
  coupon: PlanCoupon;
  couponList: Array<PlanCoupon>;
  downloadCompanyAuthorizationDocument: Scalars['String'];
  employee?: Maybe<Employee>;
  /** Fetches onboarding for the user and version provided if it exists */
  findOnboarding?: Maybe<CoreOnboarding>;
  getAdminCompanyGoals: Array<CoreGoal>;
  getAdminCompanyTasks: Array<CoreTask>;
  getAiGeneratedById: AiGenerated;
  getAiThread: AiThread;
  getAiThreadsForUser: Array<AiThread>;
  getAskNicelyWebSurveyInfo: AskNicelySurveyInfo;
  getAvailableProducts: Array<AvailableProduct>;
  getBambeePlusInfo: BambeePlus;
  /** Lists statements submitted to a company */
  getBillingHistory: Array<Statement>;
  getBillingInfo: BillingInfo;
  getBundle: BundleResponse;
  getBusinessManagerCalendly: Calendly;
  getChannelHistory: Array<ChatMessageInterface>;
  /** @deprecated Use payrollCompany instead */
  getCompany?: Maybe<Company>;
  getCompanyChannels: Array<CompanyChannel>;
  getCompanyCreditsV2: Array<Credit>;
  getCompanyDelinquency: CompanyDelinquency;
  getCompanyEmail: Scalars['String'];
  getCompanyEstimatedBenefitsCost?: Maybe<BenefitCostEstimated>;
  getCompanyProducts: Array<Product>;
  getCompanySettings: Array<CompanySetting>;
  getCompanySources: PaymentSources;
  /** @deprecated Use "contractor" instead */
  getContractor?: Maybe<Contractor>;
  /** @deprecated Use getCoreCompanyWithCompanyRoles { getPayroll {contractorPayment() } } instead. This query does not contain worker role data */
  getContractorPayment?: Maybe<ContractorPayment>;
  getContractorsByEmail: Array<Contractor>;
  getConversationByIntercomId: Conversation;
  getConversationHistory: Array<ChatMessageInterface>;
  /** @deprecated Use coreCompany instead */
  getCoreCompany: CoreCompany;
  getCoreUserById: CoreUser;
  getDocumentById: CoreDocument;
  getEligibleAddons: EligibleAddonsResponse;
  getEliteAddon: EliteAddonModel;
  /** @deprecated Use "employee" instead */
  getEmployee?: Maybe<Employee>;
  /** Retrieves one job description assigned to an employee */
  getEmployeeJobDescription?: Maybe<EmployeeJobDescription>;
  getEmployeesByEmail: Array<Employee>;
  getEoeHrRequestAnswer?: Maybe<EoEHrRequestAnswer>;
  getHrRequestBySalesforceCaseId?: Maybe<HrRequest>;
  getHrRequestOptions: HrRequestOptionsResponse;
  getHrRequests: ListHrRequestsResponse;
  getHrScore: HrScore;
  /** Get a job description by ID, including its assignment count */
  getJobDescriptionById: JobDescription;
  getLatestPricingPackagesForTier: PricingPackageResponse;
  getMyChatRecipients: Array<CoreUser>;
  getMyCompanyChannels: Array<CompanyChannel>;
  getMyCompanyGoals: Array<CoreGoal>;
  getMyCompanyTasks: Array<CoreTask>;
  getMyCompanyVoicesFeedbackList: Array<VoicesFeedback>;
  getMyCoreUser: CoreUser;
  getMyMfaEnrollments: Array<AuthMfaConfig>;
  getMySuggestedTopics: Array<ChatTopicSuggestion>;
  getMyVoicesFeedbackList: Array<VoicesFeedback>;
  getNonCoreSubscriptionBillingChanges: Array<UpcomingNonCoreSubscriptionBillingChange>;
  getOnboardingCalendlyConfig: OnboardingCalendlyConfig;
  /** @deprecated Use "payroll" instead */
  getPayroll?: Maybe<Payroll>;
  /** @deprecated Use payrollItem instead */
  getPayrollItem?: Maybe<PayrollItem>;
  getPlanLock: PlanLock;
  getPolicy?: Maybe<CorePolicy>;
  getPractice: Practice;
  getPricingPackages: PricingPackageResponse;
  getReportCard: ReportCard;
  getRescheduleLink: Scalars['String'];
  getResignationByHrRequest: Resignation;
  getSalesforceCasesForNewPolicyRequest: ListSalesforceCasesResponse;
  getScheduledEventsForUser: Array<ScheduledEvent>;
  getSystemConfiguration: SystemConfiguration;
  getTerminationByHrRequest: Termination;
  getThreadHistory: Array<ChatMessageInterface>;
  getTickets: ListTicketsResponse;
  getTopic?: Maybe<CourseTopic>;
  getTopics: Array<CourseTopic>;
  getTrainingPrices: TrainingPricesResponse;
  /** @deprecated Use `user.training.courses` query instead */
  getUserCourses: Array<UserCourse>;
  getUserMfaEnrollments: Array<AuthMfaConfig>;
  /** @deprecated Use userToken mutation instead; Queries are inherently cachable and tokens should not be cached */
  getUserToken: DoceboTokenResponse;
  getVoicesFeedbackList: Array<VoicesFeedback>;
  geyMyGroups: Array<CoreUserGroup>;
  hotlineCalls: Array<HotlineCall>;
  hrRequest: HrRequest;
  hrRequestExtendedDetail: HrRequestExtendedDetail;
  hrRequestList: ListHrRequestDetails;
  isEventScheduledForUser: IsEventScheduledForUser;
  /** Lists the job descriptions created by a company with their assignment counts */
  jobDescriptions: Array<JobDescription>;
  listPayroll: PayrollPage;
  listPractice: Array<Practice>;
  listReportCards: Array<ReportCard>;
  /** The workplaces associated with the companyId provided. By default only active === true workplaces will be returned. */
  listWorkplace: Array<Workplace>;
  me?: Maybe<Employee>;
  /** Lists notification for a user */
  myNotifications: Array<Notification>;
  myProducts: Array<Product>;
  /** Gets all recommendations for current user with optional filtering */
  myRecommendations?: Maybe<Array<CoreRecommendation>>;
  /** Gets all requests for current user with optional filtering */
  myRequests?: Maybe<Array<CoreRequest>>;
  /** Gets all training recommendations for current user with optional filtering; Aggregates training recommendations from all scopes ( SYSTEM, COMPANY, EMPLOYEE) */
  myTrainingRecommendations?: Maybe<Array<CoreRecommendation>>;
  /** Gets all training requests for current user with optional filtering */
  myTrainingRequests?: Maybe<Array<CoreRequest>>;
  /** Get a specific notice by ID */
  notice?: Maybe<Notice>;
  /** Get paginated notices for the current user or company */
  notices: PaginatedNoticesResponse;
  onboardingFileAnalysis: OnboardingFilesAnalysis;
  payroll?: Maybe<Payroll>;
  payrollCompany?: Maybe<PayrollCompany>;
  payrollItem?: Maybe<PayrollItem>;
  pendingHotlineCall?: Maybe<HotlineCall>;
  productInterest: Array<ProductInterest>;
  qaQueryTrainingCertificates: Array<QaTrainingCertificates>;
  queryEnrolledTopics: Array<CompanyCourseTopic>;
  queryWebinars: Array<Webinar>;
  /** Gets all recommendations for provided query */
  recommendations?: Maybe<Array<CoreRecommendation>>;
  removeSeatsInfo: RemoveSeatsInfoResponse;
  /** Gets all requests for current user's company with optional filtering */
  requests?: Maybe<Array<CoreRequest>>;
  resignationDownload: ResignationDownload;
  resignationExists: ResignationExist;
  resignationInfo: Resignation;
  resignationList: Array<Resignation>;
  scratchListServiceAddons: Array<ScratchServiceAddonsModel>;
  terminationDownload: TerminationDownload;
  terminationExists: TerminationExist;
  terminationInfo: Termination;
  terminationList: Array<Termination>;
  timesheets: Array<Timesheet>;
  user: User;
  /** @deprecated Use `user.training.courses` query instead */
  userCourses: Array<UserCourse>;
  warningDocuments: Array<WarningDocument>;
};


export type QueryActivationArgs = {
  data: ActivationQueryInput;
};


export type QueryActivationsArgs = {
  data?: Maybe<ActivationFilterInput>;
};


export type QueryAdvisorNextAvailableSlotArgs = {
  input: AdvisorNextAvailableSlotInput;
};


export type QueryCompanyArgs = {
  data: GetCompanyInput;
};


export type QueryCompanySubscriptionsArgs = {
  data: GetCompanySubscriptionsInput;
};


export type QueryCompanySurveyArgs = {
  data: GetCompanySurveyInput;
};


export type QueryCompanySurveyAnswerArgs = {
  data: GetCompanySurveyAnswerInput;
};


export type QueryCompanySurveyListArgs = {
  input: GetCompanySurveyListInput;
};


export type QueryContractorArgs = {
  id: Scalars['ID'];
};


export type QueryCoreCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryCoreUpgradeOptionsArgs = {
  input: GetCoreUpgradeOptionsInput;
};


export type QueryCouponArgs = {
  data: GetCouponInput;
};


export type QueryDownloadCompanyAuthorizationDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryEmployeeArgs = {
  id: Scalars['ID'];
};


export type QueryFindOnboardingArgs = {
  data: CoreOnboardingKeys;
};


export type QueryGetAdminCompanyGoalsArgs = {
  companyId: Scalars['String'];
};


export type QueryGetAdminCompanyTasksArgs = {
  companyId: Scalars['String'];
};


export type QueryGetAiGeneratedByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetAiThreadArgs = {
  threadId: Scalars['String'];
};


export type QueryGetAiThreadsForUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetAskNicelyWebSurveyInfoArgs = {
  input: GetAskNicelyWebSurveyInfoInput;
};


export type QueryGetAvailableProductsArgs = {
  data: GetAvailableProductsInput;
};


export type QueryGetBambeePlusInfoArgs = {
  input: PurchaseBambeePlusInput;
};


export type QueryGetBillingHistoryArgs = {
  companyId: Scalars['String'];
};


export type QueryGetBillingInfoArgs = {
  input: GetBillingInfoInput;
};


export type QueryGetBundleArgs = {
  data: GetEntityInput;
};


export type QueryGetBusinessManagerCalendlyArgs = {
  input: GetBusinessManagerCalendlyUrlInput;
};


export type QueryGetChannelHistoryArgs = {
  afterId?: Maybe<Scalars['ID']>;
  channelId: Scalars['ID'];
};


export type QueryGetCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyChannelsArgs = {
  companyId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};


export type QueryGetCompanyCreditsV2Args = {
  data: GetCompanyCreditsInputV2;
};


export type QueryGetCompanyDelinquencyArgs = {
  data: GetCompanyDelinquency;
};


export type QueryGetCompanyEmailArgs = {
  companyId: Scalars['String'];
};


export type QueryGetCompanyEstimatedBenefitsCostArgs = {
  zip: Scalars['String'];
};


export type QueryGetCompanyProductsArgs = {
  data: GetCompanyProductsInput;
};


export type QueryGetCompanySettingsArgs = {
  companyId: Scalars['String'];
};


export type QueryGetCompanySourcesArgs = {
  data: GetCompanyPaymentSources;
};


export type QueryGetContractorArgs = {
  id: Scalars['ID'];
};


export type QueryGetContractorPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryGetContractorsByEmailArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryGetConversationByIntercomIdArgs = {
  input: GetConversationByIntercomIdInput;
};


export type QueryGetConversationHistoryArgs = {
  input: ConversationHistoryInput;
};


export type QueryGetCoreCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGetCoreUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDocumentByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetEligibleAddonsArgs = {
  input: EligibleAddonsInput;
};


export type QueryGetEliteAddonArgs = {
  input: GetEliteAddonInput;
};


export type QueryGetEmployeeArgs = {
  id: Scalars['ID'];
};


export type QueryGetEmployeeJobDescriptionArgs = {
  id: Scalars['String'];
};


export type QueryGetEmployeesByEmailArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryGetEoeHrRequestAnswerArgs = {
  data: GetEoeHrRequestInput;
};


export type QueryGetHrRequestBySalesforceCaseIdArgs = {
  input: GetHrRequestBySalesforceCaseIdInput;
};


export type QueryGetHrScoreArgs = {
  companyId: Scalars['String'];
};


export type QueryGetJobDescriptionByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetLatestPricingPackagesForTierArgs = {
  input: ActivePlanFilters;
  tierNumber: Scalars['Float'];
};


export type QueryGetMyMfaEnrollmentsArgs = {
  includeUnconfirmed?: Maybe<Scalars['Boolean']>;
};


export type QueryGetNonCoreSubscriptionBillingChangesArgs = {
  data: GetCompanyUpcomingBillingChangesInput;
};


export type QueryGetOnboardingCalendlyConfigArgs = {
  input: OnboardingCalendlyConfigInput;
};


export type QueryGetPayrollArgs = {
  id: Scalars['ID'];
};


export type QueryGetPayrollItemArgs = {
  id: Scalars['ID'];
};


export type QueryGetPlanLockArgs = {
  companyId: Scalars['String'];
};


export type QueryGetPolicyArgs = {
  input: GetPolicy;
};


export type QueryGetPracticeArgs = {
  input: GetPracticeInput;
};


export type QueryGetPricingPackagesArgs = {
  input: PricingPackageFilterInput;
};


export type QueryGetReportCardArgs = {
  data: GetReportCardInput;
};


export type QueryGetRescheduleLinkArgs = {
  input: GetCalendlyRescheduleLinkInput;
};


export type QueryGetResignationByHrRequestArgs = {
  data: GetResignationHrRequestInput;
};


export type QueryGetSalesforceCasesForNewPolicyRequestArgs = {
  input: GetSalesforceCasesForNewPolicyRequestInput;
};


export type QueryGetScheduledEventsForUserArgs = {
  input: GetScheduledEventsForUserInput;
};


export type QueryGetTerminationByHrRequestArgs = {
  data: GetTerminationHrRequestInput;
};


export type QueryGetThreadHistoryArgs = {
  input: ThreadHistoryInput;
};


export type QueryGetTicketsArgs = {
  data: ListTicketsInput;
};


export type QueryGetTopicArgs = {
  data: GetEntityInput;
};


export type QueryGetUserCoursesArgs = {
  data: GetUserCoursesInput;
};


export type QueryGetUserMfaEnrollmentsArgs = {
  authId: Scalars['String'];
  includeUnconfirmed?: Maybe<Scalars['Boolean']>;
};


export type QueryGetVoicesFeedbackListArgs = {
  input: GetVoicesFeedbackListInput;
};


export type QueryGeyMyGroupsArgs = {
  view?: GroupView;
};


export type QueryHrRequestArgs = {
  input: GetHrRequestByIdInput;
};


export type QueryHrRequestExtendedDetailArgs = {
  input: GetHrRequestExtendedDetailByIdInput;
};


export type QueryIsEventScheduledForUserArgs = {
  input: IsEventScheduledForUserInput;
};


export type QueryListPayrollArgs = {
  advancedWhere?: Maybe<PayrollAdvancedWhereInput>;
  companyId?: Maybe<Scalars['ID']>;
  companyStatus?: Maybe<CompanyStatus>;
  deletedAt?: Maybe<ListPayrollDeletedOptions>;
  limit?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PayrollOrderByInput>;
  page?: Maybe<Scalars['Int']>;
  where?: Maybe<PayrollWhereInput>;
};


export type QueryListPracticeArgs = {
  companyId: Scalars['String'];
};


export type QueryListReportCardsArgs = {
  data: ListReportCardsInput;
};


export type QueryListWorkplaceArgs = {
  companyId: Scalars['ID'];
  showAll?: Maybe<Scalars['Boolean']>;
};


export type QueryMeArgs = {
  id: Scalars['ID'];
};


export type QueryMyRecommendationsArgs = {
  data: MyRecommendationFilterInput;
};


export type QueryMyRequestsArgs = {
  data: MyRequestFilterInput;
};


export type QueryMyTrainingRecommendationsArgs = {
  data: MyTrainingRecommendationFilterInput;
};


export type QueryMyTrainingRequestsArgs = {
  data: MyTrainingRequestFilterInput;
};


export type QueryNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryNoticesArgs = {
  pagination?: Maybe<NoticesPaginationInput>;
};


export type QueryOnboardingFileAnalysisArgs = {
  id: Scalars['ID'];
};


export type QueryPayrollArgs = {
  id: Scalars['ID'];
};


export type QueryPayrollCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryPayrollItemArgs = {
  id: Scalars['ID'];
};


export type QueryProductInterestArgs = {
  input: GetProductInterestInput;
};


export type QueryQaQueryTrainingCertificatesArgs = {
  courseTicketId: Scalars['String'];
};


export type QueryQueryEnrolledTopicsArgs = {
  companyId: Scalars['String'];
};


export type QueryQueryWebinarsArgs = {
  advisor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  tier?: Maybe<Array<Scalars['String']>>;
};


export type QueryRecommendationsArgs = {
  data: RecommendationFilterInput;
};


export type QueryRemoveSeatsInfoArgs = {
  data: RemoveSeatsInfoInput;
};


export type QueryRequestsArgs = {
  data: RequestFilterInput;
};


export type QueryResignationDownloadArgs = {
  data: GetResignationInput;
};


export type QueryResignationExistsArgs = {
  data: GetExistingResignationByEmployeeInput;
};


export type QueryResignationInfoArgs = {
  data: GetResignationInput;
};


export type QueryResignationListArgs = {
  data: GetResignationsInput;
};


export type QueryScratchListServiceAddonsArgs = {
  input: ScratchServiceAddonListInput;
};


export type QueryTerminationDownloadArgs = {
  data: GetTerminationInput;
};


export type QueryTerminationExistsArgs = {
  data: GetExistingTerminationByEmployeeInput;
};


export type QueryTerminationInfoArgs = {
  data: GetTerminationInput;
};


export type QueryTerminationListArgs = {
  data: GetTerminationsInput;
};


export type QueryTimesheetsArgs = {
  companyId: Scalars['ID'];
  filter?: Maybe<TimesheetFilter>;
};


export type QueryUserArgs = {
  data: UserQueryInput;
};


export type QueryUserCoursesArgs = {
  data: UserCoursesInput;
};


export type QueryWarningDocumentsArgs = {
  data: GetUserWarningDocumentsInput;
};

export type RawAiPrompt = {
  /** The text of the prompt, optionally included, containing questions, statements, or relevant information for the chat interaction. */
  content?: Maybe<Scalars['String']>;
  /** An optional identifier for the prompt, used for reference or categorization within the chat framework. */
  name?: Maybe<Scalars['String']>;
  /** Defines the prompt's function within the chat, such as initiating a request or guiding the conversation, based on ChatCompletionRequestMessageRoleEnum. */
  role: ChatCompletionRole;
};

/** Type of reaction to a recommendation. */
export enum ReactionType {
  Accept = 'ACCEPT',
  Decline = 'DECLINE'
}

export type ReactivatePausedCompanyInput = {
  companyId: Scalars['String'];
};

/** The demographic target of the recommendation. */
export enum RecommendationDemographic {
  Id = 'ID',
  Industry = 'INDUSTRY',
  Role = 'ROLE',
  State = 'STATE',
  Tier = 'TIER'
}

export type RecommendationFilterInput = {
  /** The id of the company to fetch recommendations for. */
  companyId?: Maybe<Scalars['String']>;
  /** The target demographic of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the recommendation. */
  resourceType?: Maybe<RequestResourceType>;
  /** The scope of the recommendation */
  scope: RecommendationScope;
  /** The status of the recommendation. */
  status?: Maybe<RecommendationStatus>;
  /** The targets of the recommendation */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The user id of the employee to fetch recommendations for. */
  userId?: Maybe<Scalars['String']>;
};

export type RecommendationInput = {
  /** The types of reactions allowed. */
  allowedReactions?: Maybe<Array<Maybe<ReactionType>>>;
  /** The company id of the employee recommending training. */
  companyId: Scalars['String'];
  /** The target demographic of the recommendation */
  demographic: RecommendationDemographic;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The roles of the users allowed to react. */
  reactorRoles?: Maybe<Array<Maybe<AuthRole>>>;
  /** The id of the resource. */
  resourceId: Scalars['String'];
  /** The resource type of the recommendation. */
  resourceType: RequestResourceType;
  /** The scope of the recommendation */
  scope: RecommendationScope;
  /** The targets of the recommendation */
  targets: Array<Scalars['String']>;
  /** The user id of the employee recommending training. */
  userId: Scalars['String'];
};

export type RecommendationReactionInput = {
  /** The reaction type */
  reaction: ReactionType;
  /** The id of the recommendation to be reacted to. */
  recommendationId: Scalars['String'];
};

/** The scope of the recommendation. */
export enum RecommendationScope {
  Company = 'COMPANY',
  Employee = 'EMPLOYEE',
  System = 'SYSTEM'
}

/** The status of the recommendation. */
export enum RecommendationStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type RefundCreditsInput = {
  companyId: Scalars['String'];
  consumptionDescription: Scalars['String'];
  consumptionReason: ProductCreditConsumptionReason;
  productKey: ProductKey;
  stripeInvoiceId: Scalars['String'];
};

export type RefundInvoiceItem = {
  __typename?: 'RefundInvoiceItem';
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  refund: Scalars['Float'];
  unitPrice: Scalars['Float'];
};

export type RefundResult = {
  __typename?: 'RefundResult';
  creditsRefunded?: Maybe<Array<Credit>>;
  id: Scalars['ID'];
  totalRefunded: Scalars['Int'];
};

export type Reimbursement = {
  __typename?: 'Reimbursement';
  amount: Scalars['Float'];
  id: Scalars['ID'];
  /** Source of Reimbursement */
  source?: Maybe<SourceType>;
};

export type ReimbursementInput = {
  amount: Scalars['Float'];
  id?: Maybe<Scalars['ID']>;
  /** Source of Reimbursement */
  source?: Maybe<SourceType>;
};

export type ReinstateEmployeeInput = {
  employeeId: Scalars['String'];
};

export type RelatedCase = {
  __typename?: 'RelatedCase';
  /** Salesforce ID of the related case */
  caseId: Scalars['String'];
  /** Subject of the related case */
  subject: Scalars['String'];
};

export type RemoveAutoAssignHrManagerInput = {
  stateGroup: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveBundleSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipRefund?: Maybe<Scalars['Boolean']>;
};

export type RemoveCompanyTrainingInput = {
  companyId: Scalars['String'];
};

export type RemoveCompanyTrainingResponse = {
  __typename?: 'RemoveCompanyTrainingResponse';
  id: Scalars['ID'];
};

export type RemoveCreditsInput = {
  companyId: Scalars['String'];
  consumptionDescription: Scalars['String'];
  consumptionReason: ProductCreditConsumptionReason;
  /** Subkey of the product, if consuming managed service credit */
  consumptionSubKey?: Maybe<ProductSubKey>;
  productKey: ProductKey;
  quantity: Scalars['Int'];
};

export type RemovePaymentMethodInput = {
  companyId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export type RemoveSeatsInfoInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipRefund?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
};

export type RemoveSeatsInfoResponse = {
  __typename?: 'RemoveSeatsInfoResponse';
  id: Scalars['ID'];
  invoices: Array<RefundInvoiceItem>;
  refund: Scalars['Float'];
  seats: Scalars['Int'];
};

export type RemoveSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipRefund?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
};

export type RemoveSeatsResponse = {
  __typename?: 'RemoveSeatsResponse';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numRemoved: Scalars['Int'];
  totalSeats: Scalars['Int'];
};

export type ReopenPayrollInput = {
  id: Scalars['ID'];
};

export type ReplyToConversationInput = {
  intercomConversationId: Scalars['String'];
  message: Scalars['String'];
};

export type ReplyToHrRequestAsAdminInput = {
  hrRequestId: Scalars['String'];
  message: Scalars['String'];
};

export type ReportCard = {
  __typename?: 'ReportCard';
  /** frequency of being created */
  cadence: Scalars['String'];
  company: CoreCompany;
  createdAt: Scalars['DateTime'];
  createdBy: CoreUser;
  directReports?: Maybe<Array<CoreUser>>;
  employees: Array<ReportCardEmployeeGrade>;
  /** ReportCardId */
  id: Scalars['ID'];
  managerReports?: Maybe<Array<ManagedReport>>;
  status: ReportCardStatusValues;
  updateHistory: Array<Maybe<ReportCardEmployeeGradeHistory>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReportCardEmployeeGrade = {
  __typename?: 'ReportCardEmployeeGrade';
  employee: CoreUser;
  /** External / public to employee feedback */
  feedback: Scalars['String'];
  /** Employee Grade */
  grade: Scalars['String'];
  /** The person who graded this report card */
  gradedBy: CoreUser;
  /** Unique Report Card Grade Id */
  id: Scalars['ID'];
  /** Owner / Manager Internal Employee Note */
  note: Scalars['String'];
  /** Status of employee grade filled out */
  status: Scalars['String'];
};

export type ReportCardEmployeeGradeHistory = {
  __typename?: 'ReportCardEmployeeGradeHistory';
  employee: CoreUser;
  /** External / public to employee feedback */
  feedback: Scalars['String'];
  /** Employee Grade */
  grade: Scalars['String'];
  gradedBy: CoreUser;
  /** Unique Report Card Grade History Id */
  id: Scalars['ID'];
  /** Owner / Manager Internal Employee Note */
  note: Scalars['String'];
};

export enum ReportCardGradeValues {
  A = 'A',
  B = 'B',
  C = 'C',
  Pending = 'PENDING',
  Skip = 'SKIP'
}

export enum ReportCardStatusValues {
  Completed = 'COMPLETED',
  Created = 'CREATED'
}

export type RequestApprovalInput = {
  /** The id of the request. */
  requestId: Scalars['String'];
};

export type RequestCancelInput = {
  /** The id of the request. */
  requestId: Scalars['String'];
};

export type RequestFilterInput = {
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the request. */
  resourceType?: Maybe<RequestResourceType>;
  /** The status of the request. */
  status?: Maybe<RequestStatus>;
  /** The user id of the employee requesting training. */
  userId?: Maybe<Scalars['String']>;
};

export type RequestInput = {
  /** The number of approvals required to approve the request. */
  approvalCriteria: Scalars['Int'];
  /** The roles of the decision makers. */
  approverRoles?: Maybe<Array<Maybe<AuthRole>>>;
  /** The company id of the employee requesting training. */
  companyId: Scalars['String'];
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The number of rejections required to reject the request. */
  rejectionCriteria: Scalars['Int'];
  /** The id of the resource. */
  resourceId: Scalars['String'];
  /** The resource type of the request. */
  resourceType: RequestResourceType;
  /** The user id of the employee requesting training. */
  userId: Scalars['String'];
};

export type RequestRejectionInput = {
  /** The id of the request. */
  requestId: Scalars['String'];
};

/** The resource type of the request. */
export enum RequestResourceType {
  TrainingBundle = 'TRAINING_BUNDLE',
  TrainingTopic = 'TRAINING_TOPIC'
}

/** The status of the request. */
export enum RequestStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Requirement = {
  __typename?: 'Requirement';
  checkId?: Maybe<Scalars['ID']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  documentOptions: Array<DocumentOption>;
  errors: Array<RequirementError>;
  id: Scalars['ID'];
  /** Human readable name of the requirement type */
  requirementName: Scalars['String'];
  requirementType: RequirementType;
  requirementTypeExt?: Maybe<Scalars['String']>;
  status: RequirementStatus;
  /** @deprecated Use files array instead */
  uploadedDocumentType?: Maybe<DocumentType>;
  /** @deprecated Use files array instead */
  uploadedFileName?: Maybe<Scalars['String']>;
  /** @deprecated Use files array instead */
  uploadedFileType?: Maybe<FileType>;
  /** Array of uploaded files */
  uploadedFiles?: Maybe<Array<UploadedFile>>;
};

export type RequirementError = {
  __typename?: 'RequirementError';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  type: RequirementErrorConst;
};

export enum RequirementErrorConst {
  ProvidedDocumentBankAccountMissing = 'PROVIDED_DOCUMENT_BANK_ACCOUNT_MISSING',
  ProvidedDocumentBankNameMissing = 'PROVIDED_DOCUMENT_BANK_NAME_MISSING',
  ProvidedDocumentBankRoutingMissing = 'PROVIDED_DOCUMENT_BANK_ROUTING_MISSING',
  ProvidedDocumentEdited = 'PROVIDED_DOCUMENT_EDITED',
  ProvidedDocumentFailedOther = 'PROVIDED_DOCUMENT_FAILED_OTHER',
  ProvidedDocumentFederalEinMissing = 'PROVIDED_DOCUMENT_FEDERAL_EIN_MISSING',
  ProvidedDocumentIncorrectPerson = 'PROVIDED_DOCUMENT_INCORRECT_PERSON',
  ProvidedDocumentLegalNameMissing = 'PROVIDED_DOCUMENT_LEGAL_NAME_MISSING',
  ProvidedDocumentNotReadable = 'PROVIDED_DOCUMENT_NOT_READABLE',
  ProvidedDocumentTypeNotSupported = 'PROVIDED_DOCUMENT_TYPE_NOT_SUPPORTED'
}

export enum RequirementStatus {
  Closed = 'CLOSED',
  Failed = 'FAILED',
  Open = 'OPEN',
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export enum RequirementType {
  BankAccountVerification = 'BANK_ACCOUNT_VERIFICATION',
  CompanyFinancialVerification = 'COMPANY_FINANCIAL_VERIFICATION',
  CompanyIdentityVerification = 'COMPANY_IDENTITY_VERIFICATION',
  FederalEinVerification = 'FEDERAL_EIN_VERIFICATION',
  NonProfitOrganization = 'NON_PROFIT_ORGANIZATION',
  PreviousPayrollProviderAccess = 'PREVIOUS_PAYROLL_PROVIDER_ACCESS',
  ResolveFundingFailure = 'RESOLVE_FUNDING_FAILURE',
  SignatoryAuthorizationVerification = 'SIGNATORY_AUTHORIZATION_VERIFICATION',
  SignatoryIdentityVerification = 'SIGNATORY_IDENTITY_VERIFICATION',
  StateRegistrationVerification = 'STATE_REGISTRATION_VERIFICATION',
  TaxParameter = 'TAX_PARAMETER'
}

export type ResetCompanyInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
};

export type ResetDeputyInput = {
  companyId: Scalars['ID'];
};

export type Resignation = {
  __typename?: 'Resignation';
  complete: Scalars['Boolean'];
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  employee: User;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  hrRequestVersion: Scalars['Boolean'];
  isLegacy: Scalars['Boolean'];
  manager: User;
  resignationDate?: Maybe<Scalars['DateTime']>;
  resignationId: Scalars['String'];
  resignationState?: Maybe<Scalars['String']>;
  selfService: Scalars['Boolean'];
  signedFiles: Array<FileStackModel>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: ResignationStatus;
  step: ResignationStep;
  user: User;
  userId: Scalars['String'];
};

export type ResignationAttachInput = {
  files: Array<FileStackInput>;
  resignationId: Scalars['String'];
};

export type ResignationCancelInput = {
  resignationId: Scalars['String'];
};

export type ResignationConfirmationInput = {
  resignationDate: Scalars['String'];
  resignationId: Scalars['String'];
  userId: Scalars['String'];
};

export type ResignationCreateInput = {
  answers?: Maybe<Scalars['JSON']>;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  resignationDate?: Maybe<Scalars['String']>;
  selfService?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  userId: Scalars['String'];
};

export type ResignationDownload = {
  __typename?: 'ResignationDownload';
  file: Scalars['String'];
  resignationId: Scalars['String'];
};

export type ResignationEditDetailsInput = {
  resignationDate: Scalars['String'];
  resignationId: Scalars['String'];
  selfService?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type ResignationExist = {
  __typename?: 'ResignationExist';
  exists: Scalars['Boolean'];
  resignationId?: Maybe<Scalars['String']>;
};

export enum ResignationStatus {
  AwaitingAcknowledgement = 'AWAITING_ACKNOWLEDGEMENT',
  AwaitingAproval = 'AWAITING_APROVAL',
  AwaitingSignature = 'AWAITING_SIGNATURE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  HrComplete = 'HR_COMPLETE',
  SelfService = 'SELF_SERVICE',
  Started = 'STARTED'
}

export enum ResignationStep {
  None = 'NONE',
  Print = 'PRINT',
  Requested = 'REQUESTED',
  UploadSigned = 'UPLOAD_SIGNED'
}

export enum SsnSteps {
  SsnSubmitted = 'SSN_SUBMITTED'
}

export type SalesforceCase = {
  __typename?: 'SalesforceCase';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  hrRequestId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status?: Maybe<CaseStatus>;
  subType?: Maybe<CaseSubType>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<CaseType>;
};

export type SaveCompanyAnswerInput = {
  companyId: Scalars['String'];
  key: Scalars['String'];
  surveyId: Scalars['Float'];
  value: Scalars['String'];
};

export type SaveCompanySettingInput = {
  boolValue?: Maybe<Scalars['Boolean']>;
  cadenceValue?: Maybe<PracticeCadenceValue>;
  companyId: Scalars['String'];
  key: CompanySettingKey;
  type?: Maybe<SettingType>;
  value?: Maybe<Scalars['String']>;
};

export type SaveJobDescriptionOnEmployeeInput = {
  jobDescriptionId: Scalars['String'];
  update?: Maybe<UpdateJobDescriptionInput>;
  userId: Scalars['String'];
};

export type ScheduledCorePlanChangeModel = {
  __typename?: 'ScheduledCorePlanChangeModel';
  effectiveOn: Scalars['DateTime'];
  /** The ID of the scheduled plan change. */
  id: Scalars['ID'];
  newPlan: CorePlanModel;
};

export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  /** The Bambee agent associated with this scheduled event */
  agent?: Maybe<CallAgent>;
  /** Email addresses of attendees as provided by Calendly */
  attendeeEmails?: Maybe<Array<Scalars['String']>>;
  /** Unique Calendly Event ID */
  calendlyEventId: Scalars['String'];
  /** The invitee ID from Calendly */
  calendlyInviteeId: Scalars['String'];
  /** Call summaries for the event */
  callSummaries: Array<CallSummary>;
  /** If the event was cancelled */
  cancelled?: Maybe<Scalars['Boolean']>;
  /** End time of the scheduled event */
  endTime: Scalars['DateTime'];
  /** Event type */
  eventLocation: SchedulerEventLocation;
  id: Scalars['ID'];
  kind: Scalars['String'];
  /** Missed Call Fee Status */
  missedCallFeeStatus?: Maybe<MissedCallFeeStatus>;
  /** The Contacts Phone number that was defined as part of the scheduled event */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Start time of the scheduled event */
  startTime: Scalars['DateTime'];
  /** Calendly Event Name + x */
  title: Scalars['String'];
  /** Transaction ID */
  transactionId?: Maybe<Scalars['String']>;
  /** The video conference link (zoom) */
  videoConferenceLink?: Maybe<Scalars['String']>;
};

export type ScheduledPlanChangeModel = {
  __typename?: 'ScheduledPlanChangeModel';
  effectiveOn: Scalars['DateTime'];
  /** The ID of the scheduled plan change. */
  id: Scalars['ID'];
  newPlan: PlanModel;
};

export enum SchedulerEventLocation {
  Phone = 'PHONE',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO'
}

export enum SchedulerZone {
  East = 'EAST',
  West = 'WEST'
}

export type ScratchServiceAddonListInput = {
  companyId?: Maybe<Scalars['String']>;
};

export type ScratchServiceAddonsModel = {
  __typename?: 'ScratchServiceAddonsModel';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  label: Scalars['String'];
  priceLabel: Scalars['String'];
};

export type ScratchToggleServiceAddonInput = {
  companyId: Scalars['String'];
  id: Scalars['String'];
};

export type SeatsSummary = {
  __typename?: 'SeatsSummary';
  enrolledUsers: Array<EnrolledUser>;
  id: Scalars['ID'];
  totalSeats: Scalars['Float'];
  unfilledSeats: Scalars['Float'];
};

export type SendJobDescriptionToEmployeeInput = {
  jobDescriptionId: Scalars['String'];
  userId: Scalars['String'];
};

export type SendMagicLinkForEmailInput = {
  email: Scalars['String'];
};

export type SendStaffOnboardInviteInput = {
  contractorIds: Array<Maybe<Scalars['ID']>>;
  employeeIds: Array<Maybe<Scalars['ID']>>;
};

/** The type of message according to sendbird */
export enum SendbirdMessageType {
  /** Not currently in use */
  Admin = 'Admin',
  /** A binary file, such as an image or other downloadable content. */
  File = 'File',
  /** A text message.  This can be a standard message of just text, or a serialized payload for Bambee customized messages */
  Message = 'Message'
}

export enum ServiceKey {
  AutoCompliance = 'AUTO_COMPLIANCE',
  BambeePlus = 'BAMBEE_PLUS',
  Calls = 'CALLS',
  Core = 'CORE',
  Elite = 'ELITE',
  Nectar = 'NECTAR',
  Payroll = 'PAYROLL',
  TimeAttendance = 'TIME_ATTENDANCE',
  Training = 'TRAINING'
}

export type SetCaseStatusInput = {
  caseId: Scalars['String'];
  status: CaseStatus;
};

export type SetDefaultPaymentMethodInput = {
  companyId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export type Setting = {
  __typename?: 'Setting';
  defaultValue: Scalars['String'];
  key: CompanySettingKey;
  type: SettingType;
};

export enum SettingType {
  BooleanType = 'BooleanType',
  StringType = 'StringType'
}

export type SetupContractorInput = {
  /** Check ID ( optionally provide if setup directly in Check and need to setup in Bambee after the fact ) */
  checkId?: Maybe<Scalars['ID']>;
  /** Bambee company ID */
  companyId: Scalars['ID'];
  /** Bambee contractor ID */
  contractorId: Scalars['ID'];
  /** Bambee workplace ID */
  workplaceId?: Maybe<Scalars['ID']>;
};

export type SetupEmployeeInput = {
  /** Check ID ( optionally provide if setup directly in Check and need to setup in Bambee after the fact ) */
  checkId?: Maybe<Scalars['ID']>;
  /** Bambee company ID */
  companyId: Scalars['ID'];
  /** Bambee employee ID */
  employeeId: Scalars['ID'];
  /** Bambee workplace ID */
  workplaceId?: Maybe<Scalars['ID']>;
};

export enum SourceType {
  Deputy = 'DEPUTY',
  Manual = 'MANUAL',
  Upload = 'UPLOAD'
}

export enum StaffStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  SignatureRequired = 'SIGNATURE_REQUIRED'
}

export enum State {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** The abbreviation of the US state or territory. */
export enum StateAbbreviation {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type Statement = {
  __typename?: 'Statement';
  amount: Scalars['Float'];
  attemptCount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  hostedUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastAttemptError?: Maybe<Scalars['Float']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  pdfUrl?: Maybe<Scalars['String']>;
  productKey?: Maybe<ProductKey>;
  quantity?: Maybe<Scalars['Float']>;
  serviceKey?: Maybe<ServiceKey>;
  statementType: StatementType;
  status: StatementStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export enum StatementStatus {
  Failed = 'FAILED',
  Issued = 'ISSUED',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Voided = 'VOIDED'
}

export enum StatementType {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE'
}

export type StringNullableFilter = {
  equals?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  amount: Scalars['Int'];
  coupon?: Maybe<PlanCoupon>;
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  isDrp: Scalars['Boolean'];
  name: Scalars['String'];
  planValue: Scalars['String'];
  productCode: ProductKey;
  serviceKey: ServiceKey;
  startDate: Scalars['DateTime'];
  status: SubscriptionStatus;
  stripeId: Scalars['String'];
  stripePriceId: Scalars['String'];
};

export type SubscriptionModel = {
  __typename?: 'SubscriptionModel';
  /** Subscription Status */
  active: Scalars['Boolean'];
  /** True when there is a pending cancellation request */
  cancellationRequested: Scalars['Boolean'];
  /** A scheduled date for when the subscription will be canceled */
  cancelsAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the subscription. */
  id: Scalars['ID'];
  /** Date when the current period will end */
  periodEndsAt: Scalars['DateTime'];
  plan: PlanModel;
  /** The quantity of the plan to which the customer is subscribed to. */
  quantity?: Maybe<Scalars['Float']>;
  /** Scheduled plan change, if any. */
  scheduledPlanChange?: Maybe<ScheduledPlanChangeModel>;
  /** Date when the subscription trial will end */
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  /** True if they are actively trialing */
  trialing: Scalars['Boolean'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  Trialing = 'TRIALING'
}

export enum Subtype {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type SummaryArtifact = {
  __typename?: 'SummaryArtifact';
  /** The summary render as a rich HTML document. */
  html: Scalars['String'];
  /** The gather summary status */
  status: Scalars['String'];
};

export type Survey = {
  __typename?: 'Survey';
  answers: Scalars['JSON'];
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  questions: Scalars['JSON'];
  type: Scalars['String'];
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  /** The id of the survey that contains the answer */
  id: Scalars['ID'];
  /** The key of the survey answer */
  key: Scalars['String'];
  /** The value of the survey answer */
  value?: Maybe<Scalars['String']>;
};

export enum SurveyQuestionKey {
  HrAuditBenefitsInterest_1 = 'HR_AUDIT_BENEFITS_INTEREST_1',
  HrAuditBenefitsInterest_2 = 'HR_AUDIT_BENEFITS_INTEREST_2',
  HrAuditPayrollInterest = 'HR_AUDIT_PAYROLL_INTEREST',
  HrAuditPayrollProvider = 'HR_AUDIT_PAYROLL_PROVIDER',
  HrAuditSelfServiceFullAudit = 'HR_AUDIT_SELF_SERVICE_FULL_AUDIT',
  HrPracticePayrollPrePurchased = 'HR_PRACTICE_PAYROLL_PRE_PURCHASED',
  HrPracticeTrainingPrePurchased = 'HR_PRACTICE_TRAINING_PRE_PURCHASED'
}

export type SyncAdded = {
  __typename?: 'SyncAdded';
  courses: Scalars['Int'];
  topics: Scalars['Int'];
};

export type SyncAttempt = {
  __typename?: 'SyncAttempt';
  /** null for sync attempts with status of pending */
  attemptedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
};

export type SyncAttemptInput = {
  id: Scalars['ID'];
};

export type SyncCompanyInput = {
  /** Bambee company id */
  id: Scalars['ID'];
};

export type SyncContractorInput = {
  /** Check ID ( optionally provide if setup directly in Check and need to setup in Bambee after the fact ) */
  checkId?: Maybe<Scalars['ID']>;
  /** Bambee company ID */
  companyId: Scalars['ID'];
  /** Bambee contractor ID */
  contractorId: Scalars['ID'];
  /** If the workplace values should be synced to Check as well */
  syncWorkplaces?: Maybe<Scalars['Boolean']>;
  /** Bambee workplace ID */
  workplaceId?: Maybe<Scalars['ID']>;
};

export type SyncEmployeeInput = {
  /** Check ID ( optionally provide if setup directly in Check and need to setup in Bambee after the fact ) */
  checkId?: Maybe<Scalars['ID']>;
  /** Bambee company ID */
  companyId: Scalars['ID'];
  /** Bambee employee ID */
  employeeId: Scalars['ID'];
  /** If the workplace values should be synced to Check as well */
  syncWorkplaces?: Maybe<Scalars['Boolean']>;
  /** Bambee workplace ID */
  workplaceId?: Maybe<Scalars['ID']>;
};

export type SyncRequirementInput = {
  companyId: Scalars['String'];
};

export type SyncResponse = {
  __typename?: 'SyncResponse';
  added: SyncAdded;
};

export type SyncTimesheetsInput = {
  /** Bambee company id */
  companyId: Scalars['ID'];
  /** Bambee payroll ID */
  id: Scalars['Int'];
  /** Import all timesheets as part of the sync ( enables backwards compatibility with alpha )  */
  import?: Scalars['Boolean'];
};

export type SyncUserEnrollmentInput = {
  userId: Scalars['String'];
};

export type SyncUserEnrollmentsResponse = {
  __typename?: 'SyncUserEnrollmentsResponse';
  errors: Array<UserEnrollmentSyncError>;
  skipped: Array<UserEnrollmentSync>;
  successes: Array<UserEnrollmentSync>;
};

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  businessManagers: Array<BusinessManager>;
  hrManagers: Array<AutoAssignHrManager>;
};

/** The enum name of the task completion status. */
export enum TaskCompletionStatus {
  Automatic = 'Automatic',
  Cancelled = 'Cancelled',
  Manual = 'Manual',
  Skipped = 'Skipped'
}

/** The enum name of the task. */
export enum TaskName {
  AddBankAndTaxInfo = 'AddBankAndTaxInfo',
  AddBenefits = 'AddBenefits',
  AddCompanyEin = 'AddCompanyEin',
  AddPostTaxDeductions = 'AddPostTaxDeductions',
  AddStaff = 'AddStaff',
  CheckForComplexPayrollScenarios = 'CheckForComplexPayrollScenarios',
  ConsiderGuidedPayroll = 'ConsiderGuidedPayroll',
  CreateJobDescriptions = 'CreateJobDescriptions',
  DownloadInterviewGuide = 'DownloadInterviewGuide',
  DownloadIntroductionMaterials = 'DownloadIntroductionMaterials',
  DownloadJobApplication = 'DownloadJobApplication',
  EnsureEmployeesReadyForPayroll = 'EnsureEmployeesReadyForPayroll',
  FinishAccountSetup = 'FinishAccountSetup',
  FinishBambeePlusSetup = 'FinishBambeePlusSetup',
  InviteAndEnrollEmployees = 'InviteAndEnrollEmployees',
  InviteStaffToSignPolicies = 'InviteStaffToSignPolicies',
  LearnEssentialBusinessPrep = 'LearnEssentialBusinessPrep',
  LearnHrAudit = 'LearnHrAudit',
  LearnImproveStaffCommunication = 'LearnImproveStaffCommunication',
  LearnIntroduceStaffToBambee = 'LearnIntroduceStaffToBambee',
  LearnMakeHiringEasy = 'LearnMakeHiringEasy',
  LearnOnboardingKitBasics = 'LearnOnboardingKitBasics',
  MigratePayrollData = 'MigratePayrollData',
  PayrollBasicSetup = 'PayrollBasicSetup',
  RunFirstPayroll = 'RunFirstPayroll',
  ScheduleHrmCall = 'ScheduleHrmCall',
  SchedulePayrollOverview = 'SchedulePayrollOverview',
  ScheduleTrainingDiscussion = 'ScheduleTrainingDiscussion',
  SetYourPayrollFrequency = 'SetYourPayrollFrequency',
  SetupCompanyPolicies = 'SetupCompanyPolicies',
  SetupEmployeeVoices = 'SetupEmployeeVoices',
  SetupReportCards = 'SetupReportCards',
  TakeHrAudit = 'TakeHrAudit',
  TrainingHiringLegallyForManagers = 'TrainingHiringLegallyForManagers',
  TrainingRecruitingAndInterviewingForSupervisors = 'TrainingRecruitingAndInterviewingForSupervisors',
  UploadDocuments = 'UploadDocuments'
}

export type Tax = {
  __typename?: 'Tax';
  amount: Scalars['Float'];
  checkId: Scalars['ID'];
  description: Scalars['String'];
  id: Scalars['ID'];
  payer: Payer;
  remittable?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use id or checkId */
  tax: Scalars['ID'];
};

export type TaxDocument = Document & {
  __typename?: 'TaxDocument';
  companyId?: Maybe<Scalars['ID']>;
  contractorId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['ID']>;
  /** Date that this document was filed */
  filedOn: Scalars['String'];
  id: Scalars['ID'];
  jurisdiction?: Maybe<Scalars['String']>;
  /** Document’s type */
  label: Scalars['String'];
  /** Quarter that this document was filed; null if this document is filed annually */
  quarter?: Maybe<Quarter>;
  /** Year that this document was filed */
  year: Scalars['Float'];
};

export enum TaxDocumentClass {
  Company = 'COMPANY',
  Contractor = 'CONTRACTOR',
  Employee = 'EMPLOYEE'
}

export enum TaxExemptStatus {
  NonProfitExempt = 'NON_PROFIT_EXEMPT',
  ReligiousExempt = 'RELIGIOUS_EXEMPT'
}

export type Termination = {
  __typename?: 'Termination';
  complete: Scalars['Boolean'];
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  employee: User;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  hrRequestVersion: Scalars['Boolean'];
  isLegacy: Scalars['Boolean'];
  manager: User;
  selfService: Scalars['Boolean'];
  signedFiles: Array<FileStackModel>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: TerminationStatus;
  step: TerminationStep;
  terminationDate?: Maybe<Scalars['DateTime']>;
  terminationId: Scalars['String'];
  terminationState?: Maybe<Scalars['String']>;
  user: User;
  userId: Scalars['String'];
};

export type TerminationAttachInput = {
  files: Array<FileStackInput>;
  terminationId: Scalars['String'];
};

export type TerminationCancelInput = {
  terminationId: Scalars['String'];
};

export type TerminationConfirmationInput = {
  terminationDate: Scalars['String'];
  terminationId: Scalars['String'];
};

export type TerminationCreateInput = {
  answers?: Maybe<Scalars['JSON']>;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  selfService?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  terminationDate?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TerminationDownload = {
  __typename?: 'TerminationDownload';
  file: Scalars['String'];
  terminationId: Scalars['String'];
};

export type TerminationEditDetailsInput = {
  selfService?: Maybe<Scalars['Boolean']>;
  terminationDate: Scalars['String'];
  terminationId: Scalars['String'];
};

export type TerminationExist = {
  __typename?: 'TerminationExist';
  exists: Scalars['Boolean'];
  terminationId?: Maybe<Scalars['String']>;
};

export enum TerminationStatus {
  Abandoned = 'ABANDONED',
  Active = 'ACTIVE',
  Broken = 'BROKEN',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  HrComplete = 'HR_COMPLETE',
  SelfService = 'SELF_SERVICE'
}

export enum TerminationStep {
  None = 'NONE',
  Print = 'PRINT',
  Requested = 'REQUESTED',
  UploadSigned = 'UPLOAD_SIGNED'
}

export type TextContentBlock = {
  __typename?: 'TextContentBlock';
  /** Text content */
  annotations: Array<AnnotationDto>;
  /** Text content */
  value: Scalars['String'];
};

export type TextMessage = ChatMessageInterface & {
  __typename?: 'TextMessage';
  channelId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isThreadMessage: Scalars['Boolean'];
  isThreadParent: Scalars['Boolean'];
  message: Scalars['String'];
  rawType: SendbirdMessageType;
  /** Recipieint, if a one-on-one message */
  recipient?: Maybe<CoreUser>;
  sender: CoreUser;
  threadParentId?: Maybe<Scalars['ID']>;
  type: ChatMessageTypeEnum;
};

export type ThreadHistoryInput = {
  afterId?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type Ticket = {
  __typename?: 'Ticket';
  bundleId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  courseId?: Maybe<Scalars['String']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  topicId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type TicketsInput = {
  companyId: Scalars['String'];
  numTickets: Scalars['Int'];
};

export type TimeAttendanceSubscriptionResponse = {
  __typename?: 'TimeAttendanceSubscriptionResponse';
  companyProductId: Scalars['String'];
  id: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  /** The duration in minutes for the slot */
  duration: Scalars['Int'];
  /** The end date for the slot */
  endAt: Scalars['DateTime'];
  /** The start date for the slot */
  startAt: Scalars['DateTime'];
};

export enum TimelineEventType {
  Created = 'CREATED',
  MeetingScheduled = 'MEETING_SCHEDULED',
  Owner = 'OWNER',
  Stage = 'STAGE',
  Status = 'STATUS'
}

export type TimelineItem = {
  __typename?: 'TimelineItem';
  eventTime: Scalars['DateTime'];
  eventType: TimelineEventType;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

export type Timesheet = {
  __typename?: 'Timesheet';
  /** Deputy employee id */
  deputyEmployeeId: Scalars['ID'];
  /**
   * Deputy employee id
   * @deprecated Use deputyEmployeeId instead
   */
  deputyId: Scalars['Int'];
  earnings: Array<Earning>;
  employee: Employee;
  /** The total time for the timesheet in hours */
  hours: Scalars['Float'];
  /** Deputy timesheet id */
  id: Scalars['ID'];
  payReturns?: Maybe<Array<TimesheetPayReturn>>;
  /** Role worker performed as */
  role?: Maybe<Scalars['String']>;
};

export type TimesheetAggregate = {
  __typename?: 'TimesheetAggregate';
  /** The holiday hours in timesheets */
  holidayHours: Scalars['Float'];
  /** The overtime hours in timesheets */
  overtimeHours: Scalars['Float'];
  /** The PTO hours in timesheets */
  ptoHours: Scalars['Float'];
  /** The regular hours in timesheets */
  regularHours: Scalars['Float'];
  /** Role worker performed as */
  role?: Maybe<TimesheetRole>;
  /** The sick hours in timesheets */
  sickHours: Scalars['Float'];
  /** The total hours in timesheets */
  totalHours: Scalars['Float'];
};

export type TimesheetFilter = {
  /** Find approved if true, find unapproved if false, do not filter on approval status if not provided. */
  approved?: Maybe<Scalars['Boolean']>;
  /** Find timesheets for a particular contractor */
  contractorId?: Maybe<Scalars['String']>;
  /** Find timesheets for a particular employee */
  employeeId?: Maybe<Scalars['String']>;
  /** Find timesheets less than or equal to end date */
  end?: Maybe<Scalars['DateTime']>;
  /** Find timesheets for a particular payroll (this will overwrite start/end fields in filter (Bambee Payroll Id) */
  payrollId?: Maybe<Scalars['Int']>;
  /** Find timesheets greater than or equal to start date */
  start?: Maybe<Scalars['DateTime']>;
};

export type TimesheetPayReturn = {
  __typename?: 'TimesheetPayReturn';
  /** The cost of the pay return */
  cost: Scalars['Float'];
  /** The multiplier value of the pay return */
  earningType: EarningType;
  /** Deputy pay return id */
  id: Scalars['ID'];
  /** The multiplier of the pay return */
  multiplier: Scalars['Float'];
  /** The value of the pay return */
  value: Scalars['Float'];
};

export type TimesheetRole = {
  __typename?: 'TimesheetRole';
  /** Pay rate of the role worker performed as */
  payRate: Scalars['String'];
  /** Title of the role worker performed as */
  title: Scalars['String'];
};

export type TopicEnrolledTickets = {
  __typename?: 'TopicEnrolledTickets';
  certificateDownloadUrl?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  enrolledAt: Scalars['DateTime'];
  id: Scalars['ID'];
  language: Scalars['String'];
  role: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userMngId: Scalars['String'];
};

export type Total = {
  __typename?: 'Total';
  /** Employees who have not provided their EMPLOYEE_DETAILS */
  missingEmployeeDetails: Scalars['Int'];
  /** Employees who have completed the payroll setup */
  onboardedEmployees: Scalars['Int'];
  /** Employees with a checkId */
  payrollEmployees: Scalars['Int'];
  /** Employees who will be included in time and attendance PEPM */
  timeAttendanceEmployees: Scalars['Int'];
};

export type Totals = {
  __typename?: 'Totals';
  /** The total cash amount that Check will withdraw from the company's account for the payroll after it is approved. */
  cashRequirement: Scalars['Float'];
  /** The total amount of company benefit contributions. */
  companyBenefits: Scalars['Float'];
  /** summary of company earnings */
  companyEarningsSummary?: Maybe<Array<Array<EarningSummaryItem>>>;
  /** The total amount of company tax liability. */
  companyTaxes: Scalars['Float'];
  /** summary of contractor earnings */
  contractorEarningsSummary?: Maybe<Array<Array<EarningSummaryItem>>>;
  /** The total amount of all contractor gross compensation. This is the sum of amount for all contractor payments. */
  contractorGross: Scalars['Float'];
  /** The total amount that should be paid from the company to its contractors, including reimbursements. */
  contractorNet: Scalars['Float'];
  /** The total amount of all contractor reimbursements. */
  contractorReimbursements: Scalars['Float'];
  /** The total amount of all employee benefit contributions. */
  employeeBenefits: Scalars['Float'];
  /** summary of employee earnings */
  employeeEarningsSummary?: Maybe<Array<Array<EarningSummaryItem>>>;
  /** The total amount of all employee gross pay, including taxable and non-taxable components. This is the sum of gross_pay for all payroll items. */
  employeeGross: Scalars['Float'];
  /** The total amount that should be paid from the company to its employees, excluding employee taxes, employee benefit contributions, and imputed income. This is the sum of net_pay for all payroll items. */
  employeeNet: Scalars['Float'];
  /** The total amount of all employee reimbursements. */
  employeeReimbursements: Scalars['Float'];
  /** The total amount of all employee tax liability. */
  employeeTaxes: Scalars['Float'];
  id: Scalars['ID'];
  /** The total amount that the company owes to employees, contractors, tax agencies, and benefits providers. */
  liability: Scalars['Float'];
  /** The total amount of all employee post-tax deductions. */
  postTaxDeductions: Scalars['Float'];
};

export enum TrainingBillingPeriod {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type TrainingPricesResponse = {
  __typename?: 'TrainingPricesResponse';
  bundle: Scalars['Int'];
  topic: Scalars['Int'];
};

export type TrainingRecommendationInput = {
  /** The id of the training bundle. */
  bundleId?: Maybe<Scalars['String']>;
  /** The company id of the employee recommending training. */
  companyId: Scalars['String'];
  /** The note of the training recommendation. May be used to provide additional context or instructions */
  note?: Maybe<Scalars['String']>;
  /** The id of the training topic. */
  topicId?: Maybe<Scalars['String']>;
  /** The user id of the employee recommending training. */
  userId: Scalars['String'];
};

export type TrainingRequestInput = {
  /** The id of the training bundle. */
  bundleId?: Maybe<Scalars['String']>;
  /** The company id of the employee requesting training. */
  companyId: Scalars['String'];
  /** The description of the training request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the training topic. */
  topicId?: Maybe<Scalars['String']>;
  /** The user id of the employee requesting training. */
  userId: Scalars['String'];
};

export type TriggerPayrollRunSnsTopicPublishInput = {
  approvedAtEnd: Scalars['DateTime'];
  approvedAtStart: Scalars['DateTime'];
  companyId?: Maybe<Scalars['String']>;
};

export enum TypeSteps {
  TypeSubmitted = 'TYPE_SUBMITTED'
}

export type UnenrollUsersFromBundleInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type UnenrollUsersInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type UnenrolledUsers = {
  __typename?: 'UnenrolledUsers';
  errors: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
  successfullyUnenrolled: Array<Maybe<Scalars['String']>>;
};

export type UpcomingCorePlanChangeInvoice = {
  __typename?: 'UpcomingCorePlanChangeInvoice';
  /** Total amount for the remaining time in the new plan */
  remainingAmount: Scalars['Float'];
  /** Tax amount charged for the invoice */
  tax: Scalars['Float'];
  /** Total amount charged for the invoice */
  total: Scalars['Float'];
  /** Total amount due now */
  totalDue: Scalars['Float'];
  /** Total amount for the unused time in the current plan */
  unusedAmount: Scalars['Float'];
};

export type UpcomingNonCoreSubscriptionBillingChange = {
  __typename?: 'UpcomingNonCoreSubscriptionBillingChange';
  /** Maximum tier number */
  maxSize?: Maybe<Scalars['Float']>;
  /** Minimum tier number */
  minSize: Scalars['Float'];
  /** The product key associated to the non-core plan object */
  productKey: ProductKey;
  /** The service key associated to the non-core plan object */
  serviceKey: ServiceKey;
  /** Monthly price of the plan */
  upcomingMonthlyPrice?: Maybe<Scalars['Float']>;
  /** Yearly price of the plan */
  upcomingYearlyPrice?: Maybe<Scalars['Float']>;
};

export type UpdateCompanyInput = {
  checkIndustry?: Maybe<IndustryType>;
  /** Timestamp for when company accepted deputy terms of service */
  deputyTosAcceptedAt?: Maybe<Scalars['DateTime']>;
  /** A list of Bambee employee IDs who are not on Payroll+ with this company. */
  excludedStaffIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Bambee company id */
  id: Scalars['ID'];
  /** Needs pay schedule assistance */
  needsPayScheduleAssistance?: Maybe<Scalars['Boolean']>;
  notifyCustomer?: Maybe<Scalars['Boolean']>;
  onboardingGarnishmentsOrDeductions?: Maybe<Array<OnboardingGarnishmentOrDeduction>>;
  onboardingGarnishmentsOrDeductionsOther?: Maybe<Scalars['String']>;
  onboardingHasComplexScenario?: Maybe<Scalars['Boolean']>;
  onboardingHasComplexTimeAttendanceScenario?: Maybe<Scalars['Boolean']>;
  onboardingHasGarnishmentsOrDeductions?: Maybe<Scalars['Boolean']>;
  onboardingOffersEmployeeBenefits?: Maybe<Scalars['Boolean']>;
  /** Past payroll usage ( prior to Bambee ) */
  pastPayrollUsage?: Maybe<PastPayrollUsage>;
  processedPayrollsThisYear?: Maybe<Scalars['Boolean']>;
  signatoryEmail?: Maybe<Scalars['String']>;
  signatoryFirstName?: Maybe<Scalars['String']>;
  signatoryLastName?: Maybe<Scalars['String']>;
  signatoryTitle?: Maybe<Scalars['String']>;
  /** Version of payroll TOS last signed */
  tosVersion?: Maybe<Scalars['String']>;
};

export type UpdateCompanyNotesInput = {
  /** Bambee company id */
  id: Scalars['ID'];
  /** notes on the company payroll entity */
  notes: Scalars['String'];
};

export type UpdateCompanyStatusInput = {
  /** Bambee company id */
  id: Scalars['ID'];
  /** state the payroll company should be moved to */
  status: CompanyStatus;
};

export type UpdateContractorPaymentInput = {
  basePayRate?: Maybe<Scalars['Float']>;
  checkNumber?: Maybe<Scalars['String']>;
  entries: Array<PaymentEntryInput>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  noteVisible?: Maybe<Scalars['Boolean']>;
  /** The way the employee will be paid */
  paymentMethod?: Maybe<PaymentMethod>;
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
};

export type UpdateContractorWorkplaceInput = {
  /** Bambee contractor ID */
  contractorId: Scalars['ID'];
  /** Bambee workplace IDs */
  workplaceId: Scalars['ID'];
};

export type UpdateCoreCompanyInput = {
  address?: Maybe<CoreAddressInput>;
  aiOptIn?: Maybe<Scalars['Boolean']>;
  dba?: Maybe<Scalars['String']>;
  fein?: Maybe<Scalars['String']>;
  handsFreeActionItemActivatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  legalAddress?: Maybe<CoreLegalAddressInput>;
  mailingAddress?: Maybe<CoreMailingAddressInput>;
  name?: Maybe<Scalars['String']>;
  numOfContractors?: Maybe<Scalars['Int']>;
  numOfFullTimeHourlyEmployees?: Maybe<Scalars['Int']>;
  numOfFullTimeSalaryEmployees?: Maybe<Scalars['Int']>;
  numOfPartTimeEmployees?: Maybe<Scalars['Int']>;
  payDayOfMonth?: Maybe<Scalars['Int']>;
  payDayOfWeek?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type UpdateEmployeeWorkplaceInput = {
  /** Bambee employee ID */
  employeeId: Scalars['ID'];
  /** Bambee workplace IDs */
  workplaceId: Scalars['ID'];
};

export type UpdateJobDescriptionInput = {
  body?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type UpdateMultipleRolesForCompanyInput = {
  /** Bambee Company id */
  companyId: Scalars['ID'];
  /** Company Roles */
  roles: Array<UpdateRoleForCompanyInput>;
};

export type UpdateNoticeInput = {
  actions?: Maybe<Array<NoticeActionInput>>;
  badge?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  visualization?: Maybe<VisualizationDataInput>;
};

export type UpdatePayScheduleInput = {
  companyId?: Maybe<Scalars['ID']>;
  /** The first date on which employees will be paid for the payroll. */
  firstPayday?: Maybe<Scalars['String']>;
  /** The end of the date range that the payroll covers. YYYY-MM-DD */
  firstPeriodEnd?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  payFrequency?: Maybe<PayScheduleFrequency>;
  /** The payday date of the the second payroll the company will run on this pay schedule. This field should only be used with the semimonthly frequency to specify custom paydays besides the 15th and last day of the month. second_payday must be between one day and one month after first_payday. */
  secondPayday?: Maybe<Scalars['String']>;
};

export type UpdatePaymentSourceAddress = {
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type UpdatePaymentSourceBillingAddress = {
  address: UpdatePaymentSourceAddress;
  companyId: Scalars['String'];
  paymentSourceId: Scalars['String'];
};

export type UpdatePayrollApprovalDeadlineInput = {
  /** Date by which the payroll must be approved. */
  approvalDeadline: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type UpdatePayrollChecksInput = {
  /** An array of payrollItem ID and check numbers to update */
  checkNumbers: Array<Maybe<PayrollItemCheckNumbers>>;
  needsChecksEntered: Scalars['Boolean'];
  /** An array of contractor payment ID and check numbers to update */
  paymentCheckNumbers?: Maybe<Array<Maybe<ContractorPaymentCheckNumbers>>>;
  payrollId: Scalars['ID'];
};

export type UpdatePayrollInput = {
  id: Scalars['ID'];
  /** Additional configuration options controlling off-cycle payroll behavior. */
  offCycleOptions?: Maybe<OffcycleOptionsInput>;
  /** The date on which employees will be paid for the payroll. */
  payday?: Maybe<Scalars['DateTime']>;
  /** The end of the date range that the payroll covers. */
  periodEnd?: Maybe<Scalars['DateTime']>;
  /** The start of the date range that the payroll covers. */
  periodStart?: Maybe<Scalars['DateTime']>;
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
};

export type UpdatePayrollItemInput = {
  basePayRate?: Maybe<Scalars['Float']>;
  checkNumber?: Maybe<Scalars['String']>;
  earnings: Array<EarningInput>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  noteVisible?: Maybe<Scalars['Boolean']>;
  /** The way the employee will be paid */
  paymentMethod?: Maybe<PaymentMethod>;
  /** The employee's remaining PTO hour balance, for display on the paystub */
  ptoBalanceHours?: Maybe<Scalars['Float']>;
  reimbursements?: Maybe<Array<Maybe<ReimbursementInput>>>;
  /** The employee's remaining sick hour balance, for display on the paystub */
  sickBalanceHours?: Maybe<Scalars['Float']>;
  /** Optimistic locking to prevent stale data clobbering fresher data */
  version: Scalars['Int'];
};

export type UpdatePlanLockInput = {
  active: Scalars['Boolean'];
  companyId: Scalars['String'];
  couponId: Scalars['String'];
  plan: Scalars['String'];
  setupFee: Scalars['Float'];
  trialDuration: Scalars['Float'];
};

export type UpdateProductInterestWasAppNotificationDismissedInput = {
  /** The ID of the product interest */
  id: Scalars['ID'];
};

export type UpdateReportCardInput = {
  /** employee id */
  employeeId: Scalars['String'];
  /** External Employee Feedback, they see this */
  feedback?: Maybe<Scalars['String']>;
  /** employee grade value */
  grade?: Maybe<ReportCardGradeValues>;
  /** Internal Note */
  note?: Maybe<Scalars['String']>;
  /** Report Card Id */
  reportCardId: Scalars['String'];
  /** Do we want to set the status of Report Card? This is independent of each employee graded status */
  status?: Maybe<ReportCardStatusValues>;
};

export type UpdateRoleForCompanyInput = {
  /** Bambee Company role id */
  id: Scalars['ID'];
  /** Bambee Core Company Role title */
  title: Scalars['String'];
};

export type UpdateWorkerRoleInput = {
  isPrimary: Scalars['Boolean'];
  payType: WorkerRolePaytype;
  workerRoleId: Scalars['ID'];
};

export type UpdateWorkplaceInput = {
  active?: Maybe<Scalars['Boolean']>;
  /** Workplace address */
  address?: Maybe<AddressInput>;
  default?: Maybe<Scalars['Boolean']>;
  /** Bambee Workplace id */
  id: Scalars['ID'];
  /** Workplace name */
  name?: Maybe<Scalars['String']>;
};

export type UpgradeCorePlanInput = {
  companyId: Scalars['String'];
  newPlanId: Scalars['String'];
  /** The type of the package */
  newPricingPackageType: PricingPackageType;
};

/** Upgrade Deputy installation from trial to paid */
export type UpgradeDeputyInstallInput = {
  /** Bambee company id */
  companyId: Scalars['String'];
};

export type UploadFileInput = {
  companyId: Scalars['String'];
  /** base64 encoded file data */
  file?: Maybe<Scalars['String']>;
  /** Array of files to upload */
  files?: Maybe<Array<FileInput>>;
  /** file name */
  name?: Maybe<Scalars['String']>;
  requirementId: Scalars['Int'];
  type?: Maybe<DocumentOptionType>;
};

export type UploadFileToIntercomInput = {
  /** The base64 encoded file */
  base64File: Scalars['String'];
  /** The name of the file */
  fileName: Scalars['String'];
  /** The type of the file (e.g application/pdf) */
  fileType: Scalars['String'];
};

export type UploadFilesToConversationInput = {
  /** The files to upload */
  filesToUpload: Array<UploadFileToIntercomInput>;
  /** The Intercom ID of the conversation */
  intercomConversationId: Scalars['String'];
};

export type UploadedFile = {
  __typename?: 'UploadedFile';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: DocumentType;
};

export type UploadedFileCore = {
  /** Whether the file content should be added to the thread as a hidden user message, default behavior is not to add the contents to the thread and just attach ids */
  addContentToThread?: Maybe<Scalars['Boolean']>;
  /** The base64 encoded file */
  base64: Scalars['String'];
  /** The MIME type of the file */
  fileType: Scalars['String'];
  /** The name of the file */
  name: Scalars['String'];
};

export type UpsertDeputyAreasInput = {
  companyId: Scalars['ID'];
};

export type UpsertDeputyConnectionInput = {
  accessToken?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  installId?: Maybe<Scalars['String']>;
};

export type UpsertDeputyLocationsInput = {
  companyId: Scalars['ID'];
};

export type UpsertDeputyUsersInput = {
  companyId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  error?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isContractor?: Maybe<Scalars['Boolean']>;
  language: Language;
  name?: Maybe<Scalars['String']>;
  profile?: Maybe<UserProfile>;
  role: UserRole;
  state?: Maybe<State>;
  training: UserTraining;
  userId: Scalars['String'];
  /** @deprecated This field is deprecated; Use userId instead */
  userMngId?: Maybe<Scalars['String']>;
};

export type UserCounts = {
  __typename?: 'UserCounts';
  completed?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  inProgress?: Maybe<Scalars['Float']>;
  notStarted?: Maybe<Scalars['Float']>;
};

export type UserCourse = {
  __typename?: 'UserCourse';
  bundleId: Scalars['String'];
  bundleName: Scalars['String'];
  certificateDownloadUrl?: Maybe<Scalars['String']>;
  certificateId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  courseId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  doceboCourseId: Scalars['String'];
  enrolledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  removedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated use key instead */
  searchTag?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  ticketId: Scalars['String'];
  topicId: Scalars['String'];
  topicName: Scalars['String'];
  topics: Array<Maybe<CourseTopic>>;
  userRole: Scalars['String'];
};

export type UserCourseTopic = {
  __typename?: 'UserCourseTopic';
  courseId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ticketId: Scalars['ID'];
};

export type UserCoursesInput = {
  bundleId?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserEnrollmentSync = {
  __typename?: 'UserEnrollmentSync';
  completedAt?: Maybe<Scalars['DateTime']>;
  ticketId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserEnrollmentSyncError = {
  __typename?: 'UserEnrollmentSyncError';
  cause: Scalars['String'];
  message: Scalars['String'];
};

export type UserFinchCodeInput = {
  code: Scalars['String'];
  /** OAuth State parameter */
  state?: Maybe<Scalars['String']>;
};

export type UserInput = {
  language: Language;
  role: UserRole;
  state?: Maybe<State>;
  userId: Scalars['String'];
  userMngId?: Maybe<Scalars['String']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  classification: EmployeeClassification;
  conference?: Maybe<Scalars['String']>;
  contractorBusinessName?: Maybe<Scalars['String']>;
  contractorType: EmployeeServiceContractorType;
  dob: Scalars['DateTime'];
  emergencyContact: EmergencyContact;
  employeeType: EmployeeServiceEmployeeType;
  firstName?: Maybe<Scalars['String']>;
  hoursPerWeek?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSocial?: Maybe<Scalars['String']>;
  payDay?: Maybe<Scalars['String']>;
  payFrequency?: Maybe<Scalars['String']>;
  payRate?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateWorkIn?: Maybe<Scalars['String']>;
  supervisor?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type: PayType;
  yearsExperience?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type UserQueryInput = {
  id: Scalars['ID'];
};

export enum UserRole {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type UserTraining = {
  __typename?: 'UserTraining';
  courses: Array<Maybe<UserCourse>>;
  history: Array<Maybe<UserCourse>>;
  id: Scalars['ID'];
  userId: Scalars['String'];
};


export type UserTrainingCoursesArgs = {
  filter: UserTrainingFilterInput;
};


export type UserTrainingHistoryArgs = {
  filter: UserTrainingFilterInput;
};

export type UserTrainingFilterInput = {
  bundleId?: Maybe<Scalars['String']>;
  topicId?: Maybe<Scalars['String']>;
};

export type VerifyFeinInCheckInput = {
  companyId: Scalars['String'];
  fein?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
};

export type VisualizationData = {
  __typename?: 'VisualizationData';
  data: Scalars['JSON'];
  type: VisualizationType;
};

export type VisualizationDataInput = {
  /** JSON string representation of the visualization data */
  data: Scalars['String'];
  type: VisualizationType;
};

/** The type of visualization for a notice */
export enum VisualizationType {
  Bar = 'BAR',
  Line = 'LINE',
  Pie = 'PIE',
  Radar = 'RADAR',
  Timeline = 'TIMELINE',
  Trend = 'TREND'
}

export type VoicesFeedback = {
  __typename?: 'VoicesFeedback';
  anonymous: Scalars['Boolean'];
  /** This will be null if anonymous is true. The User MongoId. In the future we may deprecate this for Employee ID */
  companyPersonId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CoreUser>;
  feedback: Scalars['String'];
  id: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type Warning = {
  __typename?: 'Warning';
  /** The action Check took. */
  code: WarningCode;
  /** Check ID that references the relevant deduction. */
  postTaxDeduction: Scalars['String'];
  /** Why the deduction was not applied. */
  reason: WarningReason;
};

export enum WarningCode {
  PartiallyApplied = 'PARTIALLY_APPLIED',
  Skipped = 'SKIPPED',
  SkippedPostTaxDeduction = 'SKIPPED_POST_TAX_DEDUCTION'
}

export type WarningDocument = {
  __typename?: 'WarningDocument';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export enum WarningReason {
  ExceedsMaxPercent = 'EXCEEDS_MAX_PERCENT',
  NegativeNetPay = 'NEGATIVE_NET_PAY'
}

export type Webinar = {
  __typename?: 'Webinar';
  date: Scalars['DateTime'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  registrants: Array<WebinarRegistrant>;
  title: Scalars['String'];
};

export type WebinarRegistrant = {
  __typename?: 'WebinarRegistrant';
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  user: CoreUser;
};

export type WebinarRegistration = {
  __typename?: 'WebinarRegistration';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type WorkerRole = {
  __typename?: 'WorkerRole';
  companyRole?: Maybe<CompanyRole>;
  createdAt: Scalars['DateTime'];
  /** Date of worker role deletion */
  deletedAt?: Maybe<Scalars['DateTime']>;
  employeeJobDescription?: Maybe<EmployeeJobDescription>;
  /** Bambee Worker Role id */
  id: Scalars['ID'];
  /** Determines whether or not worker role is primary */
  isPrimary: Scalars['Boolean'];
  /** Pay rate of the worker role */
  payRate: Scalars['Float'];
  /** Pay type of the worker role */
  payType: WorkerRolePaytype;
  /** Bambee User Id */
  userId: Scalars['ID'];
};

export enum WorkerRolePaytype {
  Contractor = 'Contractor',
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export enum WorkingSchedule {
  DayShifts = 'DayShifts',
  EveningShifts = 'EveningShifts',
  Holidays = 'Holidays',
  MondayFriday = 'MondayFriday',
  OvernightShifts = 'OvernightShifts',
  Overtime = 'Overtime',
  Weekends = 'Weekends'
}

export type Workplace = {
  __typename?: 'Workplace';
  active: Scalars['Boolean'];
  /** Workplace address */
  address: Address;
  default: Scalars['Boolean'];
  deputyId?: Maybe<Scalars['String']>;
  /** Bambee workplace id */
  id: Scalars['ID'];
  /** Workplace name */
  name?: Maybe<Scalars['String']>;
};

export type ZoomConfiguration = {
  __typename?: 'ZoomConfiguration';
  tokenExpiration: Scalars['DateTime'];
};

export type AppliedPlansPartsFragment = { __typename?: 'Plan', id: string, name: string };

export type CouponPartsFragment = { __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> };

export type SubscriptionPartsFragment = { __typename?: 'Subscription', name: string, productCode: ProductKey, amount: number, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, createdAt: any, isDrp: boolean, coupon?: Maybe<{ __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> }> };

export type BillingPlanPartsFragment = { __typename?: 'PlanLock', active: boolean, couponId?: Maybe<string>, plan: string, setupFee: number, trialDuration: number };

export type CompanyDelinquencyPartsFragment = { __typename?: 'CompanyDelinquency', delinquent: boolean, delinquentSince?: Maybe<any>, lockout: boolean, defaultCardVerificationStatus: CardVerificationStatus };

export type PaymentSourcePartsFragment = { __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> };

export type BillingProductPartsFragment = { __typename?: 'Product', id: string, name?: Maybe<string>, key: ProductKey, creditBalance: number, price?: Maybe<number>, subscriptionPrice?: Maybe<number>, activeSubscription?: Maybe<boolean> };

export type ProductResultPartsFragment = { __typename?: 'PurchaseResult', createdAt: any, creditsPurchased: number, productKey: ProductKey, id: string, status: StatementStatus };

export type PaymentSourcesPartsFragment = { __typename?: 'PaymentSources', companyId: string, sources: Array<{ __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> }> };

export type GetCouponByIdQueryVariables = Exact<{
  data: GetCouponInput;
}>;


export type GetCouponByIdQuery = { __typename?: 'Query', coupon: { __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> } };

export type GetLockedPlanQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetLockedPlanQuery = { __typename?: 'Query', getPlanLock: { __typename?: 'PlanLock', active: boolean, couponId?: Maybe<string>, plan: string, setupFee: number, trialDuration: number } };

export type GetBillingCompanySubscriptionsQueryVariables = Exact<{
  data: GetCompanySubscriptionsInput;
}>;


export type GetBillingCompanySubscriptionsQuery = { __typename?: 'Query', companySubscriptions: Array<{ __typename?: 'Subscription', name: string, productCode: ProductKey, amount: number, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, createdAt: any, isDrp: boolean, coupon?: Maybe<{ __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> }> }> };

export type MyProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProductsQuery = { __typename?: 'Query', myProducts: Array<{ __typename?: 'Product', id: string, name?: Maybe<string>, key: ProductKey, creditBalance: number, price?: Maybe<number>, subscriptionPrice?: Maybe<number>, activeSubscription?: Maybe<boolean> }> };

export type ApplyCorePayrollDiscountToCompanySubscriptionMutationVariables = Exact<{
  input: ApplyCorePayrollDiscountInput;
}>;


export type ApplyCorePayrollDiscountToCompanySubscriptionMutation = { __typename?: 'Mutation', applyCorePayrollDiscountToCompanySubscription: { __typename?: 'Subscription', name: string, productCode: ProductKey, amount: number, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, createdAt: any, isDrp: boolean, coupon?: Maybe<{ __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> }> } };

export type CreatePayrollSubscriptionMutationVariables = Exact<{
  data: CreatePayrollSubscriptionInput;
}>;


export type CreatePayrollSubscriptionMutation = { __typename?: 'Mutation', createPayrollSubscription: { __typename?: 'Subscription', name: string, productCode: ProductKey, amount: number, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, createdAt: any, isDrp: boolean, coupon?: Maybe<{ __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> }> } };

export type PurchaseCreditsMutationVariables = Exact<{
  data: PurchaseInput;
}>;


export type PurchaseCreditsMutation = { __typename?: 'Mutation', purchaseCredits: { __typename?: 'PurchaseResult', createdAt: any, creditsPurchased: number, productKey: ProductKey, id: string, status: StatementStatus } };

export type PurchaseSubscriptionMutationVariables = Exact<{
  data: PurchaseSubscriptionInput;
}>;


export type PurchaseSubscriptionMutation = { __typename?: 'Mutation', purchaseSubscription: { __typename?: 'PurchaseResult', createdAt: any, creditsPurchased: number, productKey: ProductKey, id: string, status: StatementStatus } };

export type GetCompanyDelinquencyQueryVariables = Exact<{
  data: GetCompanyDelinquency;
}>;


export type GetCompanyDelinquencyQuery = { __typename?: 'Query', getCompanyDelinquency: { __typename?: 'CompanyDelinquency', delinquent: boolean, delinquentSince?: Maybe<any>, lockout: boolean, defaultCardVerificationStatus: CardVerificationStatus } };

export type GetCompanySourcesQueryVariables = Exact<{
  data: GetCompanyPaymentSources;
}>;


export type GetCompanySourcesQuery = { __typename?: 'Query', getCompanySources: { __typename?: 'PaymentSources', companyId: string, sources: Array<{ __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> }> } };

export type UpdatePaymentSourceBillingAddressMutationVariables = Exact<{
  input: UpdatePaymentSourceBillingAddress;
}>;


export type UpdatePaymentSourceBillingAddressMutation = { __typename?: 'Mutation', updatePaymentSourceBillingAddress: { __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> } };

export type ScratchListServiceAddonsQueryVariables = Exact<{
  input: ScratchServiceAddonListInput;
}>;


export type ScratchListServiceAddonsQuery = { __typename?: 'Query', scratchListServiceAddons: Array<{ __typename?: 'ScratchServiceAddonsModel', id: string, label: string, priceLabel: string, enabled: boolean }> };

export type ScratchToggleServiceAddonMutationVariables = Exact<{
  input: ScratchToggleServiceAddonInput;
}>;


export type ScratchToggleServiceAddonMutation = { __typename?: 'Mutation', scratchToggleServiceAddon: { __typename?: 'ScratchServiceAddonsModel', id: string, label: string, priceLabel: string, enabled: boolean } };

export type PracticePartsFragment = { __typename?: 'Practice', id: string, status: PracticeStatuses, setupProgress: PracticeSetupProgress, state: PracticeState, title: string, shortName: string, shortDescription: string, description: string, introDescription: string, iconUrl: string, illustrationUrl: string, outroIllustrationUrl: string, successOutroTitle: string };

export type SurveyPartsFragment = { __typename?: 'Survey', id: number, type: string, answers: any, completedAt?: Maybe<any>, questions: any };

export type ListPracticeQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type ListPracticeQuery = { __typename?: 'Query', listPractice: Array<{ __typename?: 'Practice', id: string, status: PracticeStatuses, setupProgress: PracticeSetupProgress, state: PracticeState, title: string, shortName: string, shortDescription: string, description: string, introDescription: string, iconUrl: string, illustrationUrl: string, outroIllustrationUrl: string, successOutroTitle: string }> };

export type GetPracticeQueryVariables = Exact<{
  input: GetPracticeInput;
}>;


export type GetPracticeQuery = { __typename?: 'Query', getPractice: { __typename?: 'Practice', id: string, status: PracticeStatuses, setupProgress: PracticeSetupProgress, state: PracticeState, title: string, shortName: string, shortDescription: string, description: string, introDescription: string, iconUrl: string, illustrationUrl: string, outroIllustrationUrl: string, successOutroTitle: string, survey: { __typename?: 'Survey', id: number, type: string, answers: any, completedAt?: Maybe<any>, questions: any } } };

export type GetHrScoreQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetHrScoreQuery = { __typename?: 'Query', getHrScore: HrScore };

export type CompanySurveyQueryVariables = Exact<{
  data: GetCompanySurveyInput;
}>;


export type CompanySurveyQuery = { __typename?: 'Query', companySurvey: { __typename?: 'Survey', id: number, type: string, answers: any, completedAt?: Maybe<any>, questions: any } };

export type GetCompanySettingsQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetCompanySettingsQuery = { __typename?: 'Query', getCompanySettings: Array<{ __typename?: 'CompanySetting', id: number, key: CompanySettingKey, type: SettingType, value: string }> };

export type SaveCompanyAnswerMutationVariables = Exact<{
  data: SaveCompanyAnswerInput;
}>;


export type SaveCompanyAnswerMutation = { __typename?: 'Mutation', saveCompanyAnswer: { __typename?: 'Survey', id: number, type: string, answers: any, completedAt?: Maybe<any>, questions: any } };

export type CompleteCompanySurveyMutationVariables = Exact<{
  data: CompleteCompanySurveyInput;
}>;


export type CompleteCompanySurveyMutation = { __typename?: 'Mutation', completeCompanySurvey: { __typename?: 'Survey', id: number, type: string, answers: any, completedAt?: Maybe<any>, questions: any } };

export type CompleteCompanyPracticeMutationVariables = Exact<{
  data: CompletePracticeInput;
}>;


export type CompleteCompanyPracticeMutation = { __typename?: 'Mutation', completeCompanyPractice: { __typename?: 'Practice', id: string, status: PracticeStatuses, setupProgress: PracticeSetupProgress, state: PracticeState, title: string, shortName: string, shortDescription: string, description: string, introDescription: string, iconUrl: string, illustrationUrl: string, outroIllustrationUrl: string, successOutroTitle: string, survey: { __typename?: 'Survey', id: number, type: string, answers: any, completedAt?: Maybe<any>, questions: any } } };

export type BulkMessageStaffMutationVariables = Exact<{
  data: BulkMessageStaffInput;
}>;


export type BulkMessageStaffMutation = { __typename?: 'Mutation', bulkMessageStaff: { __typename?: 'BulkMessageStaffResult', successfulStaffIds: Array<Maybe<string>>, errors: Array<Maybe<{ __typename?: 'BulkMessageStaffError', errorMsg: string, staffId: string }>> } };

export type VoicesFeedbackPartsFragment = { __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, createdAt: any, updatedAt: any };

export type GetMyVoicesFeedbackListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyVoicesFeedbackListQuery = { __typename?: 'Query', getMyVoicesFeedbackList: Array<{ __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, createdAt: any, updatedAt: any }> };

export type CreateVoicesFeedbackMutationVariables = Exact<{
  input: CreateVoicesFeedbackInput;
}>;


export type CreateVoicesFeedbackMutation = { __typename?: 'Mutation', createVoicesFeedback: { __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, createdAt: any, updatedAt: any } };

export type GetMyCompanyVoicesFeedbackListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCompanyVoicesFeedbackListQuery = { __typename?: 'Query', getMyCompanyVoicesFeedbackList: Array<{ __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, createdAt: any, updatedAt: any }> };

export type TerminationPartsFragment = { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } };

export type TerminationDownloadPartsFragment = { __typename?: 'TerminationDownload', file: string, terminationId: string };

export type GetTerminationListQueryVariables = Exact<{
  data: GetTerminationsInput;
}>;


export type GetTerminationListQuery = { __typename?: 'Query', terminationList: Array<{ __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } }> };

export type GetTerminationInfoQueryVariables = Exact<{
  data: GetTerminationInput;
}>;


export type GetTerminationInfoQuery = { __typename?: 'Query', terminationInfo: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type TerminationDownloadQueryVariables = Exact<{
  data: GetTerminationInput;
}>;


export type TerminationDownloadQuery = { __typename?: 'Query', terminationDownload: { __typename?: 'TerminationDownload', file: string, terminationId: string } };

export type CancelTerminationMutationVariables = Exact<{
  data: TerminationCancelInput;
}>;


export type CancelTerminationMutation = { __typename?: 'Mutation', cancelTermination: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ConfirmTerminationMutationVariables = Exact<{
  data: TerminationConfirmationInput;
}>;


export type ConfirmTerminationMutation = { __typename?: 'Mutation', confirmTermination: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type EditTerminationDetailsMutationVariables = Exact<{
  data: TerminationEditDetailsInput;
}>;


export type EditTerminationDetailsMutation = { __typename?: 'Mutation', editTerminationDetails: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type AttachTerminationFilesMutationVariables = Exact<{
  data: TerminationAttachInput;
}>;


export type AttachTerminationFilesMutation = { __typename?: 'Mutation', attachTerminationFiles: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ResignationPartsFragment = { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } };

export type GetResignationListQueryVariables = Exact<{
  data: GetResignationsInput;
}>;


export type GetResignationListQuery = { __typename?: 'Query', resignationList: Array<{ __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } }> };

export type ResignationDownloadPartsFragment = { __typename?: 'ResignationDownload', file: string, resignationId: string };

export type AttachResignationFilesMutationVariables = Exact<{
  data: ResignationAttachInput;
}>;


export type AttachResignationFilesMutation = { __typename?: 'Mutation', attachResignationFiles: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ResignationInfoQueryVariables = Exact<{
  data: GetResignationInput;
}>;


export type ResignationInfoQuery = { __typename?: 'Query', resignationInfo: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ResignationDownloadQueryVariables = Exact<{
  data: GetResignationInput;
}>;


export type ResignationDownloadQuery = { __typename?: 'Query', resignationDownload: { __typename?: 'ResignationDownload', file: string, resignationId: string } };

export type CancelResignationMutationVariables = Exact<{
  data: ResignationCancelInput;
}>;


export type CancelResignationMutation = { __typename?: 'Mutation', cancelResignation: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ConfirmResignationMutationVariables = Exact<{
  data: ResignationConfirmationInput;
}>;


export type ConfirmResignationMutation = { __typename?: 'Mutation', confirmResignation: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type EditResignationMutationVariables = Exact<{
  data: ResignationEditDetailsInput;
}>;


export type EditResignationMutation = { __typename?: 'Mutation', editResignationDetails: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type WarningDocumentsQueryVariables = Exact<{
  data: GetUserWarningDocumentsInput;
}>;


export type WarningDocumentsQuery = { __typename?: 'Query', warningDocuments: Array<{ __typename?: 'WarningDocument', createdAt: any, name: string, type: string, id: string }> };

export type JobDescriptionPartsFragment = { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> };

export type EmployeeJobDescriptionPartsFragment = { __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type CreateJobDescriptionMutationVariables = Exact<{
  data: CreateJobDescriptionInput;
}>;


export type CreateJobDescriptionMutation = { __typename?: 'Mutation', createJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type UpdateJobDescriptionMutationVariables = Exact<{
  data: UpdateJobDescriptionInput;
}>;


export type UpdateJobDescriptionMutation = { __typename?: 'Mutation', updateJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type CompleteJobDescriptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompleteJobDescriptionMutation = { __typename?: 'Mutation', completeJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type GenerateAiJobDescriptionMutationVariables = Exact<{
  data: GenerateAiJobDescriptionInput;
}>;


export type GenerateAiJobDescriptionMutation = { __typename?: 'Mutation', generateAiJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type GenerateAiJobDescriptionV2MutationVariables = Exact<{
  data: GenerateAiJobDescriptionInputV2;
}>;


export type GenerateAiJobDescriptionV2Mutation = { __typename?: 'Mutation', generateAiJobDescriptionV2: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type SendJobDescriptionToEmployeeMutationVariables = Exact<{
  data: SendJobDescriptionToEmployeeInput;
}>;


export type SendJobDescriptionToEmployeeMutation = { __typename?: 'Mutation', sendJobDescriptionToEmployee: { __typename?: 'EmployeeJobDescription', id: string, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } } };

export type GetEmployeeJobDescriptionQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetEmployeeJobDescriptionQuery = { __typename?: 'Query', getEmployeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> };

export type SignEmployeeJobDescriptionMutationVariables = Exact<{
  signEmployeeJobDescriptionId: Scalars['String'];
}>;


export type SignEmployeeJobDescriptionMutation = { __typename?: 'Mutation', signEmployeeJobDescription: { __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } } };

export type GetJobDescriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobDescriptionsQuery = { __typename?: 'Query', jobDescriptions: Array<{ __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> }> };

export type GetStaffJobDescriptionsQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type GetStaffJobDescriptionsQuery = { __typename?: 'Query', getMyCoreUser: { __typename?: 'CoreUser', id: string, company?: Maybe<{ __typename?: 'CoreCompany', id: string, paginatedEmployees: { __typename?: 'PaginatedCoreUsers', id: string, page: number, totalPages: number, totalCount: number, result: Array<{ __typename?: 'CoreUser', id: string, active: boolean, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, title?: Maybe<string>, workerRoles: Array<{ __typename?: 'WorkerRole', id: string, userId: string, isPrimary: boolean, employeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, signedAt?: Maybe<any>, createdAt: any, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> }> }> }> } }> } };

export type MyNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyNotificationsQuery = { __typename?: 'Query', myNotifications: Array<{ __typename?: 'Notification', id: string, level: NotificationLevel, subject?: Maybe<string>, body: string, dismissible: boolean, dismissedAt?: Maybe<any>, createdAt: any, targets: Array<{ __typename?: 'NotificationTarget', id: string, type: NotificationTargetType }>, actions?: Maybe<Array<{ __typename?: 'NotificationAction', id: string, label: string, type: NotificationActionType, value: string }>> }> };

export type DismissNotificationMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DismissNotificationMutation = { __typename?: 'Mutation', dismissNotification: { __typename?: 'Notification', id: string, dismissedAt?: Maybe<any> } };

export type ClickedOnNotificationActionMutationVariables = Exact<{
  actionId: Scalars['String'];
}>;


export type ClickedOnNotificationActionMutation = { __typename?: 'Mutation', clickedOnNotificationAction: boolean };

export type AssignUserToPoliciesMutationVariables = Exact<{
  data: AssignUserToPoliciesInput;
}>;


export type AssignUserToPoliciesMutation = { __typename?: 'Mutation', assignUserToPolicies: Array<{ __typename?: 'CoreDocument', id: string }> };

export type EnrollMfaDeviceMutationVariables = Exact<{
  input: AuthMfaSmsEnrollmentInput;
}>;


export type EnrollMfaDeviceMutation = { __typename?: 'Mutation', enrollMfaDevice: { __typename?: 'AuthMfaChallenge', nonce: string, expiration: any } };

export type CreateMfaChallengeMutationVariables = Exact<{
  reason: Scalars['String'];
  type: AuthMfaType;
}>;


export type CreateMfaChallengeMutation = { __typename?: 'Mutation', createChallenge: { __typename?: 'AuthMfaChallenge', nonce: string, metadata?: Maybe<{ __typename?: 'AuthMfaMetadata', phoneLast4?: Maybe<string> }> } };

export type ResendChallengeMutationVariables = Exact<{
  nonceId: Scalars['String'];
  reason: Scalars['String'];
  type: AuthMfaType;
}>;


export type ResendChallengeMutation = { __typename?: 'Mutation', resendChallenge: { __typename?: 'AuthMfaChallenge', nonce: string, metadata?: Maybe<{ __typename?: 'AuthMfaMetadata', phoneLast4?: Maybe<string> }> } };

export type ConfirmUserMfaEnrollmentMutationVariables = Exact<{
  input: AuthMfaChallengeResponseInput;
}>;


export type ConfirmUserMfaEnrollmentMutation = { __typename?: 'Mutation', confirmUserMfaEnrollment: { __typename?: 'AuthMfaConfig', mfaType: AuthMfaType, createdAt: any, lastChallengedAt?: Maybe<any>, lastDevice?: Maybe<string>, backupCode: string } };

export type ApprovePayrollMutationVariables = Exact<{
  data: ApprovePayrollInput;
}>;


export type ApprovePayrollMutation = { __typename?: 'Mutation', approvePayroll: { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, approvedAt?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, grossPay: number, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> } };

export type DeletePayrollMutationVariables = Exact<{
  data: DeletePayrollInput;
}>;


export type DeletePayrollMutation = { __typename?: 'Mutation', deletePayroll: { __typename?: 'Payroll', id: string, deletedAt?: Maybe<any> } };

export type CreatePayrollMutationVariables = Exact<{
  data: CreatePayrollInput;
}>;


export type CreatePayrollMutation = { __typename?: 'Mutation', createPayroll: { __typename?: 'Payroll', id: string } };

export type InitPayrollMutationVariables = Exact<{
  data: InitializePayrollInput;
}>;


export type InitPayrollMutation = { __typename?: 'Mutation', initializePayroll: { __typename?: 'Payroll', id: string } };

export type UpdatePayrollMutationVariables = Exact<{
  data: UpdatePayrollInput;
}>;


export type UpdatePayrollMutation = { __typename?: 'Mutation', updatePayroll: { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, grossPay: number, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> } };

export type UpdatePayrollItemMutationVariables = Exact<{
  data: UpdatePayrollItemInput;
}>;


export type UpdatePayrollItemMutation = { __typename?: 'Mutation', updatePayrollItem: { __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } } };

export type UpdateContractorPaymentMutationVariables = Exact<{
  data: UpdateContractorPaymentInput;
}>;


export type UpdateContractorPaymentMutation = { __typename?: 'Mutation', updateContractorPayment: { __typename?: 'ContractorPayment', id: string, grossPay: number, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } } };

export type UpdatePayrollChecksMutationVariables = Exact<{
  data: UpdatePayrollChecksInput;
}>;


export type UpdatePayrollChecksMutation = { __typename?: 'Mutation', updatePayrollChecks: { __typename?: 'Payroll', id: string, needsChecksEntered?: Maybe<boolean>, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, checkNumber?: Maybe<string> }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, checkNumber?: Maybe<string> }> } };

export type PreviewPayrollMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PreviewPayrollMutation = { __typename?: 'Mutation', previewPayroll: { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> } };

export type GenerateEmployeeOnboardingLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenerateEmployeeOnboardingLinkMutation = { __typename?: 'Mutation', generateEmployeeOnboardingLink: string };

export type GenerateContractorOnboardingLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenerateContractorOnboardingLinkMutation = { __typename?: 'Mutation', generateContractorOnboardingLink: string };

export type GenerateCompanyOnboardingLinkMutationVariables = Exact<{
  data: GenerateCompanyOnboardingLinkInput;
}>;


export type GenerateCompanyOnboardingLinkMutation = { __typename?: 'Mutation', generateCompanyOnboardingLink: string };

export type GenerateEmployeePostTaxDeductionsLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenerateEmployeePostTaxDeductionsLinkMutation = { __typename?: 'Mutation', generateEmployeePostTaxDeductionsLink: string };

export type GenerateCompanyPayrollReportLinkMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenerateCompanyPayrollReportLinkMutation = { __typename?: 'Mutation', generateCompanyPayrollReportLink: string };

export type CreatePayScheduleMutationVariables = Exact<{
  data: CreatePayScheduleInput;
  coreData: UpdateCoreCompanyInput;
}>;


export type CreatePayScheduleMutation = { __typename?: 'Mutation', createPaySchedule: { __typename?: 'PaySchedule', id: string }, updateCoreCompany: { __typename?: 'CoreCompany', id: string, payDayOfWeek?: Maybe<number>, payDayOfMonth?: Maybe<number> } };

export type UpdateWorkplaceMutationVariables = Exact<{
  data: UpdateWorkplaceInput;
}>;


export type UpdateWorkplaceMutation = { __typename?: 'Mutation', updateWorkplace: { __typename?: 'Workplace', active: boolean, default: boolean, id: string, name?: Maybe<string>, address: { __typename?: 'Address', id: string, city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string } } };

export type CreateWorkplaceMutationVariables = Exact<{
  data: CreateWorkplaceInput;
}>;


export type CreateWorkplaceMutation = { __typename?: 'Mutation', createWorkplace: { __typename?: 'Workplace', id: string, name?: Maybe<string>, default: boolean, address: { __typename?: 'Address', id: string, city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string } } };

export type CreateCompanyInCheckMutationVariables = Exact<{
  data: CreateCompanyInCheckInput;
}>;


export type CreateCompanyInCheckMutation = { __typename?: 'Mutation', createCompanyInCheck: { __typename?: 'Company', id: string, checkId?: Maybe<string> } };

export type UpgradeFinchCodeMutationVariables = Exact<{
  data: UserFinchCodeInput;
}>;


export type UpgradeFinchCodeMutation = { __typename?: 'Mutation', upgradeFinchCode: { __typename?: 'CompanyFinchAccessToken', id: string } };

export type UpdateCompanyMutationVariables = Exact<{
  data: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, tosVersion?: Maybe<string>, needsPayScheduleAssistance?: Maybe<boolean>, excludedStaffIds: Array<Maybe<string>>, deputyTosAcceptedAt?: Maybe<any> } };

export type SetupEmployeeMutationVariables = Exact<{
  data: SetupEmployeeInput;
}>;


export type SetupEmployeeMutation = { __typename?: 'Mutation', setupEmployee: { __typename?: 'Employee', checkId?: Maybe<string>, id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, payType?: Maybe<PaymentType>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, remainingSteps: Array<EmployeeOnboardingSteps>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, homeAddress?: Maybe<{ __typename?: 'ProfileAddress', city?: Maybe<string>, line1?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }>, workplaces: Array<{ __typename?: 'Workplace', id: string, active: boolean, default: boolean, name?: Maybe<string>, address: { __typename?: 'Address', id: string, city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string } }> } };

export type SetupContractorMutationVariables = Exact<{
  data: SetupContractorInput;
}>;


export type SetupContractorMutation = { __typename?: 'Mutation', setupContractor: { __typename?: 'Contractor', checkId?: Maybe<string>, id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, payType?: Maybe<ContractorPayType>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', institutionName: string, mask: string }>>>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, contractorBusinessName?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> } };

export type UpdateEmployeeWorkplaceMutationVariables = Exact<{
  data: UpdateEmployeeWorkplaceInput;
}>;


export type UpdateEmployeeWorkplaceMutation = { __typename?: 'Mutation', updateEmployeeWorkplace: boolean };

export type UpdateContractorWorkplaceMutationVariables = Exact<{
  data: UpdateContractorWorkplaceInput;
}>;


export type UpdateContractorWorkplaceMutation = { __typename?: 'Mutation', updateContractorWorkplace: boolean };

export type SendStaffOnboardInviteMutationVariables = Exact<{
  data: SendStaffOnboardInviteInput;
}>;


export type SendStaffOnboardInviteMutation = { __typename?: 'Mutation', sendStaffOnboardInvite: boolean };

export type BulkEarningsImportMutationVariables = Exact<{
  data: BulkEarningsImportInput;
}>;


export type BulkEarningsImportMutation = { __typename?: 'Mutation', bulkEarningsImport: { __typename?: 'BulkEarningsImportResult', successfulStaffIds: Array<Maybe<string>>, errors: Array<Maybe<{ __typename?: 'BulkEarningsImportErrors', errorMsg: string, staffId: string }>>, payroll: { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, grossPay: number, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> } } };

export type FinchManualSetupCompletedMutationVariables = Exact<{
  data: FinchManualSetupCompletedInput;
}>;


export type FinchManualSetupCompletedMutation = { __typename?: 'Mutation', finchManualSetupCompleted: boolean };

export type CheckSyncCompanyMutationVariables = Exact<{
  data: CheckSyncCompanyInput;
}>;


export type CheckSyncCompanyMutation = { __typename?: 'Mutation', checkSyncCompany?: Maybe<{ __typename?: 'Company', id: string, status?: Maybe<CompanyStatus>, tosVersion?: Maybe<string>, excludedStaffIds: Array<Maybe<string>>, checkIndustry?: Maybe<IndustryType>, checkId?: Maybe<string>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus, targetEffectiveStart?: Maybe<string> }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, installId: string, validatedAt?: Maybe<any>, edition?: Maybe<string>, canCancel: boolean }> }> };

export type DeleteCompanyRolesMutationVariables = Exact<{
  data: DeleteCompanyRolesInput;
}>;


export type DeleteCompanyRolesMutation = { __typename?: 'Mutation', deleteCompanyRolesById?: Maybe<Array<{ __typename?: 'CompanyRole', id: string, title: string, companyId: string, deletedAt?: Maybe<any> }>> };

export type CreateCompanyRolesMutationVariables = Exact<{
  data: CreateMultipleRolesForCompanyInput;
}>;


export type CreateCompanyRolesMutation = { __typename?: 'Mutation', createCompanyRoles: Array<{ __typename?: 'CompanyRole', companyId: string, title: string, id: string, deletedAt?: Maybe<any> }> };

export type UpdateCompanyRolesMutationVariables = Exact<{
  data: UpdateMultipleRolesForCompanyInput;
}>;


export type UpdateCompanyRolesMutation = { __typename?: 'Mutation', updateCompanyRoles: Array<{ __typename?: 'CompanyRole', companyId: string, title: string, id: string, deletedAt?: Maybe<any>, createdAt: any, workerRoles?: Maybe<Array<{ __typename?: 'WorkerRole', id: string, deletedAt?: Maybe<any> }>> }> };

export type AssignWorkerRolesMutationVariables = Exact<{
  data: AssignWorkerRolesInput;
}>;


export type AssignWorkerRolesMutation = { __typename?: 'Mutation', assignWorkerRoles: { __typename?: 'CoreUser', id: string, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, workerRoles: Array<{ __typename?: 'WorkerRole', id: string, isPrimary: boolean, payRate: number, deletedAt?: Maybe<any>, companyRole?: Maybe<{ __typename?: 'CompanyRole', id: string, title: string, deletedAt?: Maybe<any>, workerRoles?: Maybe<Array<{ __typename?: 'WorkerRole', id: string }>> }> }> }> } };

export type SubmitPayrollOnboardingFormMutationVariables = Exact<{
  coreData: UpdateCoreCompanyInput;
  payrollData: UpdateCompanyInput;
  syncCompanyData: SyncCompanyInput;
  enrollmentProfile: CreateEnrollmentProfileRequest;
  checkCompanyInfo: CreateCompanyInCheckInput;
  shouldCreateCompanyInCheck: Scalars['Boolean'];
}>;


export type SubmitPayrollOnboardingFormMutation = { __typename?: 'Mutation', createEnrollmentProfile: boolean, updateCoreCompany: { __typename?: 'CoreCompany', fein?: Maybe<string>, name: string, id: string, numOfContractors?: Maybe<number>, numOfFullTimeHourlyEmployees?: Maybe<number>, numOfFullTimeSalaryEmployees?: Maybe<number>, numOfPartTimeEmployees?: Maybe<number>, website?: Maybe<string>, address: { __typename?: 'CoreAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zipCode?: Maybe<string> } }, updateCompany: { __typename?: 'Company', id: string, checkIndustry?: Maybe<IndustryType>, processedPayrollsThisYear: boolean, signatoryFirstName: string, signatoryLastName: string, signatoryTitle: string, signatoryEmail: string, onboardingOffersEmployeeBenefits: boolean, onboardingHasGarnishmentsOrDeductions?: Maybe<boolean>, onboardingGarnishmentsOrDeductions: Array<OnboardingGarnishmentOrDeduction>, onboardingGarnishmentsOrDeductionsOther: string }, createCompanyInCheck?: Maybe<{ __typename?: 'Company', id: string, checkId?: Maybe<string> }>, syncCompany: { __typename?: 'Company', id: string } };

export type UpdatePayrollSignatoryMutationVariables = Exact<{
  data: UpdateCompanyInput;
}>;


export type UpdatePayrollSignatoryMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, signatoryFirstName: string, signatoryLastName: string, signatoryTitle: string, signatoryEmail: string } };

export type VerifyFeinInCheckMutationVariables = Exact<{
  feinData: UpdateCoreCompanyInput;
  verifyData: VerifyFeinInCheckInput;
  syncCompanyData: SyncCompanyInput;
}>;


export type VerifyFeinInCheckMutation = { __typename?: 'Mutation', updateCoreCompany: { __typename?: 'CoreCompany', fein?: Maybe<string>, name: string, id: string }, syncCompany: { __typename?: 'Company', id: string }, verifyFEINInCheck?: Maybe<{ __typename?: 'Company', id: string, feinVerificationAttempts: number, feinVerification?: Maybe<{ __typename?: 'CheckFEINVerification', id: string, legalName: string, federalEin: string, status: string, company: string }> }> };

export type UploadRequirementFileMutationVariables = Exact<{
  data: UploadFileInput;
}>;


export type UploadRequirementFileMutation = { __typename?: 'Mutation', uploadFile: Array<{ __typename?: 'Goal', category: GoalCategory, id: string, name: string, label: string, required: boolean, status: GoalStatus, requirements: Array<{ __typename?: 'Requirement', checkId?: Maybe<string>, completedAt?: Maybe<any>, id: string, requirementType: RequirementType, requirementTypeExt?: Maybe<string>, status: RequirementStatus, requirementName: string, documentOptions: Array<{ __typename?: 'DocumentOption', id: DocumentOptionType, label: string, name: string }>, uploadedFiles?: Maybe<Array<{ __typename?: 'UploadedFile', id: string, name: string, type: DocumentType }>>, errors: Array<{ __typename?: 'RequirementError', type: RequirementErrorConst, label: string, id: string, description?: Maybe<string> }> }> }> };

export type ImportHoursMutationVariables = Exact<{
  data: SyncTimesheetsInput;
}>;


export type ImportHoursMutation = { __typename?: 'Mutation', syncTimesheets: { __typename?: 'DeputySyncInfo', contractors: number, earnings: number, employees: number, id: string, lastUpdate?: Maybe<any>, paymentEntries: number, synced: boolean } };

export type SyncTimesheetHoursMutationVariables = Exact<{
  data: SyncTimesheetsInput;
}>;


export type SyncTimesheetHoursMutation = { __typename?: 'Mutation', syncTimesheets: { __typename?: 'DeputySyncInfo', id: string, lastUpdate?: Maybe<any>, synced: boolean } };

export type ImportTimesheetByWorkerListMutationVariables = Exact<{
  data: ImportTimesheetsInput;
}>;


export type ImportTimesheetByWorkerListMutation = { __typename?: 'Mutation', importTimesheets: { __typename?: 'DeputySyncInfo', id: string, synced: boolean, imported: boolean, lastUpdate?: Maybe<any>, employees: number, earnings: number, contractors: number, paymentEntries: number, syncErrors: Array<{ __typename?: 'DeputySyncError', id: string, message: string }> } };

export type CompleteTaskMutationVariables = Exact<{
  data: CompleteTaskInput;
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask?: Maybe<{ __typename?: 'CoreTask', id: string, completedAt?: Maybe<any>, name: TaskName }> };

export type CompleteGoalMutationVariables = Exact<{
  data: CompleteGoalInput;
}>;


export type CompleteGoalMutation = { __typename?: 'Mutation', completeGoal: { __typename?: 'CoreGoal', id: string, completedAt?: Maybe<any>, name: GoalName } };

export type StartTaskMutationVariables = Exact<{
  startTaskId: Scalars['String'];
}>;


export type StartTaskMutation = { __typename?: 'Mutation', startTask: { __typename?: 'CoreTask', id: string, name: TaskName, startedAt?: Maybe<any> } };

export type BulkSetupStaffInPayrollMutationVariables = Exact<{
  data: BulkSetupStaffInput;
}>;


export type BulkSetupStaffInPayrollMutation = { __typename?: 'Mutation', bulkSetupStaff: boolean };

export type SavePastPayrollUsageMutationVariables = Exact<{
  data: UpdateCompanyInput;
}>;


export type SavePastPayrollUsageMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, pastPayrollUsage?: Maybe<PastPayrollUsage> } };

export type UpdateCompanyAddressesMutationVariables = Exact<{
  data: UpdateCoreCompanyInput;
}>;


export type UpdateCompanyAddressesMutation = { __typename?: 'Mutation', updateCoreCompany: { __typename?: 'CoreCompany', id: string, address: { __typename?: 'CoreAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }, legalAddress?: Maybe<{ __typename?: 'CoreLegalAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> } };

export type UpdateBasicCompanyInfoMutationVariables = Exact<{
  data: UpdateCoreCompanyInput;
}>;


export type UpdateBasicCompanyInfoMutation = { __typename?: 'Mutation', updateCoreCompany: { __typename?: 'CoreCompany', id: string, name: string, phone?: Maybe<string>, industry?: Maybe<string> } };

export type PurchaseBambeePlusMutationVariables = Exact<{
  data: PurchaseBambeePlusInput;
}>;


export type PurchaseBambeePlusMutation = { __typename?: 'Mutation', purchaseBambeePlus: { __typename?: 'BambeePlus', id: string, status: BambeePlusStatuses, eligible: boolean } };

export type SendEnrollmentProfileMutationVariables = Exact<{
  syncCompanyData: SyncCompanyInput;
  enrollmentProfile: CreateEnrollmentProfileRequest;
}>;


export type SendEnrollmentProfileMutation = { __typename?: 'Mutation', createEnrollmentProfile: boolean, syncCompany: { __typename?: 'Company', id: string } };

export type SaveCompanySettingMutationVariables = Exact<{
  input: SaveCompanySettingInput;
}>;


export type SaveCompanySettingMutation = { __typename?: 'Mutation', saveCompanySetting: { __typename?: 'CompanySetting', id: number, companyId: string, type: SettingType, key: CompanySettingKey, value: string } };

export type CancelBambeePlusMutationVariables = Exact<{
  data: PurchaseBambeePlusInput;
}>;


export type CancelBambeePlusMutation = { __typename?: 'Mutation', cancelBambeePlus: { __typename?: 'BambeePlus', id: string, status: BambeePlusStatuses, eligible: boolean, onboardingDueDate?: Maybe<any> } };

export type ApproveTrainingRequestMutationVariables = Exact<{
  data: RequestApprovalInput;
}>;


export type ApproveTrainingRequestMutation = { __typename?: 'Mutation', approveRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, resourceId: string } };

export type RejectTrainingRequestMutationVariables = Exact<{
  data: RequestRejectionInput;
}>;


export type RejectTrainingRequestMutation = { __typename?: 'Mutation', rejectRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, resourceId: string } };

export type MakeTrainingRequestMutationVariables = Exact<{
  data: TrainingRequestInput;
}>;


export type MakeTrainingRequestMutation = { __typename?: 'Mutation', trainingRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, resourceId: string } };

export type CancelTrainingRequestMutationVariables = Exact<{
  data: RequestCancelInput;
}>;


export type CancelTrainingRequestMutation = { __typename?: 'Mutation', cancelRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, resourceId: string } };

export type GenerateCheckComponentLinkMutationVariables = Exact<{
  data: CheckComponentInput;
}>;


export type GenerateCheckComponentLinkMutation = { __typename?: 'Mutation', generateCheckComponentLink: { __typename?: 'CheckComponentLink', id: string, url: string } };

export type JoinCallQueueMutationVariables = Exact<{
  data: EnqueueHotlineCallInput;
}>;


export type JoinCallQueueMutation = { __typename?: 'Mutation', enqueueHotlineCall: boolean };

export type CancelPendingHotlineCallMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelPendingHotlineCallMutation = { __typename?: 'Mutation', cancelPendingHotlineCall: boolean };

export type UpgradeCorePlanMutationVariables = Exact<{
  data: UpgradeCorePlanInput;
}>;


export type UpgradeCorePlanMutation = { __typename?: 'Mutation', upgradeCorePlan: { __typename?: 'Subscription', stripeId: string } };

export type SaveComplexPayrollOnboardingMutationVariables = Exact<{
  data: ComplexPayrollOnboardingInput;
}>;


export type SaveComplexPayrollOnboardingMutation = { __typename?: 'Mutation', saveComplexPayrollOnboarding: boolean };

export type PurchaseTimeAndAttendanceMutationVariables = Exact<{
  data: PurchaseTimeAttendanceInput;
}>;


export type PurchaseTimeAndAttendanceMutation = { __typename?: 'Mutation', purchaseTimeAttendance: { __typename?: 'TimeAttendanceSubscriptionResponse', id: string, subscriptionId: string } };

export type AcceptOfferMutationVariables = Exact<{
  input: AcceptOfferInput;
}>;


export type AcceptOfferMutation = { __typename?: 'Mutation', acceptOffer: boolean };

export type SubmitCancelRequestMutationVariables = Exact<{
  input: CreateCancellationRequestInput;
}>;


export type SubmitCancelRequestMutation = { __typename?: 'Mutation', createCancellationRequest: { __typename?: 'CancellationModel', id: string, status: CancellationStatus } };

export type TrackMutationVariables = Exact<{
  data: AnalyticEvent;
}>;


export type TrackMutation = { __typename?: 'Mutation', track: { __typename?: 'AnalyticEventTracked', id: string, success: boolean, event: string } };

export type ReactivateCompanyMutationVariables = Exact<{
  input: ReactivatePausedCompanyInput;
}>;


export type ReactivateCompanyMutation = { __typename?: 'Mutation', reactivatePausedCompany: boolean };

export type CreateProductInterestMutationVariables = Exact<{
  input: CreateProductInterestInput;
}>;


export type CreateProductInterestMutation = { __typename?: 'Mutation', createProductInterest: { __typename?: 'ProductInterest', id: string, productKey: ProductKey, productSubKey?: Maybe<ProductSubKey> } };

export type SetDefaultBillingPaymentMethodMutationVariables = Exact<{
  input: SetDefaultPaymentMethodInput;
}>;


export type SetDefaultBillingPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: { __typename?: 'BillingPaymentMethod', id: string, default: boolean, expirationDate?: Maybe<any>, name: string, nextAction?: Maybe<PaymentMethodNextAction>, status: PaymentMethodStatus, type: PaymentMethodType } };

export type RemovePaymentMethodMutationVariables = Exact<{
  input: RemovePaymentMethodInput;
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: boolean };

export type ConfirmMicroDepositMutationVariables = Exact<{
  input: ConfirmMicroDepositInput;
}>;


export type ConfirmMicroDepositMutation = { __typename?: 'Mutation', confirmMicroDeposit: { __typename?: 'BillingPaymentMethod', id: string, default: boolean, expirationDate?: Maybe<any>, name: string, nextAction?: Maybe<PaymentMethodNextAction>, status: PaymentMethodStatus, type: PaymentMethodType } };

export type UpsertEmployerOnboardingMutationVariables = Exact<{
  data: CoreOnboardingInput;
}>;


export type UpsertEmployerOnboardingMutation = { __typename?: 'Mutation', upsertOnboarding: { __typename?: 'CoreOnboarding', status: OnboardingStatus, id: string, updatedAt: any, createdAt: any, data: { __typename?: 'CoreOnboardingData', discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>, companyName?: Maybe<string>, companyLegalName?: Maybe<string>, companyType?: Maybe<CompanyType>, fein?: Maybe<string>, noFeinOrDoesNotKnow?: Maybe<boolean>, incorporatedInOtherState?: Maybe<boolean>, incorporatedState?: Maybe<StateAbbreviation>, isOwner?: Maybe<boolean>, primaryContact?: Maybe<boolean>, willHaveAdditionalContact?: Maybe<boolean>, numOfEmployees?: Maybe<number>, numOfContractors?: Maybe<number>, needsHelpConvertingContractors?: Maybe<boolean>, hasRemoteEmployees?: Maybe<boolean>, remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>, nextAction?: Maybe<NextOnboardingAction>, hasScheduledCall?: Maybe<boolean>, callEventId?: Maybe<string>, progress?: Maybe<number>, discussionTopicDetails?: Maybe<Array<Maybe<{ __typename?: 'DisucssionTopicDetail', topic: DiscussionTopic, detail: string }>>>, address?: Maybe<{ __typename?: 'CoreAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> } } };

export type AcceptTrialExtensionMutationVariables = Exact<{
  input: AcceptTrialOfferInput;
}>;


export type AcceptTrialExtensionMutation = { __typename?: 'Mutation', acceptTrialOffer: boolean };

export type AddSubscriptionMutationVariables = Exact<{
  data: PurchaseSubscriptionInput;
}>;


export type AddSubscriptionMutation = { __typename?: 'Mutation', purchaseSubscription: { __typename?: 'PurchaseResult', createdAt: any, creditsPurchased: number, id: string, productKey: ProductKey, status: StatementStatus, totalAmount: number } };

export type CreateEliteAddonSubscriptionMutationVariables = Exact<{
  input: CreateEliteAddonSubscriptionInput;
}>;


export type CreateEliteAddonSubscriptionMutation = { __typename?: 'Mutation', createEliteAddonSubscription: boolean };

export type RequestPayrollCancellationMutationVariables = Exact<{
  data: PayrollCancellationRequestInput;
}>;


export type RequestPayrollCancellationMutation = { __typename?: 'Mutation', requestPayrollCancellation: boolean };

export type ConsumeNectarCreditsMutationVariables = Exact<{
  data: RemoveCreditsInput;
}>;


export type ConsumeNectarCreditsMutation = { __typename?: 'Mutation', removeActiveCredits: Array<{ __typename?: 'Credit', id: string, consumedAt?: Maybe<any> }> };

export type PurchaseNectarCreditsMutationVariables = Exact<{
  data: PurchaseInput;
}>;


export type PurchaseNectarCreditsMutation = { __typename?: 'Mutation', purchaseCredits: { __typename?: 'PurchaseResult', id: string, createdAt: any, status: StatementStatus, totalAmount: number } };

export type ProvisionDeputyInstallMutationVariables = Exact<{
  data: ProvisionDeputyInstallInput;
}>;


export type ProvisionDeputyInstallMutation = { __typename?: 'Mutation', provisionDeputyInstall: { __typename?: 'DeputyConnection', id: string, installId: string, hasAccessToken: boolean } };

export type CreatePayrollTierSubscriptionMutationVariables = Exact<{
  data: CreatePayrollSubscriptionInput;
}>;


export type CreatePayrollTierSubscriptionMutation = { __typename?: 'Mutation', createPayrollSubscription: { __typename?: 'Subscription', name: string, stripeId: string, productCode: ProductKey, serviceKey: ServiceKey, planValue: string, amount: number, createdAt: any, startDate: any, endDate: any, status: SubscriptionStatus, isDrp: boolean } };

export type UpgradeInstallMutationVariables = Exact<{
  data: UpgradeDeputyInstallInput;
}>;


export type UpgradeInstallMutation = { __typename?: 'Mutation', upgradeInstall?: Maybe<{ __typename?: 'DeputyConnection', edition?: Maybe<string>, id: string, installId: string }> };

export type CancelTimeAttendanceMutationVariables = Exact<{
  data: CancelTimeAttendanceInput;
}>;


export type CancelTimeAttendanceMutation = { __typename?: 'Mutation', cancelTimeAttendance: boolean };

export type ChatWithAssistantMutationVariables = Exact<{
  data: AiAssistantInput;
}>;


export type ChatWithAssistantMutation = { __typename?: 'Mutation', chatWithAssistant: { __typename?: 'AIAssistantResponse', assistantId?: Maybe<string>, threadId: string, next: { __typename?: 'NextMessage', context?: Maybe<string>, sample?: Maybe<string> }, messages?: Maybe<Array<Maybe<{ __typename?: 'AIMessageDto', id: string, role: string, content: Array<{ __typename?: 'MessageContentDto', text?: Maybe<{ __typename?: 'TextContentBlock', value: string }> }>, metadata: { __typename?: 'MessageMetaDataDto', artifact?: Maybe<string>, hidden?: Maybe<string>, type?: Maybe<string>, value?: Maybe<string> } }>>>, artifact?: Maybe<{ __typename?: 'ChatArtifact', jobDescription?: Maybe<{ __typename?: 'JobDescriptionArtifact', html: string, id?: Maybe<string>, status: JobDescriptionStatus }>, summary?: Maybe<{ __typename?: 'SummaryArtifact', html: string, status: string }>, policy?: Maybe<{ __typename?: 'PolicyArtifact', html?: Maybe<string>, title?: Maybe<string>, id?: Maybe<string>, status: BestPracticeStatus }> }> } };

export type OptInAiMutationVariables = Exact<{
  data: UpdateCoreCompanyInput;
}>;


export type OptInAiMutation = { __typename?: 'Mutation', updateCoreCompany: { __typename?: 'CoreCompany', id: string, ai?: Maybe<{ __typename?: 'CompanyAiProfile', optIn?: Maybe<boolean> }> } };

export type ActivateHandsFreeMutationVariables = Exact<{
  data: UpdateCoreCompanyInput;
}>;


export type ActivateHandsFreeMutation = { __typename?: 'Mutation', updateCoreCompany: { __typename?: 'CoreCompany', id: string, handsFreeActionItemActivatedAt?: Maybe<any> } };

export type EmitMutationVariables = Exact<{
  data: EmittableEvent;
}>;


export type EmitMutation = { __typename?: 'Mutation', emit: { __typename?: 'EventEmitted', id: string, userId?: Maybe<string>, success: boolean } };

export type OnboardingPartsFragment = { __typename?: 'CoreOnboardingData', discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>, companyName?: Maybe<string>, companyLegalName?: Maybe<string>, companyType?: Maybe<CompanyType>, fein?: Maybe<string>, noFeinOrDoesNotKnow?: Maybe<boolean>, incorporatedInOtherState?: Maybe<boolean>, incorporatedState?: Maybe<StateAbbreviation>, isOwner?: Maybe<boolean>, primaryContact?: Maybe<boolean>, willHaveAdditionalContact?: Maybe<boolean>, numOfEmployees?: Maybe<number>, numOfContractors?: Maybe<number>, needsHelpConvertingContractors?: Maybe<boolean>, hasRemoteEmployees?: Maybe<boolean>, remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>, nextAction?: Maybe<NextOnboardingAction>, hasScheduledCall?: Maybe<boolean>, callEventId?: Maybe<string>, progress?: Maybe<number>, discussionTopicDetails?: Maybe<Array<Maybe<{ __typename?: 'DisucssionTopicDetail', topic: DiscussionTopic, detail: string }>>>, address?: Maybe<{ __typename?: 'CoreAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> };

export type BankAccountPartsFragment = { __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> };

export type CompanyPartsFragment = { __typename?: 'Company', id: string, checkId?: Maybe<string>, taxDocYears: Array<string>, status?: Maybe<CompanyStatus>, taxExemptStatus?: Maybe<TaxExemptStatus>, checkIndustry?: Maybe<IndustryType>, tosVersion?: Maybe<string>, signatoryEmail: string, needsPayScheduleAssistance?: Maybe<boolean>, excludedStaffIds: Array<Maybe<string>>, startDate?: Maybe<any>, processingPeriod: ProcessingPeriod, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, companyBenefits: Array<Maybe<{ __typename?: 'CompanyBenefit', id: string, name: string, effectiveStart?: Maybe<any>, effectiveEnd?: Maybe<any> }>>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, canCancel: boolean }>, paydays?: Maybe<Array<Maybe<{ __typename?: 'CompanyPaydays', approvalDeadline: any, impactedByHoliday: boolean, payday: any }>>>, paySchedules: Array<Maybe<{ __typename?: 'PaySchedule', id: string, default: boolean, firstPayday: any, firstPeriodEnd: any, name?: Maybe<string>, payFrequency: PayScheduleFrequency }>>, goals: Array<{ __typename?: 'Goal', id: string, status: GoalStatus }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, defaultPayScheduleDays?: Maybe<Array<Maybe<{ __typename?: 'DefaultPayScheduleDays', approvalDeadline: any, impactedByWeekendOrHoliday: boolean, payday: any, periodEnd: any, periodStart: any }>>> };

export type EmployeePayrollItemsPartsFragment = { __typename?: 'Employee', id: string, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, status: OnboardStatus }>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, payrollItems: Array<{ __typename?: 'PayrollItem', id: string, netPay?: Maybe<number>, note?: Maybe<string>, grossPay: number, noteVisible?: Maybe<boolean>, paymentMethod?: Maybe<PaymentMethod>, payroll: { __typename?: 'Payroll', id: string, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus } }> };

export type ContractorPaymentPartsFragment = { __typename?: 'Contractor', id: string, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, status: OnboardStatus }>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, grossPay: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, payroll: { __typename?: 'Payroll', id: string, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus } }> };

export type TaxDocumentPartsFragment = { __typename?: 'TaxDocument', id: string, label: string, quarter?: Maybe<Quarter>, year: number, filedOn: string, description?: Maybe<string>, jurisdiction?: Maybe<string>, employeeId?: Maybe<string>, contractorId?: Maybe<string> };

export type CompanyTaxDocumentPartsFragment = { __typename?: 'Company', id: string, taxDocuments: Array<Maybe<{ __typename?: 'TaxDocument', id: string, label: string, quarter?: Maybe<Quarter>, year: number, filedOn: string, description?: Maybe<string>, jurisdiction?: Maybe<string>, employeeId?: Maybe<string>, contractorId?: Maybe<string> }>> };

export type TotalPartsFragment = { __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number };

export type ItemPartsFragment = { __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } };

export type ContractorPartsFragment = { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> };

export type ContractorMinimalPartsFragment = { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> };

export type PaymentPartsFragment = { __typename?: 'ContractorPayment', id: string, grossPay: number, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } };

export type PaymentMinimalPartsFragment = { __typename?: 'ContractorPayment', id: string, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, grossPay: number, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } };

export type PaginationPartsFragment = { __typename?: 'PayrollPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number };

export type PaginationItemPartsFragment = { __typename?: 'PayrollItemPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number };

export type PaginationPaymentPartsFragment = { __typename?: 'ContractorPaymentPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number };

export type PayrollPreviewPartsFragment = { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> };

export type PayrollWithItemsPartsFragment = { __typename?: 'Payroll', id: string, approvedAt?: Maybe<any>, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, grossPay: number, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> };

export type PayrollPartsFragment = { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, grossPay: number, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> };

export type PayrollWithoutNestedPaymentsPartsFragment = { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, approvedAt?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, grossPay: number, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> };

export type PayrollInfoPartsFragment = { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> };

export type PayrollItemsPaginatedPartsFragment = { __typename?: 'Payroll', id: string, itemsPage: { __typename?: 'PayrollItemPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number, results: Array<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }> } };

export type PayrollPaymentsPaginatedPartsFragment = { __typename?: 'Payroll', id: string, contractorPaymentsPage: { __typename?: 'ContractorPaymentPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number, results: Array<{ __typename?: 'ContractorPayment', id: string, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, grossPay: number, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }> } };

export type PayrollListPartsFragment = { __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, employeeCount?: Maybe<number>, contractorCount?: Maybe<number>, hasEmployeesWithMissingSSN: boolean, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> };

export type AddressPartsFragment = { __typename?: 'Address', id: string, city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string };

export type ProfileAddressPartsFragment = { __typename?: 'ProfileAddress', id: string, city?: Maybe<string>, country?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> };

export type CoreAddressPartsFragment = { __typename?: 'CoreAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zipCode?: Maybe<string> };

export type CompanyStatusPartsFragment = { __typename?: 'Company', id: string, status?: Maybe<CompanyStatus>, tosVersion?: Maybe<string>, excludedStaffIds: Array<Maybe<string>>, checkIndustry?: Maybe<IndustryType>, checkId?: Maybe<string>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus, targetEffectiveStart?: Maybe<string> }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, installId: string, validatedAt?: Maybe<any>, edition?: Maybe<string>, canCancel: boolean }> };

export type GetCompanyStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyStatusQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, status?: Maybe<CompanyStatus>, tosVersion?: Maybe<string>, excludedStaffIds: Array<Maybe<string>>, checkIndustry?: Maybe<IndustryType>, checkId?: Maybe<string>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus, targetEffectiveStart?: Maybe<string> }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, installId: string, validatedAt?: Maybe<any>, edition?: Maybe<string>, canCancel: boolean }> }> };

export type GetCompanyOnboardingStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyOnboardingStatusQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, status?: Maybe<CompanyStatus>, tosVersion?: Maybe<string>, excludedStaffIds: Array<Maybe<string>>, checkIndustry?: Maybe<IndustryType>, checkId?: Maybe<string>, employees: Array<Maybe<{ __typename?: 'Employee', id: string, checkId?: Maybe<string>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitWorkerOnboarding', status: BenefitOnboardStatus }> }>>, contractors: Array<Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitWorkerOnboarding', status: BenefitOnboardStatus }> }>>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus, targetEffectiveStart?: Maybe<string> }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, installId: string, validatedAt?: Maybe<any>, edition?: Maybe<string>, canCancel: boolean }> }> };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, checkId?: Maybe<string>, taxDocYears: Array<string>, status?: Maybe<CompanyStatus>, taxExemptStatus?: Maybe<TaxExemptStatus>, checkIndustry?: Maybe<IndustryType>, tosVersion?: Maybe<string>, signatoryEmail: string, needsPayScheduleAssistance?: Maybe<boolean>, excludedStaffIds: Array<Maybe<string>>, startDate?: Maybe<any>, processingPeriod: ProcessingPeriod, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, companyBenefits: Array<Maybe<{ __typename?: 'CompanyBenefit', id: string, name: string, effectiveStart?: Maybe<any>, effectiveEnd?: Maybe<any> }>>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, canCancel: boolean }>, paydays?: Maybe<Array<Maybe<{ __typename?: 'CompanyPaydays', approvalDeadline: any, impactedByHoliday: boolean, payday: any }>>>, paySchedules: Array<Maybe<{ __typename?: 'PaySchedule', id: string, default: boolean, firstPayday: any, firstPeriodEnd: any, name?: Maybe<string>, payFrequency: PayScheduleFrequency }>>, goals: Array<{ __typename?: 'Goal', id: string, status: GoalStatus }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, defaultPayScheduleDays?: Maybe<Array<Maybe<{ __typename?: 'DefaultPayScheduleDays', approvalDeadline: any, impactedByWeekendOrHoliday: boolean, payday: any, periodEnd: any, periodStart: any }>>> }> };

export type GetCompanyHasRunPayrollQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyHasRunPayrollQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', status?: Maybe<CompanyStatus>, hasRunPayroll: boolean }> };

export type GetCompanyLifecycleInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyLifecycleInfoQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, checkId?: Maybe<string>, taxDocYears: Array<string>, status?: Maybe<CompanyStatus>, taxExemptStatus?: Maybe<TaxExemptStatus>, checkIndustry?: Maybe<IndustryType>, tosVersion?: Maybe<string>, signatoryEmail: string, needsPayScheduleAssistance?: Maybe<boolean>, excludedStaffIds: Array<Maybe<string>>, startDate?: Maybe<any>, processingPeriod: ProcessingPeriod, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, companyBenefits: Array<Maybe<{ __typename?: 'CompanyBenefit', id: string, name: string, effectiveStart?: Maybe<any>, effectiveEnd?: Maybe<any> }>>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, canCancel: boolean }>, paydays?: Maybe<Array<Maybe<{ __typename?: 'CompanyPaydays', approvalDeadline: any, impactedByHoliday: boolean, payday: any }>>>, paySchedules: Array<Maybe<{ __typename?: 'PaySchedule', id: string, default: boolean, firstPayday: any, firstPeriodEnd: any, name?: Maybe<string>, payFrequency: PayScheduleFrequency }>>, goals: Array<{ __typename?: 'Goal', id: string, status: GoalStatus }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, defaultPayScheduleDays?: Maybe<Array<Maybe<{ __typename?: 'DefaultPayScheduleDays', approvalDeadline: any, impactedByWeekendOrHoliday: boolean, payday: any, periodEnd: any, periodStart: any }>>> }>, listPayroll: { __typename?: 'PayrollPage', totalCount: number } };

export type GetCompanyPaySchedulesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyPaySchedulesQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, checkId?: Maybe<string>, taxDocYears: Array<string>, status?: Maybe<CompanyStatus>, taxExemptStatus?: Maybe<TaxExemptStatus>, checkIndustry?: Maybe<IndustryType>, tosVersion?: Maybe<string>, signatoryEmail: string, needsPayScheduleAssistance?: Maybe<boolean>, excludedStaffIds: Array<Maybe<string>>, startDate?: Maybe<any>, processingPeriod: ProcessingPeriod, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, companyBenefits: Array<Maybe<{ __typename?: 'CompanyBenefit', id: string, name: string, effectiveStart?: Maybe<any>, effectiveEnd?: Maybe<any> }>>, deputyConnection?: Maybe<{ __typename?: 'DeputyConnection', hasAccessToken: boolean, canCancel: boolean }>, paydays?: Maybe<Array<Maybe<{ __typename?: 'CompanyPaydays', approvalDeadline: any, impactedByHoliday: boolean, payday: any }>>>, paySchedules: Array<Maybe<{ __typename?: 'PaySchedule', id: string, default: boolean, firstPayday: any, firstPeriodEnd: any, name?: Maybe<string>, payFrequency: PayScheduleFrequency }>>, goals: Array<{ __typename?: 'Goal', id: string, status: GoalStatus }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitCompanyOnboarding', status: CompanyBenefitOnboardStatus }>, checkOnboarding?: Maybe<{ __typename?: 'CheckCompanyOnboarding', id: string, blockingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, remainingSteps: Array<Maybe<CheckCompanyOnboardingSteps>>, status: CheckOnboardSteps }>, defaultPayScheduleDays?: Maybe<Array<Maybe<{ __typename?: 'DefaultPayScheduleDays', approvalDeadline: any, impactedByWeekendOrHoliday: boolean, payday: any, periodEnd: any, periodStart: any }>>> }>, getCoreCompany: { __typename?: 'CoreCompany', id: string, payDayOfWeek?: Maybe<number>, payDayOfMonth?: Maybe<number> } };

export type GetCompanyEstimatedBenefitsCostQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type GetCompanyEstimatedBenefitsCostQuery = { __typename?: 'Query', getCompanyEstimatedBenefitsCost?: Maybe<{ __typename?: 'BenefitCostEstimated', monthlyPremium: number }> };

export type ContractorProfilePartsFragment = { __typename?: 'Contractor', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, payType?: Maybe<ContractorPayType>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, contractorBusinessName?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, homeAddress?: Maybe<{ __typename?: 'ProfileAddress', id: string, city?: Maybe<string>, country?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }> };

export type EmployeeProfilePartsFragment = { __typename?: 'Employee', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, payType?: Maybe<PaymentType>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, remainingSteps: Array<EmployeeOnboardingSteps>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, contractorBusinessName?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, homeAddress?: Maybe<{ __typename?: 'ProfileAddress', id: string, city?: Maybe<string>, country?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }>, workplaces: Array<{ __typename?: 'Workplace', id: string, active: boolean, default: boolean, name?: Maybe<string>, address: { __typename?: 'Address', id: string, city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string } }> };

export type GetCompanyStaffQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyStaffQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, contractors: Array<Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, payType?: Maybe<ContractorPayType>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, contractorBusinessName?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, homeAddress?: Maybe<{ __typename?: 'ProfileAddress', id: string, city?: Maybe<string>, country?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }> }>>, employees: Array<Maybe<{ __typename?: 'Employee', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, payType?: Maybe<PaymentType>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, remainingSteps: Array<EmployeeOnboardingSteps>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, contractorBusinessName?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, homeAddress?: Maybe<{ __typename?: 'ProfileAddress', id: string, city?: Maybe<string>, country?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }>, workplaces: Array<{ __typename?: 'Workplace', id: string, active: boolean, default: boolean, name?: Maybe<string>, address: { __typename?: 'Address', id: string, city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string } }> }>> }> };

export type GetFullStaffQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetFullStaffQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, contractors: Array<Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string>, paymentMethodPreference?: Maybe<PaymentMethod>, createdAt?: Maybe<any>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, workplaces: Array<{ __typename?: 'Workplace', id: string }> }>>, employees: Array<Maybe<{ __typename?: 'Employee', id: string, checkId?: Maybe<string>, paymentMethodPreference?: Maybe<PaymentMethod>, createdAt?: Maybe<any>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', remainingSteps: Array<EmployeeOnboardingSteps>, status: OnboardStatus }>, workplaces: Array<{ __typename?: 'Workplace', id: string }> }>> }>, getCoreCompany: { __typename?: 'CoreCompany', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, active: boolean, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, contractorBusinessName?: Maybe<string>, isContractor?: Maybe<boolean>, contractorType?: Maybe<CoreContractorType>, employeeType?: Maybe<CoreEmployeeType>, payRate?: Maybe<string>, payType?: Maybe<CoreEmployeePaytype>, startDate?: Maybe<string>, title?: Maybe<string> }>, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, dob?: Maybe<any>, phone?: Maybe<string>, email: string, address?: Maybe<{ __typename?: 'CoreAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }> }> } };

export type GetCompanyPoliciesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyPoliciesQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', id: string, policies: Array<{ __typename?: 'CorePolicy', id: string, name: string, icon: string, archivedAt?: Maybe<any> }>, documents: Array<{ __typename?: 'CoreDocument', id: string, name: string }> } };

export type TaxDocumentsQueryVariables = Exact<{
  id: Scalars['ID'];
  data: CompanyTaxDocumentsInput;
}>;


export type TaxDocumentsQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, taxDocuments: Array<Maybe<{ __typename?: 'TaxDocument', companyId?: Maybe<string>, contractorId?: Maybe<string>, employeeId?: Maybe<string>, id: string, label: string, quarter?: Maybe<Quarter>, year: number, filedOn: string, description?: Maybe<string>, jurisdiction?: Maybe<string> }>> }> };

export type ListPayrollQueryVariables = Exact<{
  companyId?: Maybe<Scalars['ID']>;
  orderBy?: Maybe<PayrollOrderByInput>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  advancedWhere?: Maybe<PayrollAdvancedWhereInput>;
}>;


export type ListPayrollQuery = { __typename?: 'Query', listPayroll: { __typename?: 'PayrollPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number, results: Array<Maybe<{ __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, employeeCount?: Maybe<number>, contractorCount?: Maybe<number>, hasEmployeesWithMissingSSN: boolean, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> }>> } };

export type ListPayrollCountQueryVariables = Exact<{
  companyId?: Maybe<Scalars['ID']>;
}>;


export type ListPayrollCountQuery = { __typename?: 'Query', listPayroll: { __typename?: 'PayrollPage', totalCount: number } };

export type CompanyPayrollCountQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyPayrollCountQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', countPayroll: number } };

export type GetPayrollQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPayrollQuery = { __typename?: 'Query', getPayroll?: Maybe<{ __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, approvedAt?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }>>>, contractorPayments: Array<{ __typename?: 'ContractorPayment', id: string, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, grossPay: number, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> }> };

export type GetPayrollInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPayrollInfoQuery = { __typename?: 'Query', getPayroll?: Maybe<{ __typename?: 'Payroll', id: string, approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, withdrawDate?: Maybe<any>, needsChecksEntered?: Maybe<boolean>, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, quickbooksSyncAttempt?: Maybe<{ __typename?: 'SyncAttempt', id: string, status: string, attemptedAt?: Maybe<any> }>, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }>, offCycleOptions?: Maybe<{ __typename?: 'OffcycleOptions', forceSupplementalWithholding?: Maybe<boolean>, applyBenefits?: Maybe<boolean>, applyPostTaxDeductions?: Maybe<boolean> }> }> };

export type GetPayrollItemsPaginatedQueryVariables = Exact<{
  companyId: Scalars['ID'];
  payrollId: Scalars['ID'];
  itemOrderBy?: Maybe<PayrollItemOrderByInput>;
  itemLimit?: Maybe<Scalars['Int']>;
  itemPage?: Maybe<Scalars['Int']>;
  itemAdvancedWhere?: Maybe<PayrollItemAdvancedWhereInput>;
}>;


export type GetPayrollItemsPaginatedQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', getPayrollWithCompanyRoles?: Maybe<{ __typename?: 'Payroll', id: string, itemsPage: { __typename?: 'PayrollItemPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number, results: Array<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }> } }> } };

export type GetPayrollPaymentsPaginatedQueryVariables = Exact<{
  companyId: Scalars['ID'];
  payrollId: Scalars['ID'];
  paymentOrderBy?: Maybe<ContractorPaymentOrderByInput>;
  paymentLimit?: Maybe<Scalars['Int']>;
  paymentPage?: Maybe<Scalars['Int']>;
  paymentAdvancedWhere?: Maybe<ContractorPaymentAdvancedWhereInput>;
}>;


export type GetPayrollPaymentsPaginatedQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', getPayrollWithCompanyRoles?: Maybe<{ __typename?: 'Payroll', id: string, contractorPaymentsPage: { __typename?: 'ContractorPaymentPage', limit: number, nextPage: boolean, page: number, prevPage: boolean, totalCount: number, results: Array<{ __typename?: 'ContractorPayment', id: string, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, grossPay: number, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }> } }> } };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', getEmployee?: Maybe<{ __typename?: 'Employee', id: string }> };

export type GetEmployeeTaxDocsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEmployeeTaxDocsQuery = { __typename?: 'Query', getEmployee?: Maybe<{ __typename?: 'Employee', id: string, taxDocuments?: Maybe<Array<Maybe<{ __typename?: 'TaxDocument', id: string, label: string, quarter?: Maybe<Quarter>, year: number, filedOn: string, description?: Maybe<string>, jurisdiction?: Maybe<string>, employeeId?: Maybe<string>, contractorId?: Maybe<string> }>>> }> };

export type EmployeeStatusPartsFragment = { __typename?: 'Employee', id: string, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, checkId?: Maybe<string>, deputyId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, remainingSteps: Array<EmployeeOnboardingSteps>, blockingSteps: Array<EmployeeOnboardingSteps> }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitWorkerOnboarding', status: BenefitOnboardStatus }> };

export type GetEmployeeStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEmployeeStatusQuery = { __typename?: 'Query', getEmployee?: Maybe<{ __typename?: 'Employee', id: string, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, checkId?: Maybe<string>, deputyId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, remainingSteps: Array<EmployeeOnboardingSteps>, blockingSteps: Array<EmployeeOnboardingSteps> }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitWorkerOnboarding', status: BenefitOnboardStatus }> }> };

export type GetContractorTaxDocsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetContractorTaxDocsQuery = { __typename?: 'Query', getContractor?: Maybe<{ __typename?: 'Contractor', id: string, taxDocuments?: Maybe<Array<Maybe<{ __typename?: 'TaxDocument', id: string, label: string, quarter?: Maybe<Quarter>, year: number, filedOn: string, description?: Maybe<string>, jurisdiction?: Maybe<string>, employeeId?: Maybe<string>, contractorId?: Maybe<string> }>>> }> };

export type ContractorStatusPartsFragment = { __typename?: 'Contractor', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, blockingSteps: Array<Maybe<ContractorOnboardingSteps>> }> };

export type GetContractorStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetContractorStatusQuery = { __typename?: 'Query', getContractor?: Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, blockingSteps: Array<Maybe<ContractorOnboardingSteps>> }> }> };

export type GetWorkerStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkerStatusQuery = { __typename?: 'Query', getEmployee?: Maybe<{ __typename?: 'Employee', id: string, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, checkId?: Maybe<string>, deputyId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, remainingSteps: Array<EmployeeOnboardingSteps>, blockingSteps: Array<EmployeeOnboardingSteps> }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitWorkerOnboarding', status: BenefitOnboardStatus }> }>, getContractor?: Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, blockingSteps: Array<Maybe<ContractorOnboardingSteps>> }> }> };

export type GetEmployeePayrollItemsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEmployeePayrollItemsQuery = { __typename?: 'Query', getEmployee?: Maybe<{ __typename?: 'Employee', id: string, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, status: OnboardStatus }>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, payrollItems: Array<{ __typename?: 'PayrollItem', id: string, netPay?: Maybe<number>, note?: Maybe<string>, grossPay: number, noteVisible?: Maybe<boolean>, paymentMethod?: Maybe<PaymentMethod>, payroll: { __typename?: 'Payroll', id: string, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus } }> }> };

export type GetContractorPaymentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetContractorPaymentsQuery = { __typename?: 'Query', getContractor?: Maybe<{ __typename?: 'Contractor', id: string, paymentMethodPreference?: Maybe<PaymentMethod>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, status: OnboardStatus }>, bankAccounts?: Maybe<Array<Maybe<{ __typename?: 'BankAccount', id: string, institutionName: string, mask: string, subType: Subtype, name?: Maybe<string> }>>>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, grossPay: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, payroll: { __typename?: 'Payroll', id: string, payday: any, periodEnd: any, periodStart: any, status: PayrollStatus } }> }> };

export type ListWorkplaceQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type ListWorkplaceQuery = { __typename?: 'Query', listWorkplace: Array<{ __typename?: 'Workplace', id: string, default: boolean, name?: Maybe<string>, active: boolean, address: { __typename?: 'Address', id: string, city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string } }> };

export type GetCompanyDefaultPayScheduleDaysQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyDefaultPayScheduleDaysQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, defaultPayScheduleDays?: Maybe<Array<Maybe<{ __typename?: 'DefaultPayScheduleDays', approvalDeadline: any, impactedByWeekendOrHoliday: boolean, payday: any, periodEnd: any, periodStart: any }>>> }> };

export type UserPartsFragment = { __typename?: 'CoreUser', id: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, phone?: Maybe<string>, dob?: Maybe<any>, email: string, avatarUrl?: Maybe<string>, address?: Maybe<{ __typename?: 'CoreAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zipCode?: Maybe<string> }> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, payType?: Maybe<CoreEmployeePaytype>, employeeType?: Maybe<CoreEmployeeType>, payRate?: Maybe<string>, startDate?: Maybe<string>, isContractor?: Maybe<boolean>, title?: Maybe<string>, stateWorksIn?: Maybe<string>, contractorBusinessName?: Maybe<string>, contractorType?: Maybe<CoreContractorType>, workerRoles: Array<{ __typename?: 'WorkerRole', id: string, isPrimary: boolean, payRate: number, deletedAt?: Maybe<any>, payType: WorkerRolePaytype, companyRole?: Maybe<{ __typename?: 'CompanyRole', id: string, title: string }> }> }> };

export type GetUserEditInfoQueryVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type GetUserEditInfoQuery = { __typename?: 'Query', getCoreUserById: { __typename?: 'CoreUser', id: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, phone?: Maybe<string>, dob?: Maybe<any>, email: string, avatarUrl?: Maybe<string>, address?: Maybe<{ __typename?: 'CoreAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zipCode?: Maybe<string> }> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, payType?: Maybe<CoreEmployeePaytype>, employeeType?: Maybe<CoreEmployeeType>, payRate?: Maybe<string>, startDate?: Maybe<string>, isContractor?: Maybe<boolean>, title?: Maybe<string>, stateWorksIn?: Maybe<string>, contractorBusinessName?: Maybe<string>, contractorType?: Maybe<CoreContractorType>, workerRoles: Array<{ __typename?: 'WorkerRole', id: string, isPrimary: boolean, payRate: number, deletedAt?: Maybe<any>, payType: WorkerRolePaytype, companyRole?: Maybe<{ __typename?: 'CompanyRole', id: string, title: string }> }> }> }, getEmployee?: Maybe<{ __typename?: 'Employee', id: string, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, checkId?: Maybe<string>, deputyId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, workplaces: Array<{ __typename?: 'Workplace', id: string }>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', id: string, remainingSteps: Array<EmployeeOnboardingSteps>, blockingSteps: Array<EmployeeOnboardingSteps> }>, benefitOnboarding?: Maybe<{ __typename?: 'BenefitWorkerOnboarding', status: BenefitOnboardStatus }> }>, getContractor?: Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string>, createdAt?: Maybe<any>, paymentMethodPreference?: Maybe<PaymentMethod>, workplaces: Array<{ __typename?: 'Workplace', id: string }>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, remainingSteps: Array<Maybe<ContractorOnboardingSteps>>, blockingSteps: Array<Maybe<ContractorOnboardingSteps>> }> }>, getCompany?: Maybe<{ __typename?: 'Company', id: string, excludedStaffIds: Array<Maybe<string>>, checkId?: Maybe<string>, status?: Maybe<CompanyStatus> }> };

export type GetCompanyRolesQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetCompanyRolesQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', id: string, companyRoles?: Maybe<Array<{ __typename?: 'CompanyRole', id: string, title: string, deletedAt?: Maybe<any>, createdAt: any, workerRoles?: Maybe<Array<{ __typename?: 'WorkerRole', id: string, deletedAt?: Maybe<any> }>> }>> } };

export type GetUserRolesQueryVariables = Exact<{
  userId: Scalars['ID'];
  showDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type GetUserRolesQuery = { __typename?: 'Query', getCoreUserById: { __typename?: 'CoreUser', id: string, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, workerRoles: Array<{ __typename?: 'WorkerRole', id: string, isPrimary: boolean, payRate: number, deletedAt?: Maybe<any>, payType: WorkerRolePaytype, companyRole?: Maybe<{ __typename?: 'CompanyRole', id: string, title: string }> }> }> } };

export type GetMfaEnrollmentsQueryVariables = Exact<{
  includeUncomfirmed?: Maybe<Scalars['Boolean']>;
}>;


export type GetMfaEnrollmentsQuery = { __typename?: 'Query', getMyMfaEnrollments: Array<{ __typename?: 'AuthMfaConfig', mfaType: AuthMfaType }> };

export type GetTrainingUserHistoryQueryVariables = Exact<{
  data: UserQueryInput;
  filter: UserTrainingFilterInput;
}>;


export type GetTrainingUserHistoryQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, training: { __typename?: 'UserTraining', history: Array<Maybe<{ __typename?: 'UserCourse', id: string, bundleId: string, topicId: string, bundleName: string, completedAt?: Maybe<any>, enrolledAt?: Maybe<any>, startedAt?: Maybe<any>, name: string, certificateDownloadUrl?: Maybe<string>, topics: Array<Maybe<{ __typename?: 'CourseTopic', id: string }>> }>> } } };

export type GetPayrollOnboardingInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPayrollOnboardingInfoQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, checkIndustry?: Maybe<IndustryType>, processedPayrollsThisYear: boolean, signatoryEmail: string, signatoryFirstName: string, signatoryLastName: string, signatoryTitle: string, onboardingOffersEmployeeBenefits: boolean, onboardingHasGarnishmentsOrDeductions?: Maybe<boolean>, onboardingGarnishmentsOrDeductions: Array<OnboardingGarnishmentOrDeduction>, onboardingGarnishmentsOrDeductionsOther: string }>, getCoreCompany: { __typename?: 'CoreCompany', id: string, name: string, dba?: Maybe<string>, fein?: Maybe<string>, numOfFullTimeHourlyEmployees?: Maybe<number>, numOfFullTimeSalaryEmployees?: Maybe<number>, numOfPartTimeEmployees?: Maybe<number>, numOfContractors?: Maybe<number>, phone?: Maybe<string>, website?: Maybe<string>, address: { __typename?: 'CoreAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> } } };

export type GetPayrollFeinStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPayrollFeinStatusQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, feinVerificationAttempts: number, feinVerification?: Maybe<{ __typename?: 'CheckFEINVerification', id: string, legalName: string, federalEin: string, status: string, company: string }> }> };

export type CompanyGoalPartsFragment = { __typename?: 'Goal', category: GoalCategory, id: string, name: string, label: string, required: boolean, status: GoalStatus, requirements: Array<{ __typename?: 'Requirement', checkId?: Maybe<string>, completedAt?: Maybe<any>, id: string, requirementType: RequirementType, requirementTypeExt?: Maybe<string>, status: RequirementStatus, requirementName: string, documentOptions: Array<{ __typename?: 'DocumentOption', id: DocumentOptionType, label: string, name: string }>, uploadedFiles?: Maybe<Array<{ __typename?: 'UploadedFile', id: string, name: string, type: DocumentType }>>, errors: Array<{ __typename?: 'RequirementError', type: RequirementErrorConst, label: string, id: string, description?: Maybe<string> }> }> };

export type GetTimesheetsQueryVariables = Exact<{
  payrollId: Scalars['ID'];
}>;


export type GetTimesheetsQuery = { __typename?: 'Query', payroll?: Maybe<{ __typename?: 'Payroll', id: string, itemsPage: { __typename?: 'PayrollItemPage', results: Array<{ __typename?: 'PayrollItem', id: string, timesheetHours?: Maybe<{ __typename?: 'TimesheetAggregate', totalHours: number, overtimeHours: number, regularHours: number, holidayHours: number, sickHours: number, ptoHours: number }>, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string> }>, user?: Maybe<{ __typename?: 'CoreUser', profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, avatarUrl?: Maybe<string> }> }> } }> }, contractorPaymentsPage: { __typename?: 'ContractorPaymentPage', results: Array<{ __typename?: 'ContractorPayment', id: string, timesheetHours?: Maybe<{ __typename?: 'TimesheetAggregate', totalHours: number, overtimeHours: number, regularHours: number, holidayHours: number, sickHours: number, ptoHours: number }>, contractor: { __typename?: 'Contractor', id: string, payRate: number, payType?: Maybe<ContractorPayType>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string> }>, user?: Maybe<{ __typename?: 'CoreUser', profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, avatarUrl?: Maybe<string> }> }> } }> } }> };

export type GetTimesheetsByRoleQueryVariables = Exact<{
  payrollId: Scalars['ID'];
}>;


export type GetTimesheetsByRoleQuery = { __typename?: 'Query', payroll?: Maybe<{ __typename?: 'Payroll', id: string, itemsPage: { __typename?: 'PayrollItemPage', results: Array<{ __typename?: 'PayrollItem', id: string, timesheetHoursByRole?: Maybe<Array<Maybe<{ __typename?: 'TimesheetAggregate', totalHours: number, overtimeHours: number, regularHours: number, holidayHours: number, sickHours: number, ptoHours: number, role?: Maybe<{ __typename?: 'TimesheetRole', title: string, payRate: string }> }>>>, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string> }>, user?: Maybe<{ __typename?: 'CoreUser', profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, avatarUrl?: Maybe<string> }> }> } }> }, contractorPaymentsPage: { __typename?: 'ContractorPaymentPage', results: Array<{ __typename?: 'ContractorPayment', id: string, timesheetHoursByRole?: Maybe<Array<Maybe<{ __typename?: 'TimesheetAggregate', totalHours: number, overtimeHours: number, regularHours: number, holidayHours: number, sickHours: number, ptoHours: number, role?: Maybe<{ __typename?: 'TimesheetRole', title: string, payRate: string }> }>>>, contractor: { __typename?: 'Contractor', id: string, payRate: number, payType?: Maybe<ContractorPayType>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string> }>, user?: Maybe<{ __typename?: 'CoreUser', profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, avatarUrl?: Maybe<string> }> }> } }> } }> };

export type GetCompanyGoalsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyGoalsQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, goals: Array<{ __typename?: 'Goal', category: GoalCategory, id: string, name: string, label: string, required: boolean, status: GoalStatus, requirements: Array<{ __typename?: 'Requirement', checkId?: Maybe<string>, completedAt?: Maybe<any>, id: string, requirementType: RequirementType, requirementTypeExt?: Maybe<string>, status: RequirementStatus, requirementName: string, documentOptions: Array<{ __typename?: 'DocumentOption', id: DocumentOptionType, label: string, name: string }>, uploadedFiles?: Maybe<Array<{ __typename?: 'UploadedFile', id: string, name: string, type: DocumentType }>>, errors: Array<{ __typename?: 'RequirementError', type: RequirementErrorConst, label: string, id: string, description?: Maybe<string> }> }> }> }> };

export type GetPayrollTasksQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPayrollTasksQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, goals: Array<{ __typename?: 'Goal', id: string, status: GoalStatus, required: boolean }> }> };

export type GetPayrollPayItemsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPayrollPayItemsQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', id: string, getPayroll?: Maybe<{ __typename?: 'Payroll', approvalDeadline?: Maybe<any>, deletedAt?: Maybe<any>, draftLiability?: Maybe<number>, id: string, status: PayrollStatus, statusChangedAt: any, type: PayrollType, version: number, contractorPayments: Array<{ __typename?: 'ContractorPayment', basePayRate: number, checkNumber?: Maybe<string>, grossPay: number, hasDeletedWorkerRole: boolean, id: string, payType: ContractorPayType, version: number, contractor: { __typename?: 'Contractor', id: string, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, id: string, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', contractorBusinessName?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, employeeType?: Maybe<string>, firstName?: Maybe<string>, id: string, lastName?: Maybe<string>, title?: Maybe<string> }> }, payroll: { __typename?: 'Payroll', id: string, version: number } }>, items?: Maybe<Array<Maybe<{ __typename?: 'PayrollItem', grossPay: number, checkNumber?: Maybe<string>, hasDeletedWorkerRole: boolean, id: string, netPay?: Maybe<number>, sickBalanceHours?: Maybe<number>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckEmployeeOnboarding', blockingSteps: Array<EmployeeOnboardingSteps>, id: string, status: OnboardStatus }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', employeeType?: Maybe<string>, firstName?: Maybe<string>, id: string, lastName?: Maybe<string>, title?: Maybe<string> }> }, payroll: { __typename?: 'Payroll', id: string, version: number } }>>> }> } };

export type GetPayrollItemQueryVariables = Exact<{
  companyId: Scalars['ID'];
  payrollId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPayrollItemQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', id: string, getPayrollWithCompanyRoles?: Maybe<{ __typename?: 'Payroll', id: string, payrollItem?: Maybe<{ __typename?: 'PayrollItem', id: string, basePayRate: number, hasDeletedWorkerRole: boolean, grossPay: number, checkNumber?: Maybe<string>, netPay?: Maybe<number>, note?: Maybe<string>, paymentMethod?: Maybe<PaymentMethod>, ptoBalanceHours?: Maybe<number>, sickBalanceHours?: Maybe<number>, noteVisible?: Maybe<boolean>, version: number, employee: { __typename?: 'Employee', id: string, payRate: number, payType?: Maybe<PaymentType>, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<EmployeeOnboardingSteps>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, employeeType?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string> }> }, earnings: Array<{ __typename?: 'Earning', id: string, amount?: Maybe<number>, description?: Maybe<string>, minutes?: Maybe<number>, decimal?: Maybe<number>, source: SourceType, type: EarningType, workerRoleId?: Maybe<string>, subtype?: Maybe<EarningSubtype> }>, reimbursements: Array<Maybe<{ __typename?: 'Reimbursement', id: string, amount: number }>>, benefits?: Maybe<Array<Maybe<{ __typename?: 'PayrollBenefit', benefit: string, companyContributionAmount?: Maybe<string>, employeeContributionAmount?: Maybe<string>, description?: Maybe<string> }>>>, postTaxDeductions?: Maybe<Array<Maybe<{ __typename?: 'PostTaxDeductionItem', amount: number, description: string, type: string }>>>, taxes?: Maybe<Array<Maybe<{ __typename?: 'Tax', amount: number, description: string, payer: Payer, remittable?: Maybe<boolean> }>>>, payroll: { __typename?: 'Payroll', id: string, version: number, totals?: Maybe<{ __typename?: 'Totals', cashRequirement: number, companyBenefits: number, companyTaxes: number, contractorGross: number, contractorNet: number, contractorReimbursements: number, employeeBenefits: number, employeeGross: number, employeeNet: number, employeeReimbursements: number, employeeTaxes: number, liability: number, postTaxDeductions: number }> } }> }> } };

export type GetContractorPaymentQueryVariables = Exact<{
  companyId: Scalars['ID'];
  payrollId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetContractorPaymentQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', id: string, getPayrollWithCompanyRoles?: Maybe<{ __typename?: 'Payroll', id: string, contractorPayment?: Maybe<{ __typename?: 'ContractorPayment', id: string, grossPay: number, hasDeletedWorkerRole: boolean, basePayRate: number, checkNumber?: Maybe<string>, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, contractor: { __typename?: 'Contractor', id: string, payRate: number, paymentMethodPreference?: Maybe<PaymentMethod>, remainingOnboardingSteps: Array<ContractorOnboardingSteps>, checkOnboarding?: Maybe<{ __typename?: 'CheckContractorOnboarding', id: string, blockingSteps: Array<Maybe<ContractorOnboardingSteps>>, status: OnboardStatus }>, payments: Array<{ __typename?: 'ContractorPayment', id: string, basePayRate: number, note?: Maybe<string>, noteVisible?: Maybe<boolean>, payType: ContractorPayType, paymentMethod?: Maybe<PaymentMethod>, version: number, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, decimal?: Maybe<number>, type: PaymentEntryType, workerRoleId?: Maybe<string> }>, payroll: { __typename?: 'Payroll', id: string, version: number } }>, profile?: Maybe<{ __typename?: 'EmployeeProfile', id: string, firstName?: Maybe<string>, lastName?: Maybe<string>, title?: Maybe<string>, employeeType?: Maybe<string>, email?: Maybe<string>, contractorType?: Maybe<PayrollContractorType>, contractorBusinessName?: Maybe<string> }> }, entries: Array<{ __typename?: 'PaymentEntry', id: string, amount?: Maybe<number>, minutes?: Maybe<number>, workerRoleId?: Maybe<string>, type: PaymentEntryType }>, payroll: { __typename?: 'Payroll', id: string, version: number } }> }> } };

export type CoreTaskPartsFragment = { __typename?: 'CoreTask', id: string, completedAt?: Maybe<any>, completionStatus?: Maybe<TaskCompletionStatus>, label: string, name: TaskName, startedAt?: Maybe<any>, startedBy?: Maybe<string>, copy: { __typename?: 'CoreTaskCopy', cta?: Maybe<string>, estimated?: Maybe<string>, confirmCta?: Maybe<string>, denyCta?: Maybe<string>, details?: Maybe<Array<{ __typename?: 'CoreTaskCopyDetails', title: string, items: Array<string> }>> } };

export type CoreGoalPartsFragment = { __typename?: 'CoreGoal', id: string, completedAt?: Maybe<any>, completionStatus?: Maybe<GoalCompletionStatus>, label: string, name: GoalName, taskNames: Array<TaskName>, updatedAt?: Maybe<any>, copy: { __typename?: 'CoreGoalCopy', description: string, estimated: string } };

export type GetMyCompanyGoalsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMyCompanyGoalsQuery = { __typename?: 'Query', getMyCompanyGoals: Array<{ __typename?: 'CoreGoal', id: string, completedAt?: Maybe<any>, completionStatus?: Maybe<GoalCompletionStatus>, label: string, name: GoalName, taskNames: Array<TaskName>, updatedAt?: Maybe<any>, tasks: Array<{ __typename?: 'CoreTask', id: string, completedAt?: Maybe<any>, completionStatus?: Maybe<TaskCompletionStatus>, label: string, name: TaskName, startedAt?: Maybe<any>, startedBy?: Maybe<string>, copy: { __typename?: 'CoreTaskCopy', cta?: Maybe<string>, estimated?: Maybe<string>, confirmCta?: Maybe<string>, denyCta?: Maybe<string>, details?: Maybe<Array<{ __typename?: 'CoreTaskCopyDetails', title: string, items: Array<string> }>> } }>, copy: { __typename?: 'CoreGoalCopy', description: string, estimated: string } }>, getCompany?: Maybe<{ __typename?: 'Company', id: string, status?: Maybe<CompanyStatus>, onboardingOffersEmployeeBenefits: boolean, onboardingHasGarnishmentsOrDeductions?: Maybe<boolean>, onboardingHasComplexScenario?: Maybe<boolean>, onboardingHasComplexTimeAttendanceScenario?: Maybe<boolean>, pastPayrollUsage?: Maybe<PastPayrollUsage>, total?: Maybe<{ __typename?: 'Total', missingEmployeeDetails: number, onboardedEmployees: number, payrollEmployees: number }> }> };

export type GetCoreCompanyEmployeesForOnboardingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCoreCompanyEmployeesForOnboardingQuery = { __typename?: 'Query', coreCompany: { __typename?: 'CoreCompany', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, email: string, phone?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, isContractor?: Maybe<boolean> }>, employee?: Maybe<{ __typename?: 'Employee', id: string, checkId?: Maybe<string> }>, contractor?: Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string> }> }> } };

export type GetCompanyPayrollHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyPayrollHistoryQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, pastPayrollUsage?: Maybe<PastPayrollUsage> }> };

export type GetPayrollSignatoryInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPayrollSignatoryInfoQuery = { __typename?: 'Query', payrollCompany?: Maybe<{ __typename?: 'PayrollCompany', id: string, signatoryFirstName: string, signatoryLastName: string, signatoryTitle: string, signatoryEmail: string }> };

export type GetCompanyAddressesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyAddressesQuery = { __typename?: 'Query', coreCompany: { __typename?: 'CoreCompany', id: string, address: { __typename?: 'CoreAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }, mailingAddress?: Maybe<{ __typename?: 'CoreMailingAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }>, legalAddress?: Maybe<{ __typename?: 'CoreLegalAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }, listWorkplace: Array<{ __typename?: 'Workplace', id: string, default: boolean, address: { __typename?: 'Address', city: string, country: string, line1: string, line2?: Maybe<string>, state: string, zip: string } }> };

export type GetBambeePlusInfoQueryVariables = Exact<{
  data: PurchaseBambeePlusInput;
  companyId: Scalars['ID'];
}>;


export type GetBambeePlusInfoQuery = { __typename?: 'Query', getBambeePlusInfo: { __typename?: 'BambeePlus', id: string, eligible: boolean, status: BambeePlusStatuses, price?: Maybe<number>, onboardingDueDate?: Maybe<any>, hasExtendedOnboardingDeadline: boolean, lateFeeImplementationPrice?: Maybe<number> }, coreCompany: { __typename?: 'CoreCompany', id: string, legalAddress?: Maybe<{ __typename?: 'CoreLegalAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }>, employees: Array<{ __typename?: 'CoreUser', id: string, employee?: Maybe<{ __typename?: 'Employee', id: string, checkId?: Maybe<string> }> }> }, payrollCompany?: Maybe<{ __typename?: 'PayrollCompany', id: string, pastPayrollUsage?: Maybe<PastPayrollUsage>, signatoryEmail: string, signatoryFirstName: string, signatoryLastName: string, signatoryTitle: string, feinVerification?: Maybe<{ __typename?: 'CheckFEINVerification', id: string, status: string }> }>, getMyCompanyGoals: Array<{ __typename?: 'CoreGoal', id: string, completedAt?: Maybe<any>, completionStatus?: Maybe<GoalCompletionStatus>, label: string, name: GoalName, taskNames: Array<TaskName>, updatedAt?: Maybe<any>, tasks: Array<{ __typename?: 'CoreTask', id: string, completedAt?: Maybe<any>, completionStatus?: Maybe<TaskCompletionStatus>, label: string, name: TaskName, startedAt?: Maybe<any>, startedBy?: Maybe<string>, copy: { __typename?: 'CoreTaskCopy', cta?: Maybe<string>, estimated?: Maybe<string>, confirmCta?: Maybe<string>, denyCta?: Maybe<string>, details?: Maybe<Array<{ __typename?: 'CoreTaskCopyDetails', title: string, items: Array<string> }>> } }>, copy: { __typename?: 'CoreGoalCopy', description: string, estimated: string } }> };

export type GetBasicCompanyInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBasicCompanyInfoQuery = { __typename?: 'Query', coreCompany: { __typename?: 'CoreCompany', id: string, name: string, phone?: Maybe<string>, industry?: Maybe<string> } };

export type GetBambeePlusDeadlineQueryVariables = Exact<{
  data: PurchaseBambeePlusInput;
}>;


export type GetBambeePlusDeadlineQuery = { __typename?: 'Query', getBambeePlusInfo: { __typename?: 'BambeePlus', id: string, eligible: boolean, status: BambeePlusStatuses, onboardingDueDate?: Maybe<any>, lateFeeImplementationPrice?: Maybe<number> } };

export type GetDeputyTosInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDeputyTosInfoQuery = { __typename?: 'Query', getCompany?: Maybe<{ __typename?: 'Company', id: string, deputyTosAcceptedAt?: Maybe<any> }> };

export type GetSimplePolicyListQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetSimplePolicyListQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', policies: Array<{ __typename?: 'CorePolicy', id: string, isCPD: boolean, name: string }> } };

export type CourseTopicPartsFragment = { __typename?: 'CourseTopic', id: string, price?: Maybe<number>, name: string, description?: Maybe<string>, duration?: Maybe<number>, imageUrl?: Maybe<string>, states?: Maybe<Array<Maybe<string>>>, tags?: Maybe<Array<Maybe<string>>>, key: string };

export type GetTrainingCompanyQueryVariables = Exact<{
  data: GetCompanyInput;
}>;


export type GetTrainingCompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, availableProducts: { __typename?: 'AvailableProducts', id: string, topics: Array<{ __typename?: 'CourseTopic', id: string, price?: Maybe<number>, name: string, description?: Maybe<string>, duration?: Maybe<number>, imageUrl?: Maybe<string>, states?: Maybe<Array<Maybe<string>>>, tags?: Maybe<Array<Maybe<string>>>, key: string }>, bundles: Array<{ __typename?: 'BundleResponse', id: string, global: boolean, name: string, price?: Maybe<number>, topics: Array<Maybe<{ __typename?: 'CourseTopic', id: string, price?: Maybe<number>, name: string, description?: Maybe<string>, duration?: Maybe<number>, imageUrl?: Maybe<string>, states?: Maybe<Array<Maybe<string>>>, tags?: Maybe<Array<Maybe<string>>>, key: string }>> }> }, purchasedProducts: { __typename?: 'PurchasedProducts', id: string, bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', id: string, name: string, description?: Maybe<string>, totalSeats: number, unfilledSeats: number, topics: Array<Maybe<{ __typename?: 'PurchasedTopic', id: string, name: string }>> }>>, topics: Array<Maybe<{ __typename?: 'PurchasedTopic', id: string, name: string, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }> }>> } } };

export type GetBillingHistoryQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetBillingHistoryQuery = { __typename?: 'Query', getBillingHistory: Array<{ __typename?: 'Statement', id: string, amount: number, attemptCount: number, createdAt: any, hostedUrl?: Maybe<string>, lastAttemptError?: Maybe<number>, pdfUrl?: Maybe<string>, statementType: StatementType, status: StatementStatus, productKey?: Maybe<ProductKey>, serviceKey?: Maybe<ServiceKey>, modifiedAt?: Maybe<any>, stripeSubscriptionId?: Maybe<string> }> };

export type GetTrainingRequestsQueryVariables = Exact<{
  data: RequestFilterInput;
}>;


export type GetTrainingRequestsQuery = { __typename?: 'Query', requests?: Maybe<Array<{ __typename?: 'CoreRequest', approvalCriteria: number, approverRoles?: Maybe<Array<Maybe<AuthRole>>>, companyId: string, createdAt: any, description?: Maybe<string>, expiresAt?: Maybe<any>, id: string, rejectionCriteria: number, requestedAt: Array<any>, resourceId: string, resourceType: RequestResourceType, status: RequestStatus, updatedAt: any, userId: string, decisions?: Maybe<Array<Maybe<{ __typename?: 'CoreRequestDecision', createdAt: any, id: string, requestId: string, result: ApprovalResult, role: AuthRole, updatedAt: any, userId: string }>>>, user: { __typename?: 'CoreUser', id: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, avatarUrl?: Maybe<string>, firstName: string, lastName: string }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, title?: Maybe<string> }> } }>> };

export type GetMyTrainingRequestsQueryVariables = Exact<{
  data: MyRequestFilterInput;
}>;


export type GetMyTrainingRequestsQuery = { __typename?: 'Query', myRequests?: Maybe<Array<{ __typename?: 'CoreRequest', approvalCriteria: number, approverRoles?: Maybe<Array<Maybe<AuthRole>>>, companyId: string, createdAt: any, description?: Maybe<string>, expiresAt?: Maybe<any>, id: string, rejectionCriteria: number, requestedAt: Array<any>, resourceId: string, resourceType: RequestResourceType, status: RequestStatus, updatedAt: any, userId: string, decisions?: Maybe<Array<Maybe<{ __typename?: 'CoreRequestDecision', createdAt: any, id: string, requestId: string, result: ApprovalResult, role: AuthRole, updatedAt: any, userId: string }>>>, user: { __typename?: 'CoreUser', id: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, avatarUrl?: Maybe<string>, firstName: string, lastName: string }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, title?: Maybe<string> }> } }>> };

export type GetTrainingRecommendationsQueryVariables = Exact<{
  data: RecommendationFilterInput;
}>;


export type GetTrainingRecommendationsQuery = { __typename?: 'Query', recommendations?: Maybe<Array<{ __typename?: 'CoreRecommendation', id: string, targets: Array<string>, resourceType: string, resourceId: string, status: RecommendationStatus, scope: RecommendationScope }>> };

export type GetPendingHotlineCallsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingHotlineCallsQuery = { __typename?: 'Query', pendingHotlineCall?: Maybe<{ __typename?: 'HotlineCall', id: string, status: HotlineCallStatus, summary?: Maybe<string> }> };

export type GetCompanySubscriptionsQueryVariables = Exact<{
  data: GetCompanySubscriptionsInput;
}>;


export type GetCompanySubscriptionsQuery = { __typename?: 'Query', companySubscriptions: Array<{ __typename?: 'Subscription', productCode: ProductKey, status: SubscriptionStatus, stripePriceId: string, stripeId: string, name: string, isDrp: boolean }> };

export type GetPricingPackagesQueryVariables = Exact<{
  data: PricingPackageFilterInput;
}>;


export type GetPricingPackagesQuery = { __typename?: 'Query', getPricingPackages: { __typename?: 'PricingPackageResponse', packages: Array<{ __typename?: 'PricingPackage', type: PricingPackageType, plans: Array<Maybe<{ __typename?: 'CorePlanModel', annual?: Maybe<boolean>, billingPeriod: BillingPeriod, chatOnly?: Maybe<boolean>, price: number, priceId: string, setupFee?: Maybe<number>, setupFeeDiscount?: Maybe<number>, maxSize?: Maybe<number>, minSize?: Maybe<number>, monthlyPrice: number, name: string, tierNumber?: Maybe<number>, value: string, status: PlanStatuses }>> }> } };

export type GetHotlineCallsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHotlineCallsQuery = { __typename?: 'Query', hotlineCalls: Array<{ __typename?: 'HotlineCall', id: string, createdAt: any, callPlacedAt?: Maybe<any>, callDuration?: Maybe<number>, status: HotlineCallStatus, summary?: Maybe<string>, agent?: Maybe<{ __typename?: 'HotlineCallAgent', id: string, avatarUrl?: Maybe<string>, name?: Maybe<string> }> }> };

export type GetUpgradeOptionsQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetUpgradeOptionsQuery = { __typename?: 'Query', coreUpgradeOptions: Array<{ __typename?: 'PreviewCorePlanChangeModel', prorationDate: any, next: { __typename?: 'CorePlanChangeInvoice', tax: number, total: number }, plan: { __typename?: 'CorePlanModel', maxSize?: Maybe<number>, minSize?: Maybe<number>, monthlyPrice: number, price: number, priceId: string, productKey: ProductKey, tierNumber?: Maybe<number>, billingPeriod: BillingPeriod, value: string }, upcoming: { __typename?: 'UpcomingCorePlanChangeInvoice', remainingAmount: number, tax: number, total: number, unusedAmount: number, totalDue: number } }> };

export type GetLatestPricingPackagesForTierQueryVariables = Exact<{
  tierNumber: Scalars['Float'];
  getLatestPricingPackagesForTierInput: ActivePlanFilters;
}>;


export type GetLatestPricingPackagesForTierQuery = { __typename?: 'Query', getLatestPricingPackagesForTier: { __typename?: 'PricingPackageResponse', packages: Array<{ __typename?: 'PricingPackage', type: PricingPackageType, plans: Array<Maybe<{ __typename?: 'CorePlanModel', name: string, billingPeriod: BillingPeriod, monthlyPrice: number, productKey: ProductKey, priceId: string, value: string, billingFeature?: Maybe<BillingFeature> }>> }> } };

export type GetGeneralPayrollCompanyQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetGeneralPayrollCompanyQuery = { __typename?: 'Query', coreCompany: { __typename?: 'CoreCompany', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, active: boolean, employee?: Maybe<{ __typename?: 'Employee', id: string, checkId?: Maybe<string>, payType?: Maybe<PaymentType> }>, contractor?: Maybe<{ __typename?: 'Contractor', id: string, checkId?: Maybe<string>, payType?: Maybe<ContractorPayType> }> }> }, listWorkplace: Array<{ __typename?: 'Workplace', id: string }>, getCompany?: Maybe<{ __typename?: 'Company', id: string, total?: Maybe<{ __typename?: 'Total', onboardedEmployees: number, missingEmployeeDetails: number, payrollEmployees: number }> }> };

export type GetCancellationReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCancellationReasonsQuery = { __typename?: 'Query', activeCancellationReasonGroups: Array<{ __typename?: 'CancellationReasonGroupModel', code: string, externalText: string, reasons: Array<{ __typename?: 'CancellationReasonModel', code: number, active: boolean, externalText: string }> }> };

export type PlanPartsFragment = { __typename?: 'CorePlanModel', price: number, priceId: string, tierNumber?: Maybe<number>, value: string, billingPeriod: BillingPeriod, productKey: ProductKey, monthlyPrice: number, minSize?: Maybe<number>, maxSize?: Maybe<number>, name: string, pause?: Maybe<boolean> };

export type CancellationOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type CancellationOffersQuery = { __typename?: 'Query', cancellationOffers: { __typename?: 'CancellationOffersModel', trialExtension: boolean, downgradePlans: Array<{ __typename?: 'CorePlanModel', price: number, priceId: string, tierNumber?: Maybe<number>, value: string, billingPeriod: BillingPeriod, productKey: ProductKey, monthlyPrice: number, minSize?: Maybe<number>, maxSize?: Maybe<number>, name: string, pause?: Maybe<boolean> }>, pausePlan?: Maybe<{ __typename?: 'CorePlanModel', price: number, priceId: string, tierNumber?: Maybe<number>, value: string, billingPeriod: BillingPeriod, productKey: ProductKey, monthlyPrice: number, minSize?: Maybe<number>, maxSize?: Maybe<number>, name: string, pause?: Maybe<boolean> }>, storagePlan?: Maybe<{ __typename?: 'CorePlanModel', price: number, priceId: string, tierNumber?: Maybe<number>, value: string, billingPeriod: BillingPeriod, productKey: ProductKey, monthlyPrice: number, minSize?: Maybe<number>, maxSize?: Maybe<number>, name: string, pause?: Maybe<boolean> }> } };

export type GetBillingInfoQueryVariables = Exact<{
  input: GetBillingInfoInput;
}>;


export type GetBillingInfoQuery = { __typename?: 'Query', getBillingInfo: { __typename?: 'BillingInfo', addonSubscriptions: Array<{ __typename?: 'SubscriptionModel', id: string, active: boolean, quantity?: Maybe<number>, periodEndsAt: any, plan: { __typename?: 'PlanModel', annual?: Maybe<boolean>, value: string, name: string, productKey: ProductKey, price?: Maybe<number>, volumeBased?: Maybe<boolean>, billingPeriod: BillingPeriod, serviceKey: ServiceKey } }>, coreSubscription?: Maybe<{ __typename?: 'CoreSubscriptionModel', id: string, cancellationRequested: boolean, cancelsAt?: Maybe<any>, active: boolean, trialEndsAt?: Maybe<any>, trialing: boolean, periodEndsAt: any, scheduledPlanChange?: Maybe<{ __typename?: 'ScheduledCorePlanChangeModel', id: string, effectiveOn: any, newPlan: { __typename?: 'CorePlanModel', billingPeriod: BillingPeriod, name: string, productKey: ProductKey } }>, plan: { __typename?: 'CorePlanModel', maxSize?: Maybe<number>, minSize?: Maybe<number>, price: number, productKey: ProductKey, billingPeriod: BillingPeriod, name: string, employeeSizeMapping?: Maybe<string> } }>, pause: { __typename?: 'Paused', id: string, isPaused: boolean, reactivatesOn?: Maybe<any> } } };

export type GetNonCoreSubscriptionBillingChangesQueryVariables = Exact<{
  data: GetCompanyUpcomingBillingChangesInput;
}>;


export type GetNonCoreSubscriptionBillingChangesQuery = { __typename?: 'Query', getNonCoreSubscriptionBillingChanges: Array<{ __typename?: 'UpcomingNonCoreSubscriptionBillingChange', serviceKey: ServiceKey, productKey: ProductKey, minSize: number, maxSize?: Maybe<number>, upcomingMonthlyPrice?: Maybe<number>, upcomingYearlyPrice?: Maybe<number> }> };

export type GetBillingInfoPaymentMethodsQueryVariables = Exact<{
  input: GetBillingInfoInput;
}>;


export type GetBillingInfoPaymentMethodsQuery = { __typename?: 'Query', getBillingInfo: { __typename?: 'BillingInfo', id: string, paymentMethods: Array<{ __typename?: 'BillingPaymentMethod', id: string, default: boolean, expirationDate?: Maybe<any>, name: string, nextAction?: Maybe<PaymentMethodNextAction>, status: PaymentMethodStatus, type: PaymentMethodType }> } };

export type GetProductInterestQueryVariables = Exact<{
  input: GetProductInterestInput;
}>;


export type GetProductInterestQuery = { __typename?: 'Query', productInterest: Array<{ __typename?: 'ProductInterest', id: string, productKey: ProductKey, productSubKey?: Maybe<ProductSubKey> }> };

export type IsEventScheduledForUserQueryVariables = Exact<{
  email: Scalars['String'];
  eventSlug: Scalars['String'];
}>;


export type IsEventScheduledForUserQuery = { __typename?: 'Query', isEventScheduledForUser: { __typename?: 'IsEventScheduledForUser', email: string, eventSlug: string, isScheduled: boolean } };

export type FindOnboardingQueryVariables = Exact<{
  data: CoreOnboardingKeys;
  id: Scalars['ID'];
}>;


export type FindOnboardingQuery = { __typename?: 'Query', findOnboarding?: Maybe<{ __typename?: 'CoreOnboarding', id: string, version: number, status: OnboardingStatus, data: { __typename?: 'CoreOnboardingData', discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>, companyName?: Maybe<string>, companyLegalName?: Maybe<string>, companyType?: Maybe<CompanyType>, fein?: Maybe<string>, noFeinOrDoesNotKnow?: Maybe<boolean>, incorporatedInOtherState?: Maybe<boolean>, incorporatedState?: Maybe<StateAbbreviation>, isOwner?: Maybe<boolean>, primaryContact?: Maybe<boolean>, willHaveAdditionalContact?: Maybe<boolean>, numOfEmployees?: Maybe<number>, numOfContractors?: Maybe<number>, needsHelpConvertingContractors?: Maybe<boolean>, hasRemoteEmployees?: Maybe<boolean>, remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>, nextAction?: Maybe<NextOnboardingAction>, hasScheduledCall?: Maybe<boolean>, callEventId?: Maybe<string>, progress?: Maybe<number>, discussionTopicDetails?: Maybe<Array<Maybe<{ __typename?: 'DisucssionTopicDetail', topic: DiscussionTopic, detail: string }>>>, address?: Maybe<{ __typename?: 'CoreAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> } }>, coreCompany: { __typename?: 'CoreCompany', id: string, whatBroughtYouToBambee?: Maybe<LeadReason> } };

export type FindOnboardingStatusQueryVariables = Exact<{
  data: CoreOnboardingKeys;
}>;


export type FindOnboardingStatusQuery = { __typename?: 'Query', findOnboarding?: Maybe<{ __typename?: 'CoreOnboarding', id: string, status: OnboardingStatus, data: { __typename?: 'CoreOnboardingData', id: string, progress?: Maybe<number>, callEventId?: Maybe<string> } }> };

export type ProductPartsFragment = { __typename?: 'Product', id: string, name?: Maybe<string>, price?: Maybe<number>, key: ProductKey, subscriptionPrice?: Maybe<number>, activeSubscription?: Maybe<boolean>, creditBalance: number, tier?: Maybe<number> };

export type GetCompanyProductsQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetCompanyProductsQuery = { __typename?: 'Query', getCompanyProducts: Array<{ __typename?: 'Product', id: string, name?: Maybe<string>, price?: Maybe<number>, key: ProductKey, subscriptionPrice?: Maybe<number>, activeSubscription?: Maybe<boolean>, creditBalance: number, tier?: Maybe<number> }> };

export type GetAvailableProductsQueryVariables = Exact<{
  data: GetAvailableProductsInput;
}>;


export type GetAvailableProductsQuery = { __typename?: 'Query', getAvailableProducts: Array<{ __typename?: 'AvailableProduct', monthlyAllowance?: Maybe<number>, billingPeriod?: Maybe<string>, id: string, price?: Maybe<number>, key: ProductKey, name?: Maybe<string>, subscriptionPrice?: Maybe<number>, tier?: Maybe<number>, discountedPrice?: Maybe<number> }> };

export type GetCompanyCreditsQueryVariables = Exact<{
  data: GetCompanyCreditsInputV2;
}>;


export type GetCompanyCreditsQuery = { __typename?: 'Query', getCompanyCreditsV2: Array<{ __typename?: 'Credit', productKey: ProductKey, consumedAt?: Maybe<any> }> };

export type GetEligibleAddonsQueryVariables = Exact<{
  input: EligibleAddonsInput;
}>;


export type GetEligibleAddonsQuery = { __typename?: 'Query', getEligibleAddons: { __typename?: 'EligibleAddonsResponse', payroll: Array<{ __typename?: 'PayrollPlanModel', serviceKey: ServiceKey, productKey: ProductKey, name: string, value: string, priceId: string, price?: Maybe<number>, billingPeriod: BillingPeriod, status: PlanStatuses, minSize: number, maxSize?: Maybe<number>, unitPriceId?: Maybe<string>, unitPrice?: Maybe<number>, version: string }> } };

export type PayrollStatusQueryVariables = Exact<{
  payrollCompanyId: Scalars['ID'];
}>;


export type PayrollStatusQuery = { __typename?: 'Query', payrollCompany?: Maybe<{ __typename?: 'PayrollCompany', status?: Maybe<CompanyStatus> }> };

export type AssignUserToPolicyMutationVariables = Exact<{
  data: AssignUserToPoliciesInput;
}>;


export type AssignUserToPolicyMutation = { __typename?: 'Mutation', assignUserToPolicies: Array<{ __typename?: 'CoreDocument', id: string, name: string, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }> };

export type AssignUsersToPoliciesMutationVariables = Exact<{
  data: AssignUsersToPoliciesInput;
}>;


export type AssignUsersToPoliciesMutation = { __typename?: 'Mutation', assignUsersToPolicies: Array<{ __typename?: 'CoreUser', id: string, documents?: Maybe<Array<{ __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }>> }> };

export type ReaffirmEmployeeDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type ReaffirmEmployeeDocumentMutation = { __typename?: 'Mutation', reaffirmDocument: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>> } };

export type ArchivePolicyMutationVariables = Exact<{
  input: ArchivePolicyInput;
}>;


export type ArchivePolicyMutation = { __typename?: 'Mutation', archivePolicy?: Maybe<{ __typename?: 'CorePolicy', id: string }> };

export type CoreDocumentSignaturePartsFragment = { __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> };

export type CoreDocumentPartsFragment = { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> };

export type CoreUserStatesPartsFragment = { __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean };

export type CoreUserPartsFragment = { __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> };

export type CorePolicyPartsFragment = { __typename?: 'CorePolicy', id: string, isCPD: boolean, name: string, icon: string, status: string, isContractor: boolean, step?: Maybe<PolicyStepNames>, recipients: Array<{ __typename?: 'CorePolicyRecipient', id: string, document: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }, employee: { __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> } }>, notSentTo: Array<{ __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> }> };

export type GetPolicyQueryVariables = Exact<{
  input: GetPolicy;
}>;


export type GetPolicyQuery = { __typename?: 'Query', getPolicy?: Maybe<{ __typename?: 'CorePolicy', id: string, isCPD: boolean, name: string, icon: string, status: string, isContractor: boolean, step?: Maybe<PolicyStepNames>, recipients: Array<{ __typename?: 'CorePolicyRecipient', id: string, document: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }, employee: { __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> } }>, notSentTo: Array<{ __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> }> }> };

export type ReaffirmDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type ReaffirmDocumentMutation = { __typename?: 'Mutation', reaffirmDocument: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> } };

export type PolicyDataTableQueryVariables = Exact<{ [key: string]: never; }>;


export type PolicyDataTableQuery = { __typename?: 'Query', getMyCoreUser: { __typename?: 'CoreUser', id: string, company?: Maybe<{ __typename?: 'CoreCompany', id: string, policies: Array<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any>, isCPD: boolean, createdAt?: Maybe<any>, status: string, recipients: Array<{ __typename?: 'CorePolicyRecipient', id: string, document: { __typename?: 'CoreDocument', reaffirmations?: Maybe<Array<any>>, id: string, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, signedAt: any }> } }> }> }> } };

export type CreateReportCardMutationVariables = Exact<{
  data: CreateReportCardInput;
}>;


export type CreateReportCardMutation = { __typename?: 'Mutation', createReportCard: { __typename: 'NewReportCard', existing: boolean, report: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } } };

export type UpdateReportCardMutationVariables = Exact<{
  data: UpdateReportCardInput;
}>;


export type UpdateReportCardMutation = { __typename?: 'Mutation', updateReportCard: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type CompleteReportCardMutationVariables = Exact<{
  data: CompleteReportCardInput;
}>;


export type CompleteReportCardMutation = { __typename?: 'Mutation', completeReportCard: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type ReportCardUserPartsFragment = { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> };

export type ReportCardEmployeeGradePartsFragment = { __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } };

export type ManagedReportPartsFragment = { __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } };

export type ReportCardPartsFragment = { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> };

export type NewReportCardPartsFragment = { __typename: 'NewReportCard', existing: boolean, report: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type GetReportCardListQueryVariables = Exact<{
  data: ListReportCardsInput;
}>;


export type GetReportCardListQuery = { __typename?: 'Query', listReportCards: Array<{ __typename?: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, employees: Array<{ __typename?: 'ReportCardEmployeeGrade', id: string, grade: string }> }> };

export type GetReportCardQueryVariables = Exact<{
  data: GetReportCardInput;
}>;


export type GetReportCardQuery = { __typename?: 'Query', getReportCard: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type TrackProductInterestMutationVariables = Exact<{
  data: ProductInterestInput;
}>;


export type TrackProductInterestMutation = { __typename?: 'Mutation', trackProductInterest: string };

export type CreateHrRequestMutationVariables = Exact<{
  input: CreateHrRequestInput;
}>;


export type CreateHrRequestMutation = { __typename?: 'Mutation', createHrRequest: { __typename?: 'HrRequest', id: string, intercomConversationId?: Maybe<string>, caseId: string } };

export type ReplyToConversationMutationVariables = Exact<{
  input: ReplyToConversationInput;
}>;


export type ReplyToConversationMutation = { __typename?: 'Mutation', replyToConversation: { __typename?: 'Conversation', id: string, intercomConversationId: string, messages: Array<{ __typename?: 'ConversationMessage', body?: Maybe<string>, createdAt: any, inBound: boolean, attachments?: Maybe<Array<{ __typename?: 'ConversationMessageAttachment', contentType: string, name: string, type: string, url: string }>> }> } };

export type CancelScheduledEventMutationVariables = Exact<{
  input: CancelScheduledEventInput;
}>;


export type CancelScheduledEventMutation = { __typename?: 'Mutation', cancelScheduledEvent: { __typename?: 'ScheduledEvent', calendlyEventId: string, id: string, cancelled?: Maybe<boolean> } };

export type UploadFilesToConversationMutationVariables = Exact<{
  input: UploadFilesToConversationInput;
}>;


export type UploadFilesToConversationMutation = { __typename?: 'Mutation', uploadFilesToConversation: { __typename?: 'Conversation', id: string, intercomConversationId: string, subject: string, messages: Array<{ __typename?: 'ConversationMessage', body?: Maybe<string>, createdAt: any, inBound: boolean, attachments?: Maybe<Array<{ __typename?: 'ConversationMessageAttachment', contentType: string, name: string, type: string, url: string }>> }> } };

export type GetHrRequestOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrRequestOptionsQuery = { __typename?: 'Query', getHrRequestOptions: { __typename?: 'HrRequestOptionsResponse', groups: Array<{ __typename?: 'HrRequestGroup', key: HrRequestGroupKey, icon: string, title: string }>, options: Array<{ __typename?: 'HrRequestOption', title: string, description: string, groupKey: HrRequestGroupKey, type: HrRequestType, subType?: Maybe<HrRequestSubType>, slug: HrRequestSlug, audience: Array<HrRequestAudience>, requiresPrimaryHrm: boolean, keywords: Array<string>, unlisted?: Maybe<boolean>, popular?: Maybe<{ __typename?: 'HrRequestOptionPopular', order: number, title?: Maybe<string>, description?: Maybe<string> }>, expectation?: Maybe<{ __typename?: 'HrRequestExpectation', cycleTime: string, description?: Maybe<string> }> }> } };

export type GetHrRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrRequestsQuery = { __typename?: 'Query', getHrRequests: { __typename?: 'ListHrRequestsResponse', hrRequests: Array<Maybe<{ __typename?: 'HrRequest', id: string }>> } };

export type HrRequestQueryVariables = Exact<{
  input: GetHrRequestByIdInput;
}>;


export type HrRequestQuery = { __typename?: 'Query', hrRequest: { __typename?: 'HrRequest', id: string, conversation?: Maybe<{ __typename?: 'Conversation', id: string, intercomConversationId: string, subject: string, messages: Array<{ __typename?: 'ConversationMessage', body?: Maybe<string>, inBound: boolean }> }> } };

export type HrRequestAiInformationQueryVariables = Exact<{
  input: GetHrRequestByIdInput;
}>;


export type HrRequestAiInformationQuery = { __typename?: 'Query', hrRequest: { __typename?: 'HrRequest', id: string, caseId: string, aiGenerated?: Maybe<string>, aiArtifacts?: Maybe<Array<Maybe<string>>>, threadId?: Maybe<string> } };

export type GetOnboardingCalendlyConfigQueryVariables = Exact<{
  input: OnboardingCalendlyConfigInput;
}>;


export type GetOnboardingCalendlyConfigQuery = { __typename?: 'Query', getOnboardingCalendlyConfig: { __typename?: 'OnboardingCalendlyConfig', link: string, tierNumber: number, zone: SchedulerZone } };

export type GetConversationByIntercomIdQueryVariables = Exact<{
  input: GetConversationByIntercomIdInput;
}>;


export type GetConversationByIntercomIdQuery = { __typename?: 'Query', getConversationByIntercomId: { __typename?: 'Conversation', id: string, intercomConversationId: string, subject: string, createdAt: any, inBound: boolean, messages: Array<{ __typename?: 'ConversationMessage', createdAt: any, body?: Maybe<string>, inBound: boolean, attachments?: Maybe<Array<{ __typename?: 'ConversationMessageAttachment', type: string, name: string, contentType: string, url: string }>> }> } };

export type GetHrRequestListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrRequestListQuery = { __typename?: 'Query', hrRequestList: { __typename?: 'ListHrRequestDetails', hrRequests: Array<Maybe<{ __typename?: 'HrRequestDetail', caseId: string, caseNumber?: Maybe<string>, completionDate?: Maybe<any>, createdDate?: Maybe<any>, description?: Maybe<string>, expectationDate?: Maybe<any>, hrRequestSurveyAnswers?: Maybe<any>, intercomId?: Maybe<string>, isComplete?: Maybe<boolean>, isOverdue?: Maybe<boolean>, lastModifiedDate?: Maybe<any>, status: CaseStatus, subType?: Maybe<CaseSubType>, subject?: Maybe<string>, type?: Maybe<CaseType>, aiMetadata?: Maybe<string> }>> } };

export type GetScheduledEventsQueryVariables = Exact<{
  input: GetScheduledEventsForUserInput;
}>;


export type GetScheduledEventsQuery = { __typename?: 'Query', getScheduledEventsForUser: Array<{ __typename?: 'ScheduledEvent', id: string, attendeeEmails?: Maybe<Array<string>>, missedCallFeeStatus?: Maybe<MissedCallFeeStatus>, title: string, calendlyEventId: string, startTime: any, endTime: any, eventLocation: SchedulerEventLocation, videoConferenceLink?: Maybe<string>, phoneNumber?: Maybe<string>, calendlyInviteeId: string, cancelled?: Maybe<boolean>, kind: string, agent?: Maybe<{ __typename?: 'CallAgent', avatarUrl?: Maybe<string>, id: string, name?: Maybe<string>, role?: Maybe<string> }>, callSummaries: Array<{ __typename?: 'CallSummary', actionItems?: Maybe<string>, approvedAt?: Maybe<any>, callDurationInMinutes?: Maybe<number>, createdAt: any, followUps?: Maybe<string>, isApproved?: Maybe<boolean>, summary?: Maybe<string>, agent?: Maybe<{ __typename?: 'CallAgent', avatarUrl?: Maybe<string>, id: string, name?: Maybe<string>, role?: Maybe<string> }> }> }> };

export type GetRescheduleLinkQueryVariables = Exact<{
  input: GetCalendlyRescheduleLinkInput;
}>;


export type GetRescheduleLinkQuery = { __typename?: 'Query', getRescheduleLink: string };

export type HrRequestExtendedDetailQueryVariables = Exact<{
  input: GetHrRequestExtendedDetailByIdInput;
}>;


export type HrRequestExtendedDetailQuery = { __typename?: 'Query', hrRequestExtendedDetail: { __typename?: 'HrRequestExtendedDetail', caseId: string, intercomId?: Maybe<string>, caseNumber?: Maybe<string>, type?: Maybe<CaseType>, subType?: Maybe<CaseSubType>, status: CaseStatus, expectationDate?: Maybe<any>, lastModifiedDate?: Maybe<any>, createdDate?: Maybe<any>, completionDate?: Maybe<any>, isComplete?: Maybe<boolean>, isOverdue?: Maybe<boolean>, subject?: Maybe<string>, description?: Maybe<string>, hrRequestSurveyAnswers?: Maybe<any>, createdBy?: Maybe<string>, summary?: Maybe<string>, ownerId?: Maybe<string>, companyId: string, aiSummary?: Maybe<string>, aiMetadata?: Maybe<string>, agent?: Maybe<{ __typename?: 'CallAgent', id: string, name?: Maybe<string>, avatarUrl?: Maybe<string>, role?: Maybe<string> }>, timeline: Array<{ __typename?: 'TimelineItem', eventType: TimelineEventType, eventTime: any, oldValue?: Maybe<string>, newValue?: Maybe<string> }>, scheduledEvents: Array<{ __typename?: 'ScheduledEvent', id: string, calendlyEventId: string }>, policies?: Maybe<Array<{ __typename?: 'HrRequestPolicy', id: string, name: string, displayName: string, description: string, icon: string, step: string, status: PolicyStatus, createdAt: any, kind: PolicyKind }>>, relatedCases?: Maybe<Array<{ __typename?: 'RelatedCase', caseId: string, subject: string }>> } };

export type GetAskNicelyWebSurveyInfoQueryVariables = Exact<{
  input: GetAskNicelyWebSurveyInfoInput;
}>;


export type GetAskNicelyWebSurveyInfoQuery = { __typename?: 'Query', getAskNicelyWebSurveyInfo: { __typename?: 'AskNicelySurveyInfo', emailHash?: Maybe<string>, force: boolean, show: boolean } };

export type CloseHrRequestMutationVariables = Exact<{
  input: CloseHrRequestInput;
}>;


export type CloseHrRequestMutation = { __typename?: 'Mutation', closeHrRequest: { __typename?: 'HrRequest', id: string, caseId: string, conversationId?: Maybe<string>, intercomConversationId?: Maybe<string>, customerCompanyId: string, createdAt: any, aiGenerated?: Maybe<string>, aiArtifacts?: Maybe<Array<Maybe<string>>>, threadId?: Maybe<string> } };

export type SetCaseStatusMutationVariables = Exact<{
  input: SetCaseStatusInput;
}>;


export type SetCaseStatusMutation = { __typename?: 'Mutation', setCaseStatus: { __typename?: 'HrRequest', id: string, caseId: string, conversationId?: Maybe<string>, intercomConversationId?: Maybe<string>, customerCompanyId: string, createdAt: any, aiGenerated?: Maybe<string>, aiArtifacts?: Maybe<Array<Maybe<string>>>, threadId?: Maybe<string> } };

export type CreateTerminationMutationVariables = Exact<{
  data: TerminationCreateInput;
}>;


export type CreateTerminationMutation = { __typename?: 'Mutation', createTermination: { __typename?: 'Termination', terminationId: string, employeeId: string, userId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, startDate?: Maybe<any>, confirmed: boolean, terminationState?: Maybe<string>, createdAt: any, complete: boolean } };

export type CreateResignationMutationVariables = Exact<{
  data: ResignationCreateInput;
}>;


export type CreateResignationMutation = { __typename?: 'Mutation', createResignation: { __typename?: 'Resignation', resignationId: string, employeeId: string, userId: string, status: ResignationStatus, step: ResignationStep, resignationDate?: Maybe<any>, resignationState?: Maybe<string>, confirmed: boolean, selfService: boolean, hrRequestId?: Maybe<string>, createdAt: any, complete: boolean } };

export type GetTerminationByHrRequestQueryVariables = Exact<{
  data: GetTerminationHrRequestInput;
}>;


export type GetTerminationByHrRequestQuery = { __typename?: 'Query', getTerminationByHrRequest: { __typename?: 'Termination', terminationId: string, employeeId: string, userId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, startDate?: Maybe<any>, confirmed: boolean, selfService: boolean, terminationState?: Maybe<string>, createdAt: any } };

export type GetResignationByHrRequestQueryVariables = Exact<{
  data: GetResignationHrRequestInput;
}>;


export type GetResignationByHrRequestQuery = { __typename?: 'Query', getResignationByHrRequest: { __typename?: 'Resignation', resignationId: string, employeeId: string, userId: string, status: ResignationStatus, step: ResignationStep, resignationDate?: Maybe<any>, startDate?: Maybe<any>, confirmed: boolean, selfService: boolean, resignationState?: Maybe<string>, createdAt: any } };

export type BulkPurchaseSeatsMutationVariables = Exact<{
  data: BulkPurchaseSeatsInput;
}>;


export type BulkPurchaseSeatsMutation = { __typename?: 'Mutation', bulkPurchaseSeats: Array<{ __typename?: 'PurchaseSeatsResponse', bundleId?: Maybe<string>, error?: Maybe<string>, id: string, numPurchased: number, topicId?: Maybe<string>, totalSeats: number }> };

export type EnrollmentResponsePartsFragment = { __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> };

export type BulkEnrollUsersResponsePartsFragment = { __typename?: 'BulkEnrollUsersResponse', enrolledUsers: Array<{ __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> }>, errors: Array<{ __typename?: 'EnrollUsersError', message: string, userIds?: Maybe<Array<string>>, topicId?: Maybe<string>, bundleId?: Maybe<string> }> };

export type BulkEnrollUsersMutationVariables = Exact<{
  data: BulkEnrollUsersInput;
}>;


export type BulkEnrollUsersMutation = { __typename?: 'Mutation', bulkEnrollUsers: { __typename?: 'BulkEnrollUsersResponse', enrolledUsers: Array<{ __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> }>, errors: Array<{ __typename?: 'EnrollUsersError', message: string, userIds?: Maybe<Array<string>>, topicId?: Maybe<string>, bundleId?: Maybe<string> }> } };

export type EnrollUsersMutationVariables = Exact<{
  data: EnrollUsersInput;
}>;


export type EnrollUsersMutation = { __typename?: 'Mutation', enrollUsers: { __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> } };

export type PurchaseSeatsForBundleMutationVariables = Exact<{
  data: PurchaseBundleSeatsInput;
}>;


export type PurchaseSeatsForBundleMutation = { __typename?: 'Mutation', purchaseSeatsForBundle: { __typename?: 'PurchaseSeatsResponse', numPurchased: number, totalSeats: number } };

export type RemoveSeatsFromBundleMutationVariables = Exact<{
  data: RemoveBundleSeatsInput;
}>;


export type RemoveSeatsFromBundleMutation = { __typename?: 'Mutation', removeSeatsFromBundle: { __typename?: 'RemoveSeatsResponse', numRemoved: number, totalSeats: number } };

export type PurchaseSeatsMutationVariables = Exact<{
  data: PurchaseSeatsInput;
}>;


export type PurchaseSeatsMutation = { __typename?: 'Mutation', purchaseSeats: { __typename?: 'PurchaseSeatsResponse', numPurchased: number, totalSeats: number } };

export type UnenrollUsersMutationVariables = Exact<{
  data: UnenrollUsersInput;
}>;


export type UnenrollUsersMutation = { __typename?: 'Mutation', unenrollUsers: { __typename?: 'UnenrolledUsers', id: string, successfullyUnenrolled: Array<Maybe<string>>, errors: Array<Maybe<string>> } };

export type UserCoursePartsFragment = { __typename?: 'UserCourse', id: string, courseId: string, ticketId: string, name: string, description?: Maybe<string>, topicName: string, topicId: string, bundleName: string, bundleId: string, state?: Maybe<string>, status: string, startedAt?: Maybe<any>, removedAt?: Maybe<any>, completedAt?: Maybe<any>, enrolledAt?: Maybe<any>, certificateId?: Maybe<string>, certificateDownloadUrl?: Maybe<string>, searchTag?: Maybe<string>, language?: Maybe<string>, userRole: string, doceboCourseId: string };

export type TopicPartsFragment = { __typename?: 'PurchasedTopic', name: string, topicId: string, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> };

export type FullCompanyPartsFragment = { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, users: Array<{ __typename?: 'User', language: Language, role: UserRole, state?: Maybe<State>, userId: string, userMngId?: Maybe<string> }>, availableProducts: { __typename?: 'AvailableProducts', bundles: Array<{ __typename?: 'BundleResponse', id: string, name: string, price?: Maybe<number>, topics: Array<Maybe<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }>> }>, topics: Array<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }> }, purchasedProducts: { __typename?: 'PurchasedProducts', topics: Array<Maybe<{ __typename?: 'PurchasedTopic', id: string, name: string, topicId: string, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>>, bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', id: string, name: string, bundleId: string, description?: Maybe<string>, totalSeats: number, unfilledSeats: number, counts: { __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }, topics: Array<Maybe<{ __typename?: 'PurchasedTopic', name: string, topicId: string, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>> }>> } };

export type ShortCompanyPartsFragment = { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, purchasedProducts: { __typename?: 'PurchasedProducts', bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', bundleId: string, name: string, totalSeats: number, unfilledSeats: number }>> } };

export type GetTrainingTrainingCompanyQueryVariables = Exact<{
  data: GetCompanyInput;
}>;


export type GetTrainingTrainingCompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, purchasedProducts: { __typename?: 'PurchasedProducts', bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', bundleId: string, name: string, totalSeats: number, unfilledSeats: number }>> } } };

export type GetCompanyVerboseQueryVariables = Exact<{
  data: GetCompanyInput;
}>;


export type GetCompanyVerboseQuery = { __typename?: 'Query', company: { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, users: Array<{ __typename?: 'User', language: Language, role: UserRole, state?: Maybe<State>, userId: string, userMngId?: Maybe<string> }>, availableProducts: { __typename?: 'AvailableProducts', bundles: Array<{ __typename?: 'BundleResponse', id: string, name: string, price?: Maybe<number>, topics: Array<Maybe<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }>> }>, topics: Array<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }> }, purchasedProducts: { __typename?: 'PurchasedProducts', topics: Array<Maybe<{ __typename?: 'PurchasedTopic', id: string, name: string, topicId: string, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>>, bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', id: string, name: string, bundleId: string, description?: Maybe<string>, totalSeats: number, unfilledSeats: number, counts: { __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }, topics: Array<Maybe<{ __typename?: 'PurchasedTopic', name: string, topicId: string, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>> }>> } } };

export type GetUserTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTokenQuery = { __typename?: 'Query', getUserToken: { __typename?: 'DoceboTokenResponse', expiresAt: any, token: string } };

export type GetUserCoursesQueryVariables = Exact<{
  data: UserCoursesInput;
}>;


export type GetUserCoursesQuery = { __typename?: 'Query', userCourses: Array<{ __typename?: 'UserCourse', id: string, courseId: string, ticketId: string, name: string, description?: Maybe<string>, topicName: string, topicId: string, bundleName: string, bundleId: string, state?: Maybe<string>, status: string, startedAt?: Maybe<any>, removedAt?: Maybe<any>, completedAt?: Maybe<any>, enrolledAt?: Maybe<any>, certificateId?: Maybe<string>, certificateDownloadUrl?: Maybe<string>, searchTag?: Maybe<string>, language?: Maybe<string>, userRole: string, doceboCourseId: string }> };

export type GetTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopicsQuery = { __typename?: 'Query', getTopics: Array<{ __typename?: 'CourseTopic', id: string, name: string, searchTag?: Maybe<string> }> };

export type GetCompanyTicketsQueryVariables = Exact<{
  data: ListTicketsInput;
}>;


export type GetCompanyTicketsQuery = { __typename?: 'Query', getTickets: { __typename?: 'ListTicketsResponse', totalTickets: number, tickets: Array<Maybe<{ __typename?: 'Ticket', id: string, topicId: string, bundleId: string, courseId?: Maybe<string>, userId?: Maybe<string>, stripeInvoiceId?: Maybe<string>, enrolledAt?: Maybe<any>, startedAt?: Maybe<any>, completedAt?: Maybe<any> }>> } };

export type GetTrainingPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrainingPricesQuery = { __typename?: 'Query', getTrainingPrices: { __typename?: 'TrainingPricesResponse', bundle: number, topic: number } };

export type GetCompanyTrainingStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompanyTrainingStatusQuery = { __typename?: 'Query', company: { __typename?: 'Company', hasTraining: boolean } };

export type UpdateCoreUserStateMutationVariables = Exact<{
  input: CoreUserStatesInput;
}>;


export type UpdateCoreUserStateMutation = { __typename?: 'Mutation', updateCoreUserState: { __typename?: 'CoreUserStates', viewedBciToHrPracticeModal: boolean, viewedBciToHrPracticeReportCardModal: boolean, viewedInAppUpgradeModal: boolean } };

export type CoreUserStatePartsFragment = { __typename?: 'CoreUserStates', viewedBciToHrPracticeModal: boolean, viewedBciToHrPracticeReportCardModal: boolean, viewedInAppUpgradeModal: boolean };

export type CoreUserEmploymentPartsFragment = { __typename?: 'CoreUserEmployment', workerRoles: Array<{ __typename?: 'WorkerRole', isPrimary: boolean, employeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> }> };

export type GetMyCoreUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCoreUserQuery = { __typename?: 'Query', getMyCoreUser: { __typename?: 'CoreUser', id: string, role: string, documents?: Maybe<Array<{ __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }>>, states?: Maybe<{ __typename?: 'CoreUserStates', viewedBciToHrPracticeModal: boolean, viewedBciToHrPracticeReportCardModal: boolean, viewedInAppUpgradeModal: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', workerRoles: Array<{ __typename?: 'WorkerRole', isPrimary: boolean, employeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> }> }> } };

export const AppliedPlansPartsFragmentDoc = gql`
    fragment AppliedPlansParts on Plan {
  id
  name
}
    `;
export const CouponPartsFragmentDoc = gql`
    fragment CouponParts on PlanCoupon {
  id
  name
  amountOff
  appliesToPlans {
    ...AppliedPlansParts
  }
  setupFeeOff
}
    ${AppliedPlansPartsFragmentDoc}`;
export const SubscriptionPartsFragmentDoc = gql`
    fragment SubscriptionParts on Subscription {
  name
  productCode
  amount
  status
  coupon {
    ...CouponParts
  }
  startDate
  endDate
  stripeId
  stripePriceId
  createdAt
  isDrp
}
    ${CouponPartsFragmentDoc}`;
export const BillingPlanPartsFragmentDoc = gql`
    fragment BillingPlanParts on PlanLock {
  active
  couponId
  plan
  setupFee
  trialDuration
}
    `;
export const CompanyDelinquencyPartsFragmentDoc = gql`
    fragment CompanyDelinquencyParts on CompanyDelinquency {
  delinquent
  delinquentSince
  lockout
  defaultCardVerificationStatus
}
    `;
export const BillingProductPartsFragmentDoc = gql`
    fragment BillingProductParts on Product {
  id
  name
  key
  creditBalance
  price
  subscriptionPrice
  activeSubscription
}
    `;
export const ProductResultPartsFragmentDoc = gql`
    fragment ProductResultParts on PurchaseResult {
  createdAt
  creditsPurchased
  productKey
  id
  status
}
    `;
export const PaymentSourcePartsFragmentDoc = gql`
    fragment PaymentSourceParts on PaymentSource {
  addressCity
  addressCountry
  addressLine1
  addressLine2
  addressState
  addressZip
  brand
  country
  cvcCheck
  default
  dynamicLast4
  expMonth
  expYear
  funding
  id
  last4
  name
}
    `;
export const PaymentSourcesPartsFragmentDoc = gql`
    fragment PaymentSourcesParts on PaymentSources {
  companyId
  sources {
    ...PaymentSourceParts
  }
}
    ${PaymentSourcePartsFragmentDoc}`;
export const PracticePartsFragmentDoc = gql`
    fragment PracticeParts on Practice {
  id
  status
  setupProgress
  state
  title
  shortName
  shortDescription
  description
  introDescription
  iconUrl
  illustrationUrl
  outroIllustrationUrl
  successOutroTitle
}
    `;
export const SurveyPartsFragmentDoc = gql`
    fragment SurveyParts on Survey {
  id
  type
  answers
  completedAt
  questions
}
    `;
export const VoicesFeedbackPartsFragmentDoc = gql`
    fragment VoicesFeedbackParts on VoicesFeedback {
  id
  companyPersonId
  feedback
  anonymous
  createdAt
  updatedAt
}
    `;
export const TerminationPartsFragmentDoc = gql`
    fragment TerminationParts on Termination {
  complete
  createdAt
  employee {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  employeeId
  manager {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  status
  step
  terminationDate
  terminationId
  user {
    id
    isContractor
    name
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  userId
}
    `;
export const TerminationDownloadPartsFragmentDoc = gql`
    fragment TerminationDownloadParts on TerminationDownload {
  file
  terminationId
}
    `;
export const ResignationPartsFragmentDoc = gql`
    fragment ResignationParts on Resignation {
  complete
  confirmed
  createdAt
  employee {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  employeeId
  hrRequestVersion
  manager {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  resignationDate
  resignationId
  resignationState
  signedFiles {
    filename
    name
    url
  }
  startDate
  status
  step
  user {
    id
    isContractor
    name
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  userId
}
    `;
export const ResignationDownloadPartsFragmentDoc = gql`
    fragment ResignationDownloadParts on ResignationDownload {
  file
  resignationId
}
    `;
export const OnboardingPartsFragmentDoc = gql`
    fragment OnboardingParts on CoreOnboardingData {
  discussionTopics
  discussionTopicDetails {
    topic
    detail
  }
  companyName
  companyLegalName
  companyType
  fein
  noFeinOrDoesNotKnow
  address {
    line1
    line2
    city
    state
    zip: zipCode
  }
  incorporatedInOtherState
  incorporatedState
  isOwner
  primaryContact
  willHaveAdditionalContact
  numOfEmployees
  numOfContractors
  needsHelpConvertingContractors
  hasRemoteEmployees
  remoteWorkerStates
  nextAction
  hasScheduledCall
  callEventId
  progress
}
    `;
export const BankAccountPartsFragmentDoc = gql`
    fragment BankAccountParts on BankAccount {
  id
  institutionName
  mask
  subType
  name
}
    `;
export const CompanyPartsFragmentDoc = gql`
    fragment CompanyParts on Company {
  id
  checkId
  taxDocYears
  bankAccounts {
    ...BankAccountParts
  }
  status
  taxExemptStatus
  companyBenefits {
    id
    name
    effectiveStart
    effectiveEnd
  }
  deputyConnection {
    hasAccessToken
    canCancel
  }
  checkIndustry
  tosVersion
  signatoryEmail
  needsPayScheduleAssistance
  excludedStaffIds
  startDate
  paydays {
    approvalDeadline
    impactedByHoliday
    payday
  }
  paySchedules {
    id
    default
    firstPayday
    firstPeriodEnd
    name
    payFrequency
  }
  processingPeriod
  goals {
    id
    status
  }
  benefitOnboarding {
    status
  }
  checkOnboarding {
    id
    blockingSteps
    remainingSteps
    status
  }
  defaultPayScheduleDays {
    approvalDeadline
    impactedByWeekendOrHoliday
    payday
    periodEnd
    periodStart
  }
}
    ${BankAccountPartsFragmentDoc}`;
export const EmployeePayrollItemsPartsFragmentDoc = gql`
    fragment EmployeePayrollItemsParts on Employee {
  id
  checkOnboarding {
    id
    status
  }
  bankAccounts {
    ...BankAccountParts
  }
  paymentMethodPreference
  payrollItems {
    id
    netPay
    note
    grossPay
    noteVisible
    paymentMethod
    payroll {
      id
      payday
      periodEnd
      periodStart
      status
    }
  }
}
    ${BankAccountPartsFragmentDoc}`;
export const ContractorPaymentPartsFragmentDoc = gql`
    fragment ContractorPaymentParts on Contractor {
  id
  checkOnboarding {
    id
    status
  }
  bankAccounts {
    ...BankAccountParts
  }
  payments {
    id
    basePayRate
    checkNumber
    netPay
    grossPay
    note
    noteVisible
    payType
    paymentMethod
    version
    payroll {
      id
      payday
      periodEnd
      periodStart
      status
    }
  }
  paymentMethodPreference
}
    ${BankAccountPartsFragmentDoc}`;
export const TaxDocumentPartsFragmentDoc = gql`
    fragment TaxDocumentParts on TaxDocument {
  id
  label
  quarter
  year
  label
  filedOn
  description
  jurisdiction
  employeeId
  contractorId
}
    `;
export const CompanyTaxDocumentPartsFragmentDoc = gql`
    fragment CompanyTaxDocumentParts on Company {
  id
  taxDocuments {
    ...TaxDocumentParts
  }
}
    ${TaxDocumentPartsFragmentDoc}`;
export const PaginationPartsFragmentDoc = gql`
    fragment PaginationParts on PayrollPage {
  limit
  nextPage
  page
  prevPage
  totalCount
}
    `;
export const TotalPartsFragmentDoc = gql`
    fragment TotalParts on Totals {
  cashRequirement
  companyBenefits
  companyTaxes
  contractorGross
  contractorNet
  contractorReimbursements
  employeeBenefits
  employeeGross
  employeeNet
  employeeReimbursements
  employeeTaxes
  liability
  postTaxDeductions
}
    `;
export const PayrollPreviewPartsFragmentDoc = gql`
    fragment PayrollPreviewParts on Payroll {
  id
  approvalDeadline
  deletedAt
  draftLiability
  withdrawDate
  needsChecksEntered
  payday
  periodEnd
  periodStart
  quickbooksSyncAttempt {
    id
    status
    attemptedAt
  }
  status
  statusChangedAt
  totals {
    ...TotalParts
  }
  type
  version
  offCycleOptions {
    forceSupplementalWithholding
    applyBenefits
    applyPostTaxDeductions
  }
}
    ${TotalPartsFragmentDoc}`;
export const ItemPartsFragmentDoc = gql`
    fragment ItemParts on PayrollItem {
  id
  basePayRate
  hasDeletedWorkerRole
  grossPay
  employee {
    id
    payRate
    payType
    paymentMethodPreference
    remainingOnboardingSteps
    profile {
      id
      employeeType
      firstName
      lastName
      title
    }
  }
  earnings {
    id
    amount
    description
    minutes
    decimal
    source
    type
    workerRoleId
    subtype
  }
  reimbursements {
    id
    amount
  }
  benefits {
    benefit
    companyContributionAmount
    employeeContributionAmount
    description
  }
  checkNumber
  netPay
  note
  paymentMethod
  ptoBalanceHours
  sickBalanceHours
  reimbursements {
    amount
  }
  postTaxDeductions {
    amount
    description
    type
  }
  noteVisible
  taxes {
    amount
    description
    payer
    remittable
  }
  version
  payroll {
    id
    version
    totals {
      ...TotalParts
    }
  }
}
    ${TotalPartsFragmentDoc}`;
export const ContractorPartsFragmentDoc = gql`
    fragment ContractorParts on Contractor {
  id
  checkOnboarding {
    id
    blockingSteps
    status
  }
  payRate
  paymentMethodPreference
  payments {
    id
    basePayRate
    note
    noteVisible
    payType
    paymentMethod
    version
    entries {
      id
      amount
      minutes
      decimal
      type
      workerRoleId
    }
    payroll {
      id
      version
    }
  }
  remainingOnboardingSteps
  profile {
    id
    firstName
    lastName
    title
    employeeType
    email
    contractorType
    contractorBusinessName
  }
}
    `;
export const PaymentPartsFragmentDoc = gql`
    fragment PaymentParts on ContractorPayment {
  id
  grossPay
  hasDeletedWorkerRole
  basePayRate
  checkNumber
  contractor {
    ...ContractorParts
  }
  entries {
    id
    amount
    minutes
    workerRoleId
    type
  }
  note
  noteVisible
  payType
  paymentMethod
  grossPay
  version
  payroll {
    id
    version
  }
}
    ${ContractorPartsFragmentDoc}`;
export const PayrollWithItemsPartsFragmentDoc = gql`
    fragment PayrollWithItemsParts on Payroll {
  id
  approvedAt
  items {
    ...ItemParts
  }
  contractorPayments {
    ...PaymentParts
  }
  totals {
    ...TotalParts
  }
}
    ${ItemPartsFragmentDoc}
${PaymentPartsFragmentDoc}
${TotalPartsFragmentDoc}`;
export const PayrollPartsFragmentDoc = gql`
    fragment PayrollParts on Payroll {
  id
  approvalDeadline
  deletedAt
  draftLiability
  withdrawDate
  items {
    ...ItemParts
  }
  contractorPayments {
    ...PaymentParts
  }
  needsChecksEntered
  payday
  periodEnd
  periodStart
  quickbooksSyncAttempt {
    id
    status
    attemptedAt
  }
  status
  statusChangedAt
  totals {
    ...TotalParts
  }
  type
  version
  offCycleOptions {
    forceSupplementalWithholding
    applyBenefits
    applyPostTaxDeductions
  }
}
    ${ItemPartsFragmentDoc}
${PaymentPartsFragmentDoc}
${TotalPartsFragmentDoc}`;
export const ContractorMinimalPartsFragmentDoc = gql`
    fragment ContractorMinimalParts on Contractor {
  id
  checkOnboarding {
    id
    blockingSteps
    status
  }
  payRate
  paymentMethodPreference
  remainingOnboardingSteps
  profile {
    id
    firstName
    lastName
    title
    employeeType
    email
    contractorType
    contractorBusinessName
  }
}
    `;
export const PaymentMinimalPartsFragmentDoc = gql`
    fragment PaymentMinimalParts on ContractorPayment {
  id
  hasDeletedWorkerRole
  basePayRate
  checkNumber
  contractor {
    ...ContractorMinimalParts
  }
  entries {
    id
    amount
    minutes
    workerRoleId
    type
  }
  note
  noteVisible
  payType
  paymentMethod
  grossPay
  version
  payroll {
    id
    version
  }
}
    ${ContractorMinimalPartsFragmentDoc}`;
export const PayrollWithoutNestedPaymentsPartsFragmentDoc = gql`
    fragment PayrollWithoutNestedPaymentsParts on Payroll {
  id
  approvalDeadline
  approvedAt
  deletedAt
  draftLiability
  withdrawDate
  items {
    ...ItemParts
  }
  contractorPayments {
    ...PaymentMinimalParts
  }
  needsChecksEntered
  payday
  periodEnd
  periodStart
  quickbooksSyncAttempt {
    id
    status
    attemptedAt
  }
  status
  statusChangedAt
  totals {
    ...TotalParts
  }
  type
  version
  offCycleOptions {
    forceSupplementalWithholding
    applyBenefits
    applyPostTaxDeductions
  }
}
    ${ItemPartsFragmentDoc}
${PaymentMinimalPartsFragmentDoc}
${TotalPartsFragmentDoc}`;
export const PayrollInfoPartsFragmentDoc = gql`
    fragment PayrollInfoParts on Payroll {
  id
  approvalDeadline
  deletedAt
  draftLiability
  withdrawDate
  needsChecksEntered
  payday
  periodEnd
  periodStart
  quickbooksSyncAttempt {
    id
    status
    attemptedAt
  }
  status
  statusChangedAt
  totals {
    ...TotalParts
  }
  type
  version
  offCycleOptions {
    forceSupplementalWithholding
    applyBenefits
    applyPostTaxDeductions
  }
}
    ${TotalPartsFragmentDoc}`;
export const PaginationItemPartsFragmentDoc = gql`
    fragment PaginationItemParts on PayrollItemPage {
  limit
  nextPage
  page
  prevPage
  totalCount
}
    `;
export const PayrollItemsPaginatedPartsFragmentDoc = gql`
    fragment PayrollItemsPaginatedParts on Payroll {
  id
  itemsPage(
    orderBy: $itemOrderBy
    limit: $itemLimit
    page: $itemPage
    advancedWhere: $itemAdvancedWhere
  ) {
    ...PaginationItemParts
    results {
      ...ItemParts
    }
  }
}
    ${PaginationItemPartsFragmentDoc}
${ItemPartsFragmentDoc}`;
export const PaginationPaymentPartsFragmentDoc = gql`
    fragment PaginationPaymentParts on ContractorPaymentPage {
  limit
  nextPage
  page
  prevPage
  totalCount
}
    `;
export const PayrollPaymentsPaginatedPartsFragmentDoc = gql`
    fragment PayrollPaymentsPaginatedParts on Payroll {
  id
  contractorPaymentsPage(
    orderBy: $paymentOrderBy
    limit: $paymentLimit
    page: $paymentPage
    advancedWhere: $paymentAdvancedWhere
  ) {
    ...PaginationPaymentParts
    results {
      ...PaymentMinimalParts
    }
  }
}
    ${PaginationPaymentPartsFragmentDoc}
${PaymentMinimalPartsFragmentDoc}`;
export const PayrollListPartsFragmentDoc = gql`
    fragment PayrollListParts on Payroll {
  id
  approvalDeadline
  deletedAt
  draftLiability
  employeeCount
  contractorCount
  hasEmployeesWithMissingSSN
  withdrawDate
  needsChecksEntered
  payday
  periodEnd
  periodStart
  status
  statusChangedAt
  totals {
    ...TotalParts
  }
  type
  version
  offCycleOptions {
    forceSupplementalWithholding
    applyBenefits
    applyPostTaxDeductions
  }
}
    ${TotalPartsFragmentDoc}`;
export const CompanyStatusPartsFragmentDoc = gql`
    fragment CompanyStatusParts on Company {
  id
  status
  tosVersion
  excludedStaffIds
  checkIndustry
  benefitOnboarding {
    status
  }
  checkId
  benefitOnboarding {
    status
    targetEffectiveStart
  }
  checkOnboarding {
    id
    blockingSteps
    remainingSteps
    status
  }
  deputyConnection {
    hasAccessToken
    installId
    validatedAt
    edition
    canCancel
  }
}
    `;
export const ProfileAddressPartsFragmentDoc = gql`
    fragment ProfileAddressParts on ProfileAddress {
  id
  city
  country
  line1
  line2
  state
  zip
}
    `;
export const ContractorProfilePartsFragmentDoc = gql`
    fragment ContractorProfileParts on Contractor {
  id
  bankAccounts {
    ...BankAccountParts
  }
  checkId
  checkOnboarding {
    id
    remainingSteps
    status
  }
  createdAt
  payRate
  paymentMethodPreference
  payType
  profile {
    id
    contractorBusinessName
    firstName
    lastName
    title
    homeAddress {
      ...ProfileAddressParts
    }
  }
}
    ${BankAccountPartsFragmentDoc}
${ProfileAddressPartsFragmentDoc}`;
export const AddressPartsFragmentDoc = gql`
    fragment AddressParts on Address {
  id
  city
  country
  line1
  line2
  state
  zip
}
    `;
export const EmployeeProfilePartsFragmentDoc = gql`
    fragment EmployeeProfileParts on Employee {
  id
  bankAccounts {
    ...BankAccountParts
  }
  checkId
  checkOnboarding {
    id
    remainingSteps
    status
  }
  createdAt
  payRate
  paymentMethodPreference
  payType
  profile {
    id
    contractorBusinessName
    firstName
    lastName
    title
    homeAddress {
      ...ProfileAddressParts
    }
  }
  workplaces {
    id
    active
    address {
      ...AddressParts
    }
    default
    name
  }
}
    ${BankAccountPartsFragmentDoc}
${ProfileAddressPartsFragmentDoc}
${AddressPartsFragmentDoc}`;
export const EmployeeStatusPartsFragmentDoc = gql`
    fragment EmployeeStatusParts on Employee {
  id
  remainingOnboardingSteps
  checkOnboarding {
    id
    remainingSteps
    blockingSteps
  }
  checkId
  deputyId
  benefitOnboarding {
    status
  }
  createdAt
  paymentMethodPreference
}
    `;
export const ContractorStatusPartsFragmentDoc = gql`
    fragment ContractorStatusParts on Contractor {
  id
  checkOnboarding {
    id
    remainingSteps
    blockingSteps
  }
  checkId
  createdAt
  paymentMethodPreference
}
    `;
export const CoreAddressPartsFragmentDoc = gql`
    fragment CoreAddressParts on CoreAddress {
  city
  line1
  line2
  state
  zipCode
}
    `;
export const UserPartsFragmentDoc = gql`
    fragment UserParts on CoreUser {
  id
  profile {
    id
    firstName
    lastName
    phone
    dob
    email
    avatarUrl
    address {
      ...CoreAddressParts
    }
  }
  employment {
    id
    payType
    employeeType
    payRate
    startDate
    isContractor
    title
    stateWorksIn
    contractorBusinessName
    contractorType
    workerRoles {
      id
      isPrimary
      payRate
      deletedAt
      payType
      companyRole {
        id
        title
      }
    }
  }
}
    ${CoreAddressPartsFragmentDoc}`;
export const CompanyGoalPartsFragmentDoc = gql`
    fragment CompanyGoalParts on Goal {
  category
  id
  name
  label
  required
  requirements {
    checkId
    completedAt
    documentOptions {
      id
      label
      name
    }
    id
    requirementType
    requirementTypeExt
    status
    uploadedFiles {
      id
      name
      type
    }
    requirementName
    errors {
      type
      label
      id
      description
    }
  }
  status
}
    `;
export const CoreTaskPartsFragmentDoc = gql`
    fragment CoreTaskParts on CoreTask {
  id
  completedAt
  completionStatus
  label
  name
  startedAt
  startedBy
  copy {
    cta
    estimated
    details {
      title
      items
    }
    confirmCta
    denyCta
  }
}
    `;
export const CoreGoalPartsFragmentDoc = gql`
    fragment CoreGoalParts on CoreGoal {
  id
  completedAt
  completionStatus
  label
  name
  taskNames
  updatedAt
  copy {
    description
    estimated
  }
}
    `;
export const CourseTopicPartsFragmentDoc = gql`
    fragment CourseTopicParts on CourseTopic {
  id
  price
  name
  description
  duration
  imageUrl
  states
  tags
  key
}
    `;
export const PlanPartsFragmentDoc = gql`
    fragment PlanParts on CorePlanModel {
  price
  priceId
  tierNumber
  value
  billingPeriod
  productKey
  monthlyPrice
  minSize
  maxSize
  name
  pause
}
    `;
export const ProductPartsFragmentDoc = gql`
    fragment ProductParts on Product {
  id
  name
  price
  key
  subscriptionPrice
  activeSubscription
  creditBalance
  tier
}
    `;
export const CoreDocumentSignaturePartsFragmentDoc = gql`
    fragment CoreDocumentSignatureParts on CoreDocumentSignature {
  id
  requestedAt
  signedAt
  signingOrder
}
    `;
export const CoreDocumentPartsFragmentDoc = gql`
    fragment CoreDocumentParts on CoreDocument {
  id
  name
  reaffirmations
  policy {
    id
    name
    archivedAt
  }
  signature {
    ...CoreDocumentSignatureParts
  }
  reaffirmations
}
    ${CoreDocumentSignaturePartsFragmentDoc}`;
export const CoreUserStatesPartsFragmentDoc = gql`
    fragment CoreUserStatesParts on CoreUserStates {
  id
  emailNotification
  onboardRequest
  onboarded
  terminationRequest
  terminated
  selfSignupRegistered
  selfSignupActivated
  resignationLastDate
  resignationStatus
  viewedOnboardingInstructions
  viewedInsuranceIntroduction
  interestedInPersonalInsurance
  viewedPersonalInsurance
  viewedCovid
  viewedTaskCenter
  viewedVideoTourBusinessHealth
  viewedVideoTourCabinet
  viewedVideoTourPolicy
  viewedVideoTourReportCards
  viewedVideoTourStaffFolder
}
    `;
export const CoreUserPartsFragmentDoc = gql`
    fragment CoreUserParts on CoreUser {
  id
  active
  roles
  role
  profile {
    firstName
    lastName
    avatarUrl
  }
  states {
    ...CoreUserStatesParts
  }
  employment {
    title
    isContractor
  }
  permissions {
    manager
    approver
  }
}
    ${CoreUserStatesPartsFragmentDoc}`;
export const CorePolicyPartsFragmentDoc = gql`
    fragment CorePolicyParts on CorePolicy {
  id
  isCPD
  name
  icon
  status
  isContractor
  step
  recipients {
    id
    document {
      ...CoreDocumentParts
    }
    employee {
      ...CoreUserParts
    }
  }
  notSentTo {
    ...CoreUserParts
  }
}
    ${CoreDocumentPartsFragmentDoc}
${CoreUserPartsFragmentDoc}`;
export const ReportCardUserPartsFragmentDoc = gql`
    fragment ReportCardUserParts on CoreUser {
  id
  profile {
    firstName
    lastName
    avatarUrl
  }
  role
  employment {
    isContractor
  }
}
    `;
export const ReportCardEmployeeGradePartsFragmentDoc = gql`
    fragment ReportCardEmployeeGradeParts on ReportCardEmployeeGrade {
  id
  __typename
  employee {
    ...ReportCardUserParts
  }
  feedback
  grade
  gradedBy {
    ...ReportCardUserParts
  }
  note
  status
}
    ${ReportCardUserPartsFragmentDoc}`;
export const ManagedReportPartsFragmentDoc = gql`
    fragment ManagedReportParts on ManagedReport {
  id
  __typename
  employees {
    ...ReportCardUserParts
  }
  manager {
    ...ReportCardUserParts
  }
}
    ${ReportCardUserPartsFragmentDoc}`;
export const ReportCardPartsFragmentDoc = gql`
    fragment ReportCardParts on ReportCard {
  __typename
  id
  cadence
  createdAt
  directReports {
    ...ReportCardUserParts
  }
  employees {
    ...ReportCardEmployeeGradeParts
  }
  managerReports {
    ...ManagedReportParts
  }
  status
}
    ${ReportCardUserPartsFragmentDoc}
${ReportCardEmployeeGradePartsFragmentDoc}
${ManagedReportPartsFragmentDoc}`;
export const NewReportCardPartsFragmentDoc = gql`
    fragment NewReportCardParts on NewReportCard {
  __typename
  existing
  report {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;
export const EnrollmentResponsePartsFragmentDoc = gql`
    fragment EnrollmentResponseParts on EnrollUsersResponse {
  id
  companyId
  enrolled
  userIds
  topicId
  bundleId
  errors
}
    `;
export const BulkEnrollUsersResponsePartsFragmentDoc = gql`
    fragment BulkEnrollUsersResponseParts on BulkEnrollUsersResponse {
  enrolledUsers {
    ...EnrollmentResponseParts
  }
  errors {
    message
    userIds
    topicId
    bundleId
  }
}
    ${EnrollmentResponsePartsFragmentDoc}`;
export const UserCoursePartsFragmentDoc = gql`
    fragment UserCourseParts on UserCourse {
  id
  courseId
  ticketId
  name
  description
  topicName
  topicId
  bundleName
  bundleId
  state
  status
  startedAt
  removedAt
  completedAt
  enrolledAt
  certificateId
  certificateDownloadUrl
  searchTag
  language
  userRole
  doceboCourseId
}
    `;
export const TopicPartsFragmentDoc = gql`
    fragment TopicParts on PurchasedTopic {
  name
  topicId
  totalSeats
  unfilledSeats
  counts {
    id
    completed
    inProgress
    notStarted
  }
  enrollments {
    certificateDownloadUrl
    completedAt
    enrolledAt
    language
    role
    startedAt
    state
    userId
    userMngId
  }
}
    `;
export const FullCompanyPartsFragmentDoc = gql`
    fragment FullCompanyParts on Company {
  companyId
  companyMngId
  users {
    language
    role
    state
    userId
    userMngId
  }
  availableProducts {
    bundles {
      id
      name
      price
      topics {
        id
        name
        price
      }
    }
    topics {
      id
      name
      price
    }
  }
  purchasedProducts {
    topics {
      id
      ...TopicParts
    }
    bundles {
      id
      name
      bundleId
      description
      counts {
        id
        completed
        inProgress
        notStarted
      }
      topics {
        ...TopicParts
      }
      totalSeats
      unfilledSeats
    }
  }
}
    ${TopicPartsFragmentDoc}`;
export const ShortCompanyPartsFragmentDoc = gql`
    fragment ShortCompanyParts on Company {
  companyId
  companyMngId
  purchasedProducts {
    bundles {
      bundleId
      name
      totalSeats
      unfilledSeats
    }
  }
}
    `;
export const CoreUserStatePartsFragmentDoc = gql`
    fragment CoreUserStateParts on CoreUserStates {
  viewedBciToHrPracticeModal
  viewedBciToHrPracticeReportCardModal
  viewedInAppUpgradeModal
}
    `;
export const JobDescriptionPartsFragmentDoc = gql`
    fragment JobDescriptionParts on JobDescription {
  aiGeneratedId
  body
  html
  completedAt
  deletedAt
  deletedBy
  id
  title
  aiGenerated {
    id
    body
    createdAt
  }
}
    `;
export const EmployeeJobDescriptionPartsFragmentDoc = gql`
    fragment EmployeeJobDescriptionParts on EmployeeJobDescription {
  id
  createdAt
  signedAt
  documentId
  jobDescription {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;
export const CoreUserEmploymentPartsFragmentDoc = gql`
    fragment CoreUserEmploymentParts on CoreUserEmployment {
  workerRoles {
    isPrimary
    employeeJobDescription {
      ...EmployeeJobDescriptionParts
    }
  }
}
    ${EmployeeJobDescriptionPartsFragmentDoc}`;
export const GetCouponByIdDocument = gql`
    query GetCouponById($data: GetCouponInput!) {
  coupon(data: $data) {
    ...CouponParts
  }
}
    ${CouponPartsFragmentDoc}`;

/**
 * __useGetCouponByIdQuery__
 *
 * To run a query within a Vue component, call `useGetCouponByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCouponByIdQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCouponByIdQuery(variables: GetCouponByIdQueryVariables | VueCompositionApi.Ref<GetCouponByIdQueryVariables> | ReactiveFunction<GetCouponByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCouponByIdQuery, GetCouponByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCouponByIdQuery, GetCouponByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCouponByIdQuery, GetCouponByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCouponByIdQuery, GetCouponByIdQueryVariables>(GetCouponByIdDocument, variables, options);
}
export type GetCouponByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCouponByIdQuery, GetCouponByIdQueryVariables>;
export const GetLockedPlanDocument = gql`
    query getLockedPlan($companyId: String!) {
  getPlanLock(companyId: $companyId) {
    ...BillingPlanParts
  }
}
    ${BillingPlanPartsFragmentDoc}`;

/**
 * __useGetLockedPlanQuery__
 *
 * To run a query within a Vue component, call `useGetLockedPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLockedPlanQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLockedPlanQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetLockedPlanQuery(variables: GetLockedPlanQueryVariables | VueCompositionApi.Ref<GetLockedPlanQueryVariables> | ReactiveFunction<GetLockedPlanQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLockedPlanQuery, GetLockedPlanQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLockedPlanQuery, GetLockedPlanQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLockedPlanQuery, GetLockedPlanQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLockedPlanQuery, GetLockedPlanQueryVariables>(GetLockedPlanDocument, variables, options);
}
export type GetLockedPlanQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLockedPlanQuery, GetLockedPlanQueryVariables>;
export const GetBillingCompanySubscriptionsDocument = gql`
    query GetBillingCompanySubscriptions($data: GetCompanySubscriptionsInput!) {
  companySubscriptions(data: $data) {
    ...SubscriptionParts
  }
}
    ${SubscriptionPartsFragmentDoc}`;

/**
 * __useGetBillingCompanySubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetBillingCompanySubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingCompanySubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingCompanySubscriptionsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetBillingCompanySubscriptionsQuery(variables: GetBillingCompanySubscriptionsQueryVariables | VueCompositionApi.Ref<GetBillingCompanySubscriptionsQueryVariables> | ReactiveFunction<GetBillingCompanySubscriptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>(GetBillingCompanySubscriptionsDocument, variables, options);
}
export type GetBillingCompanySubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>;
export const MyProductsDocument = gql`
    query myProducts {
  myProducts {
    ...BillingProductParts
  }
}
    ${BillingProductPartsFragmentDoc}`;

/**
 * __useMyProductsQuery__
 *
 * To run a query within a Vue component, call `useMyProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyProductsQuery();
 */
export function useMyProductsQuery(options: VueApolloComposable.UseQueryOptions<MyProductsQuery, MyProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyProductsQuery, MyProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyProductsQuery, MyProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyProductsQuery, MyProductsQueryVariables>(MyProductsDocument, {}, options);
}
export type MyProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyProductsQuery, MyProductsQueryVariables>;
export const ApplyCorePayrollDiscountToCompanySubscriptionDocument = gql`
    mutation ApplyCorePayrollDiscountToCompanySubscription($input: ApplyCorePayrollDiscountInput!) {
  applyCorePayrollDiscountToCompanySubscription(input: $input) {
    ...SubscriptionParts
  }
}
    ${SubscriptionPartsFragmentDoc}`;

/**
 * __useApplyCorePayrollDiscountToCompanySubscriptionMutation__
 *
 * To run a mutation, you first call `useApplyCorePayrollDiscountToCompanySubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplyCorePayrollDiscountToCompanySubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplyCorePayrollDiscountToCompanySubscriptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApplyCorePayrollDiscountToCompanySubscriptionMutation(options: VueApolloComposable.UseMutationOptions<ApplyCorePayrollDiscountToCompanySubscriptionMutation, ApplyCorePayrollDiscountToCompanySubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApplyCorePayrollDiscountToCompanySubscriptionMutation, ApplyCorePayrollDiscountToCompanySubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<ApplyCorePayrollDiscountToCompanySubscriptionMutation, ApplyCorePayrollDiscountToCompanySubscriptionMutationVariables>(ApplyCorePayrollDiscountToCompanySubscriptionDocument, options);
}
export type ApplyCorePayrollDiscountToCompanySubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApplyCorePayrollDiscountToCompanySubscriptionMutation, ApplyCorePayrollDiscountToCompanySubscriptionMutationVariables>;
export const CreatePayrollSubscriptionDocument = gql`
    mutation CreatePayrollSubscription($data: CreatePayrollSubscriptionInput!) {
  createPayrollSubscription(data: $data) {
    ...SubscriptionParts
  }
}
    ${SubscriptionPartsFragmentDoc}`;

/**
 * __useCreatePayrollSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreatePayrollSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayrollSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePayrollSubscriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreatePayrollSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<CreatePayrollSubscriptionMutation, CreatePayrollSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePayrollSubscriptionMutation, CreatePayrollSubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CreatePayrollSubscriptionMutation, CreatePayrollSubscriptionMutationVariables>(CreatePayrollSubscriptionDocument, options);
}
export type CreatePayrollSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePayrollSubscriptionMutation, CreatePayrollSubscriptionMutationVariables>;
export const PurchaseCreditsDocument = gql`
    mutation purchaseCredits($data: PurchaseInput!) {
  purchaseCredits(data: $data) {
    ...ProductResultParts
  }
}
    ${ProductResultPartsFragmentDoc}`;

/**
 * __usePurchaseCreditsMutation__
 *
 * To run a mutation, you first call `usePurchaseCreditsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseCreditsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseCreditsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseCreditsMutation(options: VueApolloComposable.UseMutationOptions<PurchaseCreditsMutation, PurchaseCreditsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseCreditsMutation, PurchaseCreditsMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseCreditsMutation, PurchaseCreditsMutationVariables>(PurchaseCreditsDocument, options);
}
export type PurchaseCreditsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseCreditsMutation, PurchaseCreditsMutationVariables>;
export const PurchaseSubscriptionDocument = gql`
    mutation purchaseSubscription($data: PurchaseSubscriptionInput!) {
  purchaseSubscription(data: $data) {
    ...ProductResultParts
  }
}
    ${ProductResultPartsFragmentDoc}`;

/**
 * __usePurchaseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePurchaseSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseSubscriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>(PurchaseSubscriptionDocument, options);
}
export type PurchaseSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>;
export const GetCompanyDelinquencyDocument = gql`
    query GetCompanyDelinquency($data: GetCompanyDelinquency!) {
  getCompanyDelinquency(data: $data) {
    ...CompanyDelinquencyParts
  }
}
    ${CompanyDelinquencyPartsFragmentDoc}`;

/**
 * __useGetCompanyDelinquencyQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyDelinquencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDelinquencyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyDelinquencyQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyDelinquencyQuery(variables: GetCompanyDelinquencyQueryVariables | VueCompositionApi.Ref<GetCompanyDelinquencyQueryVariables> | ReactiveFunction<GetCompanyDelinquencyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>(GetCompanyDelinquencyDocument, variables, options);
}
export type GetCompanyDelinquencyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>;
export const GetCompanySourcesDocument = gql`
    query GetCompanySources($data: GetCompanyPaymentSources!) {
  getCompanySources(data: $data) {
    ...PaymentSourcesParts
  }
}
    ${PaymentSourcesPartsFragmentDoc}`;

/**
 * __useGetCompanySourcesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanySourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanySourcesQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanySourcesQuery(variables: GetCompanySourcesQueryVariables | VueCompositionApi.Ref<GetCompanySourcesQueryVariables> | ReactiveFunction<GetCompanySourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanySourcesQuery, GetCompanySourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>(GetCompanySourcesDocument, variables, options);
}
export type GetCompanySourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>;
export const UpdatePaymentSourceBillingAddressDocument = gql`
    mutation UpdatePaymentSourceBillingAddress($input: UpdatePaymentSourceBillingAddress!) {
  updatePaymentSourceBillingAddress(input: $input) {
    ...PaymentSourceParts
  }
}
    ${PaymentSourcePartsFragmentDoc}`;

/**
 * __useUpdatePaymentSourceBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentSourceBillingAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentSourceBillingAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePaymentSourceBillingAddressMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentSourceBillingAddressMutation(options: VueApolloComposable.UseMutationOptions<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables>(UpdatePaymentSourceBillingAddressDocument, options);
}
export type UpdatePaymentSourceBillingAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables>;
export const ScratchListServiceAddonsDocument = gql`
    query ScratchListServiceAddons($input: ScratchServiceAddonListInput!) {
  scratchListServiceAddons(input: $input) {
    id
    label
    priceLabel
    enabled
  }
}
    `;

/**
 * __useScratchListServiceAddonsQuery__
 *
 * To run a query within a Vue component, call `useScratchListServiceAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScratchListServiceAddonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useScratchListServiceAddonsQuery({
 *   input: // value for 'input'
 * });
 */
export function useScratchListServiceAddonsQuery(variables: ScratchListServiceAddonsQueryVariables | VueCompositionApi.Ref<ScratchListServiceAddonsQueryVariables> | ReactiveFunction<ScratchListServiceAddonsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>(ScratchListServiceAddonsDocument, variables, options);
}
export type ScratchListServiceAddonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>;
export const ScratchToggleServiceAddonDocument = gql`
    mutation ScratchToggleServiceAddon($input: ScratchToggleServiceAddonInput!) {
  scratchToggleServiceAddon(input: $input) {
    id
    label
    priceLabel
    enabled
  }
}
    `;

/**
 * __useScratchToggleServiceAddonMutation__
 *
 * To run a mutation, you first call `useScratchToggleServiceAddonMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useScratchToggleServiceAddonMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useScratchToggleServiceAddonMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useScratchToggleServiceAddonMutation(options: VueApolloComposable.UseMutationOptions<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables>>) {
  return VueApolloComposable.useMutation<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables>(ScratchToggleServiceAddonDocument, options);
}
export type ScratchToggleServiceAddonMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables>;
export const ListPracticeDocument = gql`
    query ListPractice($companyId: String!) {
  listPractice(companyId: $companyId) {
    ...PracticeParts
  }
}
    ${PracticePartsFragmentDoc}`;

/**
 * __useListPracticeQuery__
 *
 * To run a query within a Vue component, call `useListPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPracticeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPracticeQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useListPracticeQuery(variables: ListPracticeQueryVariables | VueCompositionApi.Ref<ListPracticeQueryVariables> | ReactiveFunction<ListPracticeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListPracticeQuery, ListPracticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPracticeQuery, ListPracticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPracticeQuery, ListPracticeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPracticeQuery, ListPracticeQueryVariables>(ListPracticeDocument, variables, options);
}
export type ListPracticeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPracticeQuery, ListPracticeQueryVariables>;
export const GetPracticeDocument = gql`
    query getPractice($input: GetPracticeInput!) {
  getPractice(input: $input) {
    ...PracticeParts
    survey {
      ...SurveyParts
    }
  }
}
    ${PracticePartsFragmentDoc}
${SurveyPartsFragmentDoc}`;

/**
 * __useGetPracticeQuery__
 *
 * To run a query within a Vue component, call `useGetPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPracticeQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetPracticeQuery(variables: GetPracticeQueryVariables | VueCompositionApi.Ref<GetPracticeQueryVariables> | ReactiveFunction<GetPracticeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPracticeQuery, GetPracticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPracticeQuery, GetPracticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPracticeQuery, GetPracticeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPracticeQuery, GetPracticeQueryVariables>(GetPracticeDocument, variables, options);
}
export type GetPracticeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPracticeQuery, GetPracticeQueryVariables>;
export const GetHrScoreDocument = gql`
    query getHrScore($companyId: String!) {
  getHrScore(companyId: $companyId)
}
    `;

/**
 * __useGetHrScoreQuery__
 *
 * To run a query within a Vue component, call `useGetHrScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrScoreQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrScoreQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetHrScoreQuery(variables: GetHrScoreQueryVariables | VueCompositionApi.Ref<GetHrScoreQueryVariables> | ReactiveFunction<GetHrScoreQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetHrScoreQuery, GetHrScoreQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrScoreQuery, GetHrScoreQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrScoreQuery, GetHrScoreQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrScoreQuery, GetHrScoreQueryVariables>(GetHrScoreDocument, variables, options);
}
export type GetHrScoreQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrScoreQuery, GetHrScoreQueryVariables>;
export const CompanySurveyDocument = gql`
    query companySurvey($data: GetCompanySurveyInput!) {
  companySurvey(data: $data) {
    ...SurveyParts
  }
}
    ${SurveyPartsFragmentDoc}`;

/**
 * __useCompanySurveyQuery__
 *
 * To run a query within a Vue component, call `useCompanySurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySurveyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompanySurveyQuery({
 *   data: // value for 'data'
 * });
 */
export function useCompanySurveyQuery(variables: CompanySurveyQueryVariables | VueCompositionApi.Ref<CompanySurveyQueryVariables> | ReactiveFunction<CompanySurveyQueryVariables>, options: VueApolloComposable.UseQueryOptions<CompanySurveyQuery, CompanySurveyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompanySurveyQuery, CompanySurveyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompanySurveyQuery, CompanySurveyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CompanySurveyQuery, CompanySurveyQueryVariables>(CompanySurveyDocument, variables, options);
}
export type CompanySurveyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CompanySurveyQuery, CompanySurveyQueryVariables>;
export const GetCompanySettingsDocument = gql`
    query GetCompanySettings($data: String!) {
  getCompanySettings(companyId: $data) {
    id
    key
    type
    value
  }
}
    `;

/**
 * __useGetCompanySettingsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanySettingsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanySettingsQuery(variables: GetCompanySettingsQueryVariables | VueCompositionApi.Ref<GetCompanySettingsQueryVariables> | ReactiveFunction<GetCompanySettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, variables, options);
}
export type GetCompanySettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>;
export const SaveCompanyAnswerDocument = gql`
    mutation saveCompanyAnswer($data: SaveCompanyAnswerInput!) {
  saveCompanyAnswer(data: $data) {
    ...SurveyParts
  }
}
    ${SurveyPartsFragmentDoc}`;

/**
 * __useSaveCompanyAnswerMutation__
 *
 * To run a mutation, you first call `useSaveCompanyAnswerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanyAnswerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCompanyAnswerMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSaveCompanyAnswerMutation(options: VueApolloComposable.UseMutationOptions<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables>>) {
  return VueApolloComposable.useMutation<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables>(SaveCompanyAnswerDocument, options);
}
export type SaveCompanyAnswerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables>;
export const CompleteCompanySurveyDocument = gql`
    mutation completeCompanySurvey($data: CompleteCompanySurveyInput!) {
  completeCompanySurvey(data: $data) {
    ...SurveyParts
  }
}
    ${SurveyPartsFragmentDoc}`;

/**
 * __useCompleteCompanySurveyMutation__
 *
 * To run a mutation, you first call `useCompleteCompanySurveyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompanySurveyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompanySurveyMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteCompanySurveyMutation(options: VueApolloComposable.UseMutationOptions<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables>(CompleteCompanySurveyDocument, options);
}
export type CompleteCompanySurveyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables>;
export const CompleteCompanyPracticeDocument = gql`
    mutation completeCompanyPractice($data: CompletePracticeInput!) {
  completeCompanyPractice(data: $data) {
    ...PracticeParts
    survey {
      ...SurveyParts
    }
  }
}
    ${PracticePartsFragmentDoc}
${SurveyPartsFragmentDoc}`;

/**
 * __useCompleteCompanyPracticeMutation__
 *
 * To run a mutation, you first call `useCompleteCompanyPracticeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompanyPracticeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompanyPracticeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteCompanyPracticeMutation(options: VueApolloComposable.UseMutationOptions<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables>(CompleteCompanyPracticeDocument, options);
}
export type CompleteCompanyPracticeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables>;
export const BulkMessageStaffDocument = gql`
    mutation BulkMessageStaff($data: BulkMessageStaffInput!) {
  bulkMessageStaff(data: $data) {
    errors {
      errorMsg
      staffId
    }
    successfulStaffIds
  }
}
    `;

/**
 * __useBulkMessageStaffMutation__
 *
 * To run a mutation, you first call `useBulkMessageStaffMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkMessageStaffMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkMessageStaffMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkMessageStaffMutation(options: VueApolloComposable.UseMutationOptions<BulkMessageStaffMutation, BulkMessageStaffMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkMessageStaffMutation, BulkMessageStaffMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkMessageStaffMutation, BulkMessageStaffMutationVariables>(BulkMessageStaffDocument, options);
}
export type BulkMessageStaffMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkMessageStaffMutation, BulkMessageStaffMutationVariables>;
export const GetMyVoicesFeedbackListDocument = gql`
    query GetMyVoicesFeedbackList {
  getMyVoicesFeedbackList {
    ...VoicesFeedbackParts
  }
}
    ${VoicesFeedbackPartsFragmentDoc}`;

/**
 * __useGetMyVoicesFeedbackListQuery__
 *
 * To run a query within a Vue component, call `useGetMyVoicesFeedbackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVoicesFeedbackListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyVoicesFeedbackListQuery();
 */
export function useGetMyVoicesFeedbackListQuery(options: VueApolloComposable.UseQueryOptions<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>(GetMyVoicesFeedbackListDocument, {}, options);
}
export type GetMyVoicesFeedbackListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>;
export const CreateVoicesFeedbackDocument = gql`
    mutation CreateVoicesFeedback($input: CreateVoicesFeedbackInput!) {
  createVoicesFeedback(input: $input) {
    ...VoicesFeedbackParts
  }
}
    ${VoicesFeedbackPartsFragmentDoc}`;

/**
 * __useCreateVoicesFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateVoicesFeedbackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoicesFeedbackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVoicesFeedbackMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoicesFeedbackMutation(options: VueApolloComposable.UseMutationOptions<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables>(CreateVoicesFeedbackDocument, options);
}
export type CreateVoicesFeedbackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables>;
export const GetMyCompanyVoicesFeedbackListDocument = gql`
    query GetMyCompanyVoicesFeedbackList {
  getMyCompanyVoicesFeedbackList {
    ...VoicesFeedbackParts
  }
}
    ${VoicesFeedbackPartsFragmentDoc}`;

/**
 * __useGetMyCompanyVoicesFeedbackListQuery__
 *
 * To run a query within a Vue component, call `useGetMyCompanyVoicesFeedbackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCompanyVoicesFeedbackListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyCompanyVoicesFeedbackListQuery();
 */
export function useGetMyCompanyVoicesFeedbackListQuery(options: VueApolloComposable.UseQueryOptions<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>(GetMyCompanyVoicesFeedbackListDocument, {}, options);
}
export type GetMyCompanyVoicesFeedbackListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>;
export const GetTerminationListDocument = gql`
    query GetTerminationList($data: GetTerminationsInput!) {
  terminationList(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useGetTerminationListQuery__
 *
 * To run a query within a Vue component, call `useGetTerminationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminationListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTerminationListQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTerminationListQuery(variables: GetTerminationListQueryVariables | VueCompositionApi.Ref<GetTerminationListQueryVariables> | ReactiveFunction<GetTerminationListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTerminationListQuery, GetTerminationListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTerminationListQuery, GetTerminationListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTerminationListQuery, GetTerminationListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTerminationListQuery, GetTerminationListQueryVariables>(GetTerminationListDocument, variables, options);
}
export type GetTerminationListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTerminationListQuery, GetTerminationListQueryVariables>;
export const GetTerminationInfoDocument = gql`
    query GetTerminationInfo($data: GetTerminationInput!) {
  terminationInfo(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useGetTerminationInfoQuery__
 *
 * To run a query within a Vue component, call `useGetTerminationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminationInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTerminationInfoQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTerminationInfoQuery(variables: GetTerminationInfoQueryVariables | VueCompositionApi.Ref<GetTerminationInfoQueryVariables> | ReactiveFunction<GetTerminationInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTerminationInfoQuery, GetTerminationInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>(GetTerminationInfoDocument, variables, options);
}
export type GetTerminationInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>;
export const TerminationDownloadDocument = gql`
    query TerminationDownload($data: GetTerminationInput!) {
  terminationDownload(data: $data) {
    ...TerminationDownloadParts
  }
}
    ${TerminationDownloadPartsFragmentDoc}`;

/**
 * __useTerminationDownloadQuery__
 *
 * To run a query within a Vue component, call `useTerminationDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminationDownloadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTerminationDownloadQuery({
 *   data: // value for 'data'
 * });
 */
export function useTerminationDownloadQuery(variables: TerminationDownloadQueryVariables | VueCompositionApi.Ref<TerminationDownloadQueryVariables> | ReactiveFunction<TerminationDownloadQueryVariables>, options: VueApolloComposable.UseQueryOptions<TerminationDownloadQuery, TerminationDownloadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TerminationDownloadQuery, TerminationDownloadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TerminationDownloadQuery, TerminationDownloadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TerminationDownloadQuery, TerminationDownloadQueryVariables>(TerminationDownloadDocument, variables, options);
}
export type TerminationDownloadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TerminationDownloadQuery, TerminationDownloadQueryVariables>;
export const CancelTerminationDocument = gql`
    mutation CancelTermination($data: TerminationCancelInput!) {
  cancelTermination(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useCancelTerminationMutation__
 *
 * To run a mutation, you first call `useCancelTerminationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelTerminationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelTerminationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelTerminationMutation(options: VueApolloComposable.UseMutationOptions<CancelTerminationMutation, CancelTerminationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelTerminationMutation, CancelTerminationMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelTerminationMutation, CancelTerminationMutationVariables>(CancelTerminationDocument, options);
}
export type CancelTerminationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelTerminationMutation, CancelTerminationMutationVariables>;
export const ConfirmTerminationDocument = gql`
    mutation ConfirmTermination($data: TerminationConfirmationInput!) {
  confirmTermination(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useConfirmTerminationMutation__
 *
 * To run a mutation, you first call `useConfirmTerminationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTerminationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmTerminationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useConfirmTerminationMutation(options: VueApolloComposable.UseMutationOptions<ConfirmTerminationMutation, ConfirmTerminationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmTerminationMutation, ConfirmTerminationMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmTerminationMutation, ConfirmTerminationMutationVariables>(ConfirmTerminationDocument, options);
}
export type ConfirmTerminationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmTerminationMutation, ConfirmTerminationMutationVariables>;
export const EditTerminationDetailsDocument = gql`
    mutation EditTerminationDetails($data: TerminationEditDetailsInput!) {
  editTerminationDetails(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useEditTerminationDetailsMutation__
 *
 * To run a mutation, you first call `useEditTerminationDetailsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditTerminationDetailsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditTerminationDetailsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEditTerminationDetailsMutation(options: VueApolloComposable.UseMutationOptions<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables>>) {
  return VueApolloComposable.useMutation<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables>(EditTerminationDetailsDocument, options);
}
export type EditTerminationDetailsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables>;
export const AttachTerminationFilesDocument = gql`
    mutation AttachTerminationFiles($data: TerminationAttachInput!) {
  attachTerminationFiles(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useAttachTerminationFilesMutation__
 *
 * To run a mutation, you first call `useAttachTerminationFilesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachTerminationFilesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachTerminationFilesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAttachTerminationFilesMutation(options: VueApolloComposable.UseMutationOptions<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables>>) {
  return VueApolloComposable.useMutation<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables>(AttachTerminationFilesDocument, options);
}
export type AttachTerminationFilesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables>;
export const GetResignationListDocument = gql`
    query GetResignationList($data: GetResignationsInput!) {
  resignationList(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useGetResignationListQuery__
 *
 * To run a query within a Vue component, call `useGetResignationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResignationListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetResignationListQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetResignationListQuery(variables: GetResignationListQueryVariables | VueCompositionApi.Ref<GetResignationListQueryVariables> | ReactiveFunction<GetResignationListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetResignationListQuery, GetResignationListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetResignationListQuery, GetResignationListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetResignationListQuery, GetResignationListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetResignationListQuery, GetResignationListQueryVariables>(GetResignationListDocument, variables, options);
}
export type GetResignationListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetResignationListQuery, GetResignationListQueryVariables>;
export const AttachResignationFilesDocument = gql`
    mutation AttachResignationFiles($data: ResignationAttachInput!) {
  attachResignationFiles(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useAttachResignationFilesMutation__
 *
 * To run a mutation, you first call `useAttachResignationFilesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachResignationFilesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachResignationFilesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAttachResignationFilesMutation(options: VueApolloComposable.UseMutationOptions<AttachResignationFilesMutation, AttachResignationFilesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttachResignationFilesMutation, AttachResignationFilesMutationVariables>>) {
  return VueApolloComposable.useMutation<AttachResignationFilesMutation, AttachResignationFilesMutationVariables>(AttachResignationFilesDocument, options);
}
export type AttachResignationFilesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttachResignationFilesMutation, AttachResignationFilesMutationVariables>;
export const ResignationInfoDocument = gql`
    query ResignationInfo($data: GetResignationInput!) {
  resignationInfo(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useResignationInfoQuery__
 *
 * To run a query within a Vue component, call `useResignationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useResignationInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResignationInfoQuery({
 *   data: // value for 'data'
 * });
 */
export function useResignationInfoQuery(variables: ResignationInfoQueryVariables | VueCompositionApi.Ref<ResignationInfoQueryVariables> | ReactiveFunction<ResignationInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResignationInfoQuery, ResignationInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResignationInfoQuery, ResignationInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResignationInfoQuery, ResignationInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResignationInfoQuery, ResignationInfoQueryVariables>(ResignationInfoDocument, variables, options);
}
export type ResignationInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResignationInfoQuery, ResignationInfoQueryVariables>;
export const ResignationDownloadDocument = gql`
    query ResignationDownload($data: GetResignationInput!) {
  resignationDownload(data: $data) {
    ...ResignationDownloadParts
  }
}
    ${ResignationDownloadPartsFragmentDoc}`;

/**
 * __useResignationDownloadQuery__
 *
 * To run a query within a Vue component, call `useResignationDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useResignationDownloadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResignationDownloadQuery({
 *   data: // value for 'data'
 * });
 */
export function useResignationDownloadQuery(variables: ResignationDownloadQueryVariables | VueCompositionApi.Ref<ResignationDownloadQueryVariables> | ReactiveFunction<ResignationDownloadQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResignationDownloadQuery, ResignationDownloadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResignationDownloadQuery, ResignationDownloadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResignationDownloadQuery, ResignationDownloadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResignationDownloadQuery, ResignationDownloadQueryVariables>(ResignationDownloadDocument, variables, options);
}
export type ResignationDownloadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResignationDownloadQuery, ResignationDownloadQueryVariables>;
export const CancelResignationDocument = gql`
    mutation CancelResignation($data: ResignationCancelInput!) {
  cancelResignation(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useCancelResignationMutation__
 *
 * To run a mutation, you first call `useCancelResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelResignationMutation(options: VueApolloComposable.UseMutationOptions<CancelResignationMutation, CancelResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelResignationMutation, CancelResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelResignationMutation, CancelResignationMutationVariables>(CancelResignationDocument, options);
}
export type CancelResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelResignationMutation, CancelResignationMutationVariables>;
export const ConfirmResignationDocument = gql`
    mutation ConfirmResignation($data: ResignationConfirmationInput!) {
  confirmResignation(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useConfirmResignationMutation__
 *
 * To run a mutation, you first call `useConfirmResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useConfirmResignationMutation(options: VueApolloComposable.UseMutationOptions<ConfirmResignationMutation, ConfirmResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmResignationMutation, ConfirmResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmResignationMutation, ConfirmResignationMutationVariables>(ConfirmResignationDocument, options);
}
export type ConfirmResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmResignationMutation, ConfirmResignationMutationVariables>;
export const EditResignationDocument = gql`
    mutation EditResignation($data: ResignationEditDetailsInput!) {
  editResignationDetails(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useEditResignationMutation__
 *
 * To run a mutation, you first call `useEditResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEditResignationMutation(options: VueApolloComposable.UseMutationOptions<EditResignationMutation, EditResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditResignationMutation, EditResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<EditResignationMutation, EditResignationMutationVariables>(EditResignationDocument, options);
}
export type EditResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditResignationMutation, EditResignationMutationVariables>;
export const WarningDocumentsDocument = gql`
    query WarningDocuments($data: GetUserWarningDocumentsInput!) {
  warningDocuments(data: $data) {
    createdAt
    name
    type
    id
  }
}
    `;

/**
 * __useWarningDocumentsQuery__
 *
 * To run a query within a Vue component, call `useWarningDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarningDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWarningDocumentsQuery({
 *   data: // value for 'data'
 * });
 */
export function useWarningDocumentsQuery(variables: WarningDocumentsQueryVariables | VueCompositionApi.Ref<WarningDocumentsQueryVariables> | ReactiveFunction<WarningDocumentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WarningDocumentsQuery, WarningDocumentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WarningDocumentsQuery, WarningDocumentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WarningDocumentsQuery, WarningDocumentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WarningDocumentsQuery, WarningDocumentsQueryVariables>(WarningDocumentsDocument, variables, options);
}
export type WarningDocumentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WarningDocumentsQuery, WarningDocumentsQueryVariables>;
export const CreateJobDescriptionDocument = gql`
    mutation CreateJobDescription($data: CreateJobDescriptionInput!) {
  createJobDescription(data: $data) {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useCreateJobDescriptionMutation__
 *
 * To run a mutation, you first call `useCreateJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateJobDescriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables>(CreateJobDescriptionDocument, options);
}
export type CreateJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables>;
export const UpdateJobDescriptionDocument = gql`
    mutation UpdateJobDescription($data: UpdateJobDescriptionInput!) {
  updateJobDescription(data: $data) {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useUpdateJobDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateJobDescriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables>(UpdateJobDescriptionDocument, options);
}
export type UpdateJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables>;
export const CompleteJobDescriptionDocument = gql`
    mutation CompleteJobDescription($id: String!) {
  completeJobDescription(id: $id) {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useCompleteJobDescriptionMutation__
 *
 * To run a mutation, you first call `useCompleteJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteJobDescriptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCompleteJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables>(CompleteJobDescriptionDocument, options);
}
export type CompleteJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables>;
export const GenerateAiJobDescriptionDocument = gql`
    mutation GenerateAiJobDescription($data: GenerateAiJobDescriptionInput!) {
  generateAiJobDescription(data: $data) {
    aiGeneratedId
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGenerateAiJobDescriptionMutation__
 *
 * To run a mutation, you first call `useGenerateAiJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateAiJobDescriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useGenerateAiJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables>(GenerateAiJobDescriptionDocument, options);
}
export type GenerateAiJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables>;
export const GenerateAiJobDescriptionV2Document = gql`
    mutation GenerateAiJobDescriptionV2($data: GenerateAiJobDescriptionInputV2!) {
  generateAiJobDescriptionV2(data: $data) {
    aiGeneratedId
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGenerateAiJobDescriptionV2Mutation__
 *
 * To run a mutation, you first call `useGenerateAiJobDescriptionV2Mutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiJobDescriptionV2Mutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateAiJobDescriptionV2Mutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useGenerateAiJobDescriptionV2Mutation(options: VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables>(GenerateAiJobDescriptionV2Document, options);
}
export type GenerateAiJobDescriptionV2MutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables>;
export const SendJobDescriptionToEmployeeDocument = gql`
    mutation SendJobDescriptionToEmployee($data: SendJobDescriptionToEmployeeInput!) {
  sendJobDescriptionToEmployee(data: $data) {
    id
    jobDescription {
      ...JobDescriptionParts
    }
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useSendJobDescriptionToEmployeeMutation__
 *
 * To run a mutation, you first call `useSendJobDescriptionToEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendJobDescriptionToEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendJobDescriptionToEmployeeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSendJobDescriptionToEmployeeMutation(options: VueApolloComposable.UseMutationOptions<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables>>) {
  return VueApolloComposable.useMutation<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables>(SendJobDescriptionToEmployeeDocument, options);
}
export type SendJobDescriptionToEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables>;
export const GetEmployeeJobDescriptionDocument = gql`
    query GetEmployeeJobDescription($userId: String!) {
  getEmployeeJobDescription(id: $userId) {
    ...EmployeeJobDescriptionParts
  }
}
    ${EmployeeJobDescriptionPartsFragmentDoc}`;

/**
 * __useGetEmployeeJobDescriptionQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeJobDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeJobDescriptionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeJobDescriptionQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useGetEmployeeJobDescriptionQuery(variables: GetEmployeeJobDescriptionQueryVariables | VueCompositionApi.Ref<GetEmployeeJobDescriptionQueryVariables> | ReactiveFunction<GetEmployeeJobDescriptionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>(GetEmployeeJobDescriptionDocument, variables, options);
}
export type GetEmployeeJobDescriptionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>;
export const SignEmployeeJobDescriptionDocument = gql`
    mutation SignEmployeeJobDescription($signEmployeeJobDescriptionId: String!) {
  signEmployeeJobDescription(id: $signEmployeeJobDescriptionId) {
    ...EmployeeJobDescriptionParts
  }
}
    ${EmployeeJobDescriptionPartsFragmentDoc}`;

/**
 * __useSignEmployeeJobDescriptionMutation__
 *
 * To run a mutation, you first call `useSignEmployeeJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignEmployeeJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignEmployeeJobDescriptionMutation({
 *   variables: {
 *     signEmployeeJobDescriptionId: // value for 'signEmployeeJobDescriptionId'
 *   },
 * });
 */
export function useSignEmployeeJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables>(SignEmployeeJobDescriptionDocument, options);
}
export type SignEmployeeJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables>;
export const GetJobDescriptionsDocument = gql`
    query GetJobDescriptions {
  jobDescriptions {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGetJobDescriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetJobDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDescriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetJobDescriptionsQuery();
 */
export function useGetJobDescriptionsQuery(options: VueApolloComposable.UseQueryOptions<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>(GetJobDescriptionsDocument, {}, options);
}
export type GetJobDescriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>;
export const GetStaffJobDescriptionsDocument = gql`
    query GetStaffJobDescriptions($page: Float!, $limit: Float!) {
  getMyCoreUser {
    id
    company {
      id
      paginatedEmployees(active: true, page: $page, limit: $limit) {
        id
        page
        totalPages
        totalCount
        result {
          id
          active
          profile {
            id
            firstName
            lastName
            avatarUrl
          }
          employment {
            id
            title
            workerRoles {
              id
              userId
              isPrimary
              employeeJobDescription {
                id
                signedAt
                createdAt
                jobDescription {
                  ...JobDescriptionParts
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGetStaffJobDescriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetStaffJobDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffJobDescriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStaffJobDescriptionsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetStaffJobDescriptionsQuery(variables: GetStaffJobDescriptionsQueryVariables | VueCompositionApi.Ref<GetStaffJobDescriptionsQueryVariables> | ReactiveFunction<GetStaffJobDescriptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>(GetStaffJobDescriptionsDocument, variables, options);
}
export type GetStaffJobDescriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>;
export const MyNotificationsDocument = gql`
    query MyNotifications {
  myNotifications {
    id
    level
    subject
    body
    dismissible
    dismissedAt
    targets {
      id
      type
    }
    actions {
      id
      label
      type
      value
    }
    createdAt
  }
}
    `;

/**
 * __useMyNotificationsQuery__
 *
 * To run a query within a Vue component, call `useMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyNotificationsQuery();
 */
export function useMyNotificationsQuery(options: VueApolloComposable.UseQueryOptions<MyNotificationsQuery, MyNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyNotificationsQuery, MyNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyNotificationsQuery, MyNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyNotificationsQuery, MyNotificationsQueryVariables>(MyNotificationsDocument, {}, options);
}
export type MyNotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyNotificationsQuery, MyNotificationsQueryVariables>;
export const DismissNotificationDocument = gql`
    mutation DismissNotification($input: String!) {
  dismissNotification(id: $input) {
    id
    dismissedAt
  }
}
    `;

/**
 * __useDismissNotificationMutation__
 *
 * To run a mutation, you first call `useDismissNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDismissNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDismissNotificationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDismissNotificationMutation(options: VueApolloComposable.UseMutationOptions<DismissNotificationMutation, DismissNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DismissNotificationMutation, DismissNotificationMutationVariables>>) {
  return VueApolloComposable.useMutation<DismissNotificationMutation, DismissNotificationMutationVariables>(DismissNotificationDocument, options);
}
export type DismissNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DismissNotificationMutation, DismissNotificationMutationVariables>;
export const ClickedOnNotificationActionDocument = gql`
    mutation ClickedOnNotificationAction($actionId: String!) {
  clickedOnNotificationAction(actionId: $actionId)
}
    `;

/**
 * __useClickedOnNotificationActionMutation__
 *
 * To run a mutation, you first call `useClickedOnNotificationActionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClickedOnNotificationActionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClickedOnNotificationActionMutation({
 *   variables: {
 *     actionId: // value for 'actionId'
 *   },
 * });
 */
export function useClickedOnNotificationActionMutation(options: VueApolloComposable.UseMutationOptions<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables>>) {
  return VueApolloComposable.useMutation<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables>(ClickedOnNotificationActionDocument, options);
}
export type ClickedOnNotificationActionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables>;
export const AssignUserToPoliciesDocument = gql`
    mutation AssignUserToPolicies($data: AssignUserToPoliciesInput!) {
  assignUserToPolicies(data: $data) {
    id
  }
}
    `;

/**
 * __useAssignUserToPoliciesMutation__
 *
 * To run a mutation, you first call `useAssignUserToPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserToPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignUserToPoliciesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAssignUserToPoliciesMutation(options: VueApolloComposable.UseMutationOptions<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables>(AssignUserToPoliciesDocument, options);
}
export type AssignUserToPoliciesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables>;
export const EnrollMfaDeviceDocument = gql`
    mutation EnrollMFADevice($input: AuthMfaSmsEnrollmentInput!) {
  enrollMfaDevice(input: $input) {
    nonce
    expiration
  }
}
    `;

/**
 * __useEnrollMfaDeviceMutation__
 *
 * To run a mutation, you first call `useEnrollMfaDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnrollMfaDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnrollMfaDeviceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEnrollMfaDeviceMutation(options: VueApolloComposable.UseMutationOptions<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables>>) {
  return VueApolloComposable.useMutation<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables>(EnrollMfaDeviceDocument, options);
}
export type EnrollMfaDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables>;
export const CreateMfaChallengeDocument = gql`
    mutation createMfaChallenge($reason: String!, $type: AuthMfaType!) {
  createChallenge(reason: $reason, type: $type) {
    nonce
    metadata {
      phoneLast4
    }
  }
}
    `;

/**
 * __useCreateMfaChallengeMutation__
 *
 * To run a mutation, you first call `useCreateMfaChallengeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMfaChallengeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMfaChallengeMutation({
 *   variables: {
 *     reason: // value for 'reason'
 *     type: // value for 'type'
 *   },
 * });
 */
export function useCreateMfaChallengeMutation(options: VueApolloComposable.UseMutationOptions<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables>(CreateMfaChallengeDocument, options);
}
export type CreateMfaChallengeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables>;
export const ResendChallengeDocument = gql`
    mutation resendChallenge($nonceId: String!, $reason: String!, $type: AuthMfaType!) {
  resendChallenge(nonceId: $nonceId, reason: $reason, type: $type) {
    nonce
    metadata {
      phoneLast4
    }
  }
}
    `;

/**
 * __useResendChallengeMutation__
 *
 * To run a mutation, you first call `useResendChallengeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendChallengeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendChallengeMutation({
 *   variables: {
 *     nonceId: // value for 'nonceId'
 *     reason: // value for 'reason'
 *     type: // value for 'type'
 *   },
 * });
 */
export function useResendChallengeMutation(options: VueApolloComposable.UseMutationOptions<ResendChallengeMutation, ResendChallengeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResendChallengeMutation, ResendChallengeMutationVariables>>) {
  return VueApolloComposable.useMutation<ResendChallengeMutation, ResendChallengeMutationVariables>(ResendChallengeDocument, options);
}
export type ResendChallengeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResendChallengeMutation, ResendChallengeMutationVariables>;
export const ConfirmUserMfaEnrollmentDocument = gql`
    mutation ConfirmUserMfaEnrollment($input: AuthMfaChallengeResponseInput!) {
  confirmUserMfaEnrollment(input: $input) {
    mfaType
    createdAt
    lastChallengedAt
    lastDevice
    backupCode
  }
}
    `;

/**
 * __useConfirmUserMfaEnrollmentMutation__
 *
 * To run a mutation, you first call `useConfirmUserMfaEnrollmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserMfaEnrollmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmUserMfaEnrollmentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConfirmUserMfaEnrollmentMutation(options: VueApolloComposable.UseMutationOptions<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables>(ConfirmUserMfaEnrollmentDocument, options);
}
export type ConfirmUserMfaEnrollmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables>;
export const ApprovePayrollDocument = gql`
    mutation approvePayroll($data: ApprovePayrollInput!) {
  approvePayroll(data: $data) {
    ...PayrollWithoutNestedPaymentsParts
  }
}
    ${PayrollWithoutNestedPaymentsPartsFragmentDoc}`;

/**
 * __useApprovePayrollMutation__
 *
 * To run a mutation, you first call `useApprovePayrollMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApprovePayrollMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApprovePayrollMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useApprovePayrollMutation(options: VueApolloComposable.UseMutationOptions<ApprovePayrollMutation, ApprovePayrollMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApprovePayrollMutation, ApprovePayrollMutationVariables>>) {
  return VueApolloComposable.useMutation<ApprovePayrollMutation, ApprovePayrollMutationVariables>(ApprovePayrollDocument, options);
}
export type ApprovePayrollMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApprovePayrollMutation, ApprovePayrollMutationVariables>;
export const DeletePayrollDocument = gql`
    mutation DeletePayroll($data: DeletePayrollInput!) {
  deletePayroll(data: $data) {
    id
    deletedAt
  }
}
    `;

/**
 * __useDeletePayrollMutation__
 *
 * To run a mutation, you first call `useDeletePayrollMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayrollMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePayrollMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useDeletePayrollMutation(options: VueApolloComposable.UseMutationOptions<DeletePayrollMutation, DeletePayrollMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePayrollMutation, DeletePayrollMutationVariables>>) {
  return VueApolloComposable.useMutation<DeletePayrollMutation, DeletePayrollMutationVariables>(DeletePayrollDocument, options);
}
export type DeletePayrollMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePayrollMutation, DeletePayrollMutationVariables>;
export const CreatePayrollDocument = gql`
    mutation CreatePayroll($data: CreatePayrollInput!) {
  createPayroll(data: $data) {
    id
  }
}
    `;

/**
 * __useCreatePayrollMutation__
 *
 * To run a mutation, you first call `useCreatePayrollMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayrollMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePayrollMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreatePayrollMutation(options: VueApolloComposable.UseMutationOptions<CreatePayrollMutation, CreatePayrollMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePayrollMutation, CreatePayrollMutationVariables>>) {
  return VueApolloComposable.useMutation<CreatePayrollMutation, CreatePayrollMutationVariables>(CreatePayrollDocument, options);
}
export type CreatePayrollMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePayrollMutation, CreatePayrollMutationVariables>;
export const InitPayrollDocument = gql`
    mutation InitPayroll($data: InitializePayrollInput!) {
  initializePayroll(data: $data) {
    id
  }
}
    `;

/**
 * __useInitPayrollMutation__
 *
 * To run a mutation, you first call `useInitPayrollMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInitPayrollMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInitPayrollMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useInitPayrollMutation(options: VueApolloComposable.UseMutationOptions<InitPayrollMutation, InitPayrollMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InitPayrollMutation, InitPayrollMutationVariables>>) {
  return VueApolloComposable.useMutation<InitPayrollMutation, InitPayrollMutationVariables>(InitPayrollDocument, options);
}
export type InitPayrollMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InitPayrollMutation, InitPayrollMutationVariables>;
export const UpdatePayrollDocument = gql`
    mutation UpdatePayroll($data: UpdatePayrollInput!) {
  updatePayroll(data: $data) {
    ...PayrollParts
  }
}
    ${PayrollPartsFragmentDoc}`;

/**
 * __useUpdatePayrollMutation__
 *
 * To run a mutation, you first call `useUpdatePayrollMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayrollMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePayrollMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayrollMutation(options: VueApolloComposable.UseMutationOptions<UpdatePayrollMutation, UpdatePayrollMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePayrollMutation, UpdatePayrollMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePayrollMutation, UpdatePayrollMutationVariables>(UpdatePayrollDocument, options);
}
export type UpdatePayrollMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePayrollMutation, UpdatePayrollMutationVariables>;
export const UpdatePayrollItemDocument = gql`
    mutation UpdatePayrollItem($data: UpdatePayrollItemInput!) {
  updatePayrollItem(data: $data) {
    ...ItemParts
  }
}
    ${ItemPartsFragmentDoc}`;

/**
 * __useUpdatePayrollItemMutation__
 *
 * To run a mutation, you first call `useUpdatePayrollItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayrollItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePayrollItemMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayrollItemMutation(options: VueApolloComposable.UseMutationOptions<UpdatePayrollItemMutation, UpdatePayrollItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePayrollItemMutation, UpdatePayrollItemMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePayrollItemMutation, UpdatePayrollItemMutationVariables>(UpdatePayrollItemDocument, options);
}
export type UpdatePayrollItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePayrollItemMutation, UpdatePayrollItemMutationVariables>;
export const UpdateContractorPaymentDocument = gql`
    mutation UpdateContractorPayment($data: UpdateContractorPaymentInput!) {
  updateContractorPayment(data: $data) {
    ...PaymentParts
  }
}
    ${PaymentPartsFragmentDoc}`;

/**
 * __useUpdateContractorPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateContractorPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateContractorPaymentMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContractorPaymentMutation(options: VueApolloComposable.UseMutationOptions<UpdateContractorPaymentMutation, UpdateContractorPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateContractorPaymentMutation, UpdateContractorPaymentMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateContractorPaymentMutation, UpdateContractorPaymentMutationVariables>(UpdateContractorPaymentDocument, options);
}
export type UpdateContractorPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateContractorPaymentMutation, UpdateContractorPaymentMutationVariables>;
export const UpdatePayrollChecksDocument = gql`
    mutation UpdatePayrollChecks($data: UpdatePayrollChecksInput!) {
  updatePayrollChecks(data: $data) {
    id
    items {
      id
      checkNumber
    }
    contractorPayments {
      id
      checkNumber
    }
    needsChecksEntered
  }
}
    `;

/**
 * __useUpdatePayrollChecksMutation__
 *
 * To run a mutation, you first call `useUpdatePayrollChecksMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayrollChecksMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePayrollChecksMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayrollChecksMutation(options: VueApolloComposable.UseMutationOptions<UpdatePayrollChecksMutation, UpdatePayrollChecksMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePayrollChecksMutation, UpdatePayrollChecksMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePayrollChecksMutation, UpdatePayrollChecksMutationVariables>(UpdatePayrollChecksDocument, options);
}
export type UpdatePayrollChecksMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePayrollChecksMutation, UpdatePayrollChecksMutationVariables>;
export const PreviewPayrollDocument = gql`
    mutation PreviewPayroll($id: ID!) {
  previewPayroll(id: $id) {
    ...PayrollPreviewParts
  }
}
    ${PayrollPreviewPartsFragmentDoc}`;

/**
 * __usePreviewPayrollMutation__
 *
 * To run a mutation, you first call `usePreviewPayrollMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePreviewPayrollMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePreviewPayrollMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePreviewPayrollMutation(options: VueApolloComposable.UseMutationOptions<PreviewPayrollMutation, PreviewPayrollMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PreviewPayrollMutation, PreviewPayrollMutationVariables>>) {
  return VueApolloComposable.useMutation<PreviewPayrollMutation, PreviewPayrollMutationVariables>(PreviewPayrollDocument, options);
}
export type PreviewPayrollMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PreviewPayrollMutation, PreviewPayrollMutationVariables>;
export const GenerateEmployeeOnboardingLinkDocument = gql`
    mutation GenerateEmployeeOnboardingLink($id: ID!) {
  generateEmployeeOnboardingLink(id: $id)
}
    `;

/**
 * __useGenerateEmployeeOnboardingLinkMutation__
 *
 * To run a mutation, you first call `useGenerateEmployeeOnboardingLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEmployeeOnboardingLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateEmployeeOnboardingLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useGenerateEmployeeOnboardingLinkMutation(options: VueApolloComposable.UseMutationOptions<GenerateEmployeeOnboardingLinkMutation, GenerateEmployeeOnboardingLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateEmployeeOnboardingLinkMutation, GenerateEmployeeOnboardingLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateEmployeeOnboardingLinkMutation, GenerateEmployeeOnboardingLinkMutationVariables>(GenerateEmployeeOnboardingLinkDocument, options);
}
export type GenerateEmployeeOnboardingLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateEmployeeOnboardingLinkMutation, GenerateEmployeeOnboardingLinkMutationVariables>;
export const GenerateContractorOnboardingLinkDocument = gql`
    mutation GenerateContractorOnboardingLink($id: ID!) {
  generateContractorOnboardingLink(id: $id)
}
    `;

/**
 * __useGenerateContractorOnboardingLinkMutation__
 *
 * To run a mutation, you first call `useGenerateContractorOnboardingLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateContractorOnboardingLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateContractorOnboardingLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useGenerateContractorOnboardingLinkMutation(options: VueApolloComposable.UseMutationOptions<GenerateContractorOnboardingLinkMutation, GenerateContractorOnboardingLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateContractorOnboardingLinkMutation, GenerateContractorOnboardingLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateContractorOnboardingLinkMutation, GenerateContractorOnboardingLinkMutationVariables>(GenerateContractorOnboardingLinkDocument, options);
}
export type GenerateContractorOnboardingLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateContractorOnboardingLinkMutation, GenerateContractorOnboardingLinkMutationVariables>;
export const GenerateCompanyOnboardingLinkDocument = gql`
    mutation GenerateCompanyOnboardingLink($data: GenerateCompanyOnboardingLinkInput!) {
  generateCompanyOnboardingLink(data: $data)
}
    `;

/**
 * __useGenerateCompanyOnboardingLinkMutation__
 *
 * To run a mutation, you first call `useGenerateCompanyOnboardingLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompanyOnboardingLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateCompanyOnboardingLinkMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useGenerateCompanyOnboardingLinkMutation(options: VueApolloComposable.UseMutationOptions<GenerateCompanyOnboardingLinkMutation, GenerateCompanyOnboardingLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateCompanyOnboardingLinkMutation, GenerateCompanyOnboardingLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateCompanyOnboardingLinkMutation, GenerateCompanyOnboardingLinkMutationVariables>(GenerateCompanyOnboardingLinkDocument, options);
}
export type GenerateCompanyOnboardingLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateCompanyOnboardingLinkMutation, GenerateCompanyOnboardingLinkMutationVariables>;
export const GenerateEmployeePostTaxDeductionsLinkDocument = gql`
    mutation GenerateEmployeePostTaxDeductionsLink($id: ID!) {
  generateEmployeePostTaxDeductionsLink(id: $id)
}
    `;

/**
 * __useGenerateEmployeePostTaxDeductionsLinkMutation__
 *
 * To run a mutation, you first call `useGenerateEmployeePostTaxDeductionsLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEmployeePostTaxDeductionsLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateEmployeePostTaxDeductionsLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useGenerateEmployeePostTaxDeductionsLinkMutation(options: VueApolloComposable.UseMutationOptions<GenerateEmployeePostTaxDeductionsLinkMutation, GenerateEmployeePostTaxDeductionsLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateEmployeePostTaxDeductionsLinkMutation, GenerateEmployeePostTaxDeductionsLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateEmployeePostTaxDeductionsLinkMutation, GenerateEmployeePostTaxDeductionsLinkMutationVariables>(GenerateEmployeePostTaxDeductionsLinkDocument, options);
}
export type GenerateEmployeePostTaxDeductionsLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateEmployeePostTaxDeductionsLinkMutation, GenerateEmployeePostTaxDeductionsLinkMutationVariables>;
export const GenerateCompanyPayrollReportLinkDocument = gql`
    mutation GenerateCompanyPayrollReportLink($id: ID!) {
  generateCompanyPayrollReportLink(id: $id)
}
    `;

/**
 * __useGenerateCompanyPayrollReportLinkMutation__
 *
 * To run a mutation, you first call `useGenerateCompanyPayrollReportLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompanyPayrollReportLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateCompanyPayrollReportLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useGenerateCompanyPayrollReportLinkMutation(options: VueApolloComposable.UseMutationOptions<GenerateCompanyPayrollReportLinkMutation, GenerateCompanyPayrollReportLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateCompanyPayrollReportLinkMutation, GenerateCompanyPayrollReportLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateCompanyPayrollReportLinkMutation, GenerateCompanyPayrollReportLinkMutationVariables>(GenerateCompanyPayrollReportLinkDocument, options);
}
export type GenerateCompanyPayrollReportLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateCompanyPayrollReportLinkMutation, GenerateCompanyPayrollReportLinkMutationVariables>;
export const CreatePayScheduleDocument = gql`
    mutation createPaySchedule($data: CreatePayScheduleInput!, $coreData: UpdateCoreCompanyInput!) {
  createPaySchedule(data: $data) {
    id
  }
  updateCoreCompany(data: $coreData) {
    id
    payDayOfWeek
    payDayOfMonth
  }
}
    `;

/**
 * __useCreatePayScheduleMutation__
 *
 * To run a mutation, you first call `useCreatePayScheduleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayScheduleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePayScheduleMutation({
 *   variables: {
 *     data: // value for 'data'
 *     coreData: // value for 'coreData'
 *   },
 * });
 */
export function useCreatePayScheduleMutation(options: VueApolloComposable.UseMutationOptions<CreatePayScheduleMutation, CreatePayScheduleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePayScheduleMutation, CreatePayScheduleMutationVariables>>) {
  return VueApolloComposable.useMutation<CreatePayScheduleMutation, CreatePayScheduleMutationVariables>(CreatePayScheduleDocument, options);
}
export type CreatePayScheduleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePayScheduleMutation, CreatePayScheduleMutationVariables>;
export const UpdateWorkplaceDocument = gql`
    mutation UpdateWorkplace($data: UpdateWorkplaceInput!) {
  updateWorkplace(data: $data) {
    active
    address {
      ...AddressParts
    }
    default
    id
    name
  }
}
    ${AddressPartsFragmentDoc}`;

/**
 * __useUpdateWorkplaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkplaceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkplaceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWorkplaceMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWorkplaceMutation(options: VueApolloComposable.UseMutationOptions<UpdateWorkplaceMutation, UpdateWorkplaceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWorkplaceMutation, UpdateWorkplaceMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateWorkplaceMutation, UpdateWorkplaceMutationVariables>(UpdateWorkplaceDocument, options);
}
export type UpdateWorkplaceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWorkplaceMutation, UpdateWorkplaceMutationVariables>;
export const CreateWorkplaceDocument = gql`
    mutation CreateWorkplace($data: CreateWorkplaceInput!) {
  createWorkplace(data: $data) {
    id
    name
    default
    address {
      ...AddressParts
    }
  }
}
    ${AddressPartsFragmentDoc}`;

/**
 * __useCreateWorkplaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkplaceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkplaceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWorkplaceMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateWorkplaceMutation(options: VueApolloComposable.UseMutationOptions<CreateWorkplaceMutation, CreateWorkplaceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateWorkplaceMutation, CreateWorkplaceMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateWorkplaceMutation, CreateWorkplaceMutationVariables>(CreateWorkplaceDocument, options);
}
export type CreateWorkplaceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateWorkplaceMutation, CreateWorkplaceMutationVariables>;
export const CreateCompanyInCheckDocument = gql`
    mutation CreateCompanyInCheck($data: CreateCompanyInCheckInput!) {
  createCompanyInCheck(data: $data) {
    id
    checkId
  }
}
    `;

/**
 * __useCreateCompanyInCheckMutation__
 *
 * To run a mutation, you first call `useCreateCompanyInCheckMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyInCheckMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCompanyInCheckMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompanyInCheckMutation(options: VueApolloComposable.UseMutationOptions<CreateCompanyInCheckMutation, CreateCompanyInCheckMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCompanyInCheckMutation, CreateCompanyInCheckMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateCompanyInCheckMutation, CreateCompanyInCheckMutationVariables>(CreateCompanyInCheckDocument, options);
}
export type CreateCompanyInCheckMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCompanyInCheckMutation, CreateCompanyInCheckMutationVariables>;
export const UpgradeFinchCodeDocument = gql`
    mutation upgradeFinchCode($data: UserFinchCodeInput!) {
  upgradeFinchCode(data: $data) {
    id
  }
}
    `;

/**
 * __useUpgradeFinchCodeMutation__
 *
 * To run a mutation, you first call `useUpgradeFinchCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeFinchCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpgradeFinchCodeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpgradeFinchCodeMutation(options: VueApolloComposable.UseMutationOptions<UpgradeFinchCodeMutation, UpgradeFinchCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpgradeFinchCodeMutation, UpgradeFinchCodeMutationVariables>>) {
  return VueApolloComposable.useMutation<UpgradeFinchCodeMutation, UpgradeFinchCodeMutationVariables>(UpgradeFinchCodeDocument, options);
}
export type UpgradeFinchCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpgradeFinchCodeMutation, UpgradeFinchCodeMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($data: UpdateCompanyInput!) {
  updateCompany(data: $data) {
    id
    tosVersion
    needsPayScheduleAssistance
    excludedStaffIds
    deputyTosAcceptedAt
  }
}
    `;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompanyMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyMutation(options: VueApolloComposable.UseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
}
export type UpdateCompanyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const SetupEmployeeDocument = gql`
    mutation SetupEmployee($data: SetupEmployeeInput!) {
  setupEmployee(data: $data) {
    bankAccounts {
      ...BankAccountParts
    }
    checkId
    checkOnboarding {
      id
      remainingSteps
      status
    }
    id
    payRate
    paymentMethodPreference
    payType
    profile {
      id
      firstName
      lastName
      title
      homeAddress {
        city
        line1
        state
        zip
      }
    }
    workplaces {
      id
      active
      address {
        ...AddressParts
      }
      default
      name
    }
  }
}
    ${BankAccountPartsFragmentDoc}
${AddressPartsFragmentDoc}`;

/**
 * __useSetupEmployeeMutation__
 *
 * To run a mutation, you first call `useSetupEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetupEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetupEmployeeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSetupEmployeeMutation(options: VueApolloComposable.UseMutationOptions<SetupEmployeeMutation, SetupEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetupEmployeeMutation, SetupEmployeeMutationVariables>>) {
  return VueApolloComposable.useMutation<SetupEmployeeMutation, SetupEmployeeMutationVariables>(SetupEmployeeDocument, options);
}
export type SetupEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetupEmployeeMutation, SetupEmployeeMutationVariables>;
export const SetupContractorDocument = gql`
    mutation SetupContractor($data: SetupContractorInput!) {
  setupContractor(data: $data) {
    bankAccounts {
      institutionName
      mask
    }
    checkId
    checkOnboarding {
      id
      remainingSteps
      status
    }
    id
    payRate
    paymentMethodPreference
    payType
    profile {
      id
      contractorBusinessName
      firstName
      lastName
      title
    }
  }
}
    `;

/**
 * __useSetupContractorMutation__
 *
 * To run a mutation, you first call `useSetupContractorMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetupContractorMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetupContractorMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSetupContractorMutation(options: VueApolloComposable.UseMutationOptions<SetupContractorMutation, SetupContractorMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetupContractorMutation, SetupContractorMutationVariables>>) {
  return VueApolloComposable.useMutation<SetupContractorMutation, SetupContractorMutationVariables>(SetupContractorDocument, options);
}
export type SetupContractorMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetupContractorMutation, SetupContractorMutationVariables>;
export const UpdateEmployeeWorkplaceDocument = gql`
    mutation UpdateEmployeeWorkplace($data: UpdateEmployeeWorkplaceInput!) {
  updateEmployeeWorkplace(data: $data)
}
    `;

/**
 * __useUpdateEmployeeWorkplaceMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeWorkplaceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeWorkplaceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEmployeeWorkplaceMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmployeeWorkplaceMutation(options: VueApolloComposable.UseMutationOptions<UpdateEmployeeWorkplaceMutation, UpdateEmployeeWorkplaceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateEmployeeWorkplaceMutation, UpdateEmployeeWorkplaceMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateEmployeeWorkplaceMutation, UpdateEmployeeWorkplaceMutationVariables>(UpdateEmployeeWorkplaceDocument, options);
}
export type UpdateEmployeeWorkplaceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateEmployeeWorkplaceMutation, UpdateEmployeeWorkplaceMutationVariables>;
export const UpdateContractorWorkplaceDocument = gql`
    mutation UpdateContractorWorkplace($data: UpdateContractorWorkplaceInput!) {
  updateContractorWorkplace(data: $data)
}
    `;

/**
 * __useUpdateContractorWorkplaceMutation__
 *
 * To run a mutation, you first call `useUpdateContractorWorkplaceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorWorkplaceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateContractorWorkplaceMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContractorWorkplaceMutation(options: VueApolloComposable.UseMutationOptions<UpdateContractorWorkplaceMutation, UpdateContractorWorkplaceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateContractorWorkplaceMutation, UpdateContractorWorkplaceMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateContractorWorkplaceMutation, UpdateContractorWorkplaceMutationVariables>(UpdateContractorWorkplaceDocument, options);
}
export type UpdateContractorWorkplaceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateContractorWorkplaceMutation, UpdateContractorWorkplaceMutationVariables>;
export const SendStaffOnboardInviteDocument = gql`
    mutation SendStaffOnboardInvite($data: SendStaffOnboardInviteInput!) {
  sendStaffOnboardInvite(data: $data)
}
    `;

/**
 * __useSendStaffOnboardInviteMutation__
 *
 * To run a mutation, you first call `useSendStaffOnboardInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendStaffOnboardInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendStaffOnboardInviteMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSendStaffOnboardInviteMutation(options: VueApolloComposable.UseMutationOptions<SendStaffOnboardInviteMutation, SendStaffOnboardInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendStaffOnboardInviteMutation, SendStaffOnboardInviteMutationVariables>>) {
  return VueApolloComposable.useMutation<SendStaffOnboardInviteMutation, SendStaffOnboardInviteMutationVariables>(SendStaffOnboardInviteDocument, options);
}
export type SendStaffOnboardInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendStaffOnboardInviteMutation, SendStaffOnboardInviteMutationVariables>;
export const BulkEarningsImportDocument = gql`
    mutation BulkEarningsImport($data: BulkEarningsImportInput!) {
  bulkEarningsImport(data: $data) {
    errors {
      errorMsg
      staffId
    }
    payroll {
      ...PayrollParts
    }
    successfulStaffIds
  }
}
    ${PayrollPartsFragmentDoc}`;

/**
 * __useBulkEarningsImportMutation__
 *
 * To run a mutation, you first call `useBulkEarningsImportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkEarningsImportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkEarningsImportMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkEarningsImportMutation(options: VueApolloComposable.UseMutationOptions<BulkEarningsImportMutation, BulkEarningsImportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkEarningsImportMutation, BulkEarningsImportMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkEarningsImportMutation, BulkEarningsImportMutationVariables>(BulkEarningsImportDocument, options);
}
export type BulkEarningsImportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkEarningsImportMutation, BulkEarningsImportMutationVariables>;
export const FinchManualSetupCompletedDocument = gql`
    mutation FinchManualSetupCompleted($data: FinchManualSetupCompletedInput!) {
  finchManualSetupCompleted(data: $data)
}
    `;

/**
 * __useFinchManualSetupCompletedMutation__
 *
 * To run a mutation, you first call `useFinchManualSetupCompletedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFinchManualSetupCompletedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFinchManualSetupCompletedMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useFinchManualSetupCompletedMutation(options: VueApolloComposable.UseMutationOptions<FinchManualSetupCompletedMutation, FinchManualSetupCompletedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FinchManualSetupCompletedMutation, FinchManualSetupCompletedMutationVariables>>) {
  return VueApolloComposable.useMutation<FinchManualSetupCompletedMutation, FinchManualSetupCompletedMutationVariables>(FinchManualSetupCompletedDocument, options);
}
export type FinchManualSetupCompletedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FinchManualSetupCompletedMutation, FinchManualSetupCompletedMutationVariables>;
export const CheckSyncCompanyDocument = gql`
    mutation CheckSyncCompany($data: CheckSyncCompanyInput!) {
  checkSyncCompany(data: $data) {
    ...CompanyStatusParts
  }
}
    ${CompanyStatusPartsFragmentDoc}`;

/**
 * __useCheckSyncCompanyMutation__
 *
 * To run a mutation, you first call `useCheckSyncCompanyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCheckSyncCompanyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCheckSyncCompanyMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCheckSyncCompanyMutation(options: VueApolloComposable.UseMutationOptions<CheckSyncCompanyMutation, CheckSyncCompanyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CheckSyncCompanyMutation, CheckSyncCompanyMutationVariables>>) {
  return VueApolloComposable.useMutation<CheckSyncCompanyMutation, CheckSyncCompanyMutationVariables>(CheckSyncCompanyDocument, options);
}
export type CheckSyncCompanyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CheckSyncCompanyMutation, CheckSyncCompanyMutationVariables>;
export const DeleteCompanyRolesDocument = gql`
    mutation DeleteCompanyRoles($data: DeleteCompanyRolesInput!) {
  deleteCompanyRolesById(data: $data) {
    id
    title
    companyId
    deletedAt
  }
}
    `;

/**
 * __useDeleteCompanyRolesMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCompanyRolesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCompanyRolesMutation(options: VueApolloComposable.UseMutationOptions<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables>(DeleteCompanyRolesDocument, options);
}
export type DeleteCompanyRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables>;
export const CreateCompanyRolesDocument = gql`
    mutation CreateCompanyRoles($data: CreateMultipleRolesForCompanyInput!) {
  createCompanyRoles(data: $data) {
    companyId
    title
    id
    deletedAt
  }
}
    `;

/**
 * __useCreateCompanyRolesMutation__
 *
 * To run a mutation, you first call `useCreateCompanyRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCompanyRolesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompanyRolesMutation(options: VueApolloComposable.UseMutationOptions<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables>(CreateCompanyRolesDocument, options);
}
export type CreateCompanyRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables>;
export const UpdateCompanyRolesDocument = gql`
    mutation UpdateCompanyRoles($data: UpdateMultipleRolesForCompanyInput!) {
  updateCompanyRoles(data: $data) {
    companyId
    title
    id
    deletedAt
    createdAt
    workerRoles {
      id
      deletedAt
    }
  }
}
    `;

/**
 * __useUpdateCompanyRolesMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompanyRolesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyRolesMutation(options: VueApolloComposable.UseMutationOptions<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables>(UpdateCompanyRolesDocument, options);
}
export type UpdateCompanyRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables>;
export const AssignWorkerRolesDocument = gql`
    mutation AssignWorkerRoles($data: AssignWorkerRolesInput!) {
  assignWorkerRoles(input: $data) {
    id
    employment {
      id
      workerRoles {
        id
        isPrimary
        payRate
        deletedAt
        companyRole {
          id
          title
          deletedAt
          workerRoles {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssignWorkerRolesMutation__
 *
 * To run a mutation, you first call `useAssignWorkerRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignWorkerRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignWorkerRolesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAssignWorkerRolesMutation(options: VueApolloComposable.UseMutationOptions<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables>(AssignWorkerRolesDocument, options);
}
export type AssignWorkerRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables>;
export const SubmitPayrollOnboardingFormDocument = gql`
    mutation SubmitPayrollOnboardingForm($coreData: UpdateCoreCompanyInput!, $payrollData: UpdateCompanyInput!, $syncCompanyData: SyncCompanyInput!, $enrollmentProfile: CreateEnrollmentProfileRequest!, $checkCompanyInfo: CreateCompanyInCheckInput!, $shouldCreateCompanyInCheck: Boolean!) {
  updateCoreCompany(data: $coreData) {
    address {
      city
      line1
      line2
      state
      zipCode
    }
    fein
    name
    id
    numOfContractors
    numOfFullTimeHourlyEmployees
    numOfFullTimeSalaryEmployees
    numOfPartTimeEmployees
    website
  }
  updateCompany(data: $payrollData) {
    id
    checkIndustry
    processedPayrollsThisYear
    signatoryFirstName
    signatoryLastName
    signatoryTitle
    signatoryEmail
    onboardingOffersEmployeeBenefits
    onboardingHasGarnishmentsOrDeductions
    onboardingGarnishmentsOrDeductions
    onboardingGarnishmentsOrDeductionsOther
  }
  createCompanyInCheck(data: $checkCompanyInfo) @include(if: $shouldCreateCompanyInCheck) {
    id
    checkId
  }
  syncCompany(data: $syncCompanyData) {
    id
  }
  createEnrollmentProfile(data: $enrollmentProfile)
}
    `;

/**
 * __useSubmitPayrollOnboardingFormMutation__
 *
 * To run a mutation, you first call `useSubmitPayrollOnboardingFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPayrollOnboardingFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitPayrollOnboardingFormMutation({
 *   variables: {
 *     coreData: // value for 'coreData'
 *     payrollData: // value for 'payrollData'
 *     syncCompanyData: // value for 'syncCompanyData'
 *     enrollmentProfile: // value for 'enrollmentProfile'
 *     checkCompanyInfo: // value for 'checkCompanyInfo'
 *     shouldCreateCompanyInCheck: // value for 'shouldCreateCompanyInCheck'
 *   },
 * });
 */
export function useSubmitPayrollOnboardingFormMutation(options: VueApolloComposable.UseMutationOptions<SubmitPayrollOnboardingFormMutation, SubmitPayrollOnboardingFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SubmitPayrollOnboardingFormMutation, SubmitPayrollOnboardingFormMutationVariables>>) {
  return VueApolloComposable.useMutation<SubmitPayrollOnboardingFormMutation, SubmitPayrollOnboardingFormMutationVariables>(SubmitPayrollOnboardingFormDocument, options);
}
export type SubmitPayrollOnboardingFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SubmitPayrollOnboardingFormMutation, SubmitPayrollOnboardingFormMutationVariables>;
export const UpdatePayrollSignatoryDocument = gql`
    mutation UpdatePayrollSignatory($data: UpdateCompanyInput!) {
  updateCompany(data: $data) {
    id
    signatoryFirstName
    signatoryLastName
    signatoryTitle
    signatoryEmail
  }
}
    `;

/**
 * __useUpdatePayrollSignatoryMutation__
 *
 * To run a mutation, you first call `useUpdatePayrollSignatoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayrollSignatoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePayrollSignatoryMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayrollSignatoryMutation(options: VueApolloComposable.UseMutationOptions<UpdatePayrollSignatoryMutation, UpdatePayrollSignatoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePayrollSignatoryMutation, UpdatePayrollSignatoryMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePayrollSignatoryMutation, UpdatePayrollSignatoryMutationVariables>(UpdatePayrollSignatoryDocument, options);
}
export type UpdatePayrollSignatoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePayrollSignatoryMutation, UpdatePayrollSignatoryMutationVariables>;
export const VerifyFeinInCheckDocument = gql`
    mutation VerifyFEINInCheck($feinData: UpdateCoreCompanyInput!, $verifyData: VerifyFEINInCheckInput!, $syncCompanyData: SyncCompanyInput!) {
  updateCoreCompany(data: $feinData) {
    fein
    name
    id
  }
  syncCompany(data: $syncCompanyData) {
    id
  }
  verifyFEINInCheck(data: $verifyData) {
    id
    feinVerification {
      id
      legalName
      federalEin
      status
      company
    }
    feinVerificationAttempts
  }
}
    `;

/**
 * __useVerifyFeinInCheckMutation__
 *
 * To run a mutation, you first call `useVerifyFeinInCheckMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVerifyFeinInCheckMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVerifyFeinInCheckMutation({
 *   variables: {
 *     feinData: // value for 'feinData'
 *     verifyData: // value for 'verifyData'
 *     syncCompanyData: // value for 'syncCompanyData'
 *   },
 * });
 */
export function useVerifyFeinInCheckMutation(options: VueApolloComposable.UseMutationOptions<VerifyFeinInCheckMutation, VerifyFeinInCheckMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<VerifyFeinInCheckMutation, VerifyFeinInCheckMutationVariables>>) {
  return VueApolloComposable.useMutation<VerifyFeinInCheckMutation, VerifyFeinInCheckMutationVariables>(VerifyFeinInCheckDocument, options);
}
export type VerifyFeinInCheckMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<VerifyFeinInCheckMutation, VerifyFeinInCheckMutationVariables>;
export const UploadRequirementFileDocument = gql`
    mutation UploadRequirementFile($data: UploadFileInput!) {
  uploadFile(data: $data) {
    ...CompanyGoalParts
  }
}
    ${CompanyGoalPartsFragmentDoc}`;

/**
 * __useUploadRequirementFileMutation__
 *
 * To run a mutation, you first call `useUploadRequirementFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadRequirementFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadRequirementFileMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUploadRequirementFileMutation(options: VueApolloComposable.UseMutationOptions<UploadRequirementFileMutation, UploadRequirementFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadRequirementFileMutation, UploadRequirementFileMutationVariables>>) {
  return VueApolloComposable.useMutation<UploadRequirementFileMutation, UploadRequirementFileMutationVariables>(UploadRequirementFileDocument, options);
}
export type UploadRequirementFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadRequirementFileMutation, UploadRequirementFileMutationVariables>;
export const ImportHoursDocument = gql`
    mutation ImportHours($data: SyncTimesheetsInput!) {
  syncTimesheets(data: $data) {
    contractors
    earnings
    employees
    id
    lastUpdate
    paymentEntries
    synced
  }
}
    `;

/**
 * __useImportHoursMutation__
 *
 * To run a mutation, you first call `useImportHoursMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportHoursMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportHoursMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useImportHoursMutation(options: VueApolloComposable.UseMutationOptions<ImportHoursMutation, ImportHoursMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportHoursMutation, ImportHoursMutationVariables>>) {
  return VueApolloComposable.useMutation<ImportHoursMutation, ImportHoursMutationVariables>(ImportHoursDocument, options);
}
export type ImportHoursMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportHoursMutation, ImportHoursMutationVariables>;
export const SyncTimesheetHoursDocument = gql`
    mutation SyncTimesheetHours($data: SyncTimesheetsInput!) {
  syncTimesheets(data: $data) {
    id
    lastUpdate
    synced
  }
}
    `;

/**
 * __useSyncTimesheetHoursMutation__
 *
 * To run a mutation, you first call `useSyncTimesheetHoursMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncTimesheetHoursMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncTimesheetHoursMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSyncTimesheetHoursMutation(options: VueApolloComposable.UseMutationOptions<SyncTimesheetHoursMutation, SyncTimesheetHoursMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SyncTimesheetHoursMutation, SyncTimesheetHoursMutationVariables>>) {
  return VueApolloComposable.useMutation<SyncTimesheetHoursMutation, SyncTimesheetHoursMutationVariables>(SyncTimesheetHoursDocument, options);
}
export type SyncTimesheetHoursMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SyncTimesheetHoursMutation, SyncTimesheetHoursMutationVariables>;
export const ImportTimesheetByWorkerListDocument = gql`
    mutation ImportTimesheetByWorkerList($data: ImportTimesheetsInput!) {
  importTimesheets(data: $data) {
    id
    synced
    imported
    syncErrors {
      id
      message
    }
    lastUpdate
    employees
    earnings
    contractors
    paymentEntries
  }
}
    `;

/**
 * __useImportTimesheetByWorkerListMutation__
 *
 * To run a mutation, you first call `useImportTimesheetByWorkerListMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportTimesheetByWorkerListMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportTimesheetByWorkerListMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useImportTimesheetByWorkerListMutation(options: VueApolloComposable.UseMutationOptions<ImportTimesheetByWorkerListMutation, ImportTimesheetByWorkerListMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportTimesheetByWorkerListMutation, ImportTimesheetByWorkerListMutationVariables>>) {
  return VueApolloComposable.useMutation<ImportTimesheetByWorkerListMutation, ImportTimesheetByWorkerListMutationVariables>(ImportTimesheetByWorkerListDocument, options);
}
export type ImportTimesheetByWorkerListMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportTimesheetByWorkerListMutation, ImportTimesheetByWorkerListMutationVariables>;
export const CompleteTaskDocument = gql`
    mutation CompleteTask($data: CompleteTaskInput!) {
  completeTask(data: $data) {
    id
    completedAt
    name
  }
}
    `;

/**
 * __useCompleteTaskMutation__
 *
 * To run a mutation, you first call `useCompleteTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteTaskMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteTaskMutation(options: VueApolloComposable.UseMutationOptions<CompleteTaskMutation, CompleteTaskMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteTaskMutation, CompleteTaskMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteTaskMutation, CompleteTaskMutationVariables>(CompleteTaskDocument, options);
}
export type CompleteTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteTaskMutation, CompleteTaskMutationVariables>;
export const CompleteGoalDocument = gql`
    mutation CompleteGoal($data: CompleteGoalInput!) {
  completeGoal(data: $data) {
    id
    completedAt
    name
  }
}
    `;

/**
 * __useCompleteGoalMutation__
 *
 * To run a mutation, you first call `useCompleteGoalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteGoalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteGoalMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteGoalMutation(options: VueApolloComposable.UseMutationOptions<CompleteGoalMutation, CompleteGoalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteGoalMutation, CompleteGoalMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteGoalMutation, CompleteGoalMutationVariables>(CompleteGoalDocument, options);
}
export type CompleteGoalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteGoalMutation, CompleteGoalMutationVariables>;
export const StartTaskDocument = gql`
    mutation StartTask($startTaskId: String!) {
  startTask(id: $startTaskId) {
    id
    name
    startedAt
  }
}
    `;

/**
 * __useStartTaskMutation__
 *
 * To run a mutation, you first call `useStartTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartTaskMutation({
 *   variables: {
 *     startTaskId: // value for 'startTaskId'
 *   },
 * });
 */
export function useStartTaskMutation(options: VueApolloComposable.UseMutationOptions<StartTaskMutation, StartTaskMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartTaskMutation, StartTaskMutationVariables>>) {
  return VueApolloComposable.useMutation<StartTaskMutation, StartTaskMutationVariables>(StartTaskDocument, options);
}
export type StartTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartTaskMutation, StartTaskMutationVariables>;
export const BulkSetupStaffInPayrollDocument = gql`
    mutation BulkSetupStaffInPayroll($data: BulkSetupStaffInput!) {
  bulkSetupStaff(data: $data)
}
    `;

/**
 * __useBulkSetupStaffInPayrollMutation__
 *
 * To run a mutation, you first call `useBulkSetupStaffInPayrollMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetupStaffInPayrollMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkSetupStaffInPayrollMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkSetupStaffInPayrollMutation(options: VueApolloComposable.UseMutationOptions<BulkSetupStaffInPayrollMutation, BulkSetupStaffInPayrollMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkSetupStaffInPayrollMutation, BulkSetupStaffInPayrollMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkSetupStaffInPayrollMutation, BulkSetupStaffInPayrollMutationVariables>(BulkSetupStaffInPayrollDocument, options);
}
export type BulkSetupStaffInPayrollMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkSetupStaffInPayrollMutation, BulkSetupStaffInPayrollMutationVariables>;
export const SavePastPayrollUsageDocument = gql`
    mutation SavePastPayrollUsage($data: UpdateCompanyInput!) {
  updateCompany(data: $data) {
    id
    pastPayrollUsage
  }
}
    `;

/**
 * __useSavePastPayrollUsageMutation__
 *
 * To run a mutation, you first call `useSavePastPayrollUsageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSavePastPayrollUsageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSavePastPayrollUsageMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSavePastPayrollUsageMutation(options: VueApolloComposable.UseMutationOptions<SavePastPayrollUsageMutation, SavePastPayrollUsageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SavePastPayrollUsageMutation, SavePastPayrollUsageMutationVariables>>) {
  return VueApolloComposable.useMutation<SavePastPayrollUsageMutation, SavePastPayrollUsageMutationVariables>(SavePastPayrollUsageDocument, options);
}
export type SavePastPayrollUsageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SavePastPayrollUsageMutation, SavePastPayrollUsageMutationVariables>;
export const UpdateCompanyAddressesDocument = gql`
    mutation UpdateCompanyAddresses($data: UpdateCoreCompanyInput!) {
  updateCoreCompany(data: $data) {
    id
    address {
      city
      line1
      line2
      state
      zip: zipCode
    }
    legalAddress {
      city
      line1
      line2
      state
      zip: zipCode
    }
  }
}
    `;

/**
 * __useUpdateCompanyAddressesMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAddressesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAddressesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompanyAddressesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyAddressesMutation(options: VueApolloComposable.UseMutationOptions<UpdateCompanyAddressesMutation, UpdateCompanyAddressesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCompanyAddressesMutation, UpdateCompanyAddressesMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCompanyAddressesMutation, UpdateCompanyAddressesMutationVariables>(UpdateCompanyAddressesDocument, options);
}
export type UpdateCompanyAddressesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCompanyAddressesMutation, UpdateCompanyAddressesMutationVariables>;
export const UpdateBasicCompanyInfoDocument = gql`
    mutation UpdateBasicCompanyInfo($data: UpdateCoreCompanyInput!) {
  updateCoreCompany(data: $data) {
    id
    name
    phone
    industry
  }
}
    `;

/**
 * __useUpdateBasicCompanyInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicCompanyInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicCompanyInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBasicCompanyInfoMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBasicCompanyInfoMutation(options: VueApolloComposable.UseMutationOptions<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables>(UpdateBasicCompanyInfoDocument, options);
}
export type UpdateBasicCompanyInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables>;
export const PurchaseBambeePlusDocument = gql`
    mutation PurchaseBambeePlus($data: PurchaseBambeePlusInput!) {
  purchaseBambeePlus(input: $data) {
    id
    status
    eligible
  }
}
    `;

/**
 * __usePurchaseBambeePlusMutation__
 *
 * To run a mutation, you first call `usePurchaseBambeePlusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseBambeePlusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseBambeePlusMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseBambeePlusMutation(options: VueApolloComposable.UseMutationOptions<PurchaseBambeePlusMutation, PurchaseBambeePlusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseBambeePlusMutation, PurchaseBambeePlusMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseBambeePlusMutation, PurchaseBambeePlusMutationVariables>(PurchaseBambeePlusDocument, options);
}
export type PurchaseBambeePlusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseBambeePlusMutation, PurchaseBambeePlusMutationVariables>;
export const SendEnrollmentProfileDocument = gql`
    mutation SendEnrollmentProfile($syncCompanyData: SyncCompanyInput!, $enrollmentProfile: CreateEnrollmentProfileRequest!) {
  syncCompany(data: $syncCompanyData) {
    id
  }
  createEnrollmentProfile(data: $enrollmentProfile)
}
    `;

/**
 * __useSendEnrollmentProfileMutation__
 *
 * To run a mutation, you first call `useSendEnrollmentProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendEnrollmentProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendEnrollmentProfileMutation({
 *   variables: {
 *     syncCompanyData: // value for 'syncCompanyData'
 *     enrollmentProfile: // value for 'enrollmentProfile'
 *   },
 * });
 */
export function useSendEnrollmentProfileMutation(options: VueApolloComposable.UseMutationOptions<SendEnrollmentProfileMutation, SendEnrollmentProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendEnrollmentProfileMutation, SendEnrollmentProfileMutationVariables>>) {
  return VueApolloComposable.useMutation<SendEnrollmentProfileMutation, SendEnrollmentProfileMutationVariables>(SendEnrollmentProfileDocument, options);
}
export type SendEnrollmentProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendEnrollmentProfileMutation, SendEnrollmentProfileMutationVariables>;
export const SaveCompanySettingDocument = gql`
    mutation SaveCompanySetting($input: SaveCompanySettingInput!) {
  saveCompanySetting(input: $input) {
    id
    companyId
    type
    key
    value
  }
}
    `;

/**
 * __useSaveCompanySettingMutation__
 *
 * To run a mutation, you first call `useSaveCompanySettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanySettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCompanySettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveCompanySettingMutation(options: VueApolloComposable.UseMutationOptions<SaveCompanySettingMutation, SaveCompanySettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveCompanySettingMutation, SaveCompanySettingMutationVariables>>) {
  return VueApolloComposable.useMutation<SaveCompanySettingMutation, SaveCompanySettingMutationVariables>(SaveCompanySettingDocument, options);
}
export type SaveCompanySettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveCompanySettingMutation, SaveCompanySettingMutationVariables>;
export const CancelBambeePlusDocument = gql`
    mutation CancelBambeePlus($data: PurchaseBambeePlusInput!) {
  cancelBambeePlus(input: $data) {
    id
    status
    eligible
    onboardingDueDate
  }
}
    `;

/**
 * __useCancelBambeePlusMutation__
 *
 * To run a mutation, you first call `useCancelBambeePlusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelBambeePlusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelBambeePlusMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelBambeePlusMutation(options: VueApolloComposable.UseMutationOptions<CancelBambeePlusMutation, CancelBambeePlusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelBambeePlusMutation, CancelBambeePlusMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelBambeePlusMutation, CancelBambeePlusMutationVariables>(CancelBambeePlusDocument, options);
}
export type CancelBambeePlusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelBambeePlusMutation, CancelBambeePlusMutationVariables>;
export const ApproveTrainingRequestDocument = gql`
    mutation ApproveTrainingRequest($data: RequestApprovalInput!) {
  approveRequest(data: $data) {
    id
    status
    resourceId
  }
}
    `;

/**
 * __useApproveTrainingRequestMutation__
 *
 * To run a mutation, you first call `useApproveTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useApproveTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables>(ApproveTrainingRequestDocument, options);
}
export type ApproveTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables>;
export const RejectTrainingRequestDocument = gql`
    mutation RejectTrainingRequest($data: RequestRejectionInput!) {
  rejectRequest(data: $data) {
    id
    status
    resourceId
  }
}
    `;

/**
 * __useRejectTrainingRequestMutation__
 *
 * To run a mutation, you first call `useRejectTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useRejectTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables>(RejectTrainingRequestDocument, options);
}
export type RejectTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables>;
export const MakeTrainingRequestDocument = gql`
    mutation MakeTrainingRequest($data: TrainingRequestInput!) {
  trainingRequest(data: $data) {
    id
    status
    resourceId
  }
}
    `;

/**
 * __useMakeTrainingRequestMutation__
 *
 * To run a mutation, you first call `useMakeTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMakeTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMakeTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useMakeTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables>(MakeTrainingRequestDocument, options);
}
export type MakeTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables>;
export const CancelTrainingRequestDocument = gql`
    mutation CancelTrainingRequest($data: RequestCancelInput!) {
  cancelRequest(data: $data) {
    id
    status
    resourceId
  }
}
    `;

/**
 * __useCancelTrainingRequestMutation__
 *
 * To run a mutation, you first call `useCancelTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables>(CancelTrainingRequestDocument, options);
}
export type CancelTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables>;
export const GenerateCheckComponentLinkDocument = gql`
    mutation GenerateCheckComponentLink($data: CheckComponentInput!) {
  generateCheckComponentLink(data: $data) {
    id
    url
  }
}
    `;

/**
 * __useGenerateCheckComponentLinkMutation__
 *
 * To run a mutation, you first call `useGenerateCheckComponentLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCheckComponentLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateCheckComponentLinkMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useGenerateCheckComponentLinkMutation(options: VueApolloComposable.UseMutationOptions<GenerateCheckComponentLinkMutation, GenerateCheckComponentLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateCheckComponentLinkMutation, GenerateCheckComponentLinkMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateCheckComponentLinkMutation, GenerateCheckComponentLinkMutationVariables>(GenerateCheckComponentLinkDocument, options);
}
export type GenerateCheckComponentLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateCheckComponentLinkMutation, GenerateCheckComponentLinkMutationVariables>;
export const JoinCallQueueDocument = gql`
    mutation JoinCallQueue($data: EnqueueHotlineCallInput!) {
  enqueueHotlineCall(data: $data)
}
    `;

/**
 * __useJoinCallQueueMutation__
 *
 * To run a mutation, you first call `useJoinCallQueueMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useJoinCallQueueMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useJoinCallQueueMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useJoinCallQueueMutation(options: VueApolloComposable.UseMutationOptions<JoinCallQueueMutation, JoinCallQueueMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<JoinCallQueueMutation, JoinCallQueueMutationVariables>>) {
  return VueApolloComposable.useMutation<JoinCallQueueMutation, JoinCallQueueMutationVariables>(JoinCallQueueDocument, options);
}
export type JoinCallQueueMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<JoinCallQueueMutation, JoinCallQueueMutationVariables>;
export const CancelPendingHotlineCallDocument = gql`
    mutation CancelPendingHotlineCall {
  cancelPendingHotlineCall
}
    `;

/**
 * __useCancelPendingHotlineCallMutation__
 *
 * To run a mutation, you first call `useCancelPendingHotlineCallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelPendingHotlineCallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelPendingHotlineCallMutation();
 */
export function useCancelPendingHotlineCallMutation(options: VueApolloComposable.UseMutationOptions<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables>(CancelPendingHotlineCallDocument, options);
}
export type CancelPendingHotlineCallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables>;
export const UpgradeCorePlanDocument = gql`
    mutation UpgradeCorePlan($data: UpgradeCorePlanInput!) {
  upgradeCorePlan(input: $data) {
    stripeId
  }
}
    `;

/**
 * __useUpgradeCorePlanMutation__
 *
 * To run a mutation, you first call `useUpgradeCorePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeCorePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpgradeCorePlanMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpgradeCorePlanMutation(options: VueApolloComposable.UseMutationOptions<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables>>) {
  return VueApolloComposable.useMutation<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables>(UpgradeCorePlanDocument, options);
}
export type UpgradeCorePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables>;
export const SaveComplexPayrollOnboardingDocument = gql`
    mutation SaveComplexPayrollOnboarding($data: ComplexPayrollOnboardingInput!) {
  saveComplexPayrollOnboarding(data: $data)
}
    `;

/**
 * __useSaveComplexPayrollOnboardingMutation__
 *
 * To run a mutation, you first call `useSaveComplexPayrollOnboardingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveComplexPayrollOnboardingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveComplexPayrollOnboardingMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSaveComplexPayrollOnboardingMutation(options: VueApolloComposable.UseMutationOptions<SaveComplexPayrollOnboardingMutation, SaveComplexPayrollOnboardingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveComplexPayrollOnboardingMutation, SaveComplexPayrollOnboardingMutationVariables>>) {
  return VueApolloComposable.useMutation<SaveComplexPayrollOnboardingMutation, SaveComplexPayrollOnboardingMutationVariables>(SaveComplexPayrollOnboardingDocument, options);
}
export type SaveComplexPayrollOnboardingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveComplexPayrollOnboardingMutation, SaveComplexPayrollOnboardingMutationVariables>;
export const PurchaseTimeAndAttendanceDocument = gql`
    mutation PurchaseTimeAndAttendance($data: PurchaseTimeAttendanceInput!) {
  purchaseTimeAttendance(data: $data) {
    id
    subscriptionId
  }
}
    `;

/**
 * __usePurchaseTimeAndAttendanceMutation__
 *
 * To run a mutation, you first call `usePurchaseTimeAndAttendanceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseTimeAndAttendanceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseTimeAndAttendanceMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseTimeAndAttendanceMutation(options: VueApolloComposable.UseMutationOptions<PurchaseTimeAndAttendanceMutation, PurchaseTimeAndAttendanceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseTimeAndAttendanceMutation, PurchaseTimeAndAttendanceMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseTimeAndAttendanceMutation, PurchaseTimeAndAttendanceMutationVariables>(PurchaseTimeAndAttendanceDocument, options);
}
export type PurchaseTimeAndAttendanceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseTimeAndAttendanceMutation, PurchaseTimeAndAttendanceMutationVariables>;
export const AcceptOfferDocument = gql`
    mutation AcceptOffer($input: AcceptOfferInput!) {
  acceptOffer(input: $input)
}
    `;

/**
 * __useAcceptOfferMutation__
 *
 * To run a mutation, you first call `useAcceptOfferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOfferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptOfferMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAcceptOfferMutation(options: VueApolloComposable.UseMutationOptions<AcceptOfferMutation, AcceptOfferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptOfferMutation, AcceptOfferMutationVariables>>) {
  return VueApolloComposable.useMutation<AcceptOfferMutation, AcceptOfferMutationVariables>(AcceptOfferDocument, options);
}
export type AcceptOfferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptOfferMutation, AcceptOfferMutationVariables>;
export const SubmitCancelRequestDocument = gql`
    mutation SubmitCancelRequest($input: CreateCancellationRequestInput!) {
  createCancellationRequest(input: $input) {
    id
    status
  }
}
    `;

/**
 * __useSubmitCancelRequestMutation__
 *
 * To run a mutation, you first call `useSubmitCancelRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCancelRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitCancelRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCancelRequestMutation(options: VueApolloComposable.UseMutationOptions<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables>(SubmitCancelRequestDocument, options);
}
export type SubmitCancelRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables>;
export const TrackDocument = gql`
    mutation Track($data: AnalyticEvent!) {
  track(data: $data) {
    id
    success
    event
  }
}
    `;

/**
 * __useTrackMutation__
 *
 * To run a mutation, you first call `useTrackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTrackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTrackMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useTrackMutation(options: VueApolloComposable.UseMutationOptions<TrackMutation, TrackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrackMutation, TrackMutationVariables>>) {
  return VueApolloComposable.useMutation<TrackMutation, TrackMutationVariables>(TrackDocument, options);
}
export type TrackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrackMutation, TrackMutationVariables>;
export const ReactivateCompanyDocument = gql`
    mutation ReactivateCompany($input: ReactivatePausedCompanyInput!) {
  reactivatePausedCompany(input: $input)
}
    `;

/**
 * __useReactivateCompanyMutation__
 *
 * To run a mutation, you first call `useReactivateCompanyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReactivateCompanyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReactivateCompanyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReactivateCompanyMutation(options: VueApolloComposable.UseMutationOptions<ReactivateCompanyMutation, ReactivateCompanyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReactivateCompanyMutation, ReactivateCompanyMutationVariables>>) {
  return VueApolloComposable.useMutation<ReactivateCompanyMutation, ReactivateCompanyMutationVariables>(ReactivateCompanyDocument, options);
}
export type ReactivateCompanyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReactivateCompanyMutation, ReactivateCompanyMutationVariables>;
export const CreateProductInterestDocument = gql`
    mutation CreateProductInterest($input: CreateProductInterestInput!) {
  createProductInterest(input: $input) {
    id
    productKey
    productSubKey
  }
}
    `;

/**
 * __useCreateProductInterestMutation__
 *
 * To run a mutation, you first call `useCreateProductInterestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductInterestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProductInterestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductInterestMutation(options: VueApolloComposable.UseMutationOptions<CreateProductInterestMutation, CreateProductInterestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateProductInterestMutation, CreateProductInterestMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateProductInterestMutation, CreateProductInterestMutationVariables>(CreateProductInterestDocument, options);
}
export type CreateProductInterestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateProductInterestMutation, CreateProductInterestMutationVariables>;
export const SetDefaultBillingPaymentMethodDocument = gql`
    mutation SetDefaultBillingPaymentMethod($input: SetDefaultPaymentMethodInput!) {
  setDefaultPaymentMethod(input: $input) {
    id
    default
    expirationDate
    name
    nextAction
    status
    type
  }
}
    `;

/**
 * __useSetDefaultBillingPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultBillingPaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultBillingPaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetDefaultBillingPaymentMethodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultBillingPaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables>>) {
  return VueApolloComposable.useMutation<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables>(SetDefaultBillingPaymentMethodDocument, options);
}
export type SetDefaultBillingPaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation RemovePaymentMethod($input: RemovePaymentMethodInput!) {
  removePaymentMethod(input: $input)
}
    `;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePaymentMethodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>>) {
  return VueApolloComposable.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
}
export type RemovePaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const ConfirmMicroDepositDocument = gql`
    mutation ConfirmMicroDeposit($input: ConfirmMicroDepositInput!) {
  confirmMicroDeposit(input: $input) {
    id
    default
    expirationDate
    name
    nextAction
    status
    type
  }
}
    `;

/**
 * __useConfirmMicroDepositMutation__
 *
 * To run a mutation, you first call `useConfirmMicroDepositMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMicroDepositMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmMicroDepositMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConfirmMicroDepositMutation(options: VueApolloComposable.UseMutationOptions<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables>(ConfirmMicroDepositDocument, options);
}
export type ConfirmMicroDepositMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables>;
export const UpsertEmployerOnboardingDocument = gql`
    mutation UpsertEmployerOnboarding($data: CoreOnboardingInput!) {
  upsertOnboarding(data: $data) {
    data {
      ...OnboardingParts
    }
    status
    id
    updatedAt
    createdAt
  }
}
    ${OnboardingPartsFragmentDoc}`;

/**
 * __useUpsertEmployerOnboardingMutation__
 *
 * To run a mutation, you first call `useUpsertEmployerOnboardingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmployerOnboardingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertEmployerOnboardingMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertEmployerOnboardingMutation(options: VueApolloComposable.UseMutationOptions<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables>>) {
  return VueApolloComposable.useMutation<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables>(UpsertEmployerOnboardingDocument, options);
}
export type UpsertEmployerOnboardingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables>;
export const AcceptTrialExtensionDocument = gql`
    mutation AcceptTrialExtension($input: AcceptTrialOfferInput!) {
  acceptTrialOffer(input: $input)
}
    `;

/**
 * __useAcceptTrialExtensionMutation__
 *
 * To run a mutation, you first call `useAcceptTrialExtensionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTrialExtensionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptTrialExtensionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAcceptTrialExtensionMutation(options: VueApolloComposable.UseMutationOptions<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables>>) {
  return VueApolloComposable.useMutation<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables>(AcceptTrialExtensionDocument, options);
}
export type AcceptTrialExtensionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables>;
export const AddSubscriptionDocument = gql`
    mutation AddSubscription($data: PurchaseSubscriptionInput!) {
  purchaseSubscription(data: $data) {
    createdAt
    creditsPurchased
    id
    productKey
    status
    totalAmount
  }
}
    `;

/**
 * __useAddSubscriptionMutation__
 *
 * To run a mutation, you first call `useAddSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSubscriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAddSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<AddSubscriptionMutation, AddSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddSubscriptionMutation, AddSubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<AddSubscriptionMutation, AddSubscriptionMutationVariables>(AddSubscriptionDocument, options);
}
export type AddSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddSubscriptionMutation, AddSubscriptionMutationVariables>;
export const CreateEliteAddonSubscriptionDocument = gql`
    mutation CreateEliteAddonSubscription($input: CreateEliteAddonSubscriptionInput!) {
  createEliteAddonSubscription(input: $input)
}
    `;

/**
 * __useCreateEliteAddonSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateEliteAddonSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEliteAddonSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEliteAddonSubscriptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateEliteAddonSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<CreateEliteAddonSubscriptionMutation, CreateEliteAddonSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateEliteAddonSubscriptionMutation, CreateEliteAddonSubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateEliteAddonSubscriptionMutation, CreateEliteAddonSubscriptionMutationVariables>(CreateEliteAddonSubscriptionDocument, options);
}
export type CreateEliteAddonSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateEliteAddonSubscriptionMutation, CreateEliteAddonSubscriptionMutationVariables>;
export const RequestPayrollCancellationDocument = gql`
    mutation RequestPayrollCancellation($data: PayrollCancellationRequestInput!) {
  requestPayrollCancellation(data: $data)
}
    `;

/**
 * __useRequestPayrollCancellationMutation__
 *
 * To run a mutation, you first call `useRequestPayrollCancellationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestPayrollCancellationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestPayrollCancellationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useRequestPayrollCancellationMutation(options: VueApolloComposable.UseMutationOptions<RequestPayrollCancellationMutation, RequestPayrollCancellationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestPayrollCancellationMutation, RequestPayrollCancellationMutationVariables>>) {
  return VueApolloComposable.useMutation<RequestPayrollCancellationMutation, RequestPayrollCancellationMutationVariables>(RequestPayrollCancellationDocument, options);
}
export type RequestPayrollCancellationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestPayrollCancellationMutation, RequestPayrollCancellationMutationVariables>;
export const ConsumeNectarCreditsDocument = gql`
    mutation ConsumeNectarCredits($data: RemoveCreditsInput!) {
  removeActiveCredits(data: $data) {
    id
    consumedAt
  }
}
    `;

/**
 * __useConsumeNectarCreditsMutation__
 *
 * To run a mutation, you first call `useConsumeNectarCreditsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConsumeNectarCreditsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConsumeNectarCreditsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useConsumeNectarCreditsMutation(options: VueApolloComposable.UseMutationOptions<ConsumeNectarCreditsMutation, ConsumeNectarCreditsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConsumeNectarCreditsMutation, ConsumeNectarCreditsMutationVariables>>) {
  return VueApolloComposable.useMutation<ConsumeNectarCreditsMutation, ConsumeNectarCreditsMutationVariables>(ConsumeNectarCreditsDocument, options);
}
export type ConsumeNectarCreditsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConsumeNectarCreditsMutation, ConsumeNectarCreditsMutationVariables>;
export const PurchaseNectarCreditsDocument = gql`
    mutation PurchaseNectarCredits($data: PurchaseInput!) {
  purchaseCredits(data: $data) {
    id
    createdAt
    status
    totalAmount
  }
}
    `;

/**
 * __usePurchaseNectarCreditsMutation__
 *
 * To run a mutation, you first call `usePurchaseNectarCreditsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseNectarCreditsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseNectarCreditsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseNectarCreditsMutation(options: VueApolloComposable.UseMutationOptions<PurchaseNectarCreditsMutation, PurchaseNectarCreditsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseNectarCreditsMutation, PurchaseNectarCreditsMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseNectarCreditsMutation, PurchaseNectarCreditsMutationVariables>(PurchaseNectarCreditsDocument, options);
}
export type PurchaseNectarCreditsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseNectarCreditsMutation, PurchaseNectarCreditsMutationVariables>;
export const ProvisionDeputyInstallDocument = gql`
    mutation ProvisionDeputyInstall($data: ProvisionDeputyInstallInput!) {
  provisionDeputyInstall(data: $data) {
    id
    installId
    hasAccessToken
  }
}
    `;

/**
 * __useProvisionDeputyInstallMutation__
 *
 * To run a mutation, you first call `useProvisionDeputyInstallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProvisionDeputyInstallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProvisionDeputyInstallMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useProvisionDeputyInstallMutation(options: VueApolloComposable.UseMutationOptions<ProvisionDeputyInstallMutation, ProvisionDeputyInstallMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProvisionDeputyInstallMutation, ProvisionDeputyInstallMutationVariables>>) {
  return VueApolloComposable.useMutation<ProvisionDeputyInstallMutation, ProvisionDeputyInstallMutationVariables>(ProvisionDeputyInstallDocument, options);
}
export type ProvisionDeputyInstallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProvisionDeputyInstallMutation, ProvisionDeputyInstallMutationVariables>;
export const CreatePayrollTierSubscriptionDocument = gql`
    mutation CreatePayrollTierSubscription($data: CreatePayrollSubscriptionInput!) {
  createPayrollSubscription(data: $data) {
    name
    stripeId
    productCode
    serviceKey
    planValue
    amount
    createdAt
    startDate
    endDate
    status
    isDrp
  }
}
    `;

/**
 * __useCreatePayrollTierSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreatePayrollTierSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayrollTierSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePayrollTierSubscriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreatePayrollTierSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<CreatePayrollTierSubscriptionMutation, CreatePayrollTierSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePayrollTierSubscriptionMutation, CreatePayrollTierSubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CreatePayrollTierSubscriptionMutation, CreatePayrollTierSubscriptionMutationVariables>(CreatePayrollTierSubscriptionDocument, options);
}
export type CreatePayrollTierSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePayrollTierSubscriptionMutation, CreatePayrollTierSubscriptionMutationVariables>;
export const UpgradeInstallDocument = gql`
    mutation UpgradeInstall($data: UpgradeDeputyInstallInput!) {
  upgradeInstall(data: $data) {
    edition
    id
    installId
  }
}
    `;

/**
 * __useUpgradeInstallMutation__
 *
 * To run a mutation, you first call `useUpgradeInstallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeInstallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpgradeInstallMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpgradeInstallMutation(options: VueApolloComposable.UseMutationOptions<UpgradeInstallMutation, UpgradeInstallMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpgradeInstallMutation, UpgradeInstallMutationVariables>>) {
  return VueApolloComposable.useMutation<UpgradeInstallMutation, UpgradeInstallMutationVariables>(UpgradeInstallDocument, options);
}
export type UpgradeInstallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpgradeInstallMutation, UpgradeInstallMutationVariables>;
export const CancelTimeAttendanceDocument = gql`
    mutation CancelTimeAttendance($data: CancelTimeAttendanceInput!) {
  cancelTimeAttendance(data: $data)
}
    `;

/**
 * __useCancelTimeAttendanceMutation__
 *
 * To run a mutation, you first call `useCancelTimeAttendanceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelTimeAttendanceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelTimeAttendanceMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelTimeAttendanceMutation(options: VueApolloComposable.UseMutationOptions<CancelTimeAttendanceMutation, CancelTimeAttendanceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelTimeAttendanceMutation, CancelTimeAttendanceMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelTimeAttendanceMutation, CancelTimeAttendanceMutationVariables>(CancelTimeAttendanceDocument, options);
}
export type CancelTimeAttendanceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelTimeAttendanceMutation, CancelTimeAttendanceMutationVariables>;
export const ChatWithAssistantDocument = gql`
    mutation ChatWithAssistant($data: AIAssistantInput!) {
  chatWithAssistant(data: $data) {
    assistantId
    threadId
    next {
      context
      sample
    }
    messages {
      id
      role
      content {
        text {
          value
        }
      }
      metadata {
        artifact
        hidden
        type
        value
      }
    }
    artifact {
      jobDescription {
        html
        id
        status
      }
      summary {
        html
        status
      }
      policy {
        html
        title
        id
        status
      }
    }
  }
}
    `;

/**
 * __useChatWithAssistantMutation__
 *
 * To run a mutation, you first call `useChatWithAssistantMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChatWithAssistantMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChatWithAssistantMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useChatWithAssistantMutation(options: VueApolloComposable.UseMutationOptions<ChatWithAssistantMutation, ChatWithAssistantMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChatWithAssistantMutation, ChatWithAssistantMutationVariables>>) {
  return VueApolloComposable.useMutation<ChatWithAssistantMutation, ChatWithAssistantMutationVariables>(ChatWithAssistantDocument, options);
}
export type ChatWithAssistantMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChatWithAssistantMutation, ChatWithAssistantMutationVariables>;
export const OptInAiDocument = gql`
    mutation OptInAi($data: UpdateCoreCompanyInput!) {
  updateCoreCompany(data: $data) {
    id
    ai {
      optIn
    }
  }
}
    `;

/**
 * __useOptInAiMutation__
 *
 * To run a mutation, you first call `useOptInAiMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOptInAiMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOptInAiMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useOptInAiMutation(options: VueApolloComposable.UseMutationOptions<OptInAiMutation, OptInAiMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<OptInAiMutation, OptInAiMutationVariables>>) {
  return VueApolloComposable.useMutation<OptInAiMutation, OptInAiMutationVariables>(OptInAiDocument, options);
}
export type OptInAiMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<OptInAiMutation, OptInAiMutationVariables>;
export const ActivateHandsFreeDocument = gql`
    mutation ActivateHandsFree($data: UpdateCoreCompanyInput!) {
  updateCoreCompany(data: $data) {
    id
    handsFreeActionItemActivatedAt
  }
}
    `;

/**
 * __useActivateHandsFreeMutation__
 *
 * To run a mutation, you first call `useActivateHandsFreeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateHandsFreeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateHandsFreeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useActivateHandsFreeMutation(options: VueApolloComposable.UseMutationOptions<ActivateHandsFreeMutation, ActivateHandsFreeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActivateHandsFreeMutation, ActivateHandsFreeMutationVariables>>) {
  return VueApolloComposable.useMutation<ActivateHandsFreeMutation, ActivateHandsFreeMutationVariables>(ActivateHandsFreeDocument, options);
}
export type ActivateHandsFreeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActivateHandsFreeMutation, ActivateHandsFreeMutationVariables>;
export const EmitDocument = gql`
    mutation Emit($data: EmittableEvent!) {
  emit(data: $data) {
    id
    userId
    success
  }
}
    `;

/**
 * __useEmitMutation__
 *
 * To run a mutation, you first call `useEmitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEmitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEmitMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEmitMutation(options: VueApolloComposable.UseMutationOptions<EmitMutation, EmitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EmitMutation, EmitMutationVariables>>) {
  return VueApolloComposable.useMutation<EmitMutation, EmitMutationVariables>(EmitDocument, options);
}
export type EmitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EmitMutation, EmitMutationVariables>;
export const GetCompanyStatusDocument = gql`
    query GetCompanyStatus($id: ID!) {
  getCompany(id: $id) {
    ...CompanyStatusParts
  }
}
    ${CompanyStatusPartsFragmentDoc}`;

/**
 * __useGetCompanyStatusQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyStatusQuery(variables: GetCompanyStatusQueryVariables | VueCompositionApi.Ref<GetCompanyStatusQueryVariables> | ReactiveFunction<GetCompanyStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyStatusQuery, GetCompanyStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyStatusQuery, GetCompanyStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyStatusQuery, GetCompanyStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyStatusQuery, GetCompanyStatusQueryVariables>(GetCompanyStatusDocument, variables, options);
}
export type GetCompanyStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyStatusQuery, GetCompanyStatusQueryVariables>;
export const GetCompanyOnboardingStatusDocument = gql`
    query GetCompanyOnboardingStatus($id: ID!) {
  getCompany(id: $id) {
    ...CompanyStatusParts
    employees {
      id
      checkId
      benefitOnboarding {
        status
      }
    }
    contractors {
      id
      checkId
      benefitOnboarding {
        status
      }
    }
  }
}
    ${CompanyStatusPartsFragmentDoc}`;

/**
 * __useGetCompanyOnboardingStatusQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOnboardingStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyOnboardingStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyOnboardingStatusQuery(variables: GetCompanyOnboardingStatusQueryVariables | VueCompositionApi.Ref<GetCompanyOnboardingStatusQueryVariables> | ReactiveFunction<GetCompanyOnboardingStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyOnboardingStatusQuery, GetCompanyOnboardingStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyOnboardingStatusQuery, GetCompanyOnboardingStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyOnboardingStatusQuery, GetCompanyOnboardingStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyOnboardingStatusQuery, GetCompanyOnboardingStatusQueryVariables>(GetCompanyOnboardingStatusDocument, variables, options);
}
export type GetCompanyOnboardingStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyOnboardingStatusQuery, GetCompanyOnboardingStatusQueryVariables>;
export const GetCompanyDocument = gql`
    query GetCompany($id: ID!) {
  getCompany(id: $id) {
    ...CompanyParts
  }
}
    ${CompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyQuery(variables: GetCompanyQueryVariables | VueCompositionApi.Ref<GetCompanyQueryVariables> | ReactiveFunction<GetCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, variables, options);
}
export type GetCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyHasRunPayrollDocument = gql`
    query GetCompanyHasRunPayroll($id: ID!) {
  getCompany(id: $id) {
    status
    hasRunPayroll
  }
}
    `;

/**
 * __useGetCompanyHasRunPayrollQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyHasRunPayrollQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyHasRunPayrollQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyHasRunPayrollQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyHasRunPayrollQuery(variables: GetCompanyHasRunPayrollQueryVariables | VueCompositionApi.Ref<GetCompanyHasRunPayrollQueryVariables> | ReactiveFunction<GetCompanyHasRunPayrollQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyHasRunPayrollQuery, GetCompanyHasRunPayrollQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyHasRunPayrollQuery, GetCompanyHasRunPayrollQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyHasRunPayrollQuery, GetCompanyHasRunPayrollQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyHasRunPayrollQuery, GetCompanyHasRunPayrollQueryVariables>(GetCompanyHasRunPayrollDocument, variables, options);
}
export type GetCompanyHasRunPayrollQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyHasRunPayrollQuery, GetCompanyHasRunPayrollQueryVariables>;
export const GetCompanyLifecycleInfoDocument = gql`
    query GetCompanyLifecycleInfo($id: ID!) {
  getCompany(id: $id) {
    ...CompanyParts
  }
  listPayroll(companyId: $id) {
    totalCount
  }
}
    ${CompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyLifecycleInfoQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyLifecycleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLifecycleInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyLifecycleInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyLifecycleInfoQuery(variables: GetCompanyLifecycleInfoQueryVariables | VueCompositionApi.Ref<GetCompanyLifecycleInfoQueryVariables> | ReactiveFunction<GetCompanyLifecycleInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyLifecycleInfoQuery, GetCompanyLifecycleInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyLifecycleInfoQuery, GetCompanyLifecycleInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyLifecycleInfoQuery, GetCompanyLifecycleInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyLifecycleInfoQuery, GetCompanyLifecycleInfoQueryVariables>(GetCompanyLifecycleInfoDocument, variables, options);
}
export type GetCompanyLifecycleInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyLifecycleInfoQuery, GetCompanyLifecycleInfoQueryVariables>;
export const GetCompanyPaySchedulesDocument = gql`
    query GetCompanyPaySchedules($id: ID!) {
  getCompany(id: $id) {
    ...CompanyParts
  }
  getCoreCompany(id: $id) {
    id
    payDayOfWeek
    payDayOfMonth
  }
}
    ${CompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyPaySchedulesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyPaySchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPaySchedulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyPaySchedulesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyPaySchedulesQuery(variables: GetCompanyPaySchedulesQueryVariables | VueCompositionApi.Ref<GetCompanyPaySchedulesQueryVariables> | ReactiveFunction<GetCompanyPaySchedulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyPaySchedulesQuery, GetCompanyPaySchedulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyPaySchedulesQuery, GetCompanyPaySchedulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyPaySchedulesQuery, GetCompanyPaySchedulesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyPaySchedulesQuery, GetCompanyPaySchedulesQueryVariables>(GetCompanyPaySchedulesDocument, variables, options);
}
export type GetCompanyPaySchedulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyPaySchedulesQuery, GetCompanyPaySchedulesQueryVariables>;
export const GetCompanyEstimatedBenefitsCostDocument = gql`
    query GetCompanyEstimatedBenefitsCost($zip: String!) {
  getCompanyEstimatedBenefitsCost(zip: $zip) {
    monthlyPremium
  }
}
    `;

/**
 * __useGetCompanyEstimatedBenefitsCostQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyEstimatedBenefitsCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyEstimatedBenefitsCostQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyEstimatedBenefitsCostQuery({
 *   zip: // value for 'zip'
 * });
 */
export function useGetCompanyEstimatedBenefitsCostQuery(variables: GetCompanyEstimatedBenefitsCostQueryVariables | VueCompositionApi.Ref<GetCompanyEstimatedBenefitsCostQueryVariables> | ReactiveFunction<GetCompanyEstimatedBenefitsCostQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyEstimatedBenefitsCostQuery, GetCompanyEstimatedBenefitsCostQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyEstimatedBenefitsCostQuery, GetCompanyEstimatedBenefitsCostQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyEstimatedBenefitsCostQuery, GetCompanyEstimatedBenefitsCostQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyEstimatedBenefitsCostQuery, GetCompanyEstimatedBenefitsCostQueryVariables>(GetCompanyEstimatedBenefitsCostDocument, variables, options);
}
export type GetCompanyEstimatedBenefitsCostQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyEstimatedBenefitsCostQuery, GetCompanyEstimatedBenefitsCostQueryVariables>;
export const GetCompanyStaffDocument = gql`
    query GetCompanyStaff($id: ID!) {
  getCompany(id: $id) {
    id
    contractors {
      ...ContractorProfileParts
    }
    employees {
      ...EmployeeProfileParts
    }
  }
}
    ${ContractorProfilePartsFragmentDoc}
${EmployeeProfilePartsFragmentDoc}`;

/**
 * __useGetCompanyStaffQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyStaffQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyStaffQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyStaffQuery(variables: GetCompanyStaffQueryVariables | VueCompositionApi.Ref<GetCompanyStaffQueryVariables> | ReactiveFunction<GetCompanyStaffQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyStaffQuery, GetCompanyStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyStaffQuery, GetCompanyStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyStaffQuery, GetCompanyStaffQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyStaffQuery, GetCompanyStaffQueryVariables>(GetCompanyStaffDocument, variables, options);
}
export type GetCompanyStaffQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyStaffQuery, GetCompanyStaffQueryVariables>;
export const GetFullStaffDocument = gql`
    query GetFullStaff($id: ID!) {
  getCompany(id: $id) {
    id
    contractors {
      id
      checkId
      paymentMethodPreference
      checkOnboarding {
        remainingSteps
        status
      }
      createdAt
      workplaces {
        id
      }
    }
    employees {
      id
      checkId
      paymentMethodPreference
      checkOnboarding {
        remainingSteps
        status
      }
      createdAt
      workplaces {
        id
      }
    }
  }
  getCoreCompany(id: $id) {
    id
    employees {
      id
      active
      employment {
        id
        contractorBusinessName
        isContractor
        contractorType
        employeeType
        payRate
        payType
        startDate
        title
      }
      profile {
        id
        firstName
        lastName
        dob
        phone
        email
        address {
          city
          line1
          line2
          state
          zip: zipCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetFullStaffQuery__
 *
 * To run a query within a Vue component, call `useGetFullStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullStaffQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFullStaffQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetFullStaffQuery(variables: GetFullStaffQueryVariables | VueCompositionApi.Ref<GetFullStaffQueryVariables> | ReactiveFunction<GetFullStaffQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFullStaffQuery, GetFullStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFullStaffQuery, GetFullStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFullStaffQuery, GetFullStaffQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetFullStaffQuery, GetFullStaffQueryVariables>(GetFullStaffDocument, variables, options);
}
export type GetFullStaffQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetFullStaffQuery, GetFullStaffQueryVariables>;
export const GetCompanyPoliciesDocument = gql`
    query GetCompanyPolicies($id: ID!) {
  getCoreCompany(id: $id) {
    id
    policies {
      id
      name
      icon
      archivedAt
    }
    documents {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCompanyPoliciesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPoliciesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyPoliciesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyPoliciesQuery(variables: GetCompanyPoliciesQueryVariables | VueCompositionApi.Ref<GetCompanyPoliciesQueryVariables> | ReactiveFunction<GetCompanyPoliciesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>(GetCompanyPoliciesDocument, variables, options);
}
export type GetCompanyPoliciesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>;
export const TaxDocumentsDocument = gql`
    query TaxDocuments($id: ID!, $data: CompanyTaxDocumentsInput!) {
  getCompany(id: $id) {
    id
    taxDocuments(data: $data) {
      ...TaxDocumentParts
      companyId
      contractorId
      employeeId
    }
  }
}
    ${TaxDocumentPartsFragmentDoc}`;

/**
 * __useTaxDocumentsQuery__
 *
 * To run a query within a Vue component, call `useTaxDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaxDocumentsQuery({
 *   id: // value for 'id'
 *   data: // value for 'data'
 * });
 */
export function useTaxDocumentsQuery(variables: TaxDocumentsQueryVariables | VueCompositionApi.Ref<TaxDocumentsQueryVariables> | ReactiveFunction<TaxDocumentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaxDocumentsQuery, TaxDocumentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaxDocumentsQuery, TaxDocumentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaxDocumentsQuery, TaxDocumentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaxDocumentsQuery, TaxDocumentsQueryVariables>(TaxDocumentsDocument, variables, options);
}
export type TaxDocumentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaxDocumentsQuery, TaxDocumentsQueryVariables>;
export const ListPayrollDocument = gql`
    query ListPayroll($companyId: ID, $orderBy: PayrollOrderByInput, $limit: Int, $page: Int, $advancedWhere: PayrollAdvancedWhereInput) {
  listPayroll(
    companyId: $companyId
    orderBy: $orderBy
    limit: $limit
    page: $page
    advancedWhere: $advancedWhere
  ) {
    ...PaginationParts
    results {
      ...PayrollListParts
    }
  }
}
    ${PaginationPartsFragmentDoc}
${PayrollListPartsFragmentDoc}`;

/**
 * __useListPayrollQuery__
 *
 * To run a query within a Vue component, call `useListPayrollQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPayrollQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPayrollQuery({
 *   companyId: // value for 'companyId'
 *   orderBy: // value for 'orderBy'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   advancedWhere: // value for 'advancedWhere'
 * });
 */
export function useListPayrollQuery(variables: ListPayrollQueryVariables | VueCompositionApi.Ref<ListPayrollQueryVariables> | ReactiveFunction<ListPayrollQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListPayrollQuery, ListPayrollQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPayrollQuery, ListPayrollQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPayrollQuery, ListPayrollQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPayrollQuery, ListPayrollQueryVariables>(ListPayrollDocument, variables, options);
}
export type ListPayrollQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPayrollQuery, ListPayrollQueryVariables>;
export const ListPayrollCountDocument = gql`
    query ListPayrollCount($companyId: ID) {
  listPayroll(companyId: $companyId) {
    totalCount
  }
}
    `;

/**
 * __useListPayrollCountQuery__
 *
 * To run a query within a Vue component, call `useListPayrollCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPayrollCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPayrollCountQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useListPayrollCountQuery(variables: ListPayrollCountQueryVariables | VueCompositionApi.Ref<ListPayrollCountQueryVariables> | ReactiveFunction<ListPayrollCountQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ListPayrollCountQuery, ListPayrollCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPayrollCountQuery, ListPayrollCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPayrollCountQuery, ListPayrollCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPayrollCountQuery, ListPayrollCountQueryVariables>(ListPayrollCountDocument, variables, options);
}
export type ListPayrollCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPayrollCountQuery, ListPayrollCountQueryVariables>;
export const CompanyPayrollCountDocument = gql`
    query CompanyPayrollCount($companyId: ID!) {
  getCoreCompany(id: $companyId) {
    countPayroll(companyId: $companyId)
  }
}
    `;

/**
 * __useCompanyPayrollCountQuery__
 *
 * To run a query within a Vue component, call `useCompanyPayrollCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPayrollCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompanyPayrollCountQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useCompanyPayrollCountQuery(variables: CompanyPayrollCountQueryVariables | VueCompositionApi.Ref<CompanyPayrollCountQueryVariables> | ReactiveFunction<CompanyPayrollCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<CompanyPayrollCountQuery, CompanyPayrollCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompanyPayrollCountQuery, CompanyPayrollCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompanyPayrollCountQuery, CompanyPayrollCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CompanyPayrollCountQuery, CompanyPayrollCountQueryVariables>(CompanyPayrollCountDocument, variables, options);
}
export type CompanyPayrollCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CompanyPayrollCountQuery, CompanyPayrollCountQueryVariables>;
export const GetPayrollDocument = gql`
    query getPayroll($id: ID!) {
  getPayroll(id: $id) {
    ...PayrollWithoutNestedPaymentsParts
  }
}
    ${PayrollWithoutNestedPaymentsPartsFragmentDoc}`;

/**
 * __useGetPayrollQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollQuery(variables: GetPayrollQueryVariables | VueCompositionApi.Ref<GetPayrollQueryVariables> | ReactiveFunction<GetPayrollQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollQuery, GetPayrollQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollQuery, GetPayrollQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollQuery, GetPayrollQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollQuery, GetPayrollQueryVariables>(GetPayrollDocument, variables, options);
}
export type GetPayrollQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollQuery, GetPayrollQueryVariables>;
export const GetPayrollInfoDocument = gql`
    query GetPayrollInfo($id: ID!) {
  getPayroll(id: $id) {
    ...PayrollInfoParts
  }
}
    ${PayrollInfoPartsFragmentDoc}`;

/**
 * __useGetPayrollInfoQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollInfoQuery(variables: GetPayrollInfoQueryVariables | VueCompositionApi.Ref<GetPayrollInfoQueryVariables> | ReactiveFunction<GetPayrollInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollInfoQuery, GetPayrollInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollInfoQuery, GetPayrollInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollInfoQuery, GetPayrollInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollInfoQuery, GetPayrollInfoQueryVariables>(GetPayrollInfoDocument, variables, options);
}
export type GetPayrollInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollInfoQuery, GetPayrollInfoQueryVariables>;
export const GetPayrollItemsPaginatedDocument = gql`
    query GetPayrollItemsPaginated($companyId: ID!, $payrollId: ID!, $itemOrderBy: PayrollItemOrderByInput, $itemLimit: Int, $itemPage: Int, $itemAdvancedWhere: PayrollItemAdvancedWhereInput) {
  getCoreCompany(id: $companyId) {
    getPayrollWithCompanyRoles(id: $payrollId) {
      ...PayrollItemsPaginatedParts
    }
  }
}
    ${PayrollItemsPaginatedPartsFragmentDoc}`;

/**
 * __useGetPayrollItemsPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollItemsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollItemsPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollItemsPaginatedQuery({
 *   companyId: // value for 'companyId'
 *   payrollId: // value for 'payrollId'
 *   itemOrderBy: // value for 'itemOrderBy'
 *   itemLimit: // value for 'itemLimit'
 *   itemPage: // value for 'itemPage'
 *   itemAdvancedWhere: // value for 'itemAdvancedWhere'
 * });
 */
export function useGetPayrollItemsPaginatedQuery(variables: GetPayrollItemsPaginatedQueryVariables | VueCompositionApi.Ref<GetPayrollItemsPaginatedQueryVariables> | ReactiveFunction<GetPayrollItemsPaginatedQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollItemsPaginatedQuery, GetPayrollItemsPaginatedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollItemsPaginatedQuery, GetPayrollItemsPaginatedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollItemsPaginatedQuery, GetPayrollItemsPaginatedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollItemsPaginatedQuery, GetPayrollItemsPaginatedQueryVariables>(GetPayrollItemsPaginatedDocument, variables, options);
}
export type GetPayrollItemsPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollItemsPaginatedQuery, GetPayrollItemsPaginatedQueryVariables>;
export const GetPayrollPaymentsPaginatedDocument = gql`
    query GetPayrollPaymentsPaginated($companyId: ID!, $payrollId: ID!, $paymentOrderBy: ContractorPaymentOrderByInput, $paymentLimit: Int, $paymentPage: Int, $paymentAdvancedWhere: ContractorPaymentAdvancedWhereInput) {
  getCoreCompany(id: $companyId) {
    getPayrollWithCompanyRoles(id: $payrollId) {
      ...PayrollPaymentsPaginatedParts
    }
  }
}
    ${PayrollPaymentsPaginatedPartsFragmentDoc}`;

/**
 * __useGetPayrollPaymentsPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollPaymentsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollPaymentsPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollPaymentsPaginatedQuery({
 *   companyId: // value for 'companyId'
 *   payrollId: // value for 'payrollId'
 *   paymentOrderBy: // value for 'paymentOrderBy'
 *   paymentLimit: // value for 'paymentLimit'
 *   paymentPage: // value for 'paymentPage'
 *   paymentAdvancedWhere: // value for 'paymentAdvancedWhere'
 * });
 */
export function useGetPayrollPaymentsPaginatedQuery(variables: GetPayrollPaymentsPaginatedQueryVariables | VueCompositionApi.Ref<GetPayrollPaymentsPaginatedQueryVariables> | ReactiveFunction<GetPayrollPaymentsPaginatedQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollPaymentsPaginatedQuery, GetPayrollPaymentsPaginatedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollPaymentsPaginatedQuery, GetPayrollPaymentsPaginatedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollPaymentsPaginatedQuery, GetPayrollPaymentsPaginatedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollPaymentsPaginatedQuery, GetPayrollPaymentsPaginatedQueryVariables>(GetPayrollPaymentsPaginatedDocument, variables, options);
}
export type GetPayrollPaymentsPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollPaymentsPaginatedQuery, GetPayrollPaymentsPaginatedQueryVariables>;
export const GetEmployeeDocument = gql`
    query GetEmployee($id: ID!) {
  getEmployee(id: $id) {
    id
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetEmployeeQuery(variables: GetEmployeeQueryVariables | VueCompositionApi.Ref<GetEmployeeQueryVariables> | ReactiveFunction<GetEmployeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, variables, options);
}
export type GetEmployeeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeeTaxDocsDocument = gql`
    query GetEmployeeTaxDocs($id: ID!) {
  getEmployee(id: $id) {
    id
    taxDocuments {
      ...TaxDocumentParts
    }
  }
}
    ${TaxDocumentPartsFragmentDoc}`;

/**
 * __useGetEmployeeTaxDocsQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeTaxDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeTaxDocsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeTaxDocsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetEmployeeTaxDocsQuery(variables: GetEmployeeTaxDocsQueryVariables | VueCompositionApi.Ref<GetEmployeeTaxDocsQueryVariables> | ReactiveFunction<GetEmployeeTaxDocsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeTaxDocsQuery, GetEmployeeTaxDocsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeTaxDocsQuery, GetEmployeeTaxDocsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeTaxDocsQuery, GetEmployeeTaxDocsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeTaxDocsQuery, GetEmployeeTaxDocsQueryVariables>(GetEmployeeTaxDocsDocument, variables, options);
}
export type GetEmployeeTaxDocsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeTaxDocsQuery, GetEmployeeTaxDocsQueryVariables>;
export const GetEmployeeStatusDocument = gql`
    query GetEmployeeStatus($id: ID!) {
  getEmployee(id: $id) {
    ...EmployeeStatusParts
  }
}
    ${EmployeeStatusPartsFragmentDoc}`;

/**
 * __useGetEmployeeStatusQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetEmployeeStatusQuery(variables: GetEmployeeStatusQueryVariables | VueCompositionApi.Ref<GetEmployeeStatusQueryVariables> | ReactiveFunction<GetEmployeeStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeStatusQuery, GetEmployeeStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeStatusQuery, GetEmployeeStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeStatusQuery, GetEmployeeStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeStatusQuery, GetEmployeeStatusQueryVariables>(GetEmployeeStatusDocument, variables, options);
}
export type GetEmployeeStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeStatusQuery, GetEmployeeStatusQueryVariables>;
export const GetContractorTaxDocsDocument = gql`
    query GetContractorTaxDocs($id: ID!) {
  getContractor(id: $id) {
    id
    taxDocuments {
      ...TaxDocumentParts
    }
  }
}
    ${TaxDocumentPartsFragmentDoc}`;

/**
 * __useGetContractorTaxDocsQuery__
 *
 * To run a query within a Vue component, call `useGetContractorTaxDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorTaxDocsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContractorTaxDocsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetContractorTaxDocsQuery(variables: GetContractorTaxDocsQueryVariables | VueCompositionApi.Ref<GetContractorTaxDocsQueryVariables> | ReactiveFunction<GetContractorTaxDocsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContractorTaxDocsQuery, GetContractorTaxDocsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContractorTaxDocsQuery, GetContractorTaxDocsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContractorTaxDocsQuery, GetContractorTaxDocsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContractorTaxDocsQuery, GetContractorTaxDocsQueryVariables>(GetContractorTaxDocsDocument, variables, options);
}
export type GetContractorTaxDocsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContractorTaxDocsQuery, GetContractorTaxDocsQueryVariables>;
export const GetContractorStatusDocument = gql`
    query GetContractorStatus($id: ID!) {
  getContractor(id: $id) {
    ...ContractorStatusParts
  }
}
    ${ContractorStatusPartsFragmentDoc}`;

/**
 * __useGetContractorStatusQuery__
 *
 * To run a query within a Vue component, call `useGetContractorStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContractorStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetContractorStatusQuery(variables: GetContractorStatusQueryVariables | VueCompositionApi.Ref<GetContractorStatusQueryVariables> | ReactiveFunction<GetContractorStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContractorStatusQuery, GetContractorStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContractorStatusQuery, GetContractorStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContractorStatusQuery, GetContractorStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContractorStatusQuery, GetContractorStatusQueryVariables>(GetContractorStatusDocument, variables, options);
}
export type GetContractorStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContractorStatusQuery, GetContractorStatusQueryVariables>;
export const GetWorkerStatusDocument = gql`
    query GetWorkerStatus($id: ID!) {
  getEmployee(id: $id) {
    ...EmployeeStatusParts
  }
  getContractor(id: $id) {
    ...ContractorStatusParts
  }
}
    ${EmployeeStatusPartsFragmentDoc}
${ContractorStatusPartsFragmentDoc}`;

/**
 * __useGetWorkerStatusQuery__
 *
 * To run a query within a Vue component, call `useGetWorkerStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWorkerStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetWorkerStatusQuery(variables: GetWorkerStatusQueryVariables | VueCompositionApi.Ref<GetWorkerStatusQueryVariables> | ReactiveFunction<GetWorkerStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWorkerStatusQuery, GetWorkerStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWorkerStatusQuery, GetWorkerStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWorkerStatusQuery, GetWorkerStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetWorkerStatusQuery, GetWorkerStatusQueryVariables>(GetWorkerStatusDocument, variables, options);
}
export type GetWorkerStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetWorkerStatusQuery, GetWorkerStatusQueryVariables>;
export const GetEmployeePayrollItemsDocument = gql`
    query GetEmployeePayrollItems($id: ID!) {
  getEmployee(id: $id) {
    ...EmployeePayrollItemsParts
  }
}
    ${EmployeePayrollItemsPartsFragmentDoc}`;

/**
 * __useGetEmployeePayrollItemsQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeePayrollItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeePayrollItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeePayrollItemsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetEmployeePayrollItemsQuery(variables: GetEmployeePayrollItemsQueryVariables | VueCompositionApi.Ref<GetEmployeePayrollItemsQueryVariables> | ReactiveFunction<GetEmployeePayrollItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeePayrollItemsQuery, GetEmployeePayrollItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeePayrollItemsQuery, GetEmployeePayrollItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeePayrollItemsQuery, GetEmployeePayrollItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeePayrollItemsQuery, GetEmployeePayrollItemsQueryVariables>(GetEmployeePayrollItemsDocument, variables, options);
}
export type GetEmployeePayrollItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeePayrollItemsQuery, GetEmployeePayrollItemsQueryVariables>;
export const GetContractorPaymentsDocument = gql`
    query GetContractorPayments($id: ID!) {
  getContractor(id: $id) {
    ...ContractorPaymentParts
  }
}
    ${ContractorPaymentPartsFragmentDoc}`;

/**
 * __useGetContractorPaymentsQuery__
 *
 * To run a query within a Vue component, call `useGetContractorPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorPaymentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContractorPaymentsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetContractorPaymentsQuery(variables: GetContractorPaymentsQueryVariables | VueCompositionApi.Ref<GetContractorPaymentsQueryVariables> | ReactiveFunction<GetContractorPaymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContractorPaymentsQuery, GetContractorPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContractorPaymentsQuery, GetContractorPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContractorPaymentsQuery, GetContractorPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContractorPaymentsQuery, GetContractorPaymentsQueryVariables>(GetContractorPaymentsDocument, variables, options);
}
export type GetContractorPaymentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContractorPaymentsQuery, GetContractorPaymentsQueryVariables>;
export const ListWorkplaceDocument = gql`
    query listWorkplace($companyId: ID!) {
  listWorkplace(companyId: $companyId) {
    id
    address {
      ...AddressParts
    }
    default
    name
    active
  }
}
    ${AddressPartsFragmentDoc}`;

/**
 * __useListWorkplaceQuery__
 *
 * To run a query within a Vue component, call `useListWorkplaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkplaceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListWorkplaceQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useListWorkplaceQuery(variables: ListWorkplaceQueryVariables | VueCompositionApi.Ref<ListWorkplaceQueryVariables> | ReactiveFunction<ListWorkplaceQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListWorkplaceQuery, ListWorkplaceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListWorkplaceQuery, ListWorkplaceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListWorkplaceQuery, ListWorkplaceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListWorkplaceQuery, ListWorkplaceQueryVariables>(ListWorkplaceDocument, variables, options);
}
export type ListWorkplaceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListWorkplaceQuery, ListWorkplaceQueryVariables>;
export const GetCompanyDefaultPayScheduleDaysDocument = gql`
    query GetCompanyDefaultPayScheduleDays($id: ID!) {
  getCompany(id: $id) {
    id
    defaultPayScheduleDays(input: {limit: 100}) {
      approvalDeadline
      impactedByWeekendOrHoliday
      payday
      periodEnd
      periodStart
    }
  }
}
    `;

/**
 * __useGetCompanyDefaultPayScheduleDaysQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyDefaultPayScheduleDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDefaultPayScheduleDaysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyDefaultPayScheduleDaysQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyDefaultPayScheduleDaysQuery(variables: GetCompanyDefaultPayScheduleDaysQueryVariables | VueCompositionApi.Ref<GetCompanyDefaultPayScheduleDaysQueryVariables> | ReactiveFunction<GetCompanyDefaultPayScheduleDaysQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyDefaultPayScheduleDaysQuery, GetCompanyDefaultPayScheduleDaysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyDefaultPayScheduleDaysQuery, GetCompanyDefaultPayScheduleDaysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyDefaultPayScheduleDaysQuery, GetCompanyDefaultPayScheduleDaysQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyDefaultPayScheduleDaysQuery, GetCompanyDefaultPayScheduleDaysQueryVariables>(GetCompanyDefaultPayScheduleDaysDocument, variables, options);
}
export type GetCompanyDefaultPayScheduleDaysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyDefaultPayScheduleDaysQuery, GetCompanyDefaultPayScheduleDaysQueryVariables>;
export const GetUserEditInfoDocument = gql`
    query GetUserEditInfo($companyId: ID!, $userId: ID!) {
  getCoreUserById(id: $userId) {
    ...UserParts
  }
  getEmployee(id: $userId) {
    ...EmployeeStatusParts
    workplaces {
      id
    }
  }
  getContractor(id: $userId) {
    ...ContractorStatusParts
    workplaces {
      id
    }
  }
  getCompany(id: $companyId) {
    id
    excludedStaffIds
    checkId
    status
  }
}
    ${UserPartsFragmentDoc}
${EmployeeStatusPartsFragmentDoc}
${ContractorStatusPartsFragmentDoc}`;

/**
 * __useGetUserEditInfoQuery__
 *
 * To run a query within a Vue component, call `useGetUserEditInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEditInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserEditInfoQuery({
 *   companyId: // value for 'companyId'
 *   userId: // value for 'userId'
 * });
 */
export function useGetUserEditInfoQuery(variables: GetUserEditInfoQueryVariables | VueCompositionApi.Ref<GetUserEditInfoQueryVariables> | ReactiveFunction<GetUserEditInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserEditInfoQuery, GetUserEditInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>(GetUserEditInfoDocument, variables, options);
}
export type GetUserEditInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>;
export const GetCompanyRolesDocument = gql`
    query GetCompanyRoles($companyId: ID!) {
  getCoreCompany(id: $companyId) {
    id
    companyRoles {
      id
      title
      deletedAt
      createdAt
      workerRoles {
        id
        deletedAt
      }
    }
  }
}
    `;

/**
 * __useGetCompanyRolesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyRolesQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetCompanyRolesQuery(variables: GetCompanyRolesQueryVariables | VueCompositionApi.Ref<GetCompanyRolesQueryVariables> | ReactiveFunction<GetCompanyRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyRolesQuery, GetCompanyRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>(GetCompanyRolesDocument, variables, options);
}
export type GetCompanyRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>;
export const GetUserRolesDocument = gql`
    query GetUserRoles($userId: ID!, $showDeleted: Boolean = false) {
  getCoreUserById(id: $userId) {
    id
    employment {
      id
      workerRoles(showDeleted: $showDeleted) {
        id
        isPrimary
        payRate
        deletedAt
        payType
        companyRole {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a Vue component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserRolesQuery({
 *   userId: // value for 'userId'
 *   showDeleted: // value for 'showDeleted'
 * });
 */
export function useGetUserRolesQuery(variables: GetUserRolesQueryVariables | VueCompositionApi.Ref<GetUserRolesQueryVariables> | ReactiveFunction<GetUserRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserRolesQuery, GetUserRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserRolesQuery, GetUserRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserRolesQuery, GetUserRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, variables, options);
}
export type GetUserRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserRolesQuery, GetUserRolesQueryVariables>;
export const GetMfaEnrollmentsDocument = gql`
    query GetMFAEnrollments($includeUncomfirmed: Boolean) {
  getMyMfaEnrollments(includeUnconfirmed: $includeUncomfirmed) {
    mfaType
  }
}
    `;

/**
 * __useGetMfaEnrollmentsQuery__
 *
 * To run a query within a Vue component, call `useGetMfaEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfaEnrollmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMfaEnrollmentsQuery({
 *   includeUncomfirmed: // value for 'includeUncomfirmed'
 * });
 */
export function useGetMfaEnrollmentsQuery(variables: GetMfaEnrollmentsQueryVariables | VueCompositionApi.Ref<GetMfaEnrollmentsQueryVariables> | ReactiveFunction<GetMfaEnrollmentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>(GetMfaEnrollmentsDocument, variables, options);
}
export type GetMfaEnrollmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>;
export const GetTrainingUserHistoryDocument = gql`
    query GetTrainingUserHistory($data: UserQueryInput!, $filter: UserTrainingFilterInput!) {
  user(data: $data) {
    id
    training {
      history(filter: $filter) {
        id
        bundleId
        topicId
        bundleName
        completedAt
        enrolledAt
        startedAt
        name
        certificateDownloadUrl
        topics {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetTrainingUserHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingUserHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingUserHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingUserHistoryQuery({
 *   data: // value for 'data'
 *   filter: // value for 'filter'
 * });
 */
export function useGetTrainingUserHistoryQuery(variables: GetTrainingUserHistoryQueryVariables | VueCompositionApi.Ref<GetTrainingUserHistoryQueryVariables> | ReactiveFunction<GetTrainingUserHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>(GetTrainingUserHistoryDocument, variables, options);
}
export type GetTrainingUserHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>;
export const GetPayrollOnboardingInfoDocument = gql`
    query GetPayrollOnboardingInfo($id: ID!) {
  getCompany(id: $id) {
    id
    checkIndustry
    processedPayrollsThisYear
    signatoryEmail
    signatoryFirstName
    signatoryLastName
    signatoryTitle
    onboardingOffersEmployeeBenefits
    onboardingHasGarnishmentsOrDeductions
    onboardingGarnishmentsOrDeductions
    onboardingGarnishmentsOrDeductionsOther
  }
  getCoreCompany(id: $id) {
    id
    name
    dba
    fein
    numOfFullTimeHourlyEmployees
    numOfFullTimeSalaryEmployees
    numOfPartTimeEmployees
    numOfContractors
    phone
    website
    address {
      line1
      line2
      city
      state
      zip: zipCode
    }
  }
}
    `;

/**
 * __useGetPayrollOnboardingInfoQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollOnboardingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollOnboardingInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollOnboardingInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollOnboardingInfoQuery(variables: GetPayrollOnboardingInfoQueryVariables | VueCompositionApi.Ref<GetPayrollOnboardingInfoQueryVariables> | ReactiveFunction<GetPayrollOnboardingInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollOnboardingInfoQuery, GetPayrollOnboardingInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollOnboardingInfoQuery, GetPayrollOnboardingInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollOnboardingInfoQuery, GetPayrollOnboardingInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollOnboardingInfoQuery, GetPayrollOnboardingInfoQueryVariables>(GetPayrollOnboardingInfoDocument, variables, options);
}
export type GetPayrollOnboardingInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollOnboardingInfoQuery, GetPayrollOnboardingInfoQueryVariables>;
export const GetPayrollFeinStatusDocument = gql`
    query GetPayrollFeinStatus($id: ID!) {
  getCompany(id: $id) {
    id
    feinVerification {
      id
      legalName
      federalEin
      status
      company
    }
    feinVerificationAttempts
  }
}
    `;

/**
 * __useGetPayrollFeinStatusQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollFeinStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollFeinStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollFeinStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollFeinStatusQuery(variables: GetPayrollFeinStatusQueryVariables | VueCompositionApi.Ref<GetPayrollFeinStatusQueryVariables> | ReactiveFunction<GetPayrollFeinStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollFeinStatusQuery, GetPayrollFeinStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollFeinStatusQuery, GetPayrollFeinStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollFeinStatusQuery, GetPayrollFeinStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollFeinStatusQuery, GetPayrollFeinStatusQueryVariables>(GetPayrollFeinStatusDocument, variables, options);
}
export type GetPayrollFeinStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollFeinStatusQuery, GetPayrollFeinStatusQueryVariables>;
export const GetTimesheetsDocument = gql`
    query GetTimesheets($payrollId: ID!) {
  payroll(id: $payrollId) {
    id
    itemsPage {
      results {
        id
        timesheetHours {
          totalHours
          overtimeHours
          regularHours
          holidayHours
          sickHours
          ptoHours
        }
        employee {
          id
          profile {
            id
            firstName
            lastName
            title
            employeeType
          }
          payRate
          payType
          user {
            profile {
              id
              avatarUrl
            }
          }
        }
      }
    }
    contractorPaymentsPage {
      results {
        id
        timesheetHours {
          totalHours
          overtimeHours
          regularHours
          holidayHours
          sickHours
          ptoHours
        }
        contractor {
          id
          profile {
            id
            firstName
            lastName
            title
            employeeType
          }
          payRate
          payType
          user {
            profile {
              id
              avatarUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTimesheetsQuery__
 *
 * To run a query within a Vue component, call `useGetTimesheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimesheetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTimesheetsQuery({
 *   payrollId: // value for 'payrollId'
 * });
 */
export function useGetTimesheetsQuery(variables: GetTimesheetsQueryVariables | VueCompositionApi.Ref<GetTimesheetsQueryVariables> | ReactiveFunction<GetTimesheetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTimesheetsQuery, GetTimesheetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTimesheetsQuery, GetTimesheetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTimesheetsQuery, GetTimesheetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTimesheetsQuery, GetTimesheetsQueryVariables>(GetTimesheetsDocument, variables, options);
}
export type GetTimesheetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTimesheetsQuery, GetTimesheetsQueryVariables>;
export const GetTimesheetsByRoleDocument = gql`
    query GetTimesheetsByRole($payrollId: ID!) {
  payroll(id: $payrollId) {
    id
    itemsPage {
      results {
        id
        timesheetHoursByRole {
          role {
            title
            payRate
          }
          totalHours
          overtimeHours
          regularHours
          holidayHours
          sickHours
          ptoHours
        }
        employee {
          id
          profile {
            id
            firstName
            lastName
            title
            employeeType
          }
          payRate
          payType
          user {
            profile {
              id
              avatarUrl
            }
          }
        }
      }
    }
    contractorPaymentsPage {
      results {
        id
        timesheetHoursByRole {
          role {
            title
            payRate
          }
          totalHours
          overtimeHours
          regularHours
          holidayHours
          sickHours
          ptoHours
        }
        contractor {
          id
          profile {
            id
            firstName
            lastName
            title
            employeeType
          }
          payRate
          payType
          user {
            profile {
              id
              avatarUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTimesheetsByRoleQuery__
 *
 * To run a query within a Vue component, call `useGetTimesheetsByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimesheetsByRoleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTimesheetsByRoleQuery({
 *   payrollId: // value for 'payrollId'
 * });
 */
export function useGetTimesheetsByRoleQuery(variables: GetTimesheetsByRoleQueryVariables | VueCompositionApi.Ref<GetTimesheetsByRoleQueryVariables> | ReactiveFunction<GetTimesheetsByRoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTimesheetsByRoleQuery, GetTimesheetsByRoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTimesheetsByRoleQuery, GetTimesheetsByRoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTimesheetsByRoleQuery, GetTimesheetsByRoleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTimesheetsByRoleQuery, GetTimesheetsByRoleQueryVariables>(GetTimesheetsByRoleDocument, variables, options);
}
export type GetTimesheetsByRoleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTimesheetsByRoleQuery, GetTimesheetsByRoleQueryVariables>;
export const GetCompanyGoalsDocument = gql`
    query GetCompanyGoals($id: ID!) {
  getCompany(id: $id) {
    id
    goals {
      ...CompanyGoalParts
    }
  }
}
    ${CompanyGoalPartsFragmentDoc}`;

/**
 * __useGetCompanyGoalsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyGoalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyGoalsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyGoalsQuery(variables: GetCompanyGoalsQueryVariables | VueCompositionApi.Ref<GetCompanyGoalsQueryVariables> | ReactiveFunction<GetCompanyGoalsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyGoalsQuery, GetCompanyGoalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyGoalsQuery, GetCompanyGoalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyGoalsQuery, GetCompanyGoalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyGoalsQuery, GetCompanyGoalsQueryVariables>(GetCompanyGoalsDocument, variables, options);
}
export type GetCompanyGoalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyGoalsQuery, GetCompanyGoalsQueryVariables>;
export const GetPayrollTasksDocument = gql`
    query GetPayrollTasks($id: ID!) {
  getCompany(id: $id) {
    id
    goals {
      id
      status
      required
    }
  }
}
    `;

/**
 * __useGetPayrollTasksQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollTasksQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollTasksQuery(variables: GetPayrollTasksQueryVariables | VueCompositionApi.Ref<GetPayrollTasksQueryVariables> | ReactiveFunction<GetPayrollTasksQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollTasksQuery, GetPayrollTasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollTasksQuery, GetPayrollTasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollTasksQuery, GetPayrollTasksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollTasksQuery, GetPayrollTasksQueryVariables>(GetPayrollTasksDocument, variables, options);
}
export type GetPayrollTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollTasksQuery, GetPayrollTasksQueryVariables>;
export const GetPayrollPayItemsDocument = gql`
    query GetPayrollPayItems($companyId: ID!, $id: ID!) {
  getCoreCompany(id: $companyId) {
    id
    getPayroll(id: $id) {
      approvalDeadline
      contractorPayments {
        basePayRate
        checkNumber
        grossPay
        contractor {
          checkOnboarding {
            blockingSteps
            id
            status
          }
          id
          profile {
            contractorBusinessName
            contractorType
            employeeType
            firstName
            id
            lastName
            title
          }
          remainingOnboardingSteps
        }
        grossPay
        hasDeletedWorkerRole
        id
        payType
        payroll {
          id
          version
        }
        version
      }
      deletedAt
      draftLiability
      id
      items {
        grossPay
        checkNumber
        employee {
          id
          checkOnboarding {
            blockingSteps
            id
            status
          }
          payRate
          payType
          profile {
            employeeType
            firstName
            id
            lastName
            title
          }
          remainingOnboardingSteps
        }
        hasDeletedWorkerRole
        id
        netPay
        payroll {
          id
          version
        }
        sickBalanceHours
        version
      }
      status
      statusChangedAt
      type
      version
    }
  }
}
    `;

/**
 * __useGetPayrollPayItemsQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollPayItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollPayItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollPayItemsQuery({
 *   companyId: // value for 'companyId'
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollPayItemsQuery(variables: GetPayrollPayItemsQueryVariables | VueCompositionApi.Ref<GetPayrollPayItemsQueryVariables> | ReactiveFunction<GetPayrollPayItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollPayItemsQuery, GetPayrollPayItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollPayItemsQuery, GetPayrollPayItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollPayItemsQuery, GetPayrollPayItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollPayItemsQuery, GetPayrollPayItemsQueryVariables>(GetPayrollPayItemsDocument, variables, options);
}
export type GetPayrollPayItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollPayItemsQuery, GetPayrollPayItemsQueryVariables>;
export const GetPayrollItemDocument = gql`
    query GetPayrollItem($companyId: ID!, $payrollId: ID!, $id: ID!) {
  getCoreCompany(id: $companyId) {
    id
    getPayrollWithCompanyRoles(id: $payrollId) {
      id
      payrollItem(id: $id) {
        ...ItemParts
      }
    }
  }
}
    ${ItemPartsFragmentDoc}`;

/**
 * __useGetPayrollItemQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollItemQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollItemQuery({
 *   companyId: // value for 'companyId'
 *   payrollId: // value for 'payrollId'
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollItemQuery(variables: GetPayrollItemQueryVariables | VueCompositionApi.Ref<GetPayrollItemQueryVariables> | ReactiveFunction<GetPayrollItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollItemQuery, GetPayrollItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollItemQuery, GetPayrollItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollItemQuery, GetPayrollItemQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollItemQuery, GetPayrollItemQueryVariables>(GetPayrollItemDocument, variables, options);
}
export type GetPayrollItemQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollItemQuery, GetPayrollItemQueryVariables>;
export const GetContractorPaymentDocument = gql`
    query GetContractorPayment($companyId: ID!, $payrollId: ID!, $id: ID!) {
  getCoreCompany(id: $companyId) {
    id
    getPayrollWithCompanyRoles(id: $payrollId) {
      id
      contractorPayment(id: $id) {
        ...PaymentParts
      }
    }
  }
}
    ${PaymentPartsFragmentDoc}`;

/**
 * __useGetContractorPaymentQuery__
 *
 * To run a query within a Vue component, call `useGetContractorPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorPaymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContractorPaymentQuery({
 *   companyId: // value for 'companyId'
 *   payrollId: // value for 'payrollId'
 *   id: // value for 'id'
 * });
 */
export function useGetContractorPaymentQuery(variables: GetContractorPaymentQueryVariables | VueCompositionApi.Ref<GetContractorPaymentQueryVariables> | ReactiveFunction<GetContractorPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContractorPaymentQuery, GetContractorPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContractorPaymentQuery, GetContractorPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContractorPaymentQuery, GetContractorPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContractorPaymentQuery, GetContractorPaymentQueryVariables>(GetContractorPaymentDocument, variables, options);
}
export type GetContractorPaymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContractorPaymentQuery, GetContractorPaymentQueryVariables>;
export const GetMyCompanyGoalsDocument = gql`
    query GetMyCompanyGoals($id: ID!) {
  getMyCompanyGoals {
    ...CoreGoalParts
    tasks {
      ...CoreTaskParts
    }
  }
  getCompany(id: $id) {
    id
    status
    onboardingOffersEmployeeBenefits
    onboardingHasGarnishmentsOrDeductions
    onboardingHasComplexScenario
    onboardingHasComplexTimeAttendanceScenario
    pastPayrollUsage
    total {
      missingEmployeeDetails
      onboardedEmployees
      payrollEmployees
    }
  }
}
    ${CoreGoalPartsFragmentDoc}
${CoreTaskPartsFragmentDoc}`;

/**
 * __useGetMyCompanyGoalsQuery__
 *
 * To run a query within a Vue component, call `useGetMyCompanyGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCompanyGoalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyCompanyGoalsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMyCompanyGoalsQuery(variables: GetMyCompanyGoalsQueryVariables | VueCompositionApi.Ref<GetMyCompanyGoalsQueryVariables> | ReactiveFunction<GetMyCompanyGoalsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>(GetMyCompanyGoalsDocument, variables, options);
}
export type GetMyCompanyGoalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>;
export const GetCoreCompanyEmployeesForOnboardingDocument = gql`
    query GetCoreCompanyEmployeesForOnboarding($id: ID!) {
  coreCompany(id: $id) {
    id
    employees(active: true) {
      id
      profile {
        id
        firstName
        lastName
        email
        phone
      }
      employment {
        id
        isContractor
      }
      employee {
        id
        checkId
      }
      contractor {
        id
        checkId
      }
    }
  }
}
    `;

/**
 * __useGetCoreCompanyEmployeesForOnboardingQuery__
 *
 * To run a query within a Vue component, call `useGetCoreCompanyEmployeesForOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoreCompanyEmployeesForOnboardingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCoreCompanyEmployeesForOnboardingQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCoreCompanyEmployeesForOnboardingQuery(variables: GetCoreCompanyEmployeesForOnboardingQueryVariables | VueCompositionApi.Ref<GetCoreCompanyEmployeesForOnboardingQueryVariables> | ReactiveFunction<GetCoreCompanyEmployeesForOnboardingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoreCompanyEmployeesForOnboardingQuery, GetCoreCompanyEmployeesForOnboardingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoreCompanyEmployeesForOnboardingQuery, GetCoreCompanyEmployeesForOnboardingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoreCompanyEmployeesForOnboardingQuery, GetCoreCompanyEmployeesForOnboardingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCoreCompanyEmployeesForOnboardingQuery, GetCoreCompanyEmployeesForOnboardingQueryVariables>(GetCoreCompanyEmployeesForOnboardingDocument, variables, options);
}
export type GetCoreCompanyEmployeesForOnboardingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCoreCompanyEmployeesForOnboardingQuery, GetCoreCompanyEmployeesForOnboardingQueryVariables>;
export const GetCompanyPayrollHistoryDocument = gql`
    query GetCompanyPayrollHistory($id: ID!) {
  getCompany(id: $id) {
    id
    pastPayrollUsage
  }
}
    `;

/**
 * __useGetCompanyPayrollHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyPayrollHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPayrollHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyPayrollHistoryQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyPayrollHistoryQuery(variables: GetCompanyPayrollHistoryQueryVariables | VueCompositionApi.Ref<GetCompanyPayrollHistoryQueryVariables> | ReactiveFunction<GetCompanyPayrollHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyPayrollHistoryQuery, GetCompanyPayrollHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyPayrollHistoryQuery, GetCompanyPayrollHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyPayrollHistoryQuery, GetCompanyPayrollHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyPayrollHistoryQuery, GetCompanyPayrollHistoryQueryVariables>(GetCompanyPayrollHistoryDocument, variables, options);
}
export type GetCompanyPayrollHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyPayrollHistoryQuery, GetCompanyPayrollHistoryQueryVariables>;
export const GetPayrollSignatoryInfoDocument = gql`
    query GetPayrollSignatoryInfo($id: ID!) {
  payrollCompany(id: $id) {
    id
    signatoryFirstName
    signatoryLastName
    signatoryTitle
    signatoryEmail
  }
}
    `;

/**
 * __useGetPayrollSignatoryInfoQuery__
 *
 * To run a query within a Vue component, call `useGetPayrollSignatoryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollSignatoryInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPayrollSignatoryInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPayrollSignatoryInfoQuery(variables: GetPayrollSignatoryInfoQueryVariables | VueCompositionApi.Ref<GetPayrollSignatoryInfoQueryVariables> | ReactiveFunction<GetPayrollSignatoryInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPayrollSignatoryInfoQuery, GetPayrollSignatoryInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPayrollSignatoryInfoQuery, GetPayrollSignatoryInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPayrollSignatoryInfoQuery, GetPayrollSignatoryInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPayrollSignatoryInfoQuery, GetPayrollSignatoryInfoQueryVariables>(GetPayrollSignatoryInfoDocument, variables, options);
}
export type GetPayrollSignatoryInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPayrollSignatoryInfoQuery, GetPayrollSignatoryInfoQueryVariables>;
export const GetCompanyAddressesDocument = gql`
    query GetCompanyAddresses($id: ID!) {
  coreCompany(id: $id) {
    id
    address {
      line1
      line2
      city
      state
      zip: zipCode
    }
    mailingAddress {
      line1
      line2
      city
      state
      zip: zipCode
    }
    legalAddress {
      line1
      line2
      city
      state
      zip: zipCode
    }
  }
  listWorkplace(companyId: $id) {
    id
    default
    address {
      city
      country
      line1
      line2
      state
      zip
    }
  }
}
    `;

/**
 * __useGetCompanyAddressesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAddressesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyAddressesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyAddressesQuery(variables: GetCompanyAddressesQueryVariables | VueCompositionApi.Ref<GetCompanyAddressesQueryVariables> | ReactiveFunction<GetCompanyAddressesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyAddressesQuery, GetCompanyAddressesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyAddressesQuery, GetCompanyAddressesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyAddressesQuery, GetCompanyAddressesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyAddressesQuery, GetCompanyAddressesQueryVariables>(GetCompanyAddressesDocument, variables, options);
}
export type GetCompanyAddressesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyAddressesQuery, GetCompanyAddressesQueryVariables>;
export const GetBambeePlusInfoDocument = gql`
    query GetBambeePlusInfo($data: PurchaseBambeePlusInput!, $companyId: ID!) {
  getBambeePlusInfo(input: $data) {
    id
    eligible
    status
    price
    onboardingDueDate
    hasExtendedOnboardingDeadline
    lateFeeImplementationPrice
  }
  coreCompany(id: $companyId) {
    id
    legalAddress {
      line1
      line2
      city
      state
      zip: zipCode
    }
    employees {
      id
      employee {
        id
        checkId
      }
    }
  }
  payrollCompany(id: $companyId) {
    id
    feinVerification {
      id
      status
    }
    pastPayrollUsage
    signatoryEmail
    signatoryFirstName
    signatoryLastName
    signatoryTitle
  }
  getMyCompanyGoals {
    ...CoreGoalParts
    tasks {
      ...CoreTaskParts
    }
  }
}
    ${CoreGoalPartsFragmentDoc}
${CoreTaskPartsFragmentDoc}`;

/**
 * __useGetBambeePlusInfoQuery__
 *
 * To run a query within a Vue component, call `useGetBambeePlusInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBambeePlusInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBambeePlusInfoQuery({
 *   data: // value for 'data'
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetBambeePlusInfoQuery(variables: GetBambeePlusInfoQueryVariables | VueCompositionApi.Ref<GetBambeePlusInfoQueryVariables> | ReactiveFunction<GetBambeePlusInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBambeePlusInfoQuery, GetBambeePlusInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBambeePlusInfoQuery, GetBambeePlusInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBambeePlusInfoQuery, GetBambeePlusInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBambeePlusInfoQuery, GetBambeePlusInfoQueryVariables>(GetBambeePlusInfoDocument, variables, options);
}
export type GetBambeePlusInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBambeePlusInfoQuery, GetBambeePlusInfoQueryVariables>;
export const GetBasicCompanyInfoDocument = gql`
    query GetBasicCompanyInfo($id: ID!) {
  coreCompany(id: $id) {
    id
    name
    phone
    industry
  }
}
    `;

/**
 * __useGetBasicCompanyInfoQuery__
 *
 * To run a query within a Vue component, call `useGetBasicCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicCompanyInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBasicCompanyInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetBasicCompanyInfoQuery(variables: GetBasicCompanyInfoQueryVariables | VueCompositionApi.Ref<GetBasicCompanyInfoQueryVariables> | ReactiveFunction<GetBasicCompanyInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>(GetBasicCompanyInfoDocument, variables, options);
}
export type GetBasicCompanyInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>;
export const GetBambeePlusDeadlineDocument = gql`
    query GetBambeePlusDeadline($data: PurchaseBambeePlusInput!) {
  getBambeePlusInfo(input: $data) {
    id
    eligible
    status
    onboardingDueDate
    lateFeeImplementationPrice
  }
}
    `;

/**
 * __useGetBambeePlusDeadlineQuery__
 *
 * To run a query within a Vue component, call `useGetBambeePlusDeadlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBambeePlusDeadlineQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBambeePlusDeadlineQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetBambeePlusDeadlineQuery(variables: GetBambeePlusDeadlineQueryVariables | VueCompositionApi.Ref<GetBambeePlusDeadlineQueryVariables> | ReactiveFunction<GetBambeePlusDeadlineQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBambeePlusDeadlineQuery, GetBambeePlusDeadlineQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBambeePlusDeadlineQuery, GetBambeePlusDeadlineQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBambeePlusDeadlineQuery, GetBambeePlusDeadlineQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBambeePlusDeadlineQuery, GetBambeePlusDeadlineQueryVariables>(GetBambeePlusDeadlineDocument, variables, options);
}
export type GetBambeePlusDeadlineQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBambeePlusDeadlineQuery, GetBambeePlusDeadlineQueryVariables>;
export const GetDeputyTosInfoDocument = gql`
    query GetDeputyTosInfo($id: ID!) {
  getCompany(id: $id) {
    id
    deputyTosAcceptedAt
  }
}
    `;

/**
 * __useGetDeputyTosInfoQuery__
 *
 * To run a query within a Vue component, call `useGetDeputyTosInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeputyTosInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeputyTosInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeputyTosInfoQuery(variables: GetDeputyTosInfoQueryVariables | VueCompositionApi.Ref<GetDeputyTosInfoQueryVariables> | ReactiveFunction<GetDeputyTosInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetDeputyTosInfoQuery, GetDeputyTosInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDeputyTosInfoQuery, GetDeputyTosInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDeputyTosInfoQuery, GetDeputyTosInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDeputyTosInfoQuery, GetDeputyTosInfoQueryVariables>(GetDeputyTosInfoDocument, variables, options);
}
export type GetDeputyTosInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDeputyTosInfoQuery, GetDeputyTosInfoQueryVariables>;
export const GetSimplePolicyListDocument = gql`
    query GetSimplePolicyList($companyId: ID!) {
  getCoreCompany(id: $companyId) {
    policies {
      id
      isCPD
      name
    }
  }
}
    `;

/**
 * __useGetSimplePolicyListQuery__
 *
 * To run a query within a Vue component, call `useGetSimplePolicyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimplePolicyListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSimplePolicyListQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetSimplePolicyListQuery(variables: GetSimplePolicyListQueryVariables | VueCompositionApi.Ref<GetSimplePolicyListQueryVariables> | ReactiveFunction<GetSimplePolicyListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>(GetSimplePolicyListDocument, variables, options);
}
export type GetSimplePolicyListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>;
export const GetTrainingCompanyDocument = gql`
    query GetTrainingCompany($data: GetCompanyInput!) {
  company(data: $data) {
    id
    availableProducts {
      id
      topics {
        ...CourseTopicParts
      }
      bundles {
        id
        global
        name
        price
        topics {
          ...CourseTopicParts
        }
      }
    }
    purchasedProducts {
      id
      bundles {
        id
        name
        description
        totalSeats
        unfilledSeats
        topics {
          id
          name
        }
      }
      topics {
        id
        name
        totalSeats
        unfilledSeats
        counts {
          id
          completed
          inProgress
          notStarted
        }
      }
    }
  }
}
    ${CourseTopicPartsFragmentDoc}`;

/**
 * __useGetTrainingCompanyQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingCompanyQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTrainingCompanyQuery(variables: GetTrainingCompanyQueryVariables | VueCompositionApi.Ref<GetTrainingCompanyQueryVariables> | ReactiveFunction<GetTrainingCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>(GetTrainingCompanyDocument, variables, options);
}
export type GetTrainingCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>;
export const GetBillingHistoryDocument = gql`
    query GetBillingHistory($companyId: String!) {
  getBillingHistory(companyId: $companyId) {
    id
    amount
    attemptCount
    createdAt
    hostedUrl
    lastAttemptError
    pdfUrl
    statementType
    status
    productKey
    serviceKey
    modifiedAt
    stripeSubscriptionId
  }
}
    `;

/**
 * __useGetBillingHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingHistoryQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetBillingHistoryQuery(variables: GetBillingHistoryQueryVariables | VueCompositionApi.Ref<GetBillingHistoryQueryVariables> | ReactiveFunction<GetBillingHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingHistoryQuery, GetBillingHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>(GetBillingHistoryDocument, variables, options);
}
export type GetBillingHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>;
export const GetTrainingRequestsDocument = gql`
    query GetTrainingRequests($data: RequestFilterInput!) {
  requests(data: $data) {
    approvalCriteria
    approverRoles
    companyId
    createdAt
    decisions {
      createdAt
      id
      requestId
      result
      role
      updatedAt
      userId
    }
    description
    expiresAt
    id
    rejectionCriteria
    requestedAt
    resourceId
    resourceType
    status
    updatedAt
    userId
    user {
      id
      profile {
        id
        avatarUrl
        firstName
        lastName
      }
      employment {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetTrainingRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingRequestsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTrainingRequestsQuery(variables: GetTrainingRequestsQueryVariables | VueCompositionApi.Ref<GetTrainingRequestsQueryVariables> | ReactiveFunction<GetTrainingRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>(GetTrainingRequestsDocument, variables, options);
}
export type GetTrainingRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>;
export const GetMyTrainingRequestsDocument = gql`
    query GetMyTrainingRequests($data: MyRequestFilterInput!) {
  myRequests(data: $data) {
    approvalCriteria
    approverRoles
    companyId
    createdAt
    decisions {
      createdAt
      id
      requestId
      result
      role
      updatedAt
      userId
    }
    description
    expiresAt
    id
    rejectionCriteria
    requestedAt
    resourceId
    resourceType
    status
    updatedAt
    userId
    user {
      id
      profile {
        id
        avatarUrl
        firstName
        lastName
      }
      employment {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetMyTrainingRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetMyTrainingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTrainingRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyTrainingRequestsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetMyTrainingRequestsQuery(variables: GetMyTrainingRequestsQueryVariables | VueCompositionApi.Ref<GetMyTrainingRequestsQueryVariables> | ReactiveFunction<GetMyTrainingRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>(GetMyTrainingRequestsDocument, variables, options);
}
export type GetMyTrainingRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>;
export const GetTrainingRecommendationsDocument = gql`
    query GetTrainingRecommendations($data: RecommendationFilterInput!) {
  recommendations(data: $data) {
    id
    targets
    resourceType
    resourceId
    status
    scope
  }
}
    `;

/**
 * __useGetTrainingRecommendationsQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingRecommendationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingRecommendationsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTrainingRecommendationsQuery(variables: GetTrainingRecommendationsQueryVariables | VueCompositionApi.Ref<GetTrainingRecommendationsQueryVariables> | ReactiveFunction<GetTrainingRecommendationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>(GetTrainingRecommendationsDocument, variables, options);
}
export type GetTrainingRecommendationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>;
export const GetPendingHotlineCallsDocument = gql`
    query GetPendingHotlineCalls {
  pendingHotlineCall {
    id
    status
    summary
  }
}
    `;

/**
 * __useGetPendingHotlineCallsQuery__
 *
 * To run a query within a Vue component, call `useGetPendingHotlineCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingHotlineCallsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPendingHotlineCallsQuery();
 */
export function useGetPendingHotlineCallsQuery(options: VueApolloComposable.UseQueryOptions<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>(GetPendingHotlineCallsDocument, {}, options);
}
export type GetPendingHotlineCallsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>;
export const GetCompanySubscriptionsDocument = gql`
    query GetCompanySubscriptions($data: GetCompanySubscriptionsInput!) {
  companySubscriptions(data: $data) {
    productCode
    status
    stripePriceId
    stripeId
    name
    isDrp
  }
}
    `;

/**
 * __useGetCompanySubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanySubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanySubscriptionsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanySubscriptionsQuery(variables: GetCompanySubscriptionsQueryVariables | VueCompositionApi.Ref<GetCompanySubscriptionsQueryVariables> | ReactiveFunction<GetCompanySubscriptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>(GetCompanySubscriptionsDocument, variables, options);
}
export type GetCompanySubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>;
export const GetPricingPackagesDocument = gql`
    query GetPricingPackages($data: PricingPackageFilterInput!) {
  getPricingPackages(input: $data) {
    packages {
      plans {
        annual
        billingPeriod
        chatOnly
        price
        priceId
        setupFee
        setupFeeDiscount
        maxSize
        minSize
        monthlyPrice
        name
        tierNumber
        value
        status
      }
      type
    }
  }
}
    `;

/**
 * __useGetPricingPackagesQuery__
 *
 * To run a query within a Vue component, call `useGetPricingPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPackagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPricingPackagesQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetPricingPackagesQuery(variables: GetPricingPackagesQueryVariables | VueCompositionApi.Ref<GetPricingPackagesQueryVariables> | ReactiveFunction<GetPricingPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPricingPackagesQuery, GetPricingPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>(GetPricingPackagesDocument, variables, options);
}
export type GetPricingPackagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>;
export const GetHotlineCallsDocument = gql`
    query GetHotlineCalls {
  hotlineCalls {
    id
    createdAt
    callPlacedAt
    callDuration
    status
    summary
    agent {
      id
      avatarUrl
      name
    }
  }
}
    `;

/**
 * __useGetHotlineCallsQuery__
 *
 * To run a query within a Vue component, call `useGetHotlineCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotlineCallsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHotlineCallsQuery();
 */
export function useGetHotlineCallsQuery(options: VueApolloComposable.UseQueryOptions<GetHotlineCallsQuery, GetHotlineCallsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>(GetHotlineCallsDocument, {}, options);
}
export type GetHotlineCallsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>;
export const GetUpgradeOptionsDocument = gql`
    query GetUpgradeOptions($companyId: String!) {
  coreUpgradeOptions(input: {companyId: $companyId}) {
    next {
      tax
      total
    }
    plan {
      maxSize
      minSize
      monthlyPrice
      price
      priceId
      productKey
      tierNumber
      billingPeriod
      value
    }
    prorationDate
    upcoming {
      remainingAmount
      tax
      total
      unusedAmount
      totalDue
    }
  }
}
    `;

/**
 * __useGetUpgradeOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetUpgradeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpgradeOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUpgradeOptionsQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetUpgradeOptionsQuery(variables: GetUpgradeOptionsQueryVariables | VueCompositionApi.Ref<GetUpgradeOptionsQueryVariables> | ReactiveFunction<GetUpgradeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>(GetUpgradeOptionsDocument, variables, options);
}
export type GetUpgradeOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>;
export const GetLatestPricingPackagesForTierDocument = gql`
    query getLatestPricingPackagesForTier($tierNumber: Float!, $getLatestPricingPackagesForTierInput: ActivePlanFilters!) {
  getLatestPricingPackagesForTier(
    tierNumber: $tierNumber
    input: $getLatestPricingPackagesForTierInput
  ) {
    packages {
      type
      plans {
        name
        billingPeriod
        monthlyPrice
        productKey
        priceId
        value
        billingFeature
      }
    }
  }
}
    `;

/**
 * __useGetLatestPricingPackagesForTierQuery__
 *
 * To run a query within a Vue component, call `useGetLatestPricingPackagesForTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestPricingPackagesForTierQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLatestPricingPackagesForTierQuery({
 *   tierNumber: // value for 'tierNumber'
 *   getLatestPricingPackagesForTierInput: // value for 'getLatestPricingPackagesForTierInput'
 * });
 */
export function useGetLatestPricingPackagesForTierQuery(variables: GetLatestPricingPackagesForTierQueryVariables | VueCompositionApi.Ref<GetLatestPricingPackagesForTierQueryVariables> | ReactiveFunction<GetLatestPricingPackagesForTierQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLatestPricingPackagesForTierQuery, GetLatestPricingPackagesForTierQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLatestPricingPackagesForTierQuery, GetLatestPricingPackagesForTierQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLatestPricingPackagesForTierQuery, GetLatestPricingPackagesForTierQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLatestPricingPackagesForTierQuery, GetLatestPricingPackagesForTierQueryVariables>(GetLatestPricingPackagesForTierDocument, variables, options);
}
export type GetLatestPricingPackagesForTierQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLatestPricingPackagesForTierQuery, GetLatestPricingPackagesForTierQueryVariables>;
export const GetGeneralPayrollCompanyDocument = gql`
    query GetGeneralPayrollCompany($companyId: ID!) {
  coreCompany(id: $companyId) {
    id
    employees {
      id
      active
      employee {
        id
        checkId
        payType
      }
      contractor {
        id
        checkId
        payType
      }
    }
  }
  listWorkplace(companyId: $companyId) {
    id
  }
  getCompany(id: $companyId) {
    id
    total {
      onboardedEmployees
      missingEmployeeDetails
      payrollEmployees
    }
  }
}
    `;

/**
 * __useGetGeneralPayrollCompanyQuery__
 *
 * To run a query within a Vue component, call `useGetGeneralPayrollCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralPayrollCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGeneralPayrollCompanyQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetGeneralPayrollCompanyQuery(variables: GetGeneralPayrollCompanyQueryVariables | VueCompositionApi.Ref<GetGeneralPayrollCompanyQueryVariables> | ReactiveFunction<GetGeneralPayrollCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGeneralPayrollCompanyQuery, GetGeneralPayrollCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGeneralPayrollCompanyQuery, GetGeneralPayrollCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGeneralPayrollCompanyQuery, GetGeneralPayrollCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGeneralPayrollCompanyQuery, GetGeneralPayrollCompanyQueryVariables>(GetGeneralPayrollCompanyDocument, variables, options);
}
export type GetGeneralPayrollCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGeneralPayrollCompanyQuery, GetGeneralPayrollCompanyQueryVariables>;
export const GetCancellationReasonsDocument = gql`
    query GetCancellationReasons {
  activeCancellationReasonGroups {
    code
    externalText
    reasons {
      code
      active
      externalText
    }
  }
}
    `;

/**
 * __useGetCancellationReasonsQuery__
 *
 * To run a query within a Vue component, call `useGetCancellationReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationReasonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCancellationReasonsQuery();
 */
export function useGetCancellationReasonsQuery(options: VueApolloComposable.UseQueryOptions<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>(GetCancellationReasonsDocument, {}, options);
}
export type GetCancellationReasonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>;
export const CancellationOffersDocument = gql`
    query CancellationOffers {
  cancellationOffers {
    trialExtension
    downgradePlans {
      ...PlanParts
    }
    pausePlan {
      ...PlanParts
    }
    storagePlan {
      ...PlanParts
    }
  }
}
    ${PlanPartsFragmentDoc}`;

/**
 * __useCancellationOffersQuery__
 *
 * To run a query within a Vue component, call `useCancellationOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationOffersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCancellationOffersQuery();
 */
export function useCancellationOffersQuery(options: VueApolloComposable.UseQueryOptions<CancellationOffersQuery, CancellationOffersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CancellationOffersQuery, CancellationOffersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CancellationOffersQuery, CancellationOffersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CancellationOffersQuery, CancellationOffersQueryVariables>(CancellationOffersDocument, {}, options);
}
export type CancellationOffersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CancellationOffersQuery, CancellationOffersQueryVariables>;
export const GetBillingInfoDocument = gql`
    query GetBillingInfo($input: GetBillingInfoInput!) {
  getBillingInfo(input: $input) {
    addonSubscriptions {
      id
      active
      quantity
      periodEndsAt
      plan {
        annual
        value
        name
        productKey
        price
        volumeBased
        billingPeriod
        serviceKey
      }
    }
    coreSubscription {
      id
      cancellationRequested
      cancelsAt
      active
      trialEndsAt
      trialing
      periodEndsAt
      scheduledPlanChange {
        id
        effectiveOn
        newPlan {
          billingPeriod
          name
          productKey
        }
      }
      plan {
        maxSize
        minSize
        price
        productKey
        billingPeriod
        name
        employeeSizeMapping
      }
    }
    pause {
      id
      isPaused
      reactivatesOn
    }
  }
}
    `;

/**
 * __useGetBillingInfoQuery__
 *
 * To run a query within a Vue component, call `useGetBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingInfoQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetBillingInfoQuery(variables: GetBillingInfoQueryVariables | VueCompositionApi.Ref<GetBillingInfoQueryVariables> | ReactiveFunction<GetBillingInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingInfoQuery, GetBillingInfoQueryVariables>(GetBillingInfoDocument, variables, options);
}
export type GetBillingInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingInfoQuery, GetBillingInfoQueryVariables>;
export const GetNonCoreSubscriptionBillingChangesDocument = gql`
    query GetNonCoreSubscriptionBillingChanges($data: GetCompanyUpcomingBillingChangesInput!) {
  getNonCoreSubscriptionBillingChanges(data: $data) {
    serviceKey
    productKey
    minSize
    maxSize
    upcomingMonthlyPrice
    upcomingYearlyPrice
  }
}
    `;

/**
 * __useGetNonCoreSubscriptionBillingChangesQuery__
 *
 * To run a query within a Vue component, call `useGetNonCoreSubscriptionBillingChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonCoreSubscriptionBillingChangesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNonCoreSubscriptionBillingChangesQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetNonCoreSubscriptionBillingChangesQuery(variables: GetNonCoreSubscriptionBillingChangesQueryVariables | VueCompositionApi.Ref<GetNonCoreSubscriptionBillingChangesQueryVariables> | ReactiveFunction<GetNonCoreSubscriptionBillingChangesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>(GetNonCoreSubscriptionBillingChangesDocument, variables, options);
}
export type GetNonCoreSubscriptionBillingChangesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>;
export const GetBillingInfoPaymentMethodsDocument = gql`
    query GetBillingInfoPaymentMethods($input: GetBillingInfoInput!) {
  getBillingInfo(input: $input) {
    id
    paymentMethods {
      id
      default
      expirationDate
      name
      nextAction
      status
      type
    }
  }
}
    `;

/**
 * __useGetBillingInfoPaymentMethodsQuery__
 *
 * To run a query within a Vue component, call `useGetBillingInfoPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoPaymentMethodsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingInfoPaymentMethodsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetBillingInfoPaymentMethodsQuery(variables: GetBillingInfoPaymentMethodsQueryVariables | VueCompositionApi.Ref<GetBillingInfoPaymentMethodsQueryVariables> | ReactiveFunction<GetBillingInfoPaymentMethodsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>(GetBillingInfoPaymentMethodsDocument, variables, options);
}
export type GetBillingInfoPaymentMethodsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>;
export const GetProductInterestDocument = gql`
    query GetProductInterest($input: GetProductInterestInput!) {
  productInterest(input: $input) {
    id
    productKey
    productSubKey
  }
}
    `;

/**
 * __useGetProductInterestQuery__
 *
 * To run a query within a Vue component, call `useGetProductInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductInterestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProductInterestQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetProductInterestQuery(variables: GetProductInterestQueryVariables | VueCompositionApi.Ref<GetProductInterestQueryVariables> | ReactiveFunction<GetProductInterestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductInterestQuery, GetProductInterestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductInterestQuery, GetProductInterestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductInterestQuery, GetProductInterestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProductInterestQuery, GetProductInterestQueryVariables>(GetProductInterestDocument, variables, options);
}
export type GetProductInterestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProductInterestQuery, GetProductInterestQueryVariables>;
export const IsEventScheduledForUserDocument = gql`
    query IsEventScheduledForUser($email: String!, $eventSlug: String!) {
  isEventScheduledForUser(input: {email: $email, eventSlug: $eventSlug}) {
    email
    eventSlug
    isScheduled
  }
}
    `;

/**
 * __useIsEventScheduledForUserQuery__
 *
 * To run a query within a Vue component, call `useIsEventScheduledForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEventScheduledForUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIsEventScheduledForUserQuery({
 *   email: // value for 'email'
 *   eventSlug: // value for 'eventSlug'
 * });
 */
export function useIsEventScheduledForUserQuery(variables: IsEventScheduledForUserQueryVariables | VueCompositionApi.Ref<IsEventScheduledForUserQueryVariables> | ReactiveFunction<IsEventScheduledForUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>(IsEventScheduledForUserDocument, variables, options);
}
export type IsEventScheduledForUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>;
export const FindOnboardingDocument = gql`
    query FindOnboarding($data: CoreOnboardingKeys!, $id: ID!) {
  findOnboarding(data: $data) {
    id
    version
    status
    data {
      ...OnboardingParts
    }
  }
  coreCompany(id: $id) {
    id
    whatBroughtYouToBambee
  }
}
    ${OnboardingPartsFragmentDoc}`;

/**
 * __useFindOnboardingQuery__
 *
 * To run a query within a Vue component, call `useFindOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOnboardingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindOnboardingQuery({
 *   data: // value for 'data'
 *   id: // value for 'id'
 * });
 */
export function useFindOnboardingQuery(variables: FindOnboardingQueryVariables | VueCompositionApi.Ref<FindOnboardingQueryVariables> | ReactiveFunction<FindOnboardingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindOnboardingQuery, FindOnboardingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindOnboardingQuery, FindOnboardingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindOnboardingQuery, FindOnboardingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindOnboardingQuery, FindOnboardingQueryVariables>(FindOnboardingDocument, variables, options);
}
export type FindOnboardingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindOnboardingQuery, FindOnboardingQueryVariables>;
export const FindOnboardingStatusDocument = gql`
    query FindOnboardingStatus($data: CoreOnboardingKeys!) {
  findOnboarding(data: $data) {
    id
    status
    data {
      id
      progress
      callEventId
    }
  }
}
    `;

/**
 * __useFindOnboardingStatusQuery__
 *
 * To run a query within a Vue component, call `useFindOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOnboardingStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindOnboardingStatusQuery({
 *   data: // value for 'data'
 * });
 */
export function useFindOnboardingStatusQuery(variables: FindOnboardingStatusQueryVariables | VueCompositionApi.Ref<FindOnboardingStatusQueryVariables> | ReactiveFunction<FindOnboardingStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>(FindOnboardingStatusDocument, variables, options);
}
export type FindOnboardingStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>;
export const GetCompanyProductsDocument = gql`
    query getCompanyProducts($companyId: String!) {
  getCompanyProducts(data: {companyId: $companyId}) {
    ...ProductParts
  }
}
    ${ProductPartsFragmentDoc}`;

/**
 * __useGetCompanyProductsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyProductsQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetCompanyProductsQuery(variables: GetCompanyProductsQueryVariables | VueCompositionApi.Ref<GetCompanyProductsQueryVariables> | ReactiveFunction<GetCompanyProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyProductsQuery, GetCompanyProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>(GetCompanyProductsDocument, variables, options);
}
export type GetCompanyProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyProductsQuery, GetCompanyProductsQueryVariables>;
export const GetAvailableProductsDocument = gql`
    query GetAvailableProducts($data: GetAvailableProductsInput!) {
  getAvailableProducts(data: $data) {
    monthlyAllowance
    billingPeriod
    id
    price
    key
    name
    subscriptionPrice
    tier
    discountedPrice
  }
}
    `;

/**
 * __useGetAvailableProductsQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableProductsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetAvailableProductsQuery(variables: GetAvailableProductsQueryVariables | VueCompositionApi.Ref<GetAvailableProductsQueryVariables> | ReactiveFunction<GetAvailableProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAvailableProductsQuery, GetAvailableProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>(GetAvailableProductsDocument, variables, options);
}
export type GetAvailableProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>;
export const GetCompanyCreditsDocument = gql`
    query GetCompanyCredits($data: GetCompanyCreditsInputV2!) {
  getCompanyCreditsV2(data: $data) {
    productKey
    consumedAt
  }
}
    `;

/**
 * __useGetCompanyCreditsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCreditsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyCreditsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyCreditsQuery(variables: GetCompanyCreditsQueryVariables | VueCompositionApi.Ref<GetCompanyCreditsQueryVariables> | ReactiveFunction<GetCompanyCreditsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>(GetCompanyCreditsDocument, variables, options);
}
export type GetCompanyCreditsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>;
export const GetEligibleAddonsDocument = gql`
    query GetEligibleAddons($input: EligibleAddonsInput!) {
  getEligibleAddons(input: $input) {
    payroll {
      serviceKey
      productKey
      name
      value
      priceId
      price
      billingPeriod
      status
      minSize
      maxSize
      unitPriceId
      unitPrice
      version
    }
  }
}
    `;

/**
 * __useGetEligibleAddonsQuery__
 *
 * To run a query within a Vue component, call `useGetEligibleAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleAddonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEligibleAddonsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetEligibleAddonsQuery(variables: GetEligibleAddonsQueryVariables | VueCompositionApi.Ref<GetEligibleAddonsQueryVariables> | ReactiveFunction<GetEligibleAddonsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEligibleAddonsQuery, GetEligibleAddonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEligibleAddonsQuery, GetEligibleAddonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEligibleAddonsQuery, GetEligibleAddonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEligibleAddonsQuery, GetEligibleAddonsQueryVariables>(GetEligibleAddonsDocument, variables, options);
}
export type GetEligibleAddonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEligibleAddonsQuery, GetEligibleAddonsQueryVariables>;
export const PayrollStatusDocument = gql`
    query PayrollStatus($payrollCompanyId: ID!) {
  payrollCompany(id: $payrollCompanyId) {
    status
  }
}
    `;

/**
 * __usePayrollStatusQuery__
 *
 * To run a query within a Vue component, call `usePayrollStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePayrollStatusQuery({
 *   payrollCompanyId: // value for 'payrollCompanyId'
 * });
 */
export function usePayrollStatusQuery(variables: PayrollStatusQueryVariables | VueCompositionApi.Ref<PayrollStatusQueryVariables> | ReactiveFunction<PayrollStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<PayrollStatusQuery, PayrollStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PayrollStatusQuery, PayrollStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PayrollStatusQuery, PayrollStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PayrollStatusQuery, PayrollStatusQueryVariables>(PayrollStatusDocument, variables, options);
}
export type PayrollStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PayrollStatusQuery, PayrollStatusQueryVariables>;
export const AssignUserToPolicyDocument = gql`
    mutation AssignUserToPolicy($data: AssignUserToPoliciesInput!) {
  assignUserToPolicies(data: $data) {
    id
    name
    signature {
      id
      requestedAt
      signedAt
      signingOrder
    }
  }
}
    `;

/**
 * __useAssignUserToPolicyMutation__
 *
 * To run a mutation, you first call `useAssignUserToPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserToPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignUserToPolicyMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAssignUserToPolicyMutation(options: VueApolloComposable.UseMutationOptions<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables>(AssignUserToPolicyDocument, options);
}
export type AssignUserToPolicyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables>;
export const AssignUsersToPoliciesDocument = gql`
    mutation AssignUsersToPolicies($data: AssignUsersToPoliciesInput!) {
  assignUsersToPolicies(data: $data) {
    id
    documents {
      ...CoreDocumentParts
    }
  }
}
    ${CoreDocumentPartsFragmentDoc}`;

/**
 * __useAssignUsersToPoliciesMutation__
 *
 * To run a mutation, you first call `useAssignUsersToPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignUsersToPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignUsersToPoliciesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAssignUsersToPoliciesMutation(options: VueApolloComposable.UseMutationOptions<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables>(AssignUsersToPoliciesDocument, options);
}
export type AssignUsersToPoliciesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables>;
export const ReaffirmEmployeeDocumentDocument = gql`
    mutation ReaffirmEmployeeDocument($documentId: ID!) {
  reaffirmDocument(id: $documentId) {
    id
    name
    reaffirmations
  }
}
    `;

/**
 * __useReaffirmEmployeeDocumentMutation__
 *
 * To run a mutation, you first call `useReaffirmEmployeeDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReaffirmEmployeeDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReaffirmEmployeeDocumentMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useReaffirmEmployeeDocumentMutation(options: VueApolloComposable.UseMutationOptions<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables>>) {
  return VueApolloComposable.useMutation<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables>(ReaffirmEmployeeDocumentDocument, options);
}
export type ReaffirmEmployeeDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables>;
export const ArchivePolicyDocument = gql`
    mutation ArchivePolicy($input: ArchivePolicyInput!) {
  archivePolicy(input: $input) {
    id
  }
}
    `;

/**
 * __useArchivePolicyMutation__
 *
 * To run a mutation, you first call `useArchivePolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchivePolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchivePolicyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useArchivePolicyMutation(options: VueApolloComposable.UseMutationOptions<ArchivePolicyMutation, ArchivePolicyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchivePolicyMutation, ArchivePolicyMutationVariables>>) {
  return VueApolloComposable.useMutation<ArchivePolicyMutation, ArchivePolicyMutationVariables>(ArchivePolicyDocument, options);
}
export type ArchivePolicyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ArchivePolicyMutation, ArchivePolicyMutationVariables>;
export const GetPolicyDocument = gql`
    query GetPolicy($input: GetPolicy!) {
  getPolicy(input: $input) {
    ...CorePolicyParts
  }
}
    ${CorePolicyPartsFragmentDoc}`;

/**
 * __useGetPolicyQuery__
 *
 * To run a query within a Vue component, call `useGetPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPolicyQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetPolicyQuery(variables: GetPolicyQueryVariables | VueCompositionApi.Ref<GetPolicyQueryVariables> | ReactiveFunction<GetPolicyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPolicyQuery, GetPolicyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPolicyQuery, GetPolicyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPolicyQuery, GetPolicyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument, variables, options);
}
export type GetPolicyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPolicyQuery, GetPolicyQueryVariables>;
export const ReaffirmDocumentDocument = gql`
    mutation ReaffirmDocument($documentId: ID!) {
  reaffirmDocument(id: $documentId) {
    ...CoreDocumentParts
  }
}
    ${CoreDocumentPartsFragmentDoc}`;

/**
 * __useReaffirmDocumentMutation__
 *
 * To run a mutation, you first call `useReaffirmDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReaffirmDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReaffirmDocumentMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useReaffirmDocumentMutation(options: VueApolloComposable.UseMutationOptions<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables>>) {
  return VueApolloComposable.useMutation<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables>(ReaffirmDocumentDocument, options);
}
export type ReaffirmDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables>;
export const PolicyDataTableDocument = gql`
    query PolicyDataTable {
  getMyCoreUser {
    id
    company {
      id
      policies(
        status: ["in-progress", "ready", "sent", "complete", "ready", "qa", "created", "uploaded", "declined", "approved"]
      ) {
        id
        name
        archivedAt
        isCPD
        createdAt
        status
        recipients {
          id
          document {
            reaffirmations
            id
            signature {
              id
              signedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePolicyDataTableQuery__
 *
 * To run a query within a Vue component, call `usePolicyDataTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyDataTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePolicyDataTableQuery();
 */
export function usePolicyDataTableQuery(options: VueApolloComposable.UseQueryOptions<PolicyDataTableQuery, PolicyDataTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PolicyDataTableQuery, PolicyDataTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PolicyDataTableQuery, PolicyDataTableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PolicyDataTableQuery, PolicyDataTableQueryVariables>(PolicyDataTableDocument, {}, options);
}
export type PolicyDataTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PolicyDataTableQuery, PolicyDataTableQueryVariables>;
export const CreateReportCardDocument = gql`
    mutation CreateReportCard($data: CreateReportCardInput!) {
  createReportCard(data: $data) {
    ...NewReportCardParts
  }
}
    ${NewReportCardPartsFragmentDoc}`;

/**
 * __useCreateReportCardMutation__
 *
 * To run a mutation, you first call `useCreateReportCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReportCardMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportCardMutation(options: VueApolloComposable.UseMutationOptions<CreateReportCardMutation, CreateReportCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateReportCardMutation, CreateReportCardMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateReportCardMutation, CreateReportCardMutationVariables>(CreateReportCardDocument, options);
}
export type CreateReportCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateReportCardMutation, CreateReportCardMutationVariables>;
export const UpdateReportCardDocument = gql`
    mutation UpdateReportCard($data: UpdateReportCardInput!) {
  updateReportCard(data: $data) {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;

/**
 * __useUpdateReportCardMutation__
 *
 * To run a mutation, you first call `useUpdateReportCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReportCardMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportCardMutation(options: VueApolloComposable.UseMutationOptions<UpdateReportCardMutation, UpdateReportCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReportCardMutation, UpdateReportCardMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateReportCardMutation, UpdateReportCardMutationVariables>(UpdateReportCardDocument, options);
}
export type UpdateReportCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateReportCardMutation, UpdateReportCardMutationVariables>;
export const CompleteReportCardDocument = gql`
    mutation CompleteReportCard($data: CompleteReportCardInput!) {
  completeReportCard(data: $data) {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;

/**
 * __useCompleteReportCardMutation__
 *
 * To run a mutation, you first call `useCompleteReportCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteReportCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteReportCardMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteReportCardMutation(options: VueApolloComposable.UseMutationOptions<CompleteReportCardMutation, CompleteReportCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteReportCardMutation, CompleteReportCardMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteReportCardMutation, CompleteReportCardMutationVariables>(CompleteReportCardDocument, options);
}
export type CompleteReportCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteReportCardMutation, CompleteReportCardMutationVariables>;
export const GetReportCardListDocument = gql`
    query GetReportCardList($data: ListReportCardsInput!) {
  listReportCards(data: $data) {
    id
    cadence
    createdAt
    status
    employees {
      id
      grade
    }
  }
}
    `;

/**
 * __useGetReportCardListQuery__
 *
 * To run a query within a Vue component, call `useGetReportCardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportCardListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReportCardListQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetReportCardListQuery(variables: GetReportCardListQueryVariables | VueCompositionApi.Ref<GetReportCardListQueryVariables> | ReactiveFunction<GetReportCardListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReportCardListQuery, GetReportCardListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReportCardListQuery, GetReportCardListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReportCardListQuery, GetReportCardListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetReportCardListQuery, GetReportCardListQueryVariables>(GetReportCardListDocument, variables, options);
}
export type GetReportCardListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetReportCardListQuery, GetReportCardListQueryVariables>;
export const GetReportCardDocument = gql`
    query GetReportCard($data: GetReportCardInput!) {
  getReportCard(data: $data) {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;

/**
 * __useGetReportCardQuery__
 *
 * To run a query within a Vue component, call `useGetReportCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportCardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReportCardQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetReportCardQuery(variables: GetReportCardQueryVariables | VueCompositionApi.Ref<GetReportCardQueryVariables> | ReactiveFunction<GetReportCardQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReportCardQuery, GetReportCardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReportCardQuery, GetReportCardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReportCardQuery, GetReportCardQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetReportCardQuery, GetReportCardQueryVariables>(GetReportCardDocument, variables, options);
}
export type GetReportCardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetReportCardQuery, GetReportCardQueryVariables>;
export const TrackProductInterestDocument = gql`
    mutation TrackProductInterest($data: ProductInterestInput!) {
  trackProductInterest(data: $data)
}
    `;

/**
 * __useTrackProductInterestMutation__
 *
 * To run a mutation, you first call `useTrackProductInterestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTrackProductInterestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTrackProductInterestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useTrackProductInterestMutation(options: VueApolloComposable.UseMutationOptions<TrackProductInterestMutation, TrackProductInterestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrackProductInterestMutation, TrackProductInterestMutationVariables>>) {
  return VueApolloComposable.useMutation<TrackProductInterestMutation, TrackProductInterestMutationVariables>(TrackProductInterestDocument, options);
}
export type TrackProductInterestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrackProductInterestMutation, TrackProductInterestMutationVariables>;
export const CreateHrRequestDocument = gql`
    mutation CreateHrRequest($input: CreateHrRequestInput!) {
  createHrRequest(input: $input) {
    id
    intercomConversationId
    caseId
  }
}
    `;

/**
 * __useCreateHrRequestMutation__
 *
 * To run a mutation, you first call `useCreateHrRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHrRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHrRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateHrRequestMutation(options: VueApolloComposable.UseMutationOptions<CreateHrRequestMutation, CreateHrRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateHrRequestMutation, CreateHrRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateHrRequestMutation, CreateHrRequestMutationVariables>(CreateHrRequestDocument, options);
}
export type CreateHrRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateHrRequestMutation, CreateHrRequestMutationVariables>;
export const ReplyToConversationDocument = gql`
    mutation ReplyToConversation($input: ReplyToConversationInput!) {
  replyToConversation(input: $input) {
    id
    intercomConversationId
    messages {
      attachments {
        contentType
        name
        type
        url
      }
      body
      createdAt
      inBound
    }
  }
}
    `;

/**
 * __useReplyToConversationMutation__
 *
 * To run a mutation, you first call `useReplyToConversationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplyToConversationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplyToConversationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReplyToConversationMutation(options: VueApolloComposable.UseMutationOptions<ReplyToConversationMutation, ReplyToConversationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplyToConversationMutation, ReplyToConversationMutationVariables>>) {
  return VueApolloComposable.useMutation<ReplyToConversationMutation, ReplyToConversationMutationVariables>(ReplyToConversationDocument, options);
}
export type ReplyToConversationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplyToConversationMutation, ReplyToConversationMutationVariables>;
export const CancelScheduledEventDocument = gql`
    mutation CancelScheduledEvent($input: CancelScheduledEventInput!) {
  cancelScheduledEvent(input: $input) {
    calendlyEventId
    id
    cancelled
  }
}
    `;

/**
 * __useCancelScheduledEventMutation__
 *
 * To run a mutation, you first call `useCancelScheduledEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelScheduledEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCancelScheduledEventMutation(options: VueApolloComposable.UseMutationOptions<CancelScheduledEventMutation, CancelScheduledEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelScheduledEventMutation, CancelScheduledEventMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelScheduledEventMutation, CancelScheduledEventMutationVariables>(CancelScheduledEventDocument, options);
}
export type CancelScheduledEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelScheduledEventMutation, CancelScheduledEventMutationVariables>;
export const UploadFilesToConversationDocument = gql`
    mutation UploadFilesToConversation($input: UploadFilesToConversationInput!) {
  uploadFilesToConversation(input: $input) {
    id
    intercomConversationId
    messages {
      attachments {
        contentType
        name
        type
        url
      }
      body
      createdAt
      inBound
    }
    subject
  }
}
    `;

/**
 * __useUploadFilesToConversationMutation__
 *
 * To run a mutation, you first call `useUploadFilesToConversationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesToConversationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadFilesToConversationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUploadFilesToConversationMutation(options: VueApolloComposable.UseMutationOptions<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables>>) {
  return VueApolloComposable.useMutation<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables>(UploadFilesToConversationDocument, options);
}
export type UploadFilesToConversationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables>;
export const GetHrRequestOptionsDocument = gql`
    query GetHrRequestOptions {
  getHrRequestOptions {
    groups {
      key
      icon
      title
    }
    options {
      title
      description
      popular {
        order
        title
        description
      }
      groupKey
      type
      subType
      slug
      audience
      requiresPrimaryHrm
      expectation {
        cycleTime
        description
      }
      keywords
      unlisted
    }
  }
}
    `;

/**
 * __useGetHrRequestOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetHrRequestOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrRequestOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrRequestOptionsQuery();
 */
export function useGetHrRequestOptionsQuery(options: VueApolloComposable.UseQueryOptions<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>(GetHrRequestOptionsDocument, {}, options);
}
export type GetHrRequestOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>;
export const GetHrRequestsDocument = gql`
    query GetHrRequests {
  getHrRequests {
    hrRequests {
      id
    }
  }
}
    `;

/**
 * __useGetHrRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetHrRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrRequestsQuery();
 */
export function useGetHrRequestsQuery(options: VueApolloComposable.UseQueryOptions<GetHrRequestsQuery, GetHrRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrRequestsQuery, GetHrRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrRequestsQuery, GetHrRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrRequestsQuery, GetHrRequestsQueryVariables>(GetHrRequestsDocument, {}, options);
}
export type GetHrRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrRequestsQuery, GetHrRequestsQueryVariables>;
export const HrRequestDocument = gql`
    query HrRequest($input: GetHrRequestByIdInput!) {
  hrRequest(input: $input) {
    id
    conversation {
      id
      intercomConversationId
      subject
      messages {
        body
        inBound
      }
    }
  }
}
    `;

/**
 * __useHrRequestQuery__
 *
 * To run a query within a Vue component, call `useHrRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHrRequestQuery({
 *   input: // value for 'input'
 * });
 */
export function useHrRequestQuery(variables: HrRequestQueryVariables | VueCompositionApi.Ref<HrRequestQueryVariables> | ReactiveFunction<HrRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<HrRequestQuery, HrRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HrRequestQuery, HrRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HrRequestQuery, HrRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HrRequestQuery, HrRequestQueryVariables>(HrRequestDocument, variables, options);
}
export type HrRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HrRequestQuery, HrRequestQueryVariables>;
export const HrRequestAiInformationDocument = gql`
    query HrRequestAiInformation($input: GetHrRequestByIdInput!) {
  hrRequest(input: $input) {
    id
    caseId
    aiGenerated
    aiArtifacts
    threadId
  }
}
    `;

/**
 * __useHrRequestAiInformationQuery__
 *
 * To run a query within a Vue component, call `useHrRequestAiInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrRequestAiInformationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHrRequestAiInformationQuery({
 *   input: // value for 'input'
 * });
 */
export function useHrRequestAiInformationQuery(variables: HrRequestAiInformationQueryVariables | VueCompositionApi.Ref<HrRequestAiInformationQueryVariables> | ReactiveFunction<HrRequestAiInformationQueryVariables>, options: VueApolloComposable.UseQueryOptions<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>(HrRequestAiInformationDocument, variables, options);
}
export type HrRequestAiInformationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>;
export const GetOnboardingCalendlyConfigDocument = gql`
    query GetOnboardingCalendlyConfig($input: OnboardingCalendlyConfigInput!) {
  getOnboardingCalendlyConfig(input: $input) {
    link
    tierNumber
    zone
  }
}
    `;

/**
 * __useGetOnboardingCalendlyConfigQuery__
 *
 * To run a query within a Vue component, call `useGetOnboardingCalendlyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingCalendlyConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOnboardingCalendlyConfigQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetOnboardingCalendlyConfigQuery(variables: GetOnboardingCalendlyConfigQueryVariables | VueCompositionApi.Ref<GetOnboardingCalendlyConfigQueryVariables> | ReactiveFunction<GetOnboardingCalendlyConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>(GetOnboardingCalendlyConfigDocument, variables, options);
}
export type GetOnboardingCalendlyConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>;
export const GetConversationByIntercomIdDocument = gql`
    query GetConversationByIntercomId($input: GetConversationByIntercomIdInput!) {
  getConversationByIntercomId(input: $input) {
    id
    intercomConversationId
    messages {
      createdAt
      body
      inBound
      attachments {
        type
        name
        contentType
        url
      }
    }
    subject
    createdAt
    inBound
  }
}
    `;

/**
 * __useGetConversationByIntercomIdQuery__
 *
 * To run a query within a Vue component, call `useGetConversationByIntercomIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationByIntercomIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConversationByIntercomIdQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetConversationByIntercomIdQuery(variables: GetConversationByIntercomIdQueryVariables | VueCompositionApi.Ref<GetConversationByIntercomIdQueryVariables> | ReactiveFunction<GetConversationByIntercomIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>(GetConversationByIntercomIdDocument, variables, options);
}
export type GetConversationByIntercomIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>;
export const GetHrRequestListDocument = gql`
    query GetHrRequestList {
  hrRequestList {
    hrRequests {
      caseId
      caseNumber
      completionDate
      createdDate
      description
      expectationDate
      hrRequestSurveyAnswers
      intercomId
      isComplete
      isOverdue
      lastModifiedDate
      status
      subType
      subject
      type
      aiMetadata
    }
  }
}
    `;

/**
 * __useGetHrRequestListQuery__
 *
 * To run a query within a Vue component, call `useGetHrRequestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrRequestListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrRequestListQuery();
 */
export function useGetHrRequestListQuery(options: VueApolloComposable.UseQueryOptions<GetHrRequestListQuery, GetHrRequestListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrRequestListQuery, GetHrRequestListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrRequestListQuery, GetHrRequestListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrRequestListQuery, GetHrRequestListQueryVariables>(GetHrRequestListDocument, {}, options);
}
export type GetHrRequestListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrRequestListQuery, GetHrRequestListQueryVariables>;
export const GetScheduledEventsDocument = gql`
    query GetScheduledEvents($input: GetScheduledEventsForUserInput!) {
  getScheduledEventsForUser(input: $input) {
    id
    agent {
      avatarUrl
      id
      name
      role
    }
    attendeeEmails
    missedCallFeeStatus
    title
    calendlyEventId
    startTime
    endTime
    eventLocation
    videoConferenceLink
    phoneNumber
    calendlyInviteeId
    videoConferenceLink
    cancelled
    kind
    callSummaries {
      actionItems
      agent {
        avatarUrl
        id
        name
        role
      }
      approvedAt
      callDurationInMinutes
      createdAt
      followUps
      isApproved
      summary
    }
  }
}
    `;

/**
 * __useGetScheduledEventsQuery__
 *
 * To run a query within a Vue component, call `useGetScheduledEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetScheduledEventsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetScheduledEventsQuery(variables: GetScheduledEventsQueryVariables | VueCompositionApi.Ref<GetScheduledEventsQueryVariables> | ReactiveFunction<GetScheduledEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetScheduledEventsQuery, GetScheduledEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>(GetScheduledEventsDocument, variables, options);
}
export type GetScheduledEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>;
export const GetRescheduleLinkDocument = gql`
    query GetRescheduleLink($input: GetCalendlyRescheduleLinkInput!) {
  getRescheduleLink(input: $input)
}
    `;

/**
 * __useGetRescheduleLinkQuery__
 *
 * To run a query within a Vue component, call `useGetRescheduleLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRescheduleLinkQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetRescheduleLinkQuery(variables: GetRescheduleLinkQueryVariables | VueCompositionApi.Ref<GetRescheduleLinkQueryVariables> | ReactiveFunction<GetRescheduleLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>(GetRescheduleLinkDocument, variables, options);
}
export type GetRescheduleLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>;
export const HrRequestExtendedDetailDocument = gql`
    query HrRequestExtendedDetail($input: GetHrRequestExtendedDetailByIdInput!) {
  hrRequestExtendedDetail(input: $input) {
    caseId
    intercomId
    caseNumber
    type
    subType
    status
    expectationDate
    lastModifiedDate
    createdDate
    completionDate
    isComplete
    isOverdue
    subject
    description
    hrRequestSurveyAnswers
    createdBy
    summary
    agent {
      id
      name
      avatarUrl
      role
    }
    ownerId
    timeline {
      eventType
      eventTime
      oldValue
      newValue
    }
    scheduledEvents {
      id
      calendlyEventId
    }
    companyId
    policies {
      id
      name
      displayName
      description
      icon
      step
      status
      createdAt
      kind
    }
    aiSummary
    aiMetadata
    relatedCases {
      caseId
      subject
    }
  }
}
    `;

/**
 * __useHrRequestExtendedDetailQuery__
 *
 * To run a query within a Vue component, call `useHrRequestExtendedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrRequestExtendedDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHrRequestExtendedDetailQuery({
 *   input: // value for 'input'
 * });
 */
export function useHrRequestExtendedDetailQuery(variables: HrRequestExtendedDetailQueryVariables | VueCompositionApi.Ref<HrRequestExtendedDetailQueryVariables> | ReactiveFunction<HrRequestExtendedDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>(HrRequestExtendedDetailDocument, variables, options);
}
export type HrRequestExtendedDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>;
export const GetAskNicelyWebSurveyInfoDocument = gql`
    query GetAskNicelyWebSurveyInfo($input: GetAskNicelyWebSurveyInfoInput!) {
  getAskNicelyWebSurveyInfo(input: $input) {
    emailHash
    force
    show
  }
}
    `;

/**
 * __useGetAskNicelyWebSurveyInfoQuery__
 *
 * To run a query within a Vue component, call `useGetAskNicelyWebSurveyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAskNicelyWebSurveyInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAskNicelyWebSurveyInfoQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetAskNicelyWebSurveyInfoQuery(variables: GetAskNicelyWebSurveyInfoQueryVariables | VueCompositionApi.Ref<GetAskNicelyWebSurveyInfoQueryVariables> | ReactiveFunction<GetAskNicelyWebSurveyInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>(GetAskNicelyWebSurveyInfoDocument, variables, options);
}
export type GetAskNicelyWebSurveyInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>;
export const CloseHrRequestDocument = gql`
    mutation CloseHrRequest($input: CloseHrRequestInput!) {
  closeHrRequest(input: $input) {
    id
    caseId
    conversationId
    intercomConversationId
    customerCompanyId
    createdAt
    aiGenerated
    aiArtifacts
    threadId
  }
}
    `;

/**
 * __useCloseHrRequestMutation__
 *
 * To run a mutation, you first call `useCloseHrRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloseHrRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloseHrRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCloseHrRequestMutation(options: VueApolloComposable.UseMutationOptions<CloseHrRequestMutation, CloseHrRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloseHrRequestMutation, CloseHrRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<CloseHrRequestMutation, CloseHrRequestMutationVariables>(CloseHrRequestDocument, options);
}
export type CloseHrRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloseHrRequestMutation, CloseHrRequestMutationVariables>;
export const SetCaseStatusDocument = gql`
    mutation SetCaseStatus($input: SetCaseStatusInput!) {
  setCaseStatus(input: $input) {
    id
    caseId
    conversationId
    intercomConversationId
    customerCompanyId
    createdAt
    aiGenerated
    aiArtifacts
    threadId
  }
}
    `;

/**
 * __useSetCaseStatusMutation__
 *
 * To run a mutation, you first call `useSetCaseStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCaseStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCaseStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetCaseStatusMutation(options: VueApolloComposable.UseMutationOptions<SetCaseStatusMutation, SetCaseStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetCaseStatusMutation, SetCaseStatusMutationVariables>>) {
  return VueApolloComposable.useMutation<SetCaseStatusMutation, SetCaseStatusMutationVariables>(SetCaseStatusDocument, options);
}
export type SetCaseStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetCaseStatusMutation, SetCaseStatusMutationVariables>;
export const CreateTerminationDocument = gql`
    mutation CreateTermination($data: TerminationCreateInput!) {
  createTermination(data: $data) {
    terminationId
    employeeId
    userId
    status
    step
    terminationDate
    startDate
    confirmed
    terminationState
    createdAt
    complete
  }
}
    `;

/**
 * __useCreateTerminationMutation__
 *
 * To run a mutation, you first call `useCreateTerminationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerminationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTerminationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateTerminationMutation(options: VueApolloComposable.UseMutationOptions<CreateTerminationMutation, CreateTerminationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTerminationMutation, CreateTerminationMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateTerminationMutation, CreateTerminationMutationVariables>(CreateTerminationDocument, options);
}
export type CreateTerminationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateTerminationMutation, CreateTerminationMutationVariables>;
export const CreateResignationDocument = gql`
    mutation CreateResignation($data: ResignationCreateInput!) {
  createResignation(data: $data) {
    resignationId
    employeeId
    userId
    status
    step
    resignationDate
    resignationState
    confirmed
    selfService
    hrRequestId
    createdAt
    complete
  }
}
    `;

/**
 * __useCreateResignationMutation__
 *
 * To run a mutation, you first call `useCreateResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateResignationMutation(options: VueApolloComposable.UseMutationOptions<CreateResignationMutation, CreateResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateResignationMutation, CreateResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateResignationMutation, CreateResignationMutationVariables>(CreateResignationDocument, options);
}
export type CreateResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateResignationMutation, CreateResignationMutationVariables>;
export const GetTerminationByHrRequestDocument = gql`
    query GetTerminationByHrRequest($data: GetTerminationHrRequestInput!) {
  getTerminationByHrRequest(data: $data) {
    terminationId
    employeeId
    userId
    status
    step
    terminationDate
    startDate
    confirmed
    selfService
    terminationState
    createdAt
  }
}
    `;

/**
 * __useGetTerminationByHrRequestQuery__
 *
 * To run a query within a Vue component, call `useGetTerminationByHrRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminationByHrRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTerminationByHrRequestQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTerminationByHrRequestQuery(variables: GetTerminationByHrRequestQueryVariables | VueCompositionApi.Ref<GetTerminationByHrRequestQueryVariables> | ReactiveFunction<GetTerminationByHrRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>(GetTerminationByHrRequestDocument, variables, options);
}
export type GetTerminationByHrRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>;
export const GetResignationByHrRequestDocument = gql`
    query GetResignationByHrRequest($data: GetResignationHrRequestInput!) {
  getResignationByHrRequest(data: $data) {
    resignationId
    employeeId
    userId
    status
    step
    resignationDate
    startDate
    confirmed
    selfService
    resignationState
    createdAt
  }
}
    `;

/**
 * __useGetResignationByHrRequestQuery__
 *
 * To run a query within a Vue component, call `useGetResignationByHrRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResignationByHrRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetResignationByHrRequestQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetResignationByHrRequestQuery(variables: GetResignationByHrRequestQueryVariables | VueCompositionApi.Ref<GetResignationByHrRequestQueryVariables> | ReactiveFunction<GetResignationByHrRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>(GetResignationByHrRequestDocument, variables, options);
}
export type GetResignationByHrRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>;
export const BulkPurchaseSeatsDocument = gql`
    mutation bulkPurchaseSeats($data: BulkPurchaseSeatsInput!) {
  bulkPurchaseSeats(data: $data) {
    bundleId
    error
    id
    numPurchased
    topicId
    totalSeats
  }
}
    `;

/**
 * __useBulkPurchaseSeatsMutation__
 *
 * To run a mutation, you first call `useBulkPurchaseSeatsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkPurchaseSeatsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkPurchaseSeatsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkPurchaseSeatsMutation(options: VueApolloComposable.UseMutationOptions<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables>(BulkPurchaseSeatsDocument, options);
}
export type BulkPurchaseSeatsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables>;
export const BulkEnrollUsersDocument = gql`
    mutation bulkEnrollUsers($data: BulkEnrollUsersInput!) {
  bulkEnrollUsers(data: $data) {
    ...BulkEnrollUsersResponseParts
  }
}
    ${BulkEnrollUsersResponsePartsFragmentDoc}`;

/**
 * __useBulkEnrollUsersMutation__
 *
 * To run a mutation, you first call `useBulkEnrollUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkEnrollUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkEnrollUsersMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkEnrollUsersMutation(options: VueApolloComposable.UseMutationOptions<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables>(BulkEnrollUsersDocument, options);
}
export type BulkEnrollUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables>;
export const EnrollUsersDocument = gql`
    mutation enrollUsers($data: EnrollUsersInput!) {
  enrollUsers(data: $data) {
    ...EnrollmentResponseParts
  }
}
    ${EnrollmentResponsePartsFragmentDoc}`;

/**
 * __useEnrollUsersMutation__
 *
 * To run a mutation, you first call `useEnrollUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnrollUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnrollUsersMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEnrollUsersMutation(options: VueApolloComposable.UseMutationOptions<EnrollUsersMutation, EnrollUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnrollUsersMutation, EnrollUsersMutationVariables>>) {
  return VueApolloComposable.useMutation<EnrollUsersMutation, EnrollUsersMutationVariables>(EnrollUsersDocument, options);
}
export type EnrollUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnrollUsersMutation, EnrollUsersMutationVariables>;
export const PurchaseSeatsForBundleDocument = gql`
    mutation PurchaseSeatsForBundle($data: PurchaseBundleSeatsInput!) {
  purchaseSeatsForBundle(data: $data) {
    numPurchased
    totalSeats
  }
}
    `;

/**
 * __usePurchaseSeatsForBundleMutation__
 *
 * To run a mutation, you first call `usePurchaseSeatsForBundleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSeatsForBundleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseSeatsForBundleMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseSeatsForBundleMutation(options: VueApolloComposable.UseMutationOptions<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables>(PurchaseSeatsForBundleDocument, options);
}
export type PurchaseSeatsForBundleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables>;
export const RemoveSeatsFromBundleDocument = gql`
    mutation RemoveSeatsFromBundle($data: RemoveBundleSeatsInput!) {
  removeSeatsFromBundle(data: $data) {
    numRemoved
    totalSeats
  }
}
    `;

/**
 * __useRemoveSeatsFromBundleMutation__
 *
 * To run a mutation, you first call `useRemoveSeatsFromBundleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSeatsFromBundleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveSeatsFromBundleMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useRemoveSeatsFromBundleMutation(options: VueApolloComposable.UseMutationOptions<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables>>) {
  return VueApolloComposable.useMutation<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables>(RemoveSeatsFromBundleDocument, options);
}
export type RemoveSeatsFromBundleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables>;
export const PurchaseSeatsDocument = gql`
    mutation PurchaseSeats($data: PurchaseSeatsInput!) {
  purchaseSeats(data: $data) {
    numPurchased
    totalSeats
  }
}
    `;

/**
 * __usePurchaseSeatsMutation__
 *
 * To run a mutation, you first call `usePurchaseSeatsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSeatsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseSeatsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseSeatsMutation(options: VueApolloComposable.UseMutationOptions<PurchaseSeatsMutation, PurchaseSeatsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseSeatsMutation, PurchaseSeatsMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseSeatsMutation, PurchaseSeatsMutationVariables>(PurchaseSeatsDocument, options);
}
export type PurchaseSeatsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseSeatsMutation, PurchaseSeatsMutationVariables>;
export const UnenrollUsersDocument = gql`
    mutation UnenrollUsers($data: UnenrollUsersInput!) {
  unenrollUsers(data: $data) {
    id
    successfullyUnenrolled
    errors
  }
}
    `;

/**
 * __useUnenrollUsersMutation__
 *
 * To run a mutation, you first call `useUnenrollUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnenrollUsersMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUnenrollUsersMutation(options: VueApolloComposable.UseMutationOptions<UnenrollUsersMutation, UnenrollUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnenrollUsersMutation, UnenrollUsersMutationVariables>>) {
  return VueApolloComposable.useMutation<UnenrollUsersMutation, UnenrollUsersMutationVariables>(UnenrollUsersDocument, options);
}
export type UnenrollUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnenrollUsersMutation, UnenrollUsersMutationVariables>;
export const GetTrainingTrainingCompanyDocument = gql`
    query GetTrainingTrainingCompany($data: GetCompanyInput!) {
  company(data: $data) {
    ...ShortCompanyParts
  }
}
    ${ShortCompanyPartsFragmentDoc}`;

/**
 * __useGetTrainingTrainingCompanyQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingTrainingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingTrainingCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingTrainingCompanyQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTrainingTrainingCompanyQuery(variables: GetTrainingTrainingCompanyQueryVariables | VueCompositionApi.Ref<GetTrainingTrainingCompanyQueryVariables> | ReactiveFunction<GetTrainingTrainingCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingTrainingCompanyQuery, GetTrainingTrainingCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingTrainingCompanyQuery, GetTrainingTrainingCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingTrainingCompanyQuery, GetTrainingTrainingCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingTrainingCompanyQuery, GetTrainingTrainingCompanyQueryVariables>(GetTrainingTrainingCompanyDocument, variables, options);
}
export type GetTrainingTrainingCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingTrainingCompanyQuery, GetTrainingTrainingCompanyQueryVariables>;
export const GetCompanyVerboseDocument = gql`
    query GetCompanyVerbose($data: GetCompanyInput!) {
  company(data: $data) {
    ...FullCompanyParts
  }
}
    ${FullCompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyVerboseQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyVerboseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyVerboseQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyVerboseQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyVerboseQuery(variables: GetCompanyVerboseQueryVariables | VueCompositionApi.Ref<GetCompanyVerboseQueryVariables> | ReactiveFunction<GetCompanyVerboseQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>(GetCompanyVerboseDocument, variables, options);
}
export type GetCompanyVerboseQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>;
export const GetUserTokenDocument = gql`
    query GetUserToken {
  getUserToken {
    expiresAt
    token
  }
}
    `;

/**
 * __useGetUserTokenQuery__
 *
 * To run a query within a Vue component, call `useGetUserTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTokenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserTokenQuery();
 */
export function useGetUserTokenQuery(options: VueApolloComposable.UseQueryOptions<GetUserTokenQuery, GetUserTokenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserTokenQuery, GetUserTokenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserTokenQuery, GetUserTokenQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserTokenQuery, GetUserTokenQueryVariables>(GetUserTokenDocument, {}, options);
}
export type GetUserTokenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserTokenQuery, GetUserTokenQueryVariables>;
export const GetUserCoursesDocument = gql`
    query GetUserCourses($data: UserCoursesInput!) {
  userCourses(data: $data) {
    ...UserCourseParts
  }
}
    ${UserCoursePartsFragmentDoc}`;

/**
 * __useGetUserCoursesQuery__
 *
 * To run a query within a Vue component, call `useGetUserCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCoursesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserCoursesQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetUserCoursesQuery(variables: GetUserCoursesQueryVariables | VueCompositionApi.Ref<GetUserCoursesQueryVariables> | ReactiveFunction<GetUserCoursesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserCoursesQuery, GetUserCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserCoursesQuery, GetUserCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserCoursesQuery, GetUserCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserCoursesQuery, GetUserCoursesQueryVariables>(GetUserCoursesDocument, variables, options);
}
export type GetUserCoursesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserCoursesQuery, GetUserCoursesQueryVariables>;
export const GetTopicsDocument = gql`
    query GetTopics {
  getTopics {
    id
    name
    searchTag
  }
}
    `;

/**
 * __useGetTopicsQuery__
 *
 * To run a query within a Vue component, call `useGetTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTopicsQuery();
 */
export function useGetTopicsQuery(options: VueApolloComposable.UseQueryOptions<GetTopicsQuery, GetTopicsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTopicsQuery, GetTopicsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTopicsQuery, GetTopicsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTopicsQuery, GetTopicsQueryVariables>(GetTopicsDocument, {}, options);
}
export type GetTopicsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTopicsQuery, GetTopicsQueryVariables>;
export const GetCompanyTicketsDocument = gql`
    query GetCompanyTickets($data: ListTicketsInput!) {
  getTickets(data: $data) {
    totalTickets
    tickets {
      id
      topicId
      bundleId
      courseId
      userId
      stripeInvoiceId
      enrolledAt
      startedAt
      completedAt
    }
  }
}
    `;

/**
 * __useGetCompanyTicketsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyTicketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyTicketsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyTicketsQuery(variables: GetCompanyTicketsQueryVariables | VueCompositionApi.Ref<GetCompanyTicketsQueryVariables> | ReactiveFunction<GetCompanyTicketsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>(GetCompanyTicketsDocument, variables, options);
}
export type GetCompanyTicketsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>;
export const GetTrainingPricesDocument = gql`
    query GetTrainingPrices {
  getTrainingPrices {
    bundle
    topic
  }
}
    `;

/**
 * __useGetTrainingPricesQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingPricesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingPricesQuery();
 */
export function useGetTrainingPricesQuery(options: VueApolloComposable.UseQueryOptions<GetTrainingPricesQuery, GetTrainingPricesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>(GetTrainingPricesDocument, {}, options);
}
export type GetTrainingPricesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>;
export const GetCompanyTrainingStatusDocument = gql`
    query GetCompanyTrainingStatus($id: String!) {
  company(data: {companyId: $id}) {
    hasTraining
  }
}
    `;

/**
 * __useGetCompanyTrainingStatusQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyTrainingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyTrainingStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyTrainingStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyTrainingStatusQuery(variables: GetCompanyTrainingStatusQueryVariables | VueCompositionApi.Ref<GetCompanyTrainingStatusQueryVariables> | ReactiveFunction<GetCompanyTrainingStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>(GetCompanyTrainingStatusDocument, variables, options);
}
export type GetCompanyTrainingStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>;
export const UpdateCoreUserStateDocument = gql`
    mutation updateCoreUserState($input: CoreUserStatesInput!) {
  updateCoreUserState(input: $input) {
    ...CoreUserStateParts
  }
}
    ${CoreUserStatePartsFragmentDoc}`;

/**
 * __useUpdateCoreUserStateMutation__
 *
 * To run a mutation, you first call `useUpdateCoreUserStateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoreUserStateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCoreUserStateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoreUserStateMutation(options: VueApolloComposable.UseMutationOptions<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables>(UpdateCoreUserStateDocument, options);
}
export type UpdateCoreUserStateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables>;
export const GetMyCoreUserDocument = gql`
    query GetMyCoreUser {
  getMyCoreUser {
    id
    role
    documents {
      ...CoreDocumentParts
    }
    states {
      ...CoreUserStateParts
    }
    employment {
      ...CoreUserEmploymentParts
    }
  }
}
    ${CoreDocumentPartsFragmentDoc}
${CoreUserStatePartsFragmentDoc}
${CoreUserEmploymentPartsFragmentDoc}`;

/**
 * __useGetMyCoreUserQuery__
 *
 * To run a query within a Vue component, call `useGetMyCoreUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoreUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyCoreUserQuery();
 */
export function useGetMyCoreUserQuery(options: VueApolloComposable.UseQueryOptions<GetMyCoreUserQuery, GetMyCoreUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>(GetMyCoreUserDocument, {}, options);
}
export type GetMyCoreUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>;
export const namedOperations = {
  Query: {
    GetCouponById: 'GetCouponById',
    getLockedPlan: 'getLockedPlan',
    GetBillingCompanySubscriptions: 'GetBillingCompanySubscriptions',
    myProducts: 'myProducts',
    GetCompanyDelinquency: 'GetCompanyDelinquency',
    GetCompanySources: 'GetCompanySources',
    ScratchListServiceAddons: 'ScratchListServiceAddons',
    ListPractice: 'ListPractice',
    getPractice: 'getPractice',
    getHrScore: 'getHrScore',
    companySurvey: 'companySurvey',
    GetCompanySettings: 'GetCompanySettings',
    GetMyVoicesFeedbackList: 'GetMyVoicesFeedbackList',
    GetMyCompanyVoicesFeedbackList: 'GetMyCompanyVoicesFeedbackList',
    GetTerminationList: 'GetTerminationList',
    GetTerminationInfo: 'GetTerminationInfo',
    TerminationDownload: 'TerminationDownload',
    GetResignationList: 'GetResignationList',
    ResignationInfo: 'ResignationInfo',
    ResignationDownload: 'ResignationDownload',
    WarningDocuments: 'WarningDocuments',
    GetEmployeeJobDescription: 'GetEmployeeJobDescription',
    GetJobDescriptions: 'GetJobDescriptions',
    GetStaffJobDescriptions: 'GetStaffJobDescriptions',
    MyNotifications: 'MyNotifications',
    GetCompanyStatus: 'GetCompanyStatus',
    GetCompanyOnboardingStatus: 'GetCompanyOnboardingStatus',
    GetCompany: 'GetCompany',
    GetCompanyHasRunPayroll: 'GetCompanyHasRunPayroll',
    GetCompanyLifecycleInfo: 'GetCompanyLifecycleInfo',
    GetCompanyPaySchedules: 'GetCompanyPaySchedules',
    GetCompanyEstimatedBenefitsCost: 'GetCompanyEstimatedBenefitsCost',
    GetCompanyStaff: 'GetCompanyStaff',
    GetFullStaff: 'GetFullStaff',
    GetCompanyPolicies: 'GetCompanyPolicies',
    TaxDocuments: 'TaxDocuments',
    ListPayroll: 'ListPayroll',
    ListPayrollCount: 'ListPayrollCount',
    CompanyPayrollCount: 'CompanyPayrollCount',
    getPayroll: 'getPayroll',
    GetPayrollInfo: 'GetPayrollInfo',
    GetPayrollItemsPaginated: 'GetPayrollItemsPaginated',
    GetPayrollPaymentsPaginated: 'GetPayrollPaymentsPaginated',
    GetEmployee: 'GetEmployee',
    GetEmployeeTaxDocs: 'GetEmployeeTaxDocs',
    GetEmployeeStatus: 'GetEmployeeStatus',
    GetContractorTaxDocs: 'GetContractorTaxDocs',
    GetContractorStatus: 'GetContractorStatus',
    GetWorkerStatus: 'GetWorkerStatus',
    GetEmployeePayrollItems: 'GetEmployeePayrollItems',
    GetContractorPayments: 'GetContractorPayments',
    listWorkplace: 'listWorkplace',
    GetCompanyDefaultPayScheduleDays: 'GetCompanyDefaultPayScheduleDays',
    GetUserEditInfo: 'GetUserEditInfo',
    GetCompanyRoles: 'GetCompanyRoles',
    GetUserRoles: 'GetUserRoles',
    GetMFAEnrollments: 'GetMFAEnrollments',
    GetTrainingUserHistory: 'GetTrainingUserHistory',
    GetPayrollOnboardingInfo: 'GetPayrollOnboardingInfo',
    GetPayrollFeinStatus: 'GetPayrollFeinStatus',
    GetTimesheets: 'GetTimesheets',
    GetTimesheetsByRole: 'GetTimesheetsByRole',
    GetCompanyGoals: 'GetCompanyGoals',
    GetPayrollTasks: 'GetPayrollTasks',
    GetPayrollPayItems: 'GetPayrollPayItems',
    GetPayrollItem: 'GetPayrollItem',
    GetContractorPayment: 'GetContractorPayment',
    GetMyCompanyGoals: 'GetMyCompanyGoals',
    GetCoreCompanyEmployeesForOnboarding: 'GetCoreCompanyEmployeesForOnboarding',
    GetCompanyPayrollHistory: 'GetCompanyPayrollHistory',
    GetPayrollSignatoryInfo: 'GetPayrollSignatoryInfo',
    GetCompanyAddresses: 'GetCompanyAddresses',
    GetBambeePlusInfo: 'GetBambeePlusInfo',
    GetBasicCompanyInfo: 'GetBasicCompanyInfo',
    GetBambeePlusDeadline: 'GetBambeePlusDeadline',
    GetDeputyTosInfo: 'GetDeputyTosInfo',
    GetSimplePolicyList: 'GetSimplePolicyList',
    GetTrainingCompany: 'GetTrainingCompany',
    GetBillingHistory: 'GetBillingHistory',
    GetTrainingRequests: 'GetTrainingRequests',
    GetMyTrainingRequests: 'GetMyTrainingRequests',
    GetTrainingRecommendations: 'GetTrainingRecommendations',
    GetPendingHotlineCalls: 'GetPendingHotlineCalls',
    GetCompanySubscriptions: 'GetCompanySubscriptions',
    GetPricingPackages: 'GetPricingPackages',
    GetHotlineCalls: 'GetHotlineCalls',
    GetUpgradeOptions: 'GetUpgradeOptions',
    getLatestPricingPackagesForTier: 'getLatestPricingPackagesForTier',
    GetGeneralPayrollCompany: 'GetGeneralPayrollCompany',
    GetCancellationReasons: 'GetCancellationReasons',
    CancellationOffers: 'CancellationOffers',
    GetBillingInfo: 'GetBillingInfo',
    GetNonCoreSubscriptionBillingChanges: 'GetNonCoreSubscriptionBillingChanges',
    GetBillingInfoPaymentMethods: 'GetBillingInfoPaymentMethods',
    GetProductInterest: 'GetProductInterest',
    IsEventScheduledForUser: 'IsEventScheduledForUser',
    FindOnboarding: 'FindOnboarding',
    FindOnboardingStatus: 'FindOnboardingStatus',
    getCompanyProducts: 'getCompanyProducts',
    GetAvailableProducts: 'GetAvailableProducts',
    GetCompanyCredits: 'GetCompanyCredits',
    GetEligibleAddons: 'GetEligibleAddons',
    PayrollStatus: 'PayrollStatus',
    GetPolicy: 'GetPolicy',
    PolicyDataTable: 'PolicyDataTable',
    GetReportCardList: 'GetReportCardList',
    GetReportCard: 'GetReportCard',
    GetHrRequestOptions: 'GetHrRequestOptions',
    GetHrRequests: 'GetHrRequests',
    HrRequest: 'HrRequest',
    HrRequestAiInformation: 'HrRequestAiInformation',
    GetOnboardingCalendlyConfig: 'GetOnboardingCalendlyConfig',
    GetConversationByIntercomId: 'GetConversationByIntercomId',
    GetHrRequestList: 'GetHrRequestList',
    GetScheduledEvents: 'GetScheduledEvents',
    GetRescheduleLink: 'GetRescheduleLink',
    HrRequestExtendedDetail: 'HrRequestExtendedDetail',
    GetAskNicelyWebSurveyInfo: 'GetAskNicelyWebSurveyInfo',
    GetTerminationByHrRequest: 'GetTerminationByHrRequest',
    GetResignationByHrRequest: 'GetResignationByHrRequest',
    GetTrainingTrainingCompany: 'GetTrainingTrainingCompany',
    GetCompanyVerbose: 'GetCompanyVerbose',
    GetUserToken: 'GetUserToken',
    GetUserCourses: 'GetUserCourses',
    GetTopics: 'GetTopics',
    GetCompanyTickets: 'GetCompanyTickets',
    GetTrainingPrices: 'GetTrainingPrices',
    GetCompanyTrainingStatus: 'GetCompanyTrainingStatus',
    GetMyCoreUser: 'GetMyCoreUser'
  },
  Mutation: {
    ApplyCorePayrollDiscountToCompanySubscription: 'ApplyCorePayrollDiscountToCompanySubscription',
    CreatePayrollSubscription: 'CreatePayrollSubscription',
    purchaseCredits: 'purchaseCredits',
    purchaseSubscription: 'purchaseSubscription',
    UpdatePaymentSourceBillingAddress: 'UpdatePaymentSourceBillingAddress',
    ScratchToggleServiceAddon: 'ScratchToggleServiceAddon',
    saveCompanyAnswer: 'saveCompanyAnswer',
    completeCompanySurvey: 'completeCompanySurvey',
    completeCompanyPractice: 'completeCompanyPractice',
    BulkMessageStaff: 'BulkMessageStaff',
    CreateVoicesFeedback: 'CreateVoicesFeedback',
    CancelTermination: 'CancelTermination',
    ConfirmTermination: 'ConfirmTermination',
    EditTerminationDetails: 'EditTerminationDetails',
    AttachTerminationFiles: 'AttachTerminationFiles',
    AttachResignationFiles: 'AttachResignationFiles',
    CancelResignation: 'CancelResignation',
    ConfirmResignation: 'ConfirmResignation',
    EditResignation: 'EditResignation',
    CreateJobDescription: 'CreateJobDescription',
    UpdateJobDescription: 'UpdateJobDescription',
    CompleteJobDescription: 'CompleteJobDescription',
    GenerateAiJobDescription: 'GenerateAiJobDescription',
    GenerateAiJobDescriptionV2: 'GenerateAiJobDescriptionV2',
    SendJobDescriptionToEmployee: 'SendJobDescriptionToEmployee',
    SignEmployeeJobDescription: 'SignEmployeeJobDescription',
    DismissNotification: 'DismissNotification',
    ClickedOnNotificationAction: 'ClickedOnNotificationAction',
    AssignUserToPolicies: 'AssignUserToPolicies',
    EnrollMFADevice: 'EnrollMFADevice',
    createMfaChallenge: 'createMfaChallenge',
    resendChallenge: 'resendChallenge',
    ConfirmUserMfaEnrollment: 'ConfirmUserMfaEnrollment',
    approvePayroll: 'approvePayroll',
    DeletePayroll: 'DeletePayroll',
    CreatePayroll: 'CreatePayroll',
    InitPayroll: 'InitPayroll',
    UpdatePayroll: 'UpdatePayroll',
    UpdatePayrollItem: 'UpdatePayrollItem',
    UpdateContractorPayment: 'UpdateContractorPayment',
    UpdatePayrollChecks: 'UpdatePayrollChecks',
    PreviewPayroll: 'PreviewPayroll',
    GenerateEmployeeOnboardingLink: 'GenerateEmployeeOnboardingLink',
    GenerateContractorOnboardingLink: 'GenerateContractorOnboardingLink',
    GenerateCompanyOnboardingLink: 'GenerateCompanyOnboardingLink',
    GenerateEmployeePostTaxDeductionsLink: 'GenerateEmployeePostTaxDeductionsLink',
    GenerateCompanyPayrollReportLink: 'GenerateCompanyPayrollReportLink',
    createPaySchedule: 'createPaySchedule',
    UpdateWorkplace: 'UpdateWorkplace',
    CreateWorkplace: 'CreateWorkplace',
    CreateCompanyInCheck: 'CreateCompanyInCheck',
    upgradeFinchCode: 'upgradeFinchCode',
    UpdateCompany: 'UpdateCompany',
    SetupEmployee: 'SetupEmployee',
    SetupContractor: 'SetupContractor',
    UpdateEmployeeWorkplace: 'UpdateEmployeeWorkplace',
    UpdateContractorWorkplace: 'UpdateContractorWorkplace',
    SendStaffOnboardInvite: 'SendStaffOnboardInvite',
    BulkEarningsImport: 'BulkEarningsImport',
    FinchManualSetupCompleted: 'FinchManualSetupCompleted',
    CheckSyncCompany: 'CheckSyncCompany',
    DeleteCompanyRoles: 'DeleteCompanyRoles',
    CreateCompanyRoles: 'CreateCompanyRoles',
    UpdateCompanyRoles: 'UpdateCompanyRoles',
    AssignWorkerRoles: 'AssignWorkerRoles',
    SubmitPayrollOnboardingForm: 'SubmitPayrollOnboardingForm',
    UpdatePayrollSignatory: 'UpdatePayrollSignatory',
    VerifyFEINInCheck: 'VerifyFEINInCheck',
    UploadRequirementFile: 'UploadRequirementFile',
    ImportHours: 'ImportHours',
    SyncTimesheetHours: 'SyncTimesheetHours',
    ImportTimesheetByWorkerList: 'ImportTimesheetByWorkerList',
    CompleteTask: 'CompleteTask',
    CompleteGoal: 'CompleteGoal',
    StartTask: 'StartTask',
    BulkSetupStaffInPayroll: 'BulkSetupStaffInPayroll',
    SavePastPayrollUsage: 'SavePastPayrollUsage',
    UpdateCompanyAddresses: 'UpdateCompanyAddresses',
    UpdateBasicCompanyInfo: 'UpdateBasicCompanyInfo',
    PurchaseBambeePlus: 'PurchaseBambeePlus',
    SendEnrollmentProfile: 'SendEnrollmentProfile',
    SaveCompanySetting: 'SaveCompanySetting',
    CancelBambeePlus: 'CancelBambeePlus',
    ApproveTrainingRequest: 'ApproveTrainingRequest',
    RejectTrainingRequest: 'RejectTrainingRequest',
    MakeTrainingRequest: 'MakeTrainingRequest',
    CancelTrainingRequest: 'CancelTrainingRequest',
    GenerateCheckComponentLink: 'GenerateCheckComponentLink',
    JoinCallQueue: 'JoinCallQueue',
    CancelPendingHotlineCall: 'CancelPendingHotlineCall',
    UpgradeCorePlan: 'UpgradeCorePlan',
    SaveComplexPayrollOnboarding: 'SaveComplexPayrollOnboarding',
    PurchaseTimeAndAttendance: 'PurchaseTimeAndAttendance',
    AcceptOffer: 'AcceptOffer',
    SubmitCancelRequest: 'SubmitCancelRequest',
    Track: 'Track',
    ReactivateCompany: 'ReactivateCompany',
    CreateProductInterest: 'CreateProductInterest',
    SetDefaultBillingPaymentMethod: 'SetDefaultBillingPaymentMethod',
    RemovePaymentMethod: 'RemovePaymentMethod',
    ConfirmMicroDeposit: 'ConfirmMicroDeposit',
    UpsertEmployerOnboarding: 'UpsertEmployerOnboarding',
    AcceptTrialExtension: 'AcceptTrialExtension',
    AddSubscription: 'AddSubscription',
    CreateEliteAddonSubscription: 'CreateEliteAddonSubscription',
    RequestPayrollCancellation: 'RequestPayrollCancellation',
    ConsumeNectarCredits: 'ConsumeNectarCredits',
    PurchaseNectarCredits: 'PurchaseNectarCredits',
    ProvisionDeputyInstall: 'ProvisionDeputyInstall',
    CreatePayrollTierSubscription: 'CreatePayrollTierSubscription',
    UpgradeInstall: 'UpgradeInstall',
    CancelTimeAttendance: 'CancelTimeAttendance',
    ChatWithAssistant: 'ChatWithAssistant',
    OptInAi: 'OptInAi',
    ActivateHandsFree: 'ActivateHandsFree',
    Emit: 'Emit',
    AssignUserToPolicy: 'AssignUserToPolicy',
    AssignUsersToPolicies: 'AssignUsersToPolicies',
    ReaffirmEmployeeDocument: 'ReaffirmEmployeeDocument',
    ArchivePolicy: 'ArchivePolicy',
    ReaffirmDocument: 'ReaffirmDocument',
    CreateReportCard: 'CreateReportCard',
    UpdateReportCard: 'UpdateReportCard',
    CompleteReportCard: 'CompleteReportCard',
    TrackProductInterest: 'TrackProductInterest',
    CreateHrRequest: 'CreateHrRequest',
    ReplyToConversation: 'ReplyToConversation',
    CancelScheduledEvent: 'CancelScheduledEvent',
    UploadFilesToConversation: 'UploadFilesToConversation',
    CloseHrRequest: 'CloseHrRequest',
    SetCaseStatus: 'SetCaseStatus',
    CreateTermination: 'CreateTermination',
    CreateResignation: 'CreateResignation',
    bulkPurchaseSeats: 'bulkPurchaseSeats',
    bulkEnrollUsers: 'bulkEnrollUsers',
    enrollUsers: 'enrollUsers',
    PurchaseSeatsForBundle: 'PurchaseSeatsForBundle',
    RemoveSeatsFromBundle: 'RemoveSeatsFromBundle',
    PurchaseSeats: 'PurchaseSeats',
    UnenrollUsers: 'UnenrollUsers',
    updateCoreUserState: 'updateCoreUserState'
  },
  Fragment: {
    AppliedPlansParts: 'AppliedPlansParts',
    CouponParts: 'CouponParts',
    SubscriptionParts: 'SubscriptionParts',
    BillingPlanParts: 'BillingPlanParts',
    CompanyDelinquencyParts: 'CompanyDelinquencyParts',
    PaymentSourceParts: 'PaymentSourceParts',
    BillingProductParts: 'BillingProductParts',
    ProductResultParts: 'ProductResultParts',
    PaymentSourcesParts: 'PaymentSourcesParts',
    PracticeParts: 'PracticeParts',
    SurveyParts: 'SurveyParts',
    VoicesFeedbackParts: 'VoicesFeedbackParts',
    TerminationParts: 'TerminationParts',
    TerminationDownloadParts: 'TerminationDownloadParts',
    ResignationParts: 'ResignationParts',
    ResignationDownloadParts: 'ResignationDownloadParts',
    JobDescriptionParts: 'JobDescriptionParts',
    EmployeeJobDescriptionParts: 'EmployeeJobDescriptionParts',
    OnboardingParts: 'OnboardingParts',
    BankAccountParts: 'BankAccountParts',
    CompanyParts: 'CompanyParts',
    EmployeePayrollItemsParts: 'EmployeePayrollItemsParts',
    ContractorPaymentParts: 'ContractorPaymentParts',
    TaxDocumentParts: 'TaxDocumentParts',
    CompanyTaxDocumentParts: 'CompanyTaxDocumentParts',
    TotalParts: 'TotalParts',
    ItemParts: 'ItemParts',
    ContractorParts: 'ContractorParts',
    ContractorMinimalParts: 'ContractorMinimalParts',
    PaymentParts: 'PaymentParts',
    PaymentMinimalParts: 'PaymentMinimalParts',
    PaginationParts: 'PaginationParts',
    PaginationItemParts: 'PaginationItemParts',
    PaginationPaymentParts: 'PaginationPaymentParts',
    PayrollPreviewParts: 'PayrollPreviewParts',
    PayrollWithItemsParts: 'PayrollWithItemsParts',
    PayrollParts: 'PayrollParts',
    PayrollWithoutNestedPaymentsParts: 'PayrollWithoutNestedPaymentsParts',
    PayrollInfoParts: 'PayrollInfoParts',
    PayrollItemsPaginatedParts: 'PayrollItemsPaginatedParts',
    PayrollPaymentsPaginatedParts: 'PayrollPaymentsPaginatedParts',
    PayrollListParts: 'PayrollListParts',
    AddressParts: 'AddressParts',
    ProfileAddressParts: 'ProfileAddressParts',
    CoreAddressParts: 'CoreAddressParts',
    CompanyStatusParts: 'CompanyStatusParts',
    ContractorProfileParts: 'ContractorProfileParts',
    EmployeeProfileParts: 'EmployeeProfileParts',
    EmployeeStatusParts: 'EmployeeStatusParts',
    ContractorStatusParts: 'ContractorStatusParts',
    UserParts: 'UserParts',
    CompanyGoalParts: 'CompanyGoalParts',
    CoreTaskParts: 'CoreTaskParts',
    CoreGoalParts: 'CoreGoalParts',
    CourseTopicParts: 'CourseTopicParts',
    PlanParts: 'PlanParts',
    ProductParts: 'ProductParts',
    CoreDocumentSignatureParts: 'CoreDocumentSignatureParts',
    CoreDocumentParts: 'CoreDocumentParts',
    CoreUserStatesParts: 'CoreUserStatesParts',
    CoreUserParts: 'CoreUserParts',
    CorePolicyParts: 'CorePolicyParts',
    ReportCardUserParts: 'ReportCardUserParts',
    ReportCardEmployeeGradeParts: 'ReportCardEmployeeGradeParts',
    ManagedReportParts: 'ManagedReportParts',
    ReportCardParts: 'ReportCardParts',
    NewReportCardParts: 'NewReportCardParts',
    EnrollmentResponseParts: 'EnrollmentResponseParts',
    BulkEnrollUsersResponseParts: 'BulkEnrollUsersResponseParts',
    UserCourseParts: 'UserCourseParts',
    TopicParts: 'TopicParts',
    FullCompanyParts: 'FullCompanyParts',
    ShortCompanyParts: 'ShortCompanyParts',
    CoreUserStateParts: 'CoreUserStateParts',
    CoreUserEmploymentParts: 'CoreUserEmploymentParts'
  }
}